;(function() {
try { console.log('%c[EOH chat] build: voice-filler-v3+interview+clarify-fix+fmt-explicit+attach-override+queued-send \u2014 instant AI opener + mic tones + no double TTS + clarifier options never spoken \u2014 chips + no duplicate question in history', 'color:#0fb574;font-weight:bold'); } catch(e){}
// ═══════════════════════════════════════════════════════════════════════════
// GLOBAL FETCH INTERCEPTOR — MUST be first code in file
// Wraps window.fetch so ANY api response with account_blocked shows block modal
// ═══════════════════════════════════════════════════════════════════════════
var _origFetch = window.fetch.bind(window);
window.fetch = async function() {
  var response = await _origFetch.apply(this, arguments);
  var url = String(arguments[0] || '');
  // Only intercept our backend API calls
  if (url.indexOf('erp-ai-backend.vercel.app') !== -1) {
    var clone = response.clone();
    try {
      var ct = response.headers.get('content-type') || '';
      if (response.status === 403 && ct.indexOf('json') !== -1) {
        var body = await clone.json();
        if (body && body.error === 'account_blocked') {
          // Retry after DOM is ready — showBlockedModal may not exist yet on first load
          var _tryShow = function() {
            if (typeof showBlockedModal === 'function') {
              // Update S.user if available
              if (typeof S !== 'undefined' && S && S.user) {
                S.user.isBlocked   = true;
                S.user.blockReason = body.reason || null;
                try { localStorage.setItem('eoh_u', JSON.stringify(S.user)); } catch(_) {}
              }
              showBlockedModal(body.reason || null);
            } else {
              setTimeout(_tryShow, 100);
            }
          };
          _tryShow();
        }
      }
    } catch (_) { /* never break the caller */ }
  }
  return response;
};
// Expose so other functions can use the real fetch (bypass interceptor)
window._origFetch = _origFetch;
})();


function closeAttach() {
  document.getElementById('attach-menu').classList.remove('open');
}
// -- CONFIG --------------------------------------------------------------------
var _isDevEnv = (
  window.location.pathname.indexOf('/pages/erp-chat_dev') !== -1 ||  // new DEV URL
  window.location.search.indexOf('preview_theme_id=159788171482') !== -1  // old preview
);
var API = (window.location.hostname === 'erponlinehub.com' && !_isDevEnv)
  ? 'https://erp-ai-backend.vercel.app'      // LIVE
  : 'https://erp-ai-backend-dev.vercel.app'; // DEV

// ── PLAN LIMITS — always loaded from DB, never hardcoded ─────────────────────
// Starts locked to zero. Actions are gated until _planLimitsLoaded = true.
// This prevents the race window where stale hardcoded values could be used.
var _planLimitsLoaded = false;
var PLAN_LIMITS = {
  free:         {queries:0, voice:0, docs:0, docMB:0, fileDownload:false},
  basic:        {queries:0, voice:0, docs:0, docMB:0, fileDownload:false},
  professional: {queries:0, voice:0, docs:0, docMB:0, fileDownload:false},
  business:     {queries:0, voice:0, docs:0, docMB:0, fileDownload:false},
  manager:      {queries:0, voice:0, docs:0, docMB:0, fileDownload:false},
  enterprise:   {queries:0, voice:0, docs:0, docMB:0, fileDownload:false}
};

var VOICE_CONFIG = {};

// Styles are loaded from eoh-fdstyle.js — load that file before eoh-chat.js
// If eoh-fdstyle.js is missing, inject a minimal fallback so chat still works
(function() {
  if (document.getElementById('eoh-fdstyle') || document.getElementById('eoh-stream-style')) return;
  var s = document.createElement('style');
  s.id = 'eoh-stream-style';
  s.textContent = '@keyframes eohPulse{0%,100%{opacity:.6;transform:scale(.9)}50%{opacity:1;transform:scale(1.1)}}'
    + '.stream-cursor{display:inline-block;width:18px;height:18px;vertical-align:middle;margin-left:4px}'
    + '.stream-cursor img{width:100%;height:100%;object-fit:contain;border-radius:3px;animation:eohPulse 1s ease-in-out infinite}'
    + '.eoh-status{display:inline;margin-left:8px;font-size:13px;color:#0fb574;font-weight:500}'
    + '.eoh-pre-dots{display:flex;align-items:center}'
    // Trailing follow-up question — accent card so the invitation stands out from body text.
    // Theme-aware: CSS vars only, with safe fallbacks.
    + '.mbubble p.eoh-followup{margin:14px 0 2px;padding:11px 14px 11px 13px;'
    +   'background:var(--bg3,#1c2135);border:1px solid var(--border2,rgba(255,255,255,.1));'
    +   'border-left:3px solid var(--gl,#0fb574);border-radius:9px;'
    +   'color:var(--text,#e8edf5);font-weight:600;line-height:1.5;'
    +   'display:flex;align-items:flex-start;gap:9px}'
    + '.mbubble p.eoh-followup::before{content:"\\1F4AC";flex-shrink:0;font-size:14px;line-height:1.5;opacity:.9}';
  document.head.appendChild(s);
})();


(function loadPlanConfig() {
  window.fetch(API + '/admin/plans').then(function(r){return r.json();}).then(function(d) {
    if (!d.plans || !d.plans.length) return;
    d.plans.forEach(function(p) {
      PLAN_LIMITS[p.key] = {queries:p.queries, voice:p.voice_mins, screen:p.screen_mins, docs:p.docs, docMB:p.doc_mb, fileDownload:!!p.file_download};
      VOICE_CONFIG[p.key] = {s2s:!!p.s2s_enabled, speed:!!p.speed_control, voiceSelect:!!p.voice_select, voiceMins:p.voice_mins, live:!!p.live_screen, pmFeatures:!!p.pm_features, fileDownload:!!p.file_download, learningEnabled:!!p.learning_enabled, learningQueries:p.learning_queries||0, screenCapture:!!p.screen_capture_enabled, interview:!!p.interview_enabled, interviewsPerCycle:p.interviews_per_cycle||0};
    });
    _planLimitsLoaded = true;
    // Invalidate upgrade modal cache so disabled plans are never shown
    _plansCache = null;
    if (typeof updateLimits === 'function') updateLimits();
    applyFeatureFlags();
  }).catch(function(){
    // If DB is unreachable, do NOT fall back to any hardcoded values.
    // Leave limits at zero and mark as loaded-with-error so UI can warn user.
    _planLimitsLoaded = true;
    console.error('[EOH] Could not load plan limits from server — all limits locked at 0');
  });
})();

// ── Global feature flags — loaded once on page load ─────────────────────────
// Reads from /admin/features/public (no auth required).
// Any flag explicitly = false in DB disables that UI element.
var _featureFlags = {};
var _featureFlagsLoaded = false;

(function loadFeatureFlagsFromServer() {
  window.fetch(API + '/admin/features/public')
    .then(function(r) { return r.json(); })
    .then(function(d) {
      _featureFlags = d.features || {};
      _featureFlagsLoaded = true;
      applyGlobalFeatureFlags();
    })
    .catch(function() {
      _featureFlagsLoaded = true; // fail open
    });
})();

function isFeatureEnabled(key) {
  // If not loaded yet or key missing → default enabled
  if (!_featureFlagsLoaded) return true;
  return _featureFlags[key] !== false;
}

function applyGlobalFeatureFlags() {
  // Google OAuth button
  var gBtn = document.querySelector('[onclick*="doOAuthGoogle"]') ||
             document.querySelector('[onclick*="oauth/google"]');
  if (gBtn) gBtn.style.display = isFeatureEnabled('google_oauth') ? '' : 'none';

  // LinkedIn OAuth button
  var liBtn = document.querySelector('[onclick*="doOAuthLinkedIn"]') ||
              document.querySelector('[onclick*="oauth/linkedin"]');
  if (liBtn) liBtn.style.display = isFeatureEnabled('linkedin_oauth') ? '' : 'none';

  // File upload button
  var uploadBtn = document.getElementById('file-btn') ||
                  document.querySelector('[data-feature="file_upload"]');
  if (uploadBtn) uploadBtn.style.display = isFeatureEnabled('file_upload') ? '' : 'none';

  // Chat history / sessions
  var histBtn = document.getElementById('history-btn') ||
                document.getElementById('sessions-btn') ||
                document.querySelector('[data-feature="chat_history"]');
  if (histBtn) histBtn.style.display = isFeatureEnabled('chat_history') ? '' : 'none';

  // Voice (S2S) — supplement plan-level control
  if (!isFeatureEnabled('speech_to_speech')) {
    ['voice-btn', 'voice-toggle-btn'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.style.display = 'none';
    });
  }
  // S2T (mic for text input)
  if (!isFeatureEnabled('speech_to_text')) {
    var micBtn = document.getElementById('mic-btn') ||
                 document.querySelector('[data-feature="speech_to_text"]');
    if (micBtn) micBtn.style.display = 'none';
  }

  // AI Chat disabled — show a message instead of the chat interface
  if (!isFeatureEnabled('ai_chat')) {
    var chatArea = document.getElementById('chat-area') ||
                   document.getElementById('chat-input-area');
    if (chatArea) {
      chatArea.innerHTML = '<div style="text-align:center;padding:40px;color:var(--dim)">'
        + '<div style="font-size:32px;margin-bottom:12px">🔒</div>'
        + '<div style="font-size:16px;font-weight:600;color:var(--text)">AI Chat Temporarily Unavailable</div>'
        + '<div style="font-size:13px;margin-top:8px">This feature is currently disabled. Please try again later.</div>'
        + '</div>';
    }
  }
}

// PRODUCTS is loaded dynamically from the backend (erp_systems table).
// Falls back to defaults if the API is unreachable.
var PRODUCTS = {
  'SAP':               ['S/4HANA','ECC','Business One','Business ByDesign','SuccessFactors','Ariba','Concur','Analytics Cloud','Customer Experience','BTP'],
  'Oracle':            ['Fusion Cloud','E-Business Suite','JD Edwards','PeopleSoft','Hyperion','Primavera'],
  'Workday':           ['HCM','Financial Management','Adaptive Planning','Student','Peakon'],
  'Microsoft Dynamics':['Dynamics 365 Finance','D365 Supply Chain','Business Central','D365 Sales','Dynamics AX','Dynamics NAV','Dynamics GP'],
  'Odoo':              ['Community','Enterprise','Online','Odoo.sh'],
  'NetSuite':          ['ERP','OneWorld','SuitePeople','OpenAir'],
  'Sage':              ['Intacct','X3','300','200','100','HR'],
  'Infor':             ['CloudSuite','LN','M3','SunSystems','EAM','Birst'],
  'Epicor':            ['Kinetic','Prophet 21','Eclipse','iScala'],
  'IFS':               ['IFS Cloud','IFS Applications','IFS EAM','IFS Field Service Management'],
  'ADP':               ['Workforce Now','Vantage HCM','TotalSource','SmartCompliance','Lyric HCM','RUN Powered by ADP','WorkforceManager','ADP Enterprise HR']
};

// Load ERP systems from DB and repopulate the vendor dropdown
function loadErpSystems() {
  fetch(API + '/admin/erp-systems/public')
    .then(function(r) { return r.ok ? r.json() : null; })
    .then(function(data) {
      if (!data || !data.systems || !data.systems.length) return; // keep defaults
      var hasRealProducts = false;
      data.systems.forEach(function(sys) {
        var prods = sys.products;
        if (typeof prods === 'string') { try { prods = JSON.parse(prods); } catch(e) { prods = []; } }
        if (!Array.isArray(prods)) prods = [];
        if (prods.length > 0) { PRODUCTS[sys.vendor_name] = prods; hasRealProducts = true; }
      });
      if (!hasRealProducts) return;
      var vs = document.getElementById('vs');
      if (!vs) return;
      var currentVendor = vs.value;
      vs.innerHTML = '<option value="" disabled selected>Choose your ERP vendor…</option>';
      data.systems.forEach(function(sys) {
        if (!PRODUCTS[sys.vendor_name] || !PRODUCTS[sys.vendor_name].length) return;
        var o = document.createElement('option');
        o.value = sys.vendor_name; o.textContent = sys.vendor_name;
        if (sys.vendor_name === currentVendor) o.selected = true;
        vs.appendChild(o);
      });
      if (currentVendor && PRODUCTS[currentVendor] && PRODUCTS[currentVendor].length) populateProducts(currentVendor);
    })
    .catch(function() {}); // silently fail, keep defaults
}

var S = {
  user: null, token: null, vendor: null, product: null,
  history: [], loading: false,
  voiceOn: false, recording: false, recognition: null, speaking: false, audio: null,
  file: null, fileContent: null, filesAttached: [], voiceMinsUsed: 0, _voiceSpeed: null, _voiceChoice: null, _voiceLang: 'en-US'
};

// -- INIT ----------------------------------------------------------------------
(function _initOnReady() { function _doInit() {
  // Show login modal if OAuth returned an error (e.g. user cancelled)
  if (window.__oauthErrorMsg) {
    setTimeout(function() {
      showModal('login');
      var _em = document.querySelector('#login-modal .error-msg, .login-error, #oauth-error');
      if (_em) { _em.textContent = window.__oauthErrorMsg; _em.style.display = 'block'; }
      window.__oauthErrorMsg = null;
    }, 500);
    return;
  }

  // -- PASSWORD RECOVERY CALLBACK -----------------------------------------
  // Supabase sends recovery links with #access_token=...&type=recovery
  // Some versions use query params instead of hash fragments
  var hash = window.location.hash;
  var searchParams = new URLSearchParams(window.location.search);
  var _recoveryDetected = false;

  // Check hash fragment (most common)
  if (hash && hash.includes('access_token') && hash.includes('type=recovery')) {
    var rParams = {};
    hash.replace('#','').split('&').forEach(function(pair) {
      var kv = pair.split('='); rParams[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]||'');
    });
    if (rParams.access_token) {
      S._recoveryToken = rParams.access_token;
      _recoveryDetected = true;
    }
  }
  // Check query params fallback
  if (!_recoveryDetected && searchParams.get('type') === 'recovery' && searchParams.get('access_token')) {
    S._recoveryToken = searchParams.get('access_token');
    _recoveryDetected = true;
  }
  // Also check for Supabase PKCE flow: ?code=...&type=recovery (newer Supabase versions)
  if (!_recoveryDetected && searchParams.get('type') === 'recovery' && searchParams.get('code')) {
    // Exchange code for session first
    S._recoveryCode = searchParams.get('code');
    _recoveryDetected = true;
  }

  if (_recoveryDetected) {
    history.replaceState(null, '', window.location.pathname);
    // If we have a code (PKCE), exchange it first
    if (S._recoveryCode) {
      window.fetch(API + '/auth/exchange-recovery-code', {
        method: 'POST', headers: {'Content-Type':'application/json'},
        body: JSON.stringify({ code: S._recoveryCode })
      }).then(function(r) { return r.json(); }).then(function(d) {
        if (d.access_token) { S._recoveryToken = d.access_token; showModal('reset-password'); }
        else { showModal('forgot'); }
      }).catch(function() { showModal('forgot'); });
    } else {
      setTimeout(function() { showModal('reset-password'); }, 300);
    }
  }
  // -- END RECOVERY CALLBACK ---------------------------------------------

  // -- STRIPE CHECKOUT RETURN HANDLER --
  (function() {
    var _up = searchParams.get('upgraded');
    var _can = searchParams.get('upgrade_cancelled');
    var _sid = searchParams.get('session_id');
    if (_up || _can) history.replaceState(null, '', window.location.pathname);
    if (_can) { setTimeout(function(){ showUpgrade(null,'Checkout was cancelled. Choose a plan when ready.'); }, 800); return; }
    if (_up) {
      // Wait for auth token then verify session & activate plan
      function _doVerify() {
        if (!S.token) return; // auth not ready yet
        _showPaymentThankYou(_up.charAt(0).toUpperCase() + _up.slice(1));
        if (!_sid) { _syncPlan(); return; }
        window.fetch(API + '/profile/verify-session', {
          method: 'POST',
          headers: {'Content-Type':'application/json','Authorization':'Bearer '+S.token},
          body: JSON.stringify({ session_id: _sid })
        }).then(function(r){ return r.json(); })
          .then(function(d) {
            console.log('[EOH] verify-session:', d);
            _syncPlan();
          }).catch(function(e) {
            console.error('[EOH] verify-session error:', e);
            _syncPlan();
          });
      }
      function _syncPlan() {
        if (!S.token) return;
        window.fetch(API + '/profile/subscription', { headers:{'Authorization':'Bearer '+S.token} })
          .then(function(r){ return r.json(); })
          .then(function(d) {
            if (d.subscription && d.subscription.plan) {
              if (S.user) S.user.plan = d.subscription.plan;
            }
            // CRITICAL: sync usage from server so reset (0s) are detected and applied
            if (typeof syncUsageFromServer === 'function') {
              syncUsageFromServer().then(function() {
                if (typeof updateLimits === 'function') updateLimits();
              });
            } else if (typeof updateLimits==='function') updateLimits();
          }).catch(function(){});
      }
      // Poll until S.token is available (auth loads async)
      var _authWait = 0;
      var _authPoll = setInterval(function() {
        _authWait += 500;
        if (S.token || _authWait > 15000) {
          clearInterval(_authPoll);
          _doVerify();
        }
      }, 500);
    }
  })();
  // -- END STRIPE CHECKOUT RETURN HANDLER --

  // -- OAUTH CALLBACK HANDLER -----------------------------------------------
  // Check __oauthSession as fallback — in case __oauthCallback was cleared
  // before _initOnReady ran (race condition on fast connections)
  // Fallback: detect OAuth return directly from URL (in case page_erp-chat.liquid
  // didn't set __oauthCallback before eoh-chat.js ran)
  if (!window.__oauthCallback && !window.__oauthSession) {
    var _sp = new URLSearchParams(window.location.search);
    var _h  = window.location.hash || '';
    if ((_sp.get('code') && !_sp.get('type')) || _h.includes('access_token')) {
      window.__oauthCallback = true;
      // Capture session if not already listening
      if (_supabase && !window.__oauthSession) {
        _supabase.auth.onAuthStateChange(function(ev, sess) {
          if ((ev === 'SIGNED_IN' || ev === 'TOKEN_REFRESHED') && sess) {
            window.__oauthSession = sess;
          }
        });
        setTimeout(function() {
          _supabase.auth.getSession().then(function(r) {
            if (r.data && r.data.session && !window.__oauthSession) {
              window.__oauthSession = r.data.session;
            }
          });
        }, 500);
      }
    }
  }
  var _isOAuthReturn = !_recoveryDetected && (window.__oauthCallback || window.__oauthSession);
  if (_isOAuthReturn) {
    window.__oauthCallback = false;
    history.replaceState(null, '', window.location.pathname);
    function _processOAuthSession(session) {
      if (!session || !session.access_token) {
        showModal('login');
        setTimeout(function(){ var e=document.getElementById('m-err'); if(e) e.textContent='Sign-in failed. Please try again.'; }, 300);
        return;
      }
      window.fetch(API + '/auth/oauth/callback', {
        method:'POST', headers:{'Content-Type':'application/json'},
        credentials: 'include',
        body: JSON.stringify({ access_token: session.access_token, refresh_token: session.refresh_token||'' })
      }).then(function(r){ return r.json(); }).then(function(d) {
        if (d.user && d.token) {
          // Ensure avatar fields are preserved in S.user
          if (d.user.avatar) { d.user.avatar_url = d.user.avatar_url || d.user.avatar; }
          S.user=d.user; S.token=d.token;
          localStorage.setItem('eoh_t', d.token);
          localStorage.setItem('eoh_t_ts', String(Date.now())); // FIX1: mark token as fresh so updateUserUI skips immediate refresh
          if (d.refresh_token) localStorage.setItem('eoh_rt', d.refresh_token);
          localStorage.setItem('eoh_u', JSON.stringify(d.user));
          // NOTE: clear-cookie is intentionally NOT called here.
          // /auth/oauth/callback already manages the httpOnly cookie lifecycle.
          // Calling clear-cookie after oauth/callback would wipe the new cookie.
          if (checkAndShowBlock(d.user)) return;
          // Mark as fresh OAuth login so the refresh skip survives the reload
          try { localStorage.setItem('eoh_oauth_fresh', String(Date.now())); } catch(_) {}
          // Reload for clean state — token is in localStorage, URL is already clean
          window.location.reload();
          return;
        } else {
          var um=(session.user&&session.user.user_metadata)||{};
          S.token=session.access_token;
          S.user={id:session.user.id, email:session.user.email, name:um.full_name||um.name||session.user.email.split('@')[0], plan:'free', avatar:um.avatar_url||um.picture||null};
          localStorage.setItem('eoh_t', S.token);
          localStorage.setItem('eoh_u', JSON.stringify(S.user));
          syncUsageFromServer(); updateUserUI();
        }
      }).catch(function() {
        var um=(session.user&&session.user.user_metadata)||{};
        S.token=session.access_token;
        S.user={id:session.user.id, email:session.user.email, name:um.full_name||um.name||session.user.email.split('@')[0], plan:'free'};
        localStorage.setItem('eoh_t', S.token);
        localStorage.setItem('eoh_u', JSON.stringify(S.user));
        syncUsageFromServer(); updateUserUI();
      });
    }
    if (window.__oauthSession) {
      _processOAuthSession(window.__oauthSession);
    } else {
      // If existing session arrived via onAuthStateChange, process it properly
      // (handles account switching — B logging in while A is logged in)
      // Only take silent path if session is genuinely not available yet
      // Clear old session — handles both first login and account switching
      localStorage.removeItem('eoh_t');
      localStorage.removeItem('eoh_rt');
      localStorage.removeItem('eoh_u');
      localStorage.removeItem('eoh_oauth_fresh');
      window.__oauthExistingSession = false;

      // Wait for new session from onAuthStateChange or getSession
      var _pc=0, _pt=setInterval(function(){
        _pc++;
        if (window.__oauthSession) {
          clearInterval(_pt);
          _processOAuthSession(window.__oauthSession);
        } else if (_pc >= 150) {
          clearInterval(_pt);
          _supabase.auth.getSession().then(function(r) {
            var sess = r.data && r.data.session;
            if (sess && sess.access_token && (sess.expires_at * 1000) > Date.now()) {
              _processOAuthSession(sess);
            } else {
              showModal('login');
              setTimeout(function() {
                var e = document.getElementById('m-err');
                if (e) e.textContent = 'Sign-in failed. Please try again.';
              }, 300);
            }
          }).catch(function() { showModal('login'); });
        }
      }, 100);
    }
  }
  // -- END OAUTH CALLBACK ---------------------------------------------------

  // Record page load time — used to detect server-side usage resets
  window._eohPageLoadTime = new Date().toISOString();

  // Track page visit (fire-and-forget — don't await, never block UI)
  window.fetch(API + '/auth/track-visit', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + (localStorage.getItem('eoh_t') || '') },
  }).catch(function(){});

  // Load all voice settings from admin app-settings
  window._voiceSilenceMs       = 2000;
  window._voiceEndSilenceMs    = 1400;   // streaming: sustained silence (ms) before the turn ends
  window._voiceMinSpeechMs     = 1000;
  (function(){
    var _sv = localStorage.getItem('eoh_chat_lang') || 'en-US';
    var _lm = {'en-US':'EN','ar-SA':'AR','es-ES':'ES','fr-FR':'FR','de-DE':'DE','pt-BR':'PT','ru-RU':'RU','zh-CN':'ZH','ja-JP':'JA','ko-KR':'KO','tr-TR':'TR','hi-IN':'HI','it-IT':'IT','nl-NL':'NL'};
    setTimeout(function(){
      var vbLbl=document.getElementById('vb-lang-pill-lbl'); if(vbLbl) vbLbl.textContent=_lm[_sv]||'EN';
      var sel=document.getElementById('lang-select'); if(sel) sel.value=_sv;
      document.querySelectorAll('.lang-opt').forEach(function(b){ b.classList.toggle('lang-opt-active', b.dataset.val===_sv); });
      S._chatLang=_sv; S._voiceLang=_sv;
    }, 400);
  })();
  window._voiceVolumeThreshold = 8;      // VAD sensitivity
  window._voiceDefaultSpeed    = 1.0;    // playback speed
  window._voiceDefaultVoice    = 'Kore'; // Gemini voice name
  window._voiceChunkMaxChars   = 4800;   // max chars per TTS chunk
  window._voiceEnabled         = true;   // global voice on/off
  window._voiceReplyMaxChars   = 1500;   // max chars read aloud in voice conversation

// =============================================================================
// CAPTCHA WIDGET — Cloudflare Turnstile
// =============================================================================
window._captchaToken = '';

function _showCaptchaWidget() {
  var siteKey = window._captchaSiteKey;
  if (!siteKey) return;
  // Inject Turnstile script if not already loaded
  if (!document.getElementById('cf-turnstile-script')) {
    var s = document.createElement('script');
    s.id  = 'cf-turnstile-script';
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
    s.async = true;
    document.head.appendChild(s);
  }
  // Find or create captcha container in auth form
  var existing = document.getElementById('captcha-container');
  if (existing) { existing.style.display = 'block'; return; }
  var authForm = document.getElementById('auth-form') || document.getElementById('login-form') || document.querySelector('.auth-form');
  if (!authForm) return;
  var container = document.createElement('div');
  container.id = 'captcha-container';
  container.style.cssText = 'margin:12px 0;display:flex;justify-content:center';
  container.innerHTML = '<div class="cf-turnstile" data-sitekey="' + siteKey + '" data-callback="_onCaptchaSuccess" data-theme="dark"></div>';
  // Insert before the submit button
  var submitBtn = authForm.querySelector('button[type=submit]') || authForm.querySelector('.signin-btn') || authForm.lastElementChild;
  authForm.insertBefore(container, submitBtn);
}

function _onCaptchaSuccess(token) {
  window._captchaToken = token;
}


  window._voiceLiveMaxChars    = 2000;   // max chars read aloud in live screen TTS
  window._bannerEnabled        = false;  // site banner overlay

  // Apply admin-configured chat-input box appearance to #chat-ta. Safe to call any time
  // (no-op until both the settings and the textarea exist); re-applied after the chat UI
  // builds so it survives re-renders.
  window.applyChatInputSettings = function applyChatInputSettings() {
    var cfg = window._chatTa; if (!cfg) return;
    var ta = document.getElementById('chat-ta'); if (!ta) return;
    ta.style.minHeight = cfg.minH + 'px';
    ta.style.maxHeight = cfg.maxH + 'px';
    ta.style.overflowY = 'auto';            // scroll once it hits max height
    ta.style.fontSize  = cfg.font + 'px';
    ta.style.lineHeight = String(cfg.line);
    if (cfg.ph) ta.placeholder = cfg.ph;
  };

  window.fetch(API + '/admin/app-settings')
    .then(function(r){ return r.json(); })
    .then(function(d){
      var s = d.settings || {};
      var _int = function(v, min, max, def) { var n = parseInt(v||def,10); return (!isNaN(n)&&n>=min&&n<=max) ? n : def; };
      var _flt = function(v, def) { var n = parseFloat(v||def); return !isNaN(n) ? n : def; };
      window._voiceSilenceMs       = _int(s.voice_silence_ms,       500, 10000, 2000);
      window._voiceMinSpeechMs     = _int(s.voice_min_speech_ms,    200, 3000, 1000);
      window._voiceVolumeThreshold = _int(s.voice_volume_threshold,   1,   30,    8);
      window._voiceDefaultSpeed    = _flt(s.voice_default_speed,     1.0);
      window._voiceDefaultVoice    = s.voice_default_voice || 'Kore';
      window._voiceChunkMaxChars   = _int(s.voice_chunk_max_chars,  500,   9000, 4800);
      window._voiceEnabled         = s.voice_enabled !== 'false';
      window._voiceReplyMaxChars   = _int(s.voice_reply_max_chars, 200,  20000, 1500);
      window._voiceLiveMaxChars    = _int(s.voice_live_max_chars,  200,  20000, 2000);
      // Site banner overlay
      window._bannerEnabled = s.banner_enabled === 'true';
      window._captchaEnabled  = s.captcha_enabled !== 'false';
      window._captchaSiteKey  = s.captcha_site_key || '';
      window._ratingsEnabled  = s.ratings_enabled !== 'false';
      // Guest message limit — loaded from app_settings
      window._guestMessageLimit = parseInt(s.guest_message_limit || '3', 10);
      // ERP selection: if false, users can skip vendor selection and chat freely
      window._erpSelectionRequired = s.erp_selection_required !== 'false';
      // Session inactivity timeout (minutes; 0 = disabled)
      window._sessionTimeoutMins = parseInt(s.session_timeout_mins  || '720', 10);
      window._sessionWarningMins = parseInt(s.session_warning_mins  || '5',  10);
      // Welcome message — admin-editable, supports {name}/{vendor}/{product} tokens
      window._welcomeMessage = s.welcome_message || '';
      // Welcome chips — JSON array of {label, q} objects
      try { window._welcomeChips = s.welcome_chips_json ? JSON.parse(s.welcome_chips_json) : null; }
      catch(_) { window._welcomeChips = null; }
      // Chat input textarea appearance (admin-configurable in Technical Settings → 💬 Chat Input Textarea)
      window._chatTa = {
        minH: _int(s.chat_ta_min_height,  24,  200, 24),
        maxH: _int(s.chat_ta_max_height,  60,  600, 160),
        font: _int(s.chat_ta_font_size,   11,  22,  14),
        line: _flt(s.chat_ta_line_height, 1.65),
        ph:   (s.chat_ta_placeholder || '').trim()
      };
      try { applyChatInputSettings(); } catch(_) {}
      // Top voice languages — comma-separated codes shown before "More" toggle
      window._voiceTopLanguages = s.voice_top_languages || 'en,ar,es,fr,de';
      // Sync localStorage flag with DB setting
      try {
        localStorage.setItem('eoh_ratings_off', window._ratingsEnabled ? '0' : '1');
      } catch(_) {}
      // Hide bar immediately if disabled
      if (!window._ratingsEnabled) {
        var _rb = document.getElementById('eoh-rating-bar');
        if (_rb) _rb.style.display = 'none';
      }
      if (window._bannerEnabled) {
        showSiteBanner({ type: s.banner_type||'maintenance', title: s.banner_title||'', subtitle: s.banner_subtitle||'', logo: s.banner_logo||'', back: s.banner_back||'', email: s.banner_email||'', bg: s.banner_bg||'dark' });
      }
      // Hide mic button if voice disabled globally
      if (!window._voiceEnabled) {
        ['voice-btn','vi-bar','voice-bar','voice-input-bar'].forEach(function(id){
          var el = document.getElementById(id);
          if (el) el.style.display = 'none';
        });
      }
    }).catch(function(){});

  var t = localStorage.getItem('eoh_t');
  var u = localStorage.getItem('eoh_u');
  // On OAuth callback skip restoring old session — inline script already cleared tokens
  if (t && u && !window.__oauthCallback) {
    S.token = t;
    try { S.user = JSON.parse(u); } catch(e) {}
    // Show block overlay immediately if was-blocked in localStorage
    if (S.user && S.user.isBlocked) {
      setTimeout(function(){ showBlockedModal(S.user ? (S.user.blockReason || null) : null); }, 200);
    }
    // Plan-expiry locking is decided by the authoritative server sync below (syncUsageFromServer),
    // NOT from cached localStorage — a stale cached "expired" status was flashing the banner on
    // every refresh for active users. The immediate sync on load handles genuine expiry.
    // Always force an immediate sync on page load — server is authoritative for block status
    // Load per-user usage cache immediately so bar shows last-known values
    loadUsageFromCache();
    updateUserUI();
    var lb = document.getElementById('limits-bar');
    if (lb) lb.classList.add('on');
    updateLimits();
    // syncUsageFromServer is called inside _origUpdateUserUI patch above — no duplicate
  }
  document.getElementById('new-btn').addEventListener('click', resetChat);
  document.getElementById('send-btn').addEventListener('click', sendMsg);
  document.getElementById('chat-ta').addEventListener('keydown', function(e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMsg(); }
    if (e.key === 'Escape') { _closeSlashMenu(); }
    // Arrow keys to navigate slash menu
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      var menu = document.getElementById('slash-menu');
      if (menu) {
        e.preventDefault();
        var items = menu.querySelectorAll('.slash-item');
        var cur = menu.querySelector('.slash-item.active');
        var idx = cur ? Array.from(items).indexOf(cur) : -1;
        if (e.key === 'ArrowDown') idx = Math.min(idx + 1, items.length - 1);
        else idx = Math.max(idx - 1, 0);
        items.forEach(function(it) { it.classList.remove('active'); });
        if (items[idx]) { items[idx].classList.add('active'); items[idx].scrollIntoView({ block: 'nearest' }); }
      }
    }
    if (e.key === 'Tab') {
      var menu2 = document.getElementById('slash-menu');
      if (menu2) {
        e.preventDefault();
        var active = menu2.querySelector('.slash-item.active') || menu2.querySelector('.slash-item');
        if (active) active.click();
      }
    }
  });
  document.getElementById('chat-ta').addEventListener('input', function() {
    _handleSlashInput(this.value);
  });
  document.getElementById('chat-ta').addEventListener('paste', function(e) {
    var items = (e.clipboardData || {}).items || [];
    var imageFiles = [];
    for (var i = 0; i < items.length; i++) { if (items[i].type.indexOf('image') !== -1) { var b = items[i].getAsFile(); if (b) imageFiles.push(b); } }
    if (imageFiles.length) { e.preventDefault(); var dt = new DataTransfer(); imageFiles.forEach(function(f) { dt.items.add(f); }); handleMultiImages({ target: { files: dt.files, value: '' } }); }
  });
  document.getElementById('chat-ta').addEventListener('input', function() {
    this.style.height = 'auto';
    this.style.height = Math.min(this.scrollHeight, 160) + 'px';
  });
  document.getElementById('start-btn').addEventListener('click', function() {
    if (!S.user) { S._pendingStartChat = true; showModal('login'); return; }
    // If ERP selection not required, allow chat even without vendor selected
    if (window._erpSelectionRequired !== false && (!S.vendor || !S.product)) return;
    startChat();
  });
} if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',_doInit);}else{_doInit();} })();

// Load ERP systems from DB on page ready
document.addEventListener('DOMContentLoaded', function() { loadErpSystems(); });

// -- SIDEBAR -------------------------------------------------------------------
function openSidebar() {
  document.getElementById('sidebar').classList.add('open');
  document.getElementById('sb-overlay').classList.add('on');
}
function closeSidebar() {
  document.getElementById('sidebar').classList.remove('open');
  document.getElementById('sb-overlay').classList.remove('on');
}
var _sbCollapsed = false;
function toggleSidebar() {
  _sbCollapsed = !_sbCollapsed;
  var sb   = document.getElementById('sidebar');
  var rail = document.getElementById('sb-rail');
  var btn  = document.getElementById('sb-toggle-btn');
  if (_sbCollapsed) {
    if (sb)   sb.classList.add('collapsed');
    if (rail) rail.classList.add('on');
    if (btn)  btn.title = 'Open sidebar';
    _syncRailAvatar();
  } else {
    if (sb)   sb.classList.remove('collapsed');
    if (rail) rail.classList.remove('on');
    if (btn)  btn.title = 'Close sidebar';
  }
  try { localStorage.setItem('eoh_sb_collapsed', _sbCollapsed ? '1' : '0'); } catch(_) {}
}
function _syncRailAvatar() {
  // Mirror the sidebar avatar into the rail avatar
  var src  = document.getElementById('uav');
  var dest = document.getElementById('rail-uav');
  if (!src || !dest) return;
  dest.innerHTML  = src.innerHTML;
  dest.style.background = src.style.background;
  dest.style.color      = src.style.color;
}
// Restore sidebar state on load — must wait for DOM and requires sb-rail to exist
document.addEventListener('DOMContentLoaded', function() {
  try {
    if (localStorage.getItem('eoh_sb_collapsed') === '1') {
      var sb   = document.getElementById('sidebar');
      var rail = document.getElementById('sb-rail');
      var btn  = document.getElementById('sb-toggle-btn');
      // Only collapse if the rail exists — prevents collapsing when old liquid is deployed
      if (sb && rail) {
        _sbCollapsed = true;
        sb.classList.add('collapsed');
        rail.classList.add('on');
        if (btn) btn.title = 'Open sidebar';
        setTimeout(_syncRailAvatar, 500);
      } else {
        // Rail not present — reset the stored preference so next load is normal
        localStorage.removeItem('eoh_sb_collapsed');
      }
    }
  } catch(_) {}
});

// -- THEME TOGGLE (3 themes: dark → light → warm → dark) ---------------------
var _themes = ['dark', 'light', 'warm'];
var _themeLabels = ['Dark (Default)', 'Light Mode', 'Warm Mode'];
var _themeIdx = 0;
function cycleTheme() {
  document.documentElement.classList.remove('light', 'warm');
  _themeIdx = (_themeIdx + 1) % _themes.length;
  if (_themes[_themeIdx] !== 'dark') document.documentElement.classList.add(_themes[_themeIdx]);
  document.getElementById('theme-label').textContent = _themeLabels[_themeIdx];
  localStorage.setItem('eoh_theme', _themes[_themeIdx]);
  _reapplyAvatarLogos();
}
// Re-point already-rendered AI avatars + stream cursor to the current theme's logo
// (the page keeps #main-logo swapped per theme; we mirror it after the class change).
function _reapplyAvatarLogos() {
  setTimeout(function() {
    var ml = document.getElementById('main-logo');
    var url = (ml && ml.src && ml.src.length > 10 && ml.src !== window.location.href)
      ? ml.src
      : (window._getLogoSrc ? window._getLogoSrc() : '');
    if (!url) return;
    window._eohCursorSrc = url;
    document.querySelectorAll('.msg.assistant .mav img, .stream-cursor img').forEach(function(img){
      if (img.src !== url) img.src = url;
    });
  }, 60);
}
// Called by the profile modal theme select
function _pfApplyTheme(idxStr) {
  var idx = parseInt(idxStr) || 0;
  _themeIdx = idx;
  document.documentElement.classList.remove('light', 'warm');
  if (_themes[idx] !== 'dark') document.documentElement.classList.add(_themes[idx]);
  var lbl = document.getElementById('theme-label');
  if (lbl) lbl.textContent = _themeLabels[idx];
  localStorage.setItem('eoh_theme', _themes[idx]);
  _reapplyAvatarLogos();
}
(function() {
  var saved = localStorage.getItem('eoh_theme');
  if (saved && saved !== 'dark') {
    document.documentElement.classList.add(saved);
    _themeIdx = _themes.indexOf(saved);
    if (_themeIdx < 0) _themeIdx = 0;
    var lbl = document.getElementById('theme-label');
    if (lbl) lbl.textContent = _themeLabels[_themeIdx];
  }
})();

// -- FONT SETTINGS ----------------------------------------------------------
function setFontSize(size) {
  size = parseInt(size) || 14;
  document.getElementById('msgs').style.fontSize = size + 'px';
  document.querySelector('.chat-ta').style.fontSize = size + 'px';
  localStorage.setItem('eoh_font_size', size);
}
function setFontFamily(family) {
  var fonts = {
    'default': '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    'serif': 'Georgia, "Times New Roman", serif',
    'mono': '"Fira Code", "Cascadia Code", "Courier New", monospace',
    'dyslexic': '"OpenDyslexic", "Comic Sans MS", sans-serif'
  };
  document.getElementById('msgs').style.fontFamily = fonts[family] || fonts['default'];
  localStorage.setItem('eoh_font_family', family);
}
(function() {
  var fs = localStorage.getItem('eoh_font_size');
  var ff = localStorage.getItem('eoh_font_family');
  if (fs) { setFontSize(fs); var sel = document.getElementById('font-size-sel'); if (sel) sel.value = fs; }
  if (ff) { setFontFamily(ff); var sel2 = document.getElementById('font-family-sel'); if (sel2) sel2.value = ff; }
})();

// -- ERP SELECTS ---------------------------------------------------------------
function populateProducts(vendor) {
  S.vendor = vendor;
  S.product = null;
  try { if (vendor) localStorage.setItem('eoh_last_vendor', vendor); } catch(e){}
  document.getElementById('start-btn').disabled = true;
  var ps = document.getElementById('ps');
  ps.innerHTML = '<option value="">-- Product --</option>';
  if (vendor && PRODUCTS[vendor]) {
    PRODUCTS[vendor].forEach(function(p) {
      var o = document.createElement('option');
      o.value = p; o.textContent = p;
      ps.appendChild(o);
    });
    ps.removeAttribute('disabled');
  } else {
    ps.setAttribute('disabled', 'disabled');
  }
}

function selectProduct(val) {
  S.product = val;
  try { if (val) localStorage.setItem('eoh_last_product', val); } catch(e){}
  // Only disable start btn if ERP selection is required
  if (window._erpSelectionRequired !== false) {
    document.getElementById('start-btn').disabled = !val;
  }
}

// -- CHAT ----------------------------------------------------------------------
// ── ERP product profiles (welcome chips + sidebar) ──
// ════════════════════════════════════════════════════════════════════════════
// ERP PRODUCT TECH-STACK PROFILES  —  single source of truth
// Keep this block IDENTICAL in routes/chat.js (AI scope line) and
// assets/eoh-chat.js (welcome chips + sidebar). It exists so the UI and the AI
// use the CORRECT vocabulary per product — e.g. never "ABAP/SPRO" for a cloud
// product like SuccessFactors, which is XML data models, Business Rules & MDF.
//
// Fields:  cfg = configuration term · dev = build/extend term · sec = security term
//          scr = has transaction/screen-style navigation worth screenshotting
//          dom = the accurate domain sentence injected into the AI system prompt
//
// Matching: most-specific first, substring match against (vendor + ' ' + product)
// lowercased. Unmatched products fall back to a vendor-level entry, then neutral.
// ════════════════════════════════════════════════════════════════════════════
var ERP_PROFILES = [
  // ─────────────────────────────  SAP  ──────────────────────────────────────
  { k:['s/4hana','s4hana','s/4','ecc','r/3','sap erp','sap fico','sap fi','sap co','sap mm','sap sd','sap pp','sap wm','sap ewm','sap ps','sap pm','sap qm','sap le','sap hcm on'],
    cfg:'SPRO configuration', dev:'ABAP development', sec:'Roles & authorizations (PFCG)', scr:true,
    dom:'SPRO/IMG configuration, transaction codes, Fiori apps, ABAP, CDS views, IDocs and BAPIs, data migration (LSMW/LTMC) and authorizations (PFCG)' },
  { k:['successfactors','employee central','sf ec','sap hxm','hcm cloud'],
    cfg:'Business Rules & MDF', dev:'XML data models & integrations', sec:'Role-Based Permissions (RBP)', scr:false,
    dom:'XML data models (Succession & Corporate Data Model), Business Rules, the Metadata Framework (MDF), Picklists, Integration Center and Role-Based Permissions in Admin Center — NOT ABAP, SPRO or transaction codes' },
  { k:['ariba'],
    cfg:'Realm & workspace setup', dev:'Cloud Integration Gateway (CIG)', sec:'Groups & permissions', scr:false,
    dom:'realm configuration, guided buying, sourcing & contract workspaces, supplier and Ariba Network setup, and integration via the Cloud Integration Gateway (CIG)' },
  { k:['concur'],
    cfg:'Group configurations', dev:'Web Services & APIs', sec:'Roles & permissions', scr:false,
    dom:'expense, travel and invoice configuration, group configurations, audit rules, workflow and the Concur Web Services / APIs' },
  { k:['fieldglass'],
    cfg:'VMS configuration', dev:'Integrations & connectors', sec:'Roles & user groups', scr:false,
    dom:'Vendor Management System (VMS) configuration, contingent-workforce and services-procurement workflows, and integrations' },
  { k:['business one','sap b1'],
    cfg:'Company & module setup', dev:'SDK, Formatted Searches & UDFs', sec:'Authorizations', scr:true,
    dom:'company configuration, user-defined fields and tables, Formatted Searches, the SAP B1 SDK/DI-API and SQL queries' },
  { k:['bydesign','byd'],
    cfg:'Business Configuration', dev:'Cloud Application Studio (PDI)', sec:'Access & work centers', scr:false,
    dom:'Business Configuration scoping, key-user tooling and the Cloud Application Studio (PDI) for extensions' },
  { k:['btp','business technology platform','cloud platform','hana cloud'],
    cfg:'Subaccount & service setup', dev:'CAP, RAP & CDS', sec:'Roles & role collections', scr:false,
    dom:'BTP subaccounts and services, the Cloud Application Programming model (CAP), the ABAP RESTful model (RAP), CDS, and role collections' },
  { k:['analytics cloud','sac'],
    cfg:'Models & stories', dev:'Data actions & scripting', sec:'Roles & teams', scr:false,
    dom:'SAC models, stories, data actions, planning and analytic applications with scripting' },
  { k:['ibp','integrated business planning'],
    cfg:'Planning area setup', dev:'Operators & Excel add-in', sec:'Roles & visibility', scr:false,
    dom:'planning areas, time profiles, planning operators, the IBP Excel add-in and supply/demand planning' },
  { k:['hybris','sap commerce','commerce cloud'],
    cfg:'Type system & catalogs', dev:'Java, Spring & ImpEx', sec:'User groups & rights', scr:false,
    dom:'the SAP Commerce type system, catalogs, ImpEx, Java/Spring extensions and storefront configuration' },
  { k:['datasphere','bw/4','bw4','sap bw'],
    cfg:'Data modeling', dev:'CDS & data flows', sec:'Analysis authorizations', scr:false,
    dom:'data modeling, CDS views, data flows/transformations and analysis authorizations' },
  { k:['sap'], // any other SAP product — generic on-prem default
    cfg:'Configuration (IMG)', dev:'ABAP / extensions', sec:'Authorizations', scr:true,
    dom:'configuration, transaction codes, ABAP/extensions, integration, data migration and authorizations' },

  // ────────────────────────────  ORACLE  ────────────────────────────────────
  { k:['fusion','oracle cloud','oracle erp cloud','oracle hcm cloud','oracle scm cloud','redwood'],
    cfg:'Functional Setup Manager (FSM)', dev:'Fast Formulas & BI Publisher', sec:'Roles & data security', scr:false,
    dom:'the Functional Setup Manager (FSM), offerings and setup tasks, Fast Formulas, BI Publisher & OTBI reporting, HCM/Data loaders and role-based data security' },
  { k:['e-business','ebs','oracle apps','oracle 11i','oracle r12'],
    cfg:'Application setup', dev:'PL/SQL, Forms & Workflow', sec:'Responsibilities & AOL', scr:true,
    dom:'application setup, PL/SQL, Oracle Forms & Reports, Workflow, concurrent programs and responsibilities (AOL security)' },
  { k:['netsuite'],
    cfg:'SuiteBuilder setup', dev:'SuiteScript & SuiteFlow', sec:'Roles & permissions', scr:false,
    dom:'SuiteBuilder customization, saved searches, SuiteScript, SuiteFlow workflows and role-based permissions' },
  { k:['jd edwards','jde','enterpriseone','jde world'],
    cfg:'Application setup', dev:'C / NER event rules', sec:'Security Workbench', scr:true,
    dom:'EnterpriseOne application setup, table/business-view design, C and Named Event Rules (NER), OMW and the Security Workbench' },
  { k:['peoplesoft','peopletools'],
    cfg:'Setup & configuration', dev:'PeopleCode & App Engine', sec:'Permission lists & roles', scr:true,
    dom:'PeopleTools configuration, Application Designer, PeopleCode, App Engine, Component Interfaces and permission lists/roles' },
  { k:['primavera','p6'],
    cfg:'EPS / project setup', dev:'Global change & API', sec:'Security profiles', scr:false,
    dom:'the EPS/WBS, activities, resource and cost loading, scheduling, levelling and project controls' },
  { k:['hyperion','essbase','epm','planning and budgeting','pbcs','epbcs'],
    cfg:'Application & dimensions', dev:'Calc scripts & business rules', sec:'Access permissions', scr:false,
    dom:'EPM applications, dimensions, calc scripts and business rules, Smart View and consolidation/planning logic' },
  { k:['taleo'],
    cfg:'Recruiting configuration', dev:'Integrations (TCC)', sec:'User types & roles', scr:false,
    dom:'recruiting and onboarding configuration, requisition/candidate workflows and integrations (Taleo Connect Client)' },
  { k:['oracle'], // any other Oracle product
    cfg:'Functional setup', dev:'PL/SQL / extensions', sec:'Roles & security', scr:false,
    dom:'functional setup, PL/SQL or cloud extensions, reporting, integrations and role-based security' },

  // ──────────────────────────  MICROSOFT  ───────────────────────────────────
  { k:['finance and operations','finance & operations','f&o','d365 fo','dynamics ax','dynamics 365 finance','dynamics 365 supply'],
    cfg:'D365 F&O configuration', dev:'X++ development', sec:'Roles, duties & privileges', scr:true,
    dom:'D365 Finance & Operations setup, the AOT, X++, data entities, Electronic Reporting and role/duty/privilege security' },
  { k:['business central','dynamics nav','navision','d365 bc'],
    cfg:'Assisted setup', dev:'AL extensions', sec:'Permission sets', scr:true,
    dom:'Business Central assisted setup, the AL language and extensions, report layouts and permission sets' },
  { k:['customer engagement','dynamics crm','d365 ce','dynamics 365 sales','dynamics 365 customer'],
    cfg:'Model-driven app setup', dev:'Power Platform & plugins', sec:'Security roles', scr:false,
    dom:'Dataverse and model-driven app configuration, Power Automate flows, C# plug-ins and security roles' },
  { k:['great plains','dynamics gp'],
    cfg:'Module setup', dev:'Dexterity & SQL', sec:'Security tasks & roles', scr:true,
    dom:'Dynamics GP module setup, Dexterity/SQL customization, SmartLists and security tasks/roles' },
  { k:['power platform','power apps','power automate','dataverse'],
    cfg:'Environment & tables', dev:'Power Fx & flows', sec:'Security roles', scr:false,
    dom:'Dataverse tables, model-driven & canvas apps (Power Fx), Power Automate flows and environment security roles' },

  // ──────────────────────────  WORKDAY  ─────────────────────────────────────
  { k:['workday'],
    cfg:'Business Process Framework', dev:'Calculated fields & EIB', sec:'Security groups', scr:false,
    dom:'the Business Process Framework, calculated fields, custom reports (Report Writer), EIB and Workday Studio integrations, and security groups — NOT code or transaction codes' },

  // ──────────────────────────  INFOR  ───────────────────────────────────────
  { k:['infor ln','baan'],
    cfg:'Parameters & sessions', dev:'Tools 4GL & DAL', sec:'Authorizations', scr:true,
    dom:'Infor LN parameters and sessions, Tools 4GL, the Data Access Layer (DAL) and authorizations' },
  { k:['infor m3','lawson m3'],
    cfg:'Configuration (CRS)', dev:'MAK / Java & MEC', sec:'Function & field security', scr:true,
    dom:'Infor M3 configuration, the H5 client, MAK/Java modifications and MEC integrations' },
  { k:['cloudsuite','infor os','infor ion','lawson','syteline','infor csi'],
    cfg:'Configuration & ION', dev:'Mongoose IDOs & BODs', sec:'Roles & security classes', scr:false,
    dom:'Infor CloudSuite configuration, the Mongoose framework and IDOs, ION workflows/BODs and Infor OS' },

  // ────────────────────────  OTHER ERP / SaaS  ──────────────────────────────
  { k:['odoo'],
    cfg:'App & module setup', dev:'Python, OWL & XML views', sec:'Access rights & record rules', scr:false,
    dom:'Odoo app configuration, Python ORM models, OWL/JS, XML views and access rights & record rules — NOT ABAP or transaction codes' },
  { k:['sage x3'],
    cfg:'Parameters & setup', dev:'4GL & entry points', sec:'Function profiles', scr:true,
    dom:'Sage X3 parameters, the 4GL, classes/representations, entry points and function profiles' },
  { k:['sage intacct','intacct'],
    cfg:'Dimensions & setup', dev:'Platform Services & API', sec:'Roles & permissions', scr:false,
    dom:'Sage Intacct dimensions, smart rules/events, Platform Services customization and the API' },
  { k:['sage 50','sage 100','sage 300','sage 200','sage'],
    cfg:'Company & module setup', dev:'Custom reports & SDK', sec:'User roles', scr:true,
    dom:'Sage company and module setup, custom reports and available SDK/customization' },
  { k:['epicor','kinetic'],
    cfg:'Company configuration', dev:'BPM directives & BAQ', sec:'Security groups', scr:true,
    dom:'Epicor Kinetic company configuration, Business Process Management (BPM) directives, Business Activity Queries (BAQ) and customizations' },
  { k:['ifs'],
    cfg:'Configuration & lobbies', dev:'PL/SQL & projections', sec:'Permission sets', scr:true,
    dom:'IFS Cloud configuration, PL/SQL, projection & client metadata (Aurena), lobbies and permission sets' },
  { k:['acumatica'],
    cfg:'Configuration & GIs', dev:'xRP / C# customization', sec:'Roles & access', scr:false,
    dom:'Acumatica configuration, Generic Inquiries, the xRP framework with C#, business events and access roles' },
  { k:['syspro'],
    cfg:'Setup options', dev:'VBScript & e.net', sec:'Operator & role security', scr:true,
    dom:'SYSPRO setup options, customized panes, VBScript customization and the e.net business object library' },
  { k:['deltek','costpoint','maconomy'],
    cfg:'Project ERP setup', dev:'Extensibility & workflow', sec:'Roles & rights', scr:true,
    dom:'project-based ERP configuration, workflow, extensibility and role-based rights' },
  { k:['unit4','agresso','business world'],
    cfg:'Flexi-fields & setup', dev:'Excelerator & workflow', sec:'Roles & access', scr:true,
    dom:'Unit4 flexi-fields and attributes, workflow, the Excelerator and role-based access' },
  { k:['qad'],
    cfg:'Control programs', dev:'Progress 4GL / ABL', sec:'Role permissions', scr:true,
    dom:'QAD control programs, Progress 4GL/ABL, browses and role permissions' },
  { k:['salesforce','apex','lightning'],
    cfg:'Setup & objects', dev:'Apex, LWC & Flows', sec:'Profiles & permission sets', scr:false,
    dom:'Salesforce objects and setup, Apex, Lightning Web Components, Flows, validation rules and profiles/permission sets' },
  { k:['servicenow'],
    cfg:'Tables & modules', dev:'GlideScript & Flow Designer', sec:'ACLs & roles', scr:false,
    dom:'ServiceNow tables, business rules, GlideScript, Flow Designer and ACL/role security' },
  { k:['zoho'],
    cfg:'Module setup', dev:'Deluge & custom functions', sec:'Roles & profiles', scr:false,
    dom:'Zoho module setup, blueprints, Deluge scripting/custom functions and roles & profiles' },
  { k:['dayforce','ceridian'],
    cfg:'Org & pay setup', dev:'Rules & integrations', sec:'Roles', scr:false,
    dom:'Dayforce organization and pay configuration, eligibility/entitlement rules and integrations' },
  { k:['ukg','kronos','workforce'],
    cfg:'WFM configuration', dev:'Rules & integrations', sec:'Roles & profiles', scr:false,
    dom:'workforce-management configuration, pay/accrual rules, scheduling and integrations' },
  { k:['adaptive planning','adaptive insights'],
    cfg:'Sheets & dimensions', dev:'Formulas & integrations', sec:'Access levels', scr:false,
    dom:'Adaptive Planning sheets, dimensions, modeled formulas and integrations' },
  { k:['ramco'],
    cfg:'Configuration', dev:'Custom objects & extensions', sec:'Roles & access', scr:false,
    dom:'Ramco configuration, custom objects/extensions, reporting and role-based access' },
  { k:['priority'],
    cfg:'Forms & setup', dev:'Procedures & business rules', sec:'Roles & permissions', scr:true,
    dom:'Priority ERP forms and setup, procedures, business rules and role permissions' },
  { k:['abas'],
    cfg:'Configuration', dev:'FOP customization', sec:'Access rights', scr:true,
    dom:'abas ERP configuration, FOP customization, infosystems and access rights' }
];

// Resolve the best profile for a vendor/product, with neutral fallback.
function _erpProfile(vendor, product) {
  var s = ((vendor || '') + ' ' + (product || '')).toLowerCase();
  for (var i = 0; i < ERP_PROFILES.length; i++) {
    var p = ERP_PROFILES[i];
    for (var j = 0; j < p.k.length; j++) {
      if (s.indexOf(p.k[j]) >= 0) return p;
    }
  }
  return {
    cfg: 'System configuration', dev: 'Custom development', sec: 'Roles & permissions', scr: false,
    dom: ((vendor || 'ERP') + ' ' + (product || '')).trim() +
         ' configuration, implementation, integrations, data migration, security, reporting and business processes'
  };
}

function _addWelcomeCard(name, vendor, product) {
  var m = document.getElementById('msgs');
  var el = document.createElement('div');
  el.className = 'msg assistant';
  var logoSrc = document.getElementById('main-logo') ? document.getElementById('main-logo').src : '';
  var time = new Date().toLocaleTimeString([],{hour:'2-digit',minute:'2-digit'});
  var _n = name || 'there';
  var _v = vendor || 'ERP';
  var _p = product ? ' · ' + product : '';
  function _pill(prompt, label, cls) {
    var safe = prompt.replace(/&/g,'&amp;').replace(/"/g,'&quot;');
    return '<button onclick="sendMsg_fromWelcome(this.dataset.p)" data-p="' + safe + '" class="wc-pill' + (cls ? ' ' + cls : '') + '">' + label + '</button>';
  }
  function _btn(prompt, label) {
    var safe = prompt.replace(/&/g,'&amp;').replace(/"/g,'&quot;');
    return '<button onclick="sendMsg_fromWelcome(this.dataset.p)" data-p="' + safe + '" class="wc-btn">' + label + ' ↗</button>';
  }
  function _feat(prompt, bg, color, icon, title, sub) {
    var safe = prompt.replace(/&/g,'&amp;').replace(/"/g,'&quot;');
    return '<button onclick="sendMsg_fromWelcome(this.dataset.p)" data-p="' + safe + '" class="wc-feat">'
      + '<span class="wc-feat-icon" style="background:' + bg + ';color:' + color + '">' + icon + '</span>'
      + '<span class="wc-feat-title">' + title + '</span>'
      + '<span class="wc-feat-sub">' + sub + '</span>'
      + '</button>';
  }
    // ── Product-aware pill/button content (driven by _erpProfile) ────────────
  var _prof = _erpProfile(_v, product);
  var hasScreens = _prof.scr;

  var p2label  = _prof.cfg;   // configuration term, correct per product
  var p3label  = _prof.sec;   // security term
  var p4label  = _prof.dev;   // build/extend term (XML for SF, ABAP for ECC, X++ for D365 F&O …)
  var p6label  = 'Go-live support';

  var b3label  = hasScreens ? 'Show system screens' : 'Show me best practices';
  var b3prompt = hasScreens ? ('Show me ' + _v + ' ' + (product||'') + ' screens') : ('What are the best practices for ' + _v + ' ' + (product||''));

  var card = '<div style="padding:4px 0">'
    + '<p style="margin:0 0 2px;font-size:17px;font-weight:500;color:var(--text)">Hello, <span style="color:var(--gl)">' + _n + '</span> 👋</p>'
    + '<p style="margin:0 0 18px;font-size:13px;color:var(--muted)">Your ' + _v + _p + ' AI consultant — ask anything, generate any document, analyze any file.</p>'
    + '<div style="display:flex;flex-wrap:wrap;gap:7px;margin-bottom:20px">'
    + _pill('Help me diagnose a ' + _v + ' error', 'Error diagnosis', 'wc-info')
    + _pill('Help me with ' + _v + ' ' + (product||'') + ' configuration', p2label)
    + _pill('Help me with ' + _v + ' security and access control', p3label)
    + _pill('Help me with ' + _v + ' data migration', 'Data migration')
    + _pill('Help me with ' + _v + ' ' + (product||'') + ' development and customization', p4label)
    + _pill('Help me plan a ' + _v + ' go-live', p6label)
    + _pill('Generate a document — Word, PowerPoint, PDF or Excel', 'PDF · Word · Excel · PPT', 'wc-success')
    + _pill('Analyze an uploaded file — PDF, Word, Excel or image', 'File analysis', 'wc-success')
    + _pill('Help me create ' + _v + ' training guides', 'Training guides')
    + _pill('Help me with ' + _v + ' reporting and dashboards', 'Reporting')
    + _pill('Help me with ' + _v + ' project planning', 'Project planning')
    + _pill('What else can you help me with in ' + _v + '? List all remaining capabilities including: freelance consulting, system upgrades, master data templates, data upload validation, application development, UX enhancements, multi-system integration, business blueprint creation, ticket resolution, and advanced technical analysis.', 'Show all capabilities')
    + '</div>'
    + '<p style="margin:0 0 8px;font-size:11px;color:var(--dim)">Quick start</p>'
    + '<div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:18px">'
    + _btn('Diagnose this ' + _v + ' error', 'Diagnose an error')
    + _btn('Create a PowerPoint presentation', 'Create a presentation')
    + _btn(b3prompt, b3label)
    + '</div>'
    + '<div style="display:grid;grid-template-columns:repeat(3,1fr);gap:8px">'
    + _feat('Explain the EOH Voice Mode feature on this platform — what it is, how to activate the mic button, how the AI speaks responses aloud, the voice languages supported, and the voice speed controls available in EOH.', 'rgba(10,138,95,.12)', 'var(--gl)', '🎙', 'Voice mode', 'Speak naturally — AI listens and responds aloud')
    + _feat('Explain the EOH Live Screen feature on this platform — what it is, how the AI watches the user screen in real time, how it gives step-by-step guidance while the user works in ' + _v + ', and how to start it using the Live button.', 'rgba(59,130,246,.1)', '#60a5fa', '📹', 'Live screen', 'AI watches your screen and guides you live')
    + _feat('Explain the EOH Learning Hub feature on this platform — what it is, what ' + _v + ' courses and structured guides are available, how the query balance works, and how to access it from the Learn button in the toolbar.', 'rgba(139,92,246,.1)', '#a78bfa', '📚', 'Learning hub', 'Courses, guides and certifications')
    + '</div>'
    + '</div>';

  if (!document.getElementById('wc-style')) {
    var st = document.createElement('style');
    st.id = 'wc-style';
    st.textContent = '.wc-pill{font-size:12px;padding:5px 13px;border-radius:20px;background:var(--bg2);color:var(--muted);border:1px solid var(--border);cursor:pointer;transition:opacity .15s}'
      + '.wc-pill:hover{opacity:.75}'
      + '.wc-pill.wc-info{background:rgba(10,138,95,.12);color:var(--gl);border-color:rgba(10,138,95,.3)}'
      + '.wc-pill.wc-success{background:rgba(10,138,95,.08);color:var(--gl);border-color:rgba(10,138,95,.22)}'
      + '.wc-btn{font-size:13px;padding:7px 15px;border-radius:8px;background:var(--bg2);color:var(--text);border:1px solid var(--border);cursor:pointer;transition:opacity .15s}'
      + '.wc-btn:hover{opacity:.75}'
      + '.wc-feat{display:flex;flex-direction:column;align-items:flex-start;gap:5px;padding:12px 14px;border-radius:var(--border-radius-lg,10px);border:1px solid var(--border);background:var(--bg2);cursor:pointer;text-align:left;transition:opacity .15s;width:100%;box-sizing:border-box}'
      + '.wc-feat:hover{opacity:.75}'
      + '.wc-feat-icon{font-size:18px;display:block}'
      + '.wc-feat-title{font-size:13px;font-weight:500;color:var(--text)}'
      + '.wc-feat-sub{font-size:11px;color:var(--dim);line-height:1.4}';
    document.head.appendChild(st);
  }

  el.innerHTML = '<div class="mav"><img src="' + logoSrc + '" alt="AI"></div>'
    + '<div class="mbody"><div class="msender">EOH</div>'
    + '<div class="mbubble">' + card + '</div>'
    + '<div class="mmeta"><span class="mtime">' + time + '</span></div>'
    + '</div>';
  m.appendChild(el);
}

function sendMsg_fromWelcome(promptOrEl) {
  // promptOrEl is either a string (old API) or this.dataset.p (new API)
  var prompt = (typeof promptOrEl === 'string') ? promptOrEl : promptOrEl;
  var ta = document.getElementById('chat-ta');
  if (ta) { ta.value = prompt; ta.style.height = 'auto'; ta.style.height = ta.scrollHeight + 'px'; }
  sendMsg();
}
window.sendMsg_fromWelcome = sendMsg_fromWelcome;

function startChat() {
  if (S.user && S.token && S.history && S.history.length >= 2) { saveCurrentSession(); }
  S_sessionId = null;
  S.history = [];
  document.getElementById('msgs').innerHTML = '';
  try { if (typeof window.eohOnConversationRendered === 'function') window.eohOnConversationRendered(null); } catch(_){}
  var ta = document.getElementById('chat-ta');
  ta.disabled = false;
  ta.placeholder = (window._chatTa && window._chatTa.ph) ? window._chatTa.ph
    : ('Ask about ' + S.vendor + ' ' + S.product + '... or type "create a PDF" to export');
  try { applyChatInputSettings(); } catch(_) {}
  document.getElementById('send-btn').disabled = false;
  S.chatActive = true; startLimTicker();
  document.getElementById('ihint').textContent = 'Enter to send | Shift+Enter new line | Type "export to PDF/Word/Excel"';
  document.getElementById('tb-title').textContent = S.vendor + ' - ' + S.product;
  document.getElementById('tb-badge').textContent = 'ACTIVE';
  var _er=document.getElementById('exp-row');if(_er)_er.classList.add('on');
  // Show voice buttons — applyFeatureFlags() will immediately hide the ones
  // that are disabled by the plan's feature settings.
  document.getElementById('voice-btn').style.display = 'inline-flex';
  var vtb = document.getElementById('voice-toggle-btn'); if(vtb) vtb.style.display = 'flex';
  // Apply feature flags immediately (if plan already loaded) — no flash
  if (_planLimitsLoaded) applyFeatureFlags();
  // live-btn and live-header-btn visibility is controlled by updateLimits() based on plan
  document.getElementById('limits-bar').classList.add('on');
  // Always sync fresh usage + limits from DB when starting a chat
  syncUsageFromServer().then(function() { updateLimits(); syncLearningBalance(); });
  updateLimits(); // show cached values immediately while sync is in flight
  loadSessions();
  var name    = S.user && S.user.fullName ? S.user.fullName.split(' ')[0] : null;
  var vendor  = S.vendor  || '';
  var product = S.product || '';
  // Use admin-configured welcome message if set
  if (window._welcomeMessage && window._welcomeMessage.trim().length > 20) {
    var greeting = window._welcomeMessage
      .replace(/\{name\}/g,    name    || 'there')
      .replace(/\{vendor\}/g,  vendor  || 'ERP')
      .replace(/\{product\}/g, product || 'system');
    addMsg('assistant', greeting, null);
  } else {
    _addWelcomeCard(name, vendor, product);
  }
  var _msgsEl = document.getElementById('msgs');
  if (_msgsEl) _msgsEl.scrollTop = 0;
  if (window.innerWidth < 768) {
    closeSidebar();
    var _cb = document.getElementById('change-sys-btn');
    if (_cb) _cb.style.display = 'block';
  }
  ta.focus();
}

function resetChat() {
  S.history = []; S.vendor = null; S.product = null; S.file = null; S.fileContent = null; S.resumeState = null; S.docState = null;
  S_memSession = _genMemId(); // new conversation → fresh durable memory thread
  document.getElementById('vs').value = '';
  var ps = document.getElementById('ps');
  ps.innerHTML = '<option value="">-- Product --</option>';
  ps.setAttribute('disabled', 'disabled');
  var ta = document.getElementById('chat-ta');
  ta.value = ''; ta.style.height = 'auto';
  // If ERP selection is optional, enable start immediately with a friendly placeholder
  if (window._erpSelectionRequired === false) {
    document.getElementById('start-btn').disabled = false;
    ta.disabled = false;
    ta.placeholder = (window._chatTa && window._chatTa.ph) ? window._chatTa.ph : 'Ask any ERP question, or select a vendor above...';
    document.getElementById('send-btn').disabled = false;
    document.getElementById('ihint').textContent = '';
  } else {
    document.getElementById('start-btn').disabled = true;
    ta.disabled = true;
    ta.placeholder = (window._chatTa && window._chatTa.ph) ? window._chatTa.ph : 'Select an ERP system to begin...';
    document.getElementById('send-btn').disabled = true;
    document.getElementById('ihint').textContent = 'Select an ERP system to begin';
  }
  document.getElementById('tb-title').textContent = 'ERP AI Support';
  document.getElementById('tb-badge').textContent = 'READY';
  var _er=document.getElementById('exp-row');if(_er)_er.classList.remove('on');
  document.getElementById('voice-btn').style.display = 'none';
  var vtb2 = document.getElementById('voice-toggle-btn'); if(vtb2) { vtb2.style.display = 'none'; vtb2.classList.remove('active'); }
  document.getElementById('limits-bar').classList.remove('on');
  document.getElementById('upload-bar').style.display='none';
  if (S.voiceOn) toggleVoiceMode();
  var wimg = document.getElementById('main-logo') ? document.getElementById('main-logo').src : '';
  // Build chips — from app_settings if available, else hardcoded defaults
  var _defaultChips = [
    { label: 'SAP posting error',  q: 'SAP S/4HANA posting period error — how do I fix it?' },
    { label: 'Oracle report',      q: 'Oracle Fusion report showing no data — troubleshooting steps?' },
    { label: 'D365 journal',       q: 'D365 Finance journal entry failed — what causes this?' },
    { label: 'Odoo inventory',     q: 'Odoo inventory mismatch between system and physical count' },
    { label: 'Workday BP',         q: 'Workday business process approval not routing correctly' },
    { label: 'NetSuite script',    q: 'NetSuite SuiteScript not triggering — common causes?' },
  ];
  var _chips = (window._welcomeChips && window._welcomeChips.length) ? window._welcomeChips : _defaultChips;
  var _chipsHtml = _chips.map(function(c) {
    var q = (c.q || c.label).replace(/'/g, "\\'");
    return '<div class="wchip" onclick="setQ(\'' + q + '\')">' + _esc(c.label) + '</div>';
  }).join('');

  document.getElementById('msgs').innerHTML = '<div class="welcome" id="welcome">'
    + '<div class="wlogo"><img src="https://erponlinehub.com/cdn/shop/files/Online_Hub_6.png?v=1771744557" alt="ERP AI"></div>'
    + '<div><div class="wtitle">ERP Online Hub <span>AI Support</span></div>'
    + '<div class="wsub" style="margin-top:10px">Expert AI assistance for 50+ ERP systems.</div></div>'
    + '<div class="wchips">' + _chipsHtml + '</div></div>';
}

// ── Slash command menu ────────────────────────────────────────────────────────
var _SLASH_COMMANDS = [
  { cmd: '/image',  icon: '🖼',  label: '/image',  sub: 'Search for ERP screenshots',         trigger: function(q) { setQ('/image ' + q); } },
  { cmd: '/export', icon: '📄',  label: '/export', sub: 'Export conversation to PDF/Word/Excel', trigger: function()  { openExportModal(); } },
  { cmd: '/search', icon: '🔍',  label: '/search', sub: 'Search the web for ERP information',  trigger: function(q) { setQ('/search ' + q); } },
  { cmd: '/help',   icon: '❓',  label: '/help',   sub: 'Show what EOH can do',                trigger: function()  { setQ('What can you help me with?'); } },
];

function _handleSlashInput(val) {
  if (!val || val[0] !== '/') { _closeSlashMenu(); return; }
  var parts  = val.slice(1).split(' ');
  var typed  = '/' + parts[0].toLowerCase();
  var rest   = parts.slice(1).join(' ');
  // Merge admin-managed slash commands (set by eoh-chat-inputs.js) with the built-in ones.
  var _allSlash = _SLASH_COMMANDS.concat(window._eohSlashCommands || []);
  var matches = _allSlash.filter(function(c) { return c.cmd.startsWith(typed); });
  if (!matches.length) { _closeSlashMenu(); return; }
  _showSlashMenu(matches, rest);
}

function _showSlashMenu(cmds, rest) {
  _closeSlashMenu();
  var ta = document.getElementById('chat-ta');
  var rect = ta.getBoundingClientRect();
  var menu = document.createElement('div');
  menu.id = 'slash-menu';
  menu.style.cssText = 'position:fixed;left:' + rect.left + 'px;bottom:' + (window.innerHeight - rect.top + 6) + 'px;'
    + 'width:' + Math.min(rect.width, 360) + 'px;background:var(--bg2);border:1px solid var(--border2);'
    + 'border-radius:10px;z-index:9999;overflow:hidden;box-shadow:0 8px 32px rgba(0,0,0,.4);max-height:220px;overflow-y:auto';
  cmds.forEach(function(c, i) {
    var item = document.createElement('div');
    item.className = 'slash-item' + (i === 0 ? ' active' : '');
    item.style.cssText = 'display:flex;align-items:center;gap:10px;padding:10px 14px;cursor:pointer;border-bottom:1px solid var(--border)';
    item.innerHTML = '<span style="font-size:18px">' + c.icon + '</span>'
      + '<div><div style="font-size:13px;font-weight:600;color:var(--text)">' + c.label + '</div>'
      + '<div style="font-size:11px;color:var(--dim)">' + c.sub + '</div></div>';
    item.addEventListener('mouseenter', function() {
      menu.querySelectorAll('.slash-item').forEach(function(el) { el.classList.remove('active'); });
      item.classList.add('active');
    });
    item.addEventListener('mousedown', function(e) {
      e.preventDefault();
      _closeSlashMenu();
      var ta2 = document.getElementById('chat-ta');
      ta2.value = '';
      if (c.cmd === '/image' && !rest) {
        ta2.placeholder = 'Type image query, e.g. SAP PA30 screen';
        ta2.value = '/image ';
        ta2.focus();
      } else {
        c.trigger(rest);
      }
    });
    menu.appendChild(item);
  });
  // Style active item
  var style = document.getElementById('slash-menu-style');
  if (!style) {
    style = document.createElement('style');
    style.id = 'slash-menu-style';
    style.textContent = '.slash-item.active{background:rgba(10,138,95,.12)!important}.slash-item:last-child{border-bottom:none!important}';
    document.head.appendChild(style);
  }
  document.body.appendChild(menu);
}

function _closeSlashMenu() {
  var m = document.getElementById('slash-menu'); if (m) m.remove();
}

// Close slash menu on outside click
document.addEventListener('click', function(e) {
  if (!e.target.closest('#slash-menu') && !e.target.closest('#chat-ta')) _closeSlashMenu();
});

// Handle /image query — wrap in DOMContentLoaded so chat-ta exists
document.addEventListener('DOMContentLoaded', function() {
  var ta = document.getElementById('chat-ta');
  if (!ta) return;
  ta.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter' || e.shiftKey) return;
    var val = ta.value.trim();
    if (val.startsWith('/image ')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var query = val.replace(/^\/image\s+/i, '').trim();
      if (query) { ta.value = 'show me ' + query; sendMsg(); }
    }
  }, true); // capture phase — fires before normal Enter handler
});

function setQ(q) {
  var ta = document.getElementById('chat-ta');
  if (ta.disabled) { alert('Please select an ERP system first.'); return; }
  ta.value = q; ta.focus();
}

// -- SMART EXPORT DETECTION ----------------------------------------------------
function detectExportIntent(msg) {
  var lower = msg.toLowerCase();
  var cleanLower = lower.replace(/[''`]/g,'').replace(/[?!.,]/g,'');

  // -- LAYER 0: CHANGE REQUEST - if user wants to modify an existing file --
  var changeWords = ['change','update','edit','modify','fix','revise','add more detail','remove the','replace','make it longer','different color','add a slide','add slide','new slide about','add section','update slide','redo the','redo this'];
  var isChange = changeWords.some(function(w){ return lower.includes(w); });
  // EXPLICIT FORMAT IN THIS MESSAGE ALWAYS WINS over the sticky last-used format. "update this cv
  // and do new PDF" must be PDF even if the previous export was PPTX. (Root cause of the CV→PPTX bug.)
  var _explicitFmt = (lower.includes('powerpoint')||lower.includes('pptx')||lower.includes('presentation')||lower.includes('slide')) ? 'pptx'
                   : (lower.includes('word')||lower.includes('docx')||lower.includes('.doc')) ? 'docx'
                   : (lower.includes('excel')||lower.includes('xlsx')||lower.includes('spreadsheet')) ? 'xlsx'
                   : (lower.includes('.txt')||lower.includes('text file')||lower.includes('plain text')) ? 'txt'
                   : (lower.includes('pdf')) ? 'pdf' : null;
  if (isChange && _explicitFmt) { return _explicitFmt; }
  if (isChange && S.lastExportFmt) {
    // They want to change the last exported format
    return S.lastExportFmt;
  }
  if (isChange) {
    // Look back for last exported format
    var hist0 = S.history || [];
    for (var j0=hist0.length-1; j0>=0; j0--) {
      var c0=(hist0[j0].content||'').toLowerCase();
      if (c0.includes('export_trigger:pptx')) return 'pptx';
      if (c0.includes('export_trigger:docx')) return 'docx';
      if (c0.includes('export_trigger:xlsx')) return 'xlsx';
      if (c0.includes('export_trigger:txt')) return 'txt';
      if (c0.includes('export_trigger:pdf')) return 'pdf';
    }
  }

  // -- LAYER 1: Direct format mention --------------------------------------
  if (lower.includes('powerpoint')||lower.includes('pptx')||lower.includes('presentation')||lower.includes('slide')) return 'pptx';
  if (lower.includes('word')||lower.includes('docx')||lower.includes('.doc')) return 'docx';
  if (lower.includes('excel')||lower.includes('xlsx')||lower.includes('spreadsheet')) return 'xlsx';
  if (lower.includes('.txt')||lower.includes('text file')||lower.includes('plain text')||lower.includes('txt file')||lower.includes('notepad')) return 'txt';
  if (lower.includes('pdf')) return 'pdf';

  // -- LAYER 2: Logo + file request -----------------------------------------
  if ((lower.includes('logo')||lower.includes('add it')||lower.includes('include it'))&&S.lastImageBase64) {
    var hist2=S.history||[];
    for (var j2=hist2.length-1;j2>=0;j2--) {
      var c2=(hist2[j2].content||'').toLowerCase();
      if (c2.includes('export_trigger:pptx')||c2.includes('powerpoint')||c2.includes('pptx')||c2.includes('slide')) return 'pptx';
      if (c2.includes('export_trigger:docx')||c2.includes('word')||c2.includes('docx')) return 'docx';
      if (c2.includes('export_trigger:xlsx')||c2.includes('excel')) return 'xlsx';
      if (c2.includes('export_trigger:pdf')||c2.includes('pdf')) return 'pdf';
    }
  }

  // -- LAYER 3: Follow-up / "where's the file" ------------------------------
  // EXCLUDE image/search requests - these are NOT file requests
  var imageRelatedWords = ['image', 'images', 'screenshot', 'pictures', 'photos', 'visual', 'search', 'find'];
  var isImageRelated = imageRelatedWords.some(function(w) { return lower.includes(w); });
  if (isImageRelated) return null; // Not a file request

  var fileWords=['where','the file','download','get it','send it','where is','wheres','the pptx','the doc','not working','still waiting','export it','export now','i dont see','dont see','no file','no download','missing','nothing happened','didnt get','cant find'];
  var isFileReq=fileWords.some(function(w){ return cleanLower.includes(w)||lower.includes(w); });
  if (isFileReq) {
    var hist3=S.history||[];
    for (var j3=hist3.length-1;j3>=0;j3--) {
      var c3=(hist3[j3].content||'').toLowerCase();
      if (c3.includes('export_trigger:pptx')||c3.includes('powerpoint')||c3.includes('slide')) return 'pptx';
      if (c3.includes('export_trigger:docx')||c3.includes('word')||c3.includes('docx')) return 'docx';
      if (c3.includes('export_trigger:xlsx')||c3.includes('excel')) return 'xlsx';
      if (c3.includes('export_trigger:pdf')||c3.includes('pdf')) return 'pdf';
    }
    return null;
  }

  // -- LAYER 4: Generic create document ------------------------------------
  var actionWords=['export','create','generate','download','save','make','write','build','prepare','design','produce'];
  var docWords=['document','report','file','doc'];
  if (actionWords.some(function(k){return lower.includes(k);})&&docWords.some(function(k){return lower.includes(k);})) return 'docx';

  return null;
}

// -- SEND MESSAGE --------------------------------------------------------------
// ── Send / Stop button (Claude-style): the same button sends when idle and stops the
// AI mid-generation when it's working. _chatAbort aborts the in-flight /chat stream. ──
var _chatAbort = null;

function _setSendStop(stop) {
  var b = document.getElementById('send-btn');
  if (!b) return;
  if (stop) {
    b.disabled = false;
    b.classList.add('stopping');
    b.title = 'Stop';
    b.setAttribute('aria-label', 'Stop generating');
    b.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="6" width="12" height="12" rx="2.5"/></svg>';
  } else {
    b.classList.remove('stopping');
    b.title = 'Send';
    b.setAttribute('aria-label', 'Send');
    b.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>';
  }
}

function stopGeneration() {
  try { if (_chatAbort) _chatAbort.abort(); } catch(_){}
  _chatAbort = null;
  S.loading = false;
  try { removeTyping(); } catch(_){}
  _setSendStop(false);
}
window.stopGeneration = stopGeneration;

async function sendMsg() {
  // While the AI is generating, this same button acts as STOP (abort the stream).
  if (S.loading) { stopGeneration(); return; }

  // ── Guest limit check — track unauthenticated send attempts in localStorage ─
  // Counts daily attempts before showing signup CTA instead of plain login modal.
  if (!S.user || !S.token) {
    try {
      var _today = new Date().toISOString().substring(0, 10);
      var _guestKey = 'eoh_guest_attempts_' + _today;
      var _guestCount = parseInt(localStorage.getItem(_guestKey) || '0', 10);
      var _guestLimit = (window._guestMessageLimit !== undefined) ? window._guestMessageLimit : 3;
      if (_guestCount >= _guestLimit) {
        _showGuestLimitModal(); return;
      }
      localStorage.setItem(_guestKey, String(_guestCount + 1));
    } catch(_) {}
    showModal('login'); return;
  }
  // ── AUTH GATE — must be logged in to use chat ─────────────────────────────
  // ── BLOCK GATE ────────────────────────────────────────────────────────────
  var ta = document.getElementById('chat-ta');
  var msg = ta.value.trim();
  // Auto-detect language from user's typed message
  if (msg) autoDetectInputLang(msg);
  // Block send while file is still being read — but QUEUE it, don't drop it. Pressing Enter while
  // the file is still analyzing used to silently return, so text/file never went together (the
  // reported "sent text not with the file"). Now it auto-sends the moment the file is ready.
  if (S.fileReading) {
    if (!S._sendQueued) { S._sendQueued = true; try { showToast('Sending as soon as the file is ready\u2026', 'info', 2500); } catch (_) {} }
    return;
  }
  // Block send while a file is still GENERATING — otherwise the chat request and the export
  // run at the same time, both writing to the shared conversation history (S.history) and
  // confusing the file being built. Ask the user to wait until generation finishes.
  if (_exportInProgress) { showToast('Your file is still generating — please wait until it finishes, then send your message.', 'info', 3500); return; }
  // Allow send if file is attached even with no text
  if ((!msg && !S.file && (!S.filesAttached || !S.filesAttached.length)) || S.loading) return;
  // Don't inject any message - let AI see file content silently
  if (!msg && S.file) msg = '';
  // Include reply context if replying to a message
  if (S._replyContext && msg) {
    msg = 'Regarding: "' + S._replyContext + '"\n\n' + msg;
    cancelReply();
  }
  ta.value = ''; ta.style.height = 'auto';
  var w = document.getElementById('welcome'); if (w) w.remove();

  // Smart export detection:
  // - Change requests & "where's the file" → auto-trigger immediately
  // - FIRST TIME mentions (e.g. "pdf for SAP HCM") → send to AI to ask questions first
  var exportFmt = detectExportIntent(msg);
  var isChangeReq = exportFmt && ['change','update','edit','modify','fix','revise','add','remove','replace','redo','regenerate','rebuild'].some(function(w){return msg.toLowerCase().includes(w);});
  // A VAGUE or QUESTION-style change request ("can we change some things?", "I want to change
  // something", "can you edit it?") is a request to DISCUSS, not a command to regenerate. Only
  // auto-export when the user names a concrete change or clearly asks to regenerate now. Otherwise
  // let it fall through to the AI, which asks what they'd like to change.
  var _mLow = msg.toLowerCase().trim();
  var _isQuestionish = /[?？]\s*$/.test(msg) || /^(can|could|may|would|should|is it possible|do you|are you able|how (do|can)|what if|i want to|i'?d like to|let'?s|lets)\b/.test(_mLow);
  var _isVagueChange = /\b(some|any|a few|couple|thing|things|stuff|something|anything|bit)\b/.test(_mLow) && !/\b(pdf|word|docx|excel|xlsx|powerpoint|pptx|format|style|template|color|colour|font|section|summary|title|photo|picture|name|email|phone|bullet|date)\b/.test(_mLow);
  var _isDiscussChange = _isQuestionish || _isVagueChange;
  if (isChangeReq && _isDiscussChange) { isChangeReq = false; }   // treat as discussion, not export
  var isFileReq = exportFmt && ['where','the file','download','get it','send it','give me','cant find','dont see','missing','export now','export it'].some(function(w){return msg.toLowerCase().includes(w);});
  // isRepeatExport: ONLY trigger if the current message also explicitly mentions the export format
  var _exportWords = ['pdf','word','docx','excel','xlsx','powerpoint','pptx','export','file','document','report'];
  var isRepeatExport = exportFmt && S.lastExportFmt && _exportWords.some(function(w){return msg.toLowerCase().includes(w);});

  // ATTACHMENT OVERRIDE: a freshly attached file is the subject of THIS turn. The export shortcut
  // below builds from conversation/last-file state and never sends the new attachment, so "update
  // this cv" with a CV attached produced a deck from stale state. With any attachment present, skip
  // the shortcut so the file + text go through the normal send and the backend reads the real file.
  var _hasAttachNow = !!(S.file || (S.filesAttached && S.filesAttached.length) || (S.filesContent && S.filesContent.length));
  if (_hasAttachNow && exportFmt) { console.log('[EOH send] attachment present — export shortcut skipped, file goes with the message'); exportFmt = null; }
  if (exportFmt && (isChangeReq || isFileReq || isRepeatExport)) {
    // If this is a RESUME conversation and the user wants to change the format/style/look,
    // re-open the resume chooser (style + format) rather than silently re-exporting the same
    // format through the generic path (which mislabels the file "SAP_S_4HANA_..." and skips
    // the style question). "change the format", "different style", etc. → let them choose.
    var _wantsChooser = /\b(format|style|template|layout|design|different\s+(style|format|template|look)|another\s+(style|format|template))\b/i.test(msg);
    if (_wantsChooser && !_isDiscussChange && typeof _isResumeConversation === 'function' && _isResumeConversation()) {
      addMsg('user', msg, null);
      S.history.push({ role: 'user', content: msg, timestamp: new Date().toISOString() });
      addMsg('assistant', 'Sure — pick the style and format you\u2019d like for your CV:', null);
      try { _renderFormatChooser(); } catch (_) { await doExport('resume', null, null, 'resume'); }
      return;
    }
    // Auto-trigger: user is requesting a change, follow-up, or re-export
    addMsg('user', msg, null);
    // Resend after a failed request: the previous user turn is still the last entry (no
    // assistant reply followed it). Replace it instead of stacking a duplicate.
    var _lastH = S.history[S.history.length - 1];
    if (_lastH && _lastH.role === 'user' && String(_lastH.content || '').replace(/\s+/g, ' ').trim().toLowerCase() === String(msg || '').replace(/\s+/g, ' ').trim().toLowerCase() && !_lastH.attachments && !_lastH.file) {
      S.history[S.history.length - 1] = {role: 'user', content: msg, timestamp: new Date().toISOString()};
    } else {
    S.history.push({role: 'user', content: msg, timestamp: new Date().toISOString()});
    }
    addMsg('assistant', isChangeReq ? 'Applying your changes and regenerating the ' + exportFmt.toUpperCase() + '...' : 'Got it! Building your ' + exportFmt.toUpperCase() + ' file now...', null);
    await doExport(exportFmt, S.lastImageBase64 || S.fileBase64, S.lastImageExt || S.fileExt);
    return;
  }
  // If first time export request → do NOT auto-trigger, let AI ask questions below

  var fullMsg = msg;
  var fileAtt = null;
  // ── Handle multi-document files (filesAttached) ───────────────────────────
  var _hasDocFiles = S.filesAttached && S.filesAttached.length > 0;
  var _hasImgFiles = S.filesContent && S.filesContent.length > 0;
  if (_hasDocFiles) {
    var _allFiles = S.filesAttached.slice();
    var _fNames = _allFiles.map(function(f){return f.name;}).join(', ');
    // Also count images in the name
    if (_hasImgFiles) {
      S.filesContent.forEach(function(f){ _fNames += (_fNames?', ':'')+f.name; });
    }
    fileAtt = { name: _fNames, size: _allFiles.reduce(function(t,f){return t+(f.size||0);},0), type: 'multi' };
    fullMsg = '';
    _allFiles.forEach(function(f, i) {
      fullMsg += '[File '+(i+1)+': '+f.name+' ('+f.type+', '+(( f.size||0)/1024).toFixed(1)+'KB)]\n\n';
      fullMsg += f.content + '\n\n';
      if (f.truncated) fullMsg += '[Note: file was truncated — showing first '+f.chars+' characters]\n\n';
      fullMsg += '---\n\n';
    });
    if (_hasImgFiles) {
      fullMsg += '['+S.filesContent.length+' image(s) also attached — see visual content above]\n\n---\n\n';
    }
    fullMsg += msg ? 'Question: '+msg : 'Please analyze these files and answer any questions.';
  }
  // Handle multiple images only (no documents)
  else if (_hasImgFiles) {
    var imgNames = S.filesContent.map(function(f) { return f.name; });
    fileAtt = { name: imgNames.join(', '), size: S.filesContent.length + ' images', type: 'images' };
    fullMsg = '[Attached ' + S.filesContent.length + ' images: ' + imgNames.join(', ') + ']\n\n';
    S.filesContent.forEach(function(f, i) {
      fullMsg += '[Image ' + (i + 1) + ': ' + f.name + ']\n';
    });
    fullMsg += '\n---\n' + (msg ? 'Question: ' + msg : 'Please analyze these images and describe what you see.');
  } else if (S.file && S.fileContent) {
    fileAtt = {name: S.file.name, size: S.file.size || 0, type: S.file.type || ''};
    fullMsg = '[Attached: ' + S.file.name + ']\n\n' + S.fileContent + '\n\n---\nQuestion: ' + msg;
  }
  // ── File display name for user bubble ─────────────────────────────────────
  // Save uploaded IMAGES (only) for embedding in AI analysis. A PDF/DOCX is NOT an image —
  // its text is already extracted into fileContent, so it must never go into the images
  // array (that would route it to the vision pipeline and time out with a 504).
  function _isImageFile(f) {
    var n = String((f && (f.name || f.ext)) || '').toLowerCase();
    var byName = /\.(png|jpe?g|webp|gif|bmp)$/.test(n) || /^(png|jpe?g|webp|gif|bmp)$/.test(String((f&&f.ext)||'').toLowerCase());
    var byData = typeof (f&&f.base64) === 'string' && /^data:image\//i.test(f.base64);
    return byName || byData;
  }
  var _imgFiles = (S.filesContent || []).filter(_isImageFile);
  if (_imgFiles.length > 0) {
    S._lastUploadedImages = _imgFiles.map(function(f) { return f.base64; });
  } else if (S.fileBase64 && /^(png|jpe?g|webp|gif|bmp)$/.test(String(S.fileExt||'').toLowerCase())) {
    S._lastUploadedImages = [S.fileBase64];
  } else {
    S._lastUploadedImages = [];   // document upload → no images
  }

  var displayMsg = msg || '';
  // Build image preview HTML for user's message
  var imgPreviewHtml = '';
  if (S.filesContent && S.filesContent.length > 0) {
    var _userImgId = 'uimg' + Math.random().toString(36).substr(2,5);
    imgPreviewHtml = '<div class="chat-img-row" style="margin:8px 0">';
    S.filesContent.forEach(function(f, i) {
      imgPreviewHtml += '<div class="chat-img-item" style="max-width:160px" data-imggroup="' + _userImgId + '" data-imgidx="' + i + '" onclick="openLightboxGroup(this)"><img src="' + f.base64 + '" alt="' + f.name + '"></div>';
    });
    imgPreviewHtml += '</div>';
    imgPreviewHtml += '<script type="application/json" class="img-data" data-group="' + _userImgId + '">' + JSON.stringify(S.filesContent.map(function(f) { return f.base64; })) + '<\/script>';
  } else if (S.fileBase64 && ['png','jpg','jpeg','webp','gif'].indexOf(S.fileExt) !== -1) {
    var _singleImgId = 'uimg' + Math.random().toString(36).substr(2,5);
    imgPreviewHtml = '<div class="chat-img-row" style="margin:8px 0"><div class="chat-img-item solo" style="max-width:280px" data-imggroup="' + _singleImgId + '" data-imgidx="0" onclick="openLightboxGroup(this)"><img src="' + S.fileBase64 + '" alt="attached"></div></div>';
    imgPreviewHtml += '<script type="application/json" class="img-data" data-group="' + _singleImgId + '">' + JSON.stringify([S.fileBase64]) + '<\/script>';
  }
  if (imgPreviewHtml) {
    displayMsg = (msg ? msg + '\n' : '') + imgPreviewHtml;
  }
  addMsg('user', displayMsg || (fileAtt ? '📎 ' + fileAtt.name : ''), fileAtt);
  var _uMsgEl = (function(){ var c = document.getElementById('msgs'); return c ? c.lastElementChild : null; })();
  var _cfgForHistory = S._uploadConfig || {};
  var _fileRetainTurns = parseInt(_cfgForHistory.file_history_turns||3);
  var _uMsg = {
    role: 'user',
    // Bubble/history content stays CLEAN — the user's question, or just the filename. The full
    // extracted file text goes to the AI via _fileContent only (never dumped into the bubble).
    content: (msg && msg.trim()) ? msg : (fileAtt ? ('\ud83d\udcce ' + fileAtt.name) : ''),
    timestamp: new Date().toISOString(),
    file: fileAtt ? {name: fileAtt.name, size: fileAtt.size, type: fileAtt.type} : null,
    _fileRetainTurns: fileAtt ? _fileRetainTurns : 0,
    _fileContent: fileAtt ? fullMsg : null,
  };
  var _docsForPersist = (S.filesAttached || []).slice();
  S.history.push(_uMsg);
  // Save image refs before removeFile clears them
  var savedBase64 = S.fileBase64;
  var savedExt = S.fileExt;
  // Build images array with consistent {data, ext, name} format
  var savedImages = [];
  if (S.filesContent && S.filesContent.length > 0) {
    savedImages = S.filesContent.map(function(f) {
      return { data: f.base64 || f.data, ext: f.ext || 'jpeg', name: f.name || 'image' };
    });
  } else if (savedBase64) {
    savedImages = [{ data: savedBase64, ext: savedExt || 'png', name: 'image' }];
  }
  console.log('[SendMsg] Images to send:', savedImages.length, savedImages.length > 0 ? 'first size:' + (savedImages[0].data || '').length : '');
  removeFile();
  // Persist uploaded images + documents to storage so they survive in chat history (90-day retention).
  _persistMsgAttachments(_uMsg, savedImages, _docsForPersist, _uMsgEl);
  // Enforce query limit before sending
  if (!checkQueryLimit()) return;
  S.loading = true; showTyping();
  _chatAbort = new AbortController();
  _setSendStop(true);
  // Safety: always reset loading on exit (prevents permanent freeze)
  var _loadingReset = false;
  function _safeReset() { if (!_loadingReset) { _loadingReset = true; S.loading = false; removeTyping(); _setSendStop(false); _chatAbort = null; } }
  try {
    var hasRealLogo = !!(S.lastImageBase64 || (S.file && ['png','jpg','jpeg','webp','gif'].indexOf((S.file.name||'').split('.').pop().toLowerCase()) !== -1));
    var logoStatus = hasRealLogo
      ? 'LOGO STATUS: A real image file HAS been uploaded and stored. Confirm it will appear on every slide and cover page.'
      : 'LOGO STATUS: No image file has been uploaded yet. If user mentioned logo in text only with no actual file, you MUST respond: Please upload your logo file (PNG or JPG) and I will include it on every slide. NEVER confirm a logo that was not uploaded.';

    // Detect if user is requesting a document/file for the FIRST TIME
    var isFirstExportReq = exportFmt && !isChangeReq && !isFileReq && !isRepeatExport;
    // Generate immediately — no pre-flight questions
    var exportInstructions = exportFmt
      ? ` FILE EXPORT REQUESTED (${exportFmt.toUpperCase()}): Respond with EXPORT_TRIGGER:${exportFmt} on the FIRST line, followed by one short sentence. Generate immediately — do NOT ask any questions.`
      : ' FILE EXPORT: If the user is clearly requesting a file export, respond with EXPORT_TRIGGER:pptx/docx/xlsx/pdf on line 1 only. Never explain how exports work.';

    // Collect image base64 for multimodal AI vision
    var attachedImages = savedImages.length > 0 ? savedImages : [];

    // When sending images, trim conversation history to reduce payload size
    // Vercel has 4.5MB limit - images take most of the space
    var msgHistory = S.history;
    if (attachedImages.length > 0) {
      // Only send last 4 messages when images are attached (to save space)
      msgHistory = S.history.slice(-4);
      // CRITICAL: ensure history starts with a user message
      while (msgHistory.length > 0 && msgHistory[0].role !== 'user') {
        msgHistory.shift();
      }
      // If empty after trimming, add the current message
      if (msgHistory.length === 0) {
        msgHistory = [S.history[S.history.length - 1]];
      }
      console.log('[SendMsg] Trimmed history to', msgHistory.length, 'messages for image payload');
    }

    // The model must receive the full file text, but stored history keeps clean content.
    var _apiMessages = (msgHistory || []).map(function(m){
      // Surface the exported CV draft (or attached file text) as content so revision
      // requests after an export can see the full resume, not just "Generated file".
      return { role: m.role, content: (m._resumeDraft || m._fileContent || m.content || '') };
    });
    var bodyObj = {
      messages: _apiMessages,
      resumeState: S.resumeState || null,   // canonical CV — so the AI always has the full current résumé
      docState: S.docState || null,          // canonical documents — any file the user uploaded stays available
      vendor: S.vendor || (function(){ try { return localStorage.getItem('eoh_last_vendor') || ''; } catch(e){ return ''; } })(),
      product: S.product || (function(){ try { return localStorage.getItem('eoh_last_product') || ''; } catch(e){ return ''; } })(),
      userId: S.user ? S.user.id : null,
      pm_project_id: (typeof window !== 'undefined' && window._eohPmProjectId) ? window._eohPmProjectId : null,
      guided_action: (function(){ var _g = (typeof window !== 'undefined' && window._eohGuidedAction) || null; if (typeof window !== 'undefined') window._eohGuidedAction = null; return _g; })(),
      chat_mode: (typeof S !== 'undefined' && S && S.voiceOn) ? 'voice' : 'chat',
      output_prefs: (typeof window !== 'undefined' && window._eohOutputPrefs) ? window._eohOutputPrefs : null,
      sessionId: S_sessionId || null,
      mem_session: S_memSession,
      systemNote: logoStatus + exportInstructions,
      images: attachedImages.length > 0 ? attachedImages : undefined,
      lang: S._chatLang || 'en-US',
      // Pass the stored-file reference (key) so the backend can edit the ACTUAL file
      // without the browser resending base64. upload.js already saved it full-size.
      attachments: (_docsForPersist && _docsForPersist.length)
        ? _docsForPersist.map(function(d){ return { name:d.name, mime:(d.mime||''), type:(d.type||''), size:(d.size||0), key:(d.attKey||null) }; })
        : undefined
    };
    var bodyStr = JSON.stringify(bodyObj);
    console.log('[SendMsg] Body size:', Math.round(bodyStr.length / 1024) + 'KB, images:', attachedImages.length);
    try {
      if (bodyObj.attachments && bodyObj.attachments.length) {
        console.log('[EOH chat] sending ' + bodyObj.attachments.length + ' attachment(s):',
          bodyObj.attachments.map(function (a) { return a.name + ' \u2192 ' + (a.key ? ('key ' + String(a.key).slice(-22)) : 'NO KEY (cannot edit)'); }).join(' | '));
      } else if (_docsForPersist && _docsForPersist.length) {
        console.log('[EOH chat] WARNING: ' + _docsForPersist.length + ' file(s) attached but no attachments field sent \u2014 stale eoh-chat.js?');
      }
    } catch (e) {}

    // Check if body is too large for Vercel (4.5MB limit)
    if (bodyStr.length > 4400000) {
      console.warn('[SendMsg] Body too large! Reducing image quality...');
      // Re-compress images smaller
      attachedImages = attachedImages.map(function(img) {
        if (img.data && img.data.length > 500000) {
          // Truncate to ~500KB per image
          return { data: img.data.substring(0, 500000), ext: img.ext, name: img.name };
        }
        return img;
      });
      bodyObj.images = attachedImages;
      bodyStr = JSON.stringify(bodyObj);
      console.log('[SendMsg] Reduced body size:', Math.round(bodyStr.length / 1024) + 'KB');
    }

    // ── STREAMING FETCH — token-by-token delivery ─────────────────────────
    // Uses _streamChat() which handles SSE parsing and incremental rendering.
    // Falls back to a single non-streaming retry on 401 (token refresh) or
    // on any error so the user always gets a response.
    var _streamDone = false;
    await _streamChat(bodyStr, async function(reply, streamErr, pm_action) {
      _streamDone = true;
      _safeReset();

      // ── 401 inside stream: refresh token then retry non-streaming ────────
      if (streamErr && (streamErr.includes('401') || streamErr.includes('Unauthorized') || streamErr.includes('expired'))) {
        var _rt401 = localStorage.getItem('eoh_rt');
        if (_rt401) {
          try {
            var _rr = await window.fetch(API + '/auth/refresh', {
              method: 'POST', headers: {'Content-Type':'application/json'},
              credentials: 'include',
              body: JSON.stringify({refresh_token: _rt401})
            });
            var _rd = await _rr.json();
            if (_rd.token) {
              S.token = _rd.token;
              localStorage.setItem('eoh_t', _rd.token);
              if (_rd.refresh_token) localStorage.setItem('eoh_rt', _rd.refresh_token);
              if (_rd.user) { _mergeUser(_rd.user); localStorage.setItem('eoh_u', JSON.stringify(S.user)); }
              // Retry with new token — non-streaming fallback
              var _retryObj = JSON.parse(bodyStr);
              var _retryRes = await window.fetch(API + '/chat', {
                method: 'POST',
                headers: {'Content-Type':'application/json','Authorization':'Bearer '+S.token},
                body: JSON.stringify(_retryObj),
                signal: (typeof _chatAbort !== 'undefined' && _chatAbort) ? _chatAbort.signal : undefined
              });
              var _retryCt = _retryRes.headers.get('content-type') || '';
              var _retryReply = '';
              if (_retryRes.ok && _retryCt.includes('text/event-stream')) {
                var _rr2 = _retryRes.body.getReader(); var _rd2 = new TextDecoder(); var _rb = '';
                while(true){ var _rc=await _rr2.read(); if(_rc.done)break; _rb+=_rd2.decode(_rc.value,{stream:true}); var _rl=_rb.split('\n'); _rb=_rl.pop();
                  for(var _ri=0;_ri<_rl.length;_ri++){var _rln=_rl[_ri].trim();if(!_rln.startsWith('data: '))continue;try{var _rev=JSON.parse(_rln.slice(6));if(_rev.done&&_rev.reply){_retryReply=_rev.reply;break;}if(_rev.chunk)_retryReply+=_rev.chunk;}catch(_){}} }
              } else if (_retryRes.ok) {
                var _retryData = await _retryRes.json().catch(function(){return {};});
                _retryReply = _retryData.reply || '';
              }
              if (_retryRes.ok && _retryReply) {
                reply = _retryReply;
                streamErr = null;
              } else if (!_retryRes.ok) {
                // Retry also failed - show actual error, not "session expired"
                var _retryErrData = {};
                try { _retryErrData = await _retryRes.clone().json(); } catch(_) {}
                var _retryErr = _retryErrData.error || ('Request failed (' + _retryRes.status + ')');
                addMsg('assistant', '⚠️ ' + _retryErr, null);
                return;
              } else {
                // Retry returned ok but empty reply - AI issue, not auth
                addMsg('assistant', '⚠️ AI returned empty response. Please try again.', null);
                return;
              }
            } else {
              // Refresh returned no token — show login modal but keep state
              // Don't wipe token here; user can re-login and continue
              addMsg('assistant', '🔒 Your session has expired. Please sign in again.', null);
              showModal('login'); return;
            }
          } catch(e) {
            // Network error during refresh — don't log out, just retry next message
            console.warn('[EOH] Refresh network error — keeping session:', e.message);
            addMsg('assistant', '⚠️ Connection issue. Please try again.', null); return;
          }
        } else {
          // No refresh token — show login modal, keep state intact
          addMsg('assistant', '🔒 Please sign in again to continue.', null);
          showModal('login'); return;
        }
      }

      // ── account_blocked ──────────────────────────────────────────────────
      if (streamErr && streamErr.includes('account_blocked')) {
        showBlockedModal(S.user ? S.user.blockReason : null); return;
      }

      // ── guest_limit_reached — unauthenticated user hit free message cap ──
      if (streamErr && streamErr.includes('guest_limit_reached')) {
        _showGuestLimitModal(); return;
      }

      // ── Other stream errors ──────────────────────────────────────────────
      if (streamErr && !reply) {
        var errMsg = streamErr;
        if (errMsg.includes('503') || errMsg.includes('UNAVAILABLE') || errMsg.includes('high demand')) {
          addMsg('assistant', '⏳ The AI is experiencing high demand right now. Please try again in a few seconds.', null);
        } else if (errMsg.includes('429') || errMsg.includes('RESOURCE_EXHAUSTED') || errMsg.startsWith('rate_limited:')) {
          addMsg('assistant', '⏳ Rate limit reached — too many requests. Please wait a moment and try again.', null);
        } else if (errMsg.includes('limit_reached') || errMsg.includes('plan_expired')) {
          addMsg('assistant', '⚠️ ' + errMsg, null);
        } else {
          addMsg('assistant', '⚠️ Something went wrong. Please try again.\n\n_' + errMsg.substring(0, 150) + '_', null);
        }
        return;
      }

      if (!reply) return;

      // ── Export trigger detection ─────────────────────────────────────────
      // Detect ALL export triggers (the AI may emit more than one for "export both files").
      var _allTriggers = (reply.match(/EXPORT_TRIGGER:(pdf|docx|xlsx|pptx|resume)/gi) || [])
        .map(function (s) { return s.split(':')[1].toLowerCase(); });
      var exportMatch = _allTriggers.length ? true : null;
      if (exportMatch) {
        var rawReply = reply;
        reply = reply.replace(/[-]*\s*EXPORT_TRIGGER:(pdf|docx|xlsx|pptx|resume)\s*[-]*/gi, '').trim();
        // _streamChat already rendered the cleaned reply — just push to history
        S.history.push({role: 'assistant', content: rawReply});
        try { _updateResumeState(rawReply); } catch(_){}
        saveNow();
        incrementQuery();

        // Build the export queue. Each trigger is either the CV (needs the style chooser)
        // or a regular document (exports directly). Attribute each trigger to the announcement
        // line(s) ABOVE it (since the previous trigger) to tell what that file IS.
        var _isResumeConvo = false; try { _isResumeConvo = _isResumeConversation(); } catch(_){}
        var _jobs = [];
        (function(){
          var _ls = rawReply.split('\n'); var _buf = [];
          _ls.forEach(function (ln) {
            var m = ln.match(/EXPORT_TRIGGER:(pdf|docx|xlsx|pptx|resume)/i);
            if (m) {
              var announce = _buf.join(' ');
              var fmt = m[1].toLowerCase();
              var isCV = fmt === 'resume' || /\b(cv|resume|r\u00e9sum\u00e9)\b/i.test(announce);
              _jobs.push({ fmt: fmt, isCV: isCV });
              _buf = [];
            } else { _buf.push(ln); }
          });
        })();
        // Single-file resume conversation with no explicit CV wording → treat it as the CV.
        if (_isResumeConvo && _jobs.length === 1 && !_jobs[0].isCV) _jobs[0].isCV = true;

        // ══ ROBUST MULTI-FILE EXPORT ══════════════════════════════════════════
        // The fragile part was mixing the interactive CV chooser with background
        // generation. Fix: if the batch contains a CV, ASK its style/format FIRST
        // (collect the choices), THEN generate every file in strict sequence where
        // each file only starts after the previous one has fully finished. No race,
        // nothing skipped.
        var _isResumeConvo = false; try { _isResumeConvo = _isResumeConversation(); } catch(_){}
        var _jobs = [];
        (function(){
          var _ls = rawReply.split('\n'); var _buf = [];
          _ls.forEach(function (ln) {
            var m = ln.match(/EXPORT_TRIGGER:(pdf|docx|xlsx|pptx|resume)/i);
            if (m) {
              var announce = _buf.join(' ');
              var fmt = m[1].toLowerCase();
              var isCV = fmt === 'resume' || /\b(cv|resume|r\u00e9sum\u00e9)\b/i.test(announce);
              _jobs.push({ fmt: fmt, isCV: isCV });
              _buf = [];
            } else { _buf.push(ln); }
          });
        })();
        if (_isResumeConvo && _jobs.length === 1 && !_jobs[0].isCV) _jobs[0].isCV = true;

        // De-dupe accidental repeats and cap.
        _jobs = _jobs.slice(0, 5);

        // Generate every job in sequence; each waits for real completion via S._exportQueue.
        var _qi = 0;
        function _generateAll() {
          if (_qi >= _jobs.length) { S._exportQueue = null; return; }
          var job = _jobs[_qi++];
          S._exportQueue = { run: _generateAll };   // continue after THIS file finishes
          if (job.isCV && job._choices) {
            // CV with choices already collected → export directly, no chooser mid-sequence
            doExport(job._choices.fmt, null, null, 'resume', job._choices.style, job._choices.depth, job._choices.visuals, job._choices.visualTier);
          } else {
            doExport(job.fmt, savedBase64, savedExt);
          }
        }

        function _startBatch() {
          if (_jobs.length > 1) {
            addMsg('assistant', 'I\u2019ll generate ' + _jobs.length + ' files. ' + (_jobs.some(function(j){return j.isCV;}) ? 'First choose your CV style, then I\u2019ll build them all.' : 'Generating them now.'), null);
          }
          // Collect CV choices FIRST if any CV is in the batch.
          var _cvJob = _jobs.filter(function (j) { return j.isCV; })[0];
          if (_cvJob) {
            _renderFormatChooser(function (choices) {
              _cvJob._choices = choices;
              setTimeout(_generateAll, 300);   // now generate everything in sequence
            });
          } else {
            setTimeout(_generateAll, 300);
          }
        }
        setTimeout(_startBatch, 400);
      } else {
        // SAFETY NET for Bug 1: the AI sometimes SAYS "Generating your ... now" but forgets to
        // emit EXPORT_TRIGGER, so no file appears. If the reply clearly announces a generation
        // and this is an export-capable context, trigger the export anyway.
        // Safety net fires ONLY when the user's own message asked for a file — an answer that
        // merely says "generating…" on a plain question must never turn into an export.
        var _userAskedFile = /\b(file|document|docx?|word|pdf|excel|xlsx?|spreadsheet|powerpoint|pptx?|slides?|presentation|report|guide|manual|template|cv|resume|certificate)\b/i.test(msg || '')
          || /(ملف|مستند|وورد|إكسل|اكسل|بوربوينت|تقرير|دليل|سيرة|صدّر|صدر|حمّل|حمل)/.test(msg || '');
        var _saysGenerating = _userAskedFile
          && /\b(generating|creating|building|producing|preparing)\b[^.\n]*\b(word|docx|pdf|excel|xlsx|powerpoint|pptx|cv|resume|document|guide|file|report)\b/i.test(reply)
          && !/\b(would you|do you want|which|shall i|should i|can i|let me know|once you|after you)\b/i.test(reply);
        if (_saysGenerating) {
          S.history.push({role: 'assistant', content: reply});
          try { _updateResumeState(reply); } catch(_){}
          incrementQuery(); saveNow();
          var _fmt2 = /\b(pdf)\b/i.test(reply) ? 'pdf' : (/\b(excel|xlsx)\b/i.test(reply) ? 'xlsx' : (/\b(powerpoint|pptx)\b/i.test(reply) ? 'pptx' : 'docx'));
          var _resumeCtx2 = false; try { _resumeCtx2 = _isResumeConversation() || /\b(cv|resume)\b/i.test(reply); } catch(_){}
          setTimeout(function(){ if (_resumeCtx2) { try { _renderFormatChooser(); } catch(_){ doExport(_fmt2, savedBase64, savedExt); } } else { doExport(_fmt2, savedBase64, savedExt); } }, 400);
        } else {
          S.history.push({role: 'assistant', content: reply});
          try { _updateResumeState(reply); } catch(_){}
          incrementQuery();
          saveNow();
        }
      }
      if (S.voiceOn) if (checkVoiceLimit()) speakText(reply);
      try { showRatingBar(msg || '', S.vendor, S.product, 'chat'); } catch(_) {}
    });

  } catch(e) {
    _safeReset();
    addMsg('assistant', 'Connection error. Please try again.', null);
    console.error('[SendMsg]', e.message);
  } finally {
    _safeReset(); // always release loading state
  }
}

// ─────────────────────────────────────────────────────────────────────────────
// formatMarkdown — powered by marked.js + DOMPurify
// marked.js handles all CommonMark edge cases (nested lists, tables, fenced code)
// DOMPurify sanitises output before injection — XSS-safe
// IMGMETA markers and EOH custom UI (image cards, source pills, vote bars)
// are preserved exactly as before — marked.js only handles the text parts.
// ─────────────────────────────────────────────────────────────────────────────
(function _loadMarkdownLibs() {
  // Load marked.js if not already present.
  // Served from Shopify CDN (first-party) to avoid Edge Tracking Prevention warnings.
  // Upload marked.min.js (9.1.6) to Shopify theme assets if not already there.
  if (!window._markedLoaded) {
    var ms = document.createElement('script');
    // Prefer Shopify-hosted asset; fall back to cdnjs if asset not yet uploaded
    ms.src = window._markedSrc || 'https://cdnjs.cloudflare.com/ajax/libs/marked/9.1.6/marked.min.js';
    ms.onload = function() {
      window._markedLoaded = true;
      // Configure marked: GFM tables, line breaks, safe links
      if (window.marked) {
        window.marked.setOptions({
          gfm: true, breaks: true, pedantic: false,
          renderer: (function() {
            var r = new window.marked.Renderer();
            // Open all links in new tab safely
            r.link = function(href, title, text) {
              var h = (href || '').replace(/"/g, '&quot;');
              var t = title ? ' title="' + title.replace(/"/g, '&quot;') + '"' : '';
              return '<a href="' + h + '"' + t + ' target="_blank" rel="noopener" class="src-link">'
                + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:12px;height:12px;vertical-align:-1px;margin-right:3px"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>'
                + text + '</a>';
            };
            // Add copy button to code blocks
            r.code = function(code, lang) {
              // Visualization spec blocks → placeholders rendered by eoh-chat-visuals.js.
              var _l = String(lang || '').trim().toLowerCase();
              if (_l === 'chart' || _l === 'stat' || _l === 'kpi' || _l === 'mermaid') {
                var _cls = _l === 'mermaid' ? 'eoh-mermaid' : (_l === 'chart' ? 'eoh-chart' : 'eoh-stat');
                return '<div class="' + _cls + '" data-eoh-spec="' + encodeURIComponent(code) + '"></div>';
              }
              if (_l === 'visual') {
                return '<div class="eoh-visual" data-eoh-spec="' + encodeURIComponent(code) + '"></div>';
              }
              var escaped = code.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
              return '<pre><button class="copy-code-btn" onclick="copyCodeBlock(this)">Copy</button>'
                + '<code>' + escaped + '</code></pre>';
            };
            return r;
          })()
        });
      }
    };
    ms.onerror = function() { window._markedLoaded = false; };
    document.head.appendChild(ms);
  }
  // Load DOMPurify if not already present.
  // Served from Shopify CDN (first-party) — same reasoning as above.
  if (!window._dpLoaded) {
    var ds = document.createElement('script');
    ds.src = window._dpSrc || 'https://cdnjs.cloudflare.com/ajax/libs/dompurify/3.1.6/purify.min.js';
    ds.onload = function() { window._dpLoaded = true; };
    ds.onerror = function() { window._dpLoaded = false; };
    document.head.appendChild(ds);
  }
})();

function formatMarkdown(text) {
  if (text) text = text.replace(/\uFFFD/g,'');  // remove only the broken replacement char
  // ── Step 1: Extract IMGMETA markers BEFORE any processing ────────────────
  // These contain JSON metadata for image cards — must survive HTML encoding
  var _metaByUrl = {};
  var _imgMetaPlaceholders = {};
  var _phIdx = 0;
  text = text.replace(/<!--IMGMETA:(\{[\s\S]*?\\})-->/g, function(m, json) {
    try { var meta = JSON.parse(json); if (meta.url) _metaByUrl[meta.url] = meta; } catch(_) {}
    return '';
  });

  // ── Step 2: Extract user-uploaded image previews (base64) ────────────────
  // These are already HTML — protect them from being re-processed by marked
  var _htmlChunks = {};
  text = text.replace(/<div class="chat-img-row"[\s\S]*?<\/div>\s*(<script[^>]*>[\s\S]*?<\/script>)?/g, function(m) {
    var ph = '\x00HTMLCHUNK' + (_phIdx++) + '\x00';
    _htmlChunks[ph] = m;
    return ph;
  });
  // Also protect inline script tags (img-data)
  text = text.replace(/<script type="application\/json"[\s\S]*?<\/script>/g, function(m) {
    var ph = '\x00HTMLCHUNK' + (_phIdx++) + '\x00';
    _htmlChunks[ph] = m;
    return ph;
  });

  // ── Step 3: Inject user uploaded images above Image [N] headings ─────────
  if (S && S._lastUploadedImages && S._lastUploadedImages.length > 0) {
    text = text.replace(/(#{1,3}\s*(?:📋\s*)?(?:Analysis of\s+)?Image\s+(\d+)[^\n]*)/gi, function(match, full, num) {
      var idx = parseInt(num) - 1;
      if (idx >= 0 && idx < S._lastUploadedImages.length) {
        return '![uploaded image ' + num + '](' + S._lastUploadedImages[idx] + ')\n\n' + full;
      }
      return full;
    });
  }

  // ── Step 4: Render with marked.js (or regex fallback if not loaded) ───────
  var html = '';
  if (window._markedLoaded && window.marked) {
    try {
      html = window.marked.parse(text);
    } catch(e) {
      html = _markdownFallback(text);
    }
  } else {
    // marked.js not yet loaded — use lightweight fallback
    html = _markdownFallback(text);
  }

  // ── Step 5: Sanitise with DOMPurify (XSS protection) ─────────────────────
  if (window._dpLoaded && window.DOMPurify) {
    html = window.DOMPurify.sanitize(html, {
      ALLOWED_TAGS: ['p','br','b','strong','i','em','u','s','del','code','pre',
                     'h1','h2','h3','h4','h5','h6','ul','ol','li','blockquote',
                     'table','thead','tbody','tr','th','td','hr','a','img',
                     'div','span','button','script'],
      ALLOWED_ATTR: ['href','src','alt','class','target','rel','style',
                     'title','data-group','data-imggroup','data-imgidx',
                     'data-img-url','data-voted','data-n','type','onclick',
                     'onload','onerror','referrerpolicy'],
      FORCE_BODY: false,
      ALLOW_DATA_ATTR: true
    });
  }

  // ── Step 6: Post-process — restore EOH custom UI elements ────────────────
  // Convert markdown image syntax to EOH image cards with IMGMETA
  var _imgCollector = [];
  var _imgMetaMap   = {};
  var _imgGroupId   = 'imgs' + Math.random().toString(36).substr(2, 5);

  html = html.replace(/<img[^>]+src="(https?:\/\/[^"]+)"[^>]*>/g, function(tag, url) {
    var idx = _imgCollector.length;
    _imgCollector.push(url);
    if (_metaByUrl[url]) _imgMetaMap[idx] = _metaByUrl[url];
    return '<!--CHATIMG:' + idx + '-->';
  });

  // Group consecutive image placeholders into EOH image card grid
  html = html.replace(/(<!--CHATIMG:\d+-->[\s\n]*)+/g, function(block) {
    var re = /<!--CHATIMG:(\d+)-->/g, idxs = [], m;
    while ((m = re.exec(block)) !== null) idxs.push(parseInt(m[1]));
    if (!idxs.length) return block;
    var gridCls = idxs.length === 1 ? 'eoh-img-grid single' : 'eoh-img-grid';
    var gridHtml = '<div class="' + gridCls + '">';
    idxs.forEach(function(idx) {
      var imgUrl  = _imgCollector[idx];
      var meta    = _imgMetaMap[idx] || {};
      var isLib   = !!meta.from_lib;
      var srcLabel = isLib ? '📚 Library' : (meta.source || 'Web').substring(0, 24);
      var srcClass = isLib ? 'eoh-img-src library' : 'eoh-img-src';
      var tcBadge  = meta.t_code ? '<span class="eoh-img-tcode">' + meta.t_code + '</span>' : '';
      var safeUrl  = imgUrl.replace(/\)/g, '%29');
      gridHtml += '<div class="eoh-img-card">'
        + '<div class="eoh-img-wrap" data-imggroup="' + _imgGroupId + '" data-imgidx="' + idx + '" onclick="openLightboxGroup(this)">'
        + '<img src="' + safeUrl + '" alt="" referrerpolicy="no-referrer" '
        + 'onload="this.style.opacity=1;var s=this.nextElementSibling;if(s)s.style.display=\'none\'" '
        + 'onerror="var c=this.closest(\'.eoh-img-card\');if(c){c.style.display=\'none\';c.style.height=\'0\';c.style.margin=\'0\';c.style.padding=\'0\';c.style.border=\'none\';}" '
        + 'style="width:100%;display:block;opacity:0;transition:opacity .3s">'
        + '<div class="eoh-img-skeleton" style="position:absolute;inset:0"></div>'
        + '</div>';
      if (tcBadge || !isLib) {
        gridHtml += '<div class="eoh-img-badges">' + tcBadge + '<span class="' + srcClass + '">' + srcLabel + '</span></div>';
      }
      if (meta.screen_name || meta.table_name) {
        gridHtml += '<div class="eoh-img-caption">';
        if (meta.screen_name) gridHtml += '<div class="eoh-img-screen-name">' + meta.screen_name + '</div>';
        if (meta.table_name)  gridHtml += '<div class="eoh-img-table">🗄 ' + meta.table_name + '</div>';
        gridHtml += '</div>';
      }
      if (meta.user_description) {
        gridHtml += '<div class="eoh-img-desc">' + meta.user_description + '</div>';
      }
      gridHtml += '</div>';
    });
    gridHtml += '</div>';
    if (_imgCollector.length > 0) {
      gridHtml += '<script type="application/json" class="img-data" data-group="' + _imgGroupId + '">'
        + JSON.stringify(_imgCollector) + '<\/script>';
    }
    return gridHtml;
  });
  html = html.replace(/<!--CHATIMG:\d+-->/g, '');

  // Convert bare markdown links that survived to EOH source pills
  html = html.replace(/<a href="(https?:\/\/[^"]+)"([^>]*)>([^<]+)<\/a>/g, function(m, url, attrs, txt) {
    if (attrs.includes('src-link')) return m; // already styled
    return '<a href="' + url + '" target="_blank" rel="noopener" class="src-link">'
      + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:12px;height:12px;vertical-align:-1px;margin-right:3px"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>'
      + txt + '</a>';
  });

  // Restore HTML chunks (user image previews, script tags)
  Object.keys(_htmlChunks).forEach(function(ph) {
    html = html.replace(ph, _htmlChunks[ph]);
  });

  return html;
}

// ── Lightweight fallback renderer (used while marked.js loads) ───────────────
// Handles the most common patterns only — full rendering takes over once loaded
function _markdownFallback(text) {
  var s = text.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  s = s.replace(/```([a-z]*)\n([\s\S]*?)```/g, function(m,lang,code) {
    return '<pre><button class="copy-code-btn" onclick="copyCodeBlock(this)">Copy</button><code>' + code.trim() + '</code></pre>';
  });
  s = s.replace(/`([^`\n]+)`/g, '<code>$1</code>');
  s = s.replace(/^####\s+(.+)$/gm, '<h4>$1</h4>');
  s = s.replace(/^###\s+(.+)$/gm,  '<h3>$1</h3>');
  s = s.replace(/^##\s+(.+)$/gm,   '<h2>$1</h2>');
  s = s.replace(/\*\*\*([^*]+)\*\*\*/g, '<strong><em>$1</em></strong>');
  s = s.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  s = s.replace(/\*([^*\n]+)\*/g,   '<em>$1</em>');
  s = s.replace(/^[-•]\s+(.+)$/gm, '<li>$1</li>');
  s = s.replace(/(<li>[\s\S]+?<\/li>)/g, function(b) { return '<ul>' + b + '</ul>'; });
  s = s.replace(/^(\d+)\.\s+(.+)$/gm, '<li>$2</li>');
  s = s.replace(/^---+$/gm, '<hr>');
  s = s.replace(/\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g,
    '<a href="$2" target="_blank" rel="noopener" class="src-link">$1</a>');
  s = s.replace(/\n\n+/g, '</p><p>');
  s = '<p>' + s + '</p>';
  // ── Highlight a trailing follow-up question ────────────────────────────────
  // The AI often closes with an invitation ("Would you like to…?"). As plain body text it
  // gets lost, so give the LAST paragraph a distinct accent card when it's a question.
  // Theme-aware: uses CSS vars only (no hardcoded colors).
  s = s.replace(/<p>((?:(?!<\/p>)[\s\S])*\?)\s*<\/p>\s*$/, function (m, inner) {
    var plain = inner.replace(/<[^>]*>/g, '').trim();
    // Only a short, genuine closing question — not a long paragraph that merely ends in "?"
    if (plain.length < 12 || plain.length > 240) return m;
    if (/<(ul|ol|li|h[1-4]|pre|table)\b/i.test(inner)) return m;
    return '<p class="eoh-followup">' + inner + '</p>';
  });
  return s;
}

// ── Visuals render trigger ───────────────────────────────────────────────────
// formatMarkdown() emits <div class="eoh-visual|eoh-chart|eoh-stat|eoh-mermaid"> placeholders
// that eoh-chat-visuals.js fills in. The streaming path called the hook directly, but history
// reloads, voice replies and non-streaming replies never did — so their charts stayed blank.
// Call this after ANY assistant HTML is injected.
function _eohRenderVisuals(el, payload) {
  try {
    if (!el) return;
    if (typeof window.eohOnMessageComplete === 'function') {
      window.eohOnMessageComplete(el, payload || {});
    } else if (typeof window.eohRenderVisuals === 'function') {
      window.eohRenderVisuals(el);
    }
  } catch (e) { console.warn('[EOH] visuals render failed:', e); }
}

function addMsg(role, content, fileAtt) {
  var m = document.getElementById('msgs');
  var el = document.createElement('div');
  el.className = 'msg ' + role;
  var fmt = role === 'assistant' ? formatMarkdown(content)
    : (content.indexOf('chat-img-') !== -1 ? content : content.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/\n/g,'<br>'));
  var time = new Date().toLocaleTimeString([],{hour:'2-digit',minute:'2-digit'});
  var logoSrc = document.getElementById('main-logo') ? document.getElementById('main-logo').src : '';
  var _uAvatar = (S.user && (S.user.avatar || S.user.avatar_url)) || '';
  var _uInit   = (S.user && S.user.fullName ? S.user.fullName[0] : S.user && S.user.email ? S.user.email[0] : 'U').toUpperCase();
  var av = role === 'assistant'
    ? '<img src="' + logoSrc + '" alt="AI">'
    : _uInit;
  var dp = fileAtt ? '<div class="doc-prev"><span>&#128196;</span><span>' + fileAtt.name + '</span></div>' : '';
  var spk = role === 'assistant'
    ? '<button class="mspeak" data-txt="' + content.replace(/"/g,'&quot;').replace(/\n/g,' ').substring(0,500) + '" onclick="speakBtn(this)" title="Play / Stop voice">&#128266;</button>'
    : '';
  var replyBtn = role === 'assistant'
    ? '<button class="mreply" data-txt="' + content.replace(/"/g,'&quot;').replace(/\n/g,' ').substring(0,200) + '" onclick="replyToMsg(this)" title="Reply">&#8617;</button>'
    : '';
  el.innerHTML = '<div class="mav">' + av + '</div>'
    + '<div class="mbody"><div class="msender">' + (role === 'assistant' ? 'EOH' : (S.user && S.user.fullName ? S.user.fullName.toUpperCase() : 'YOU')) + '</div>'
    + dp + '<div class="mbubble">' + fmt + '</div>'
    + '<div class="mmeta"><span class="mtime">' + time + '</span>'
    + '<button class="mcopy" onclick="copyMsg(this)">Copy</button>' + replyBtn + spk
    + (role === 'assistant' ? '<button class="mshare" onclick="shareMsg(this)" title="Share this response"><svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-2px"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.6" y1="13.5" x2="15.4" y2="17.5"/><line x1="15.4" y1="6.5" x2="8.6" y2="10.5"/></svg></button>' : '')
    + '</div>'
    + '</div>';
  m.appendChild(el);
  // Fill in any visualization placeholders in this message (charts/KPIs/mermaid).
  if (role === 'assistant') {
    var _vb = el.querySelector('.mbubble') || el;
    if (_vb.querySelector('.eoh-visual, .eoh-chart, .eoh-stat, .eoh-mermaid')) {
      _eohRenderVisuals(_vb, { reply: content });
    }
  }
  // Preload user avatar after el is in DOM — closure keeps _uAvatar and _uInit in scope
  if (role === 'user' && _uAvatar) {
    var _mavEl  = el.querySelector('.mav');
    var _tmpImg = new Image();
    _tmpImg.onload = function() {
      if (!_mavEl) return;
      _mavEl.style.background = 'none';
      _mavEl.style.border     = 'none';
      _mavEl.style.color      = 'transparent';
      _mavEl.innerHTML        = '';
      var img = document.createElement('img');
      img.src = _uAvatar;
      img.alt = '';
      img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;border-radius:4px';
      _mavEl.appendChild(img);
    };
    _tmpImg.onerror = function() { /* keep initial letter */ };
    _tmpImg.src = _uAvatar;
  }
  m.scrollTop = m.scrollHeight;
}


// ═══════════════════════════════════════════════════════════════════════════════
// STREAMING CHAT — Phase 3 AI Optimization
// Receives text chunks via SSE and renders them token-by-token
// ═══════════════════════════════════════════════════════════════════════════════
async function _streamChat(bodyStr, onStreamDone) {
  // Create the assistant bubble immediately (empty)
  var msgs = document.getElementById('msgs');
  var bubble = document.createElement('div');
  bubble.className = 'msg assistant';
  var logoSrc = document.getElementById('main-logo') ? document.getElementById('main-logo').src : '';
  var time = new Date().toLocaleTimeString([],{hour:'2-digit',minute:'2-digit'});
  // Show typing dots while waiting for first chunk, replace with content when it arrives
  var _bubbleUid = 'sbc-' + Date.now();
  bubble.innerHTML = '<div class="mav"><img src="' + _getLogoSrc() + '" alt="AI"></div>'
    + '<div class="mbody"><div class="msender">EOH</div>'
    + '<div class="mbubble"></div>'
    + '<div class="mmeta"><span class="mtime">' + time + '</span></div>'
    + '</div>';

  // showTyping() stays visible until first chunk — gives animation time to run
  var bubbleEl = bubble.querySelector('.mbubble');
  if (typeof window._eohTwInit === 'function') window._eohTwInit(bubbleEl, msgs);
  var _bubbleAdded = false;
  function _addBubble() {
    if (_bubbleAdded) return;
    _stopStatusAnim();
    removeTyping();
    msgs.appendChild(bubble);
    msgs.scrollTop = msgs.scrollHeight;
    _bubbleAdded = true;
  }
  var accumulated = '';

  // ── Proactive token refresh — prevents 401 mid-chat ─────────────────────
  try {
    var _rt = localStorage.getItem('eoh_rt');
    var _tTs = parseInt(localStorage.getItem('eoh_t_ts') || '0', 10);
    if (_rt && S.token && (Date.now() - _tTs > 45 * 60 * 1000)) {
      var _prRes = await window.fetch(API + '/auth/refresh', {
        method:'POST', headers:{'Content-Type':'application/json'}, credentials:'include',
        body: JSON.stringify({refresh_token: _rt})
      }).catch(function(){return null;});
      if (_prRes && _prRes.ok) {
        var _prData = await _prRes.json().catch(function(){return {};});
        if (_prData.token) {
          S.token = _prData.token;
          localStorage.setItem('eoh_t', _prData.token);
          localStorage.setItem('eoh_t_ts', String(Date.now()));
          if (_prData.refresh_token) localStorage.setItem('eoh_rt', _prData.refresh_token);
        }
      }
    }
  } catch(_) { /* silent — proceed with existing token */ }

  try {
    var streamRes = await window.fetch(API + '/chat', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + (S.token || ''),
        'Accept': 'text/event-stream'
      },
      body: bodyStr,
      signal: (typeof _chatAbort !== 'undefined' && _chatAbort) ? _chatAbort.signal : undefined
    });

    if (!streamRes.ok) {
      var errData = await streamRes.json().catch(function(){return {};});
      bubble.remove();
      // Pass meaningful error strings for upstream handlers to act on
      var _errStr = errData.error || 'Request failed';
      if (streamRes.status === 401) _errStr = '401 ' + _errStr;
      if (streamRes.status === 403 && errData.error === 'account_blocked') _errStr = 'account_blocked';
      if (streamRes.status === 429) _errStr = 'rate_limited:' + (errData.error || 'Too many requests');
      onStreamDone(null, _errStr);
      return;
    }

    // ── Safety net: if backend returned JSON instead of SSE (e.g. fallback path) ──
    // Parse immediately and call onStreamDone — prevents infinite hanging dots
    var _ct = streamRes.headers.get('content-type') || '';
    if (!_ct.includes('text/event-stream') && _ct.includes('application/json')) {
      var _jsonData = await streamRes.json().catch(function(){ return {}; });
      var _jsonReply = _jsonData.reply || '';
      if (_jsonData.download && _jsonData.download.url) {
        _jsonReply = _jsonReply.replace(/\[Download[^\]]*\]\([^)]*\)/gi, '').replace(/\n{3,}/g, '\n\n').trim();
        _jsonReply += '\n\n[\u2193 Download ' + (_jsonData.download.name || 'file') + '](' + _jsonData.download.url + ')';
      }
      if (_jsonReply) {
        // Render the reply in the bubble directly
        _addBubble();
        if (bubbleEl) {
          var _jcs = _eohCursorSrc || _getLogoSrc();
          bubbleEl.innerHTML = formatMarkdown(_jsonReply) + (_jcs ? '<span class="stream-cursor"><img src="' + _jcs + '"></span>' : '<span class="stream-cursor">▊</span>');
          msgs.scrollTop = msgs.scrollHeight;
          var _jbEl = bubbleEl, _jReply = _jsonReply, _jBub = bubble, _jT = time;
          var _jPa = _jsonData.pm_action || null;
          setTimeout(function() {
            if (_jbEl) _jbEl.innerHTML = formatMarkdown(_jReply);
            var metaEl = _jBub.querySelector('.mmeta');
            if (metaEl) {
              var _rt = _jReply.replace(/"/g,'&quot;').replace(/\n/g,' ');
              metaEl.innerHTML = '<span class="mtime">' + _jT + '</span>'
                + '<button class="mcopy" onclick="copyMsg(this)">Copy</button>'
                + '<button class="mreply" data-txt="' + _rt.substring(0,200) + '" onclick="replyToMsg(this)" title="Reply">&#8617;</button>'
                + '<button class="mspeak" data-txt="' + _rt.substring(0, window._voiceReplyMaxChars||1500) + '" onclick="speakBtn(this)" title="Play / Stop voice">&#128266;</button>'
                + '<button class="mshare" onclick="shareMsg(this)" title="Share"><svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-2px"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.6" y1="13.5" x2="15.4" y2="17.5"/><line x1="15.4" y1="6.5" x2="8.6" y2="10.5"/></svg></button>';
            }
            msgs.scrollTop = msgs.scrollHeight;
          }, 700);
        }
      }
      onStreamDone(_jsonReply || '', _jsonData.error || null, _jsonData.pm_action || null);
      return;
    }

    var reader = streamRes.body.getReader();
    var decoder = new TextDecoder();
    var buf = '';

    while (true) {
      var _read = await reader.read();
      if (_read.done) break;
      buf += decoder.decode(_read.value, { stream: true });

      // Parse SSE lines
      var lines = buf.split('\n');
      buf = lines.pop(); // keep incomplete line

      for (var i = 0; i < lines.length; i++) {
        var line = lines[i].trim();
        if (!line || !line.startsWith('data: ')) continue;
        var jsonStr = line.slice(6);
        try {
          var evt = JSON.parse(jsonStr);
          if (evt.error) {
            bubble.remove();
            onStreamDone(null, evt.error);
            return;
          }
          if (evt.chunk) {
            accumulated += evt.chunk;
            if (accumulated.indexOf('\uFFFD') !== -1) accumulated = accumulated.replace(/\uFFFD/g, '');  // kill broken char at source
            _addBubble();
            if (typeof window._eohTwFeed === 'function') {
              window._eohTwFeed(_hideAskForDisplay(accumulated));
            } else if (bubbleEl) {
              var _cs = _eohCursorSrc || _getLogoSrc();
              bubbleEl.innerHTML = formatMarkdown(_hideAskForDisplay(accumulated)) + (_cs ? '<span class="stream-cursor"><img src="' + _cs + '"></span>' : '<span class="stream-cursor">&#9642;</span>');
              msgs.scrollTop = msgs.scrollHeight;
            }
          }
          if (evt.done) {
            var finalReply = evt.reply || accumulated;
            finalReply = finalReply.replace(/\[IMAGE[^\]]*\]/gi, '');
            var _rawFinalForRecovery = finalReply;
            // Structured clarify from the backend is authoritative — no text parsing needed.
            // The client used to reconstruct this from markers in the answer text, which broke
            // whenever the model varied the format. Parsers below are a legacy fallback only.
            try {
              console.log('[EOH] clarify from backend: '
                + (evt.clarify ? ((evt.clarify.options || []).length + ' options') : 'NONE (field absent)'));
            } catch (_) {}
            var _askParsed = (evt.clarify && evt.clarify.options && evt.clarify.options.length)
              ? { question: String(evt.clarify.question || '').trim(), options: evt.clarify.options }
              : (_parseAskBlock(finalReply) || _parseDidYouMean(finalReply) || _parseNextBlock(finalReply) || _parseClarifyLenient(finalReply));
            if (_askParsed && !(_parseAskBlock(finalReply) || _parseDidYouMean(finalReply) || _parseNextBlock(finalReply))) {
              try { console.warn('[EOH] clarify recovered leniently \u2014 ' + _askParsed.options.length + ' options'); } catch (_) {}
            }
            // Robust strip for the bubble: handles complete AND malformed/unclosed [[ASK]]/[[DIDYOUMEAN]]
            // blocks, so a stray directive never leaks as a quoted-JSON "quotation" at the end.
            finalReply = _hideAskForDisplay(finalReply).replace(/\n{3,}/g, '\n\n').trim();
            // Guard: if stripping emptied the bubble AND no clarify widget will render, the
            // directive was malformed — recover readable text instead of showing nothing.
            if (!finalReply && !_askParsed) {
              finalReply = _recoverClarifyText(_rawFinalForRecovery || '');
              if (finalReply) console.warn('[EOH] recovered text from malformed clarify directive');
            }
            // Option B: the follow-up question is shown INLINE as a tinted prompt bar, not in a
            // separate panel. A directive-supplied question is appended to the bubble text so
            // formatMarkdown can tag it — this is why it can never render empty or attach to
            // the wrong message: it is part of the answer text itself.
            if (_askParsed && String(_askParsed.question || '').trim()) {
              var _q = String(_askParsed.question).trim();
              // The backend now strips the directive and leaves the prose question in the
              // reply, so appending it again duplicated the question — visible after a
              // reload because BOTH copies were saved to history. Only supply the question
              // when the reply genuinely has no text of its own.
              if (!finalReply.trim()) finalReply = _q;
              // The OPTIONS must survive too. Without them the user sees a dangling
              // "are you looking to:" they cannot answer, and the model asks again.
              // Options are ALWAYS rendered as tappable chips below (from _askParsed,
              // whatever its source), so they must never also be written into the text.
              // Gating this on evt.clarify was wrong: with an older backend the chips
              // still rendered AND the list was duplicated into the answer.
            }
            finalReply = _dedupeParas(_stripDirectiveMarkers(finalReply));
            var _frBubble = finalReply;  // the bubble shows everything, question included
            if (_askParsed) {
              // History/context keep the question ONCE (the backend already leaves the prose
              // question in the reply, so appending blindly saved it twice) and keep the OPTIONS
              // (they were only ever rendered as chips, so after a reload — and to the AI on the
              // next turn — the question looked unanswered and it asked again).
              var _norm = function (x) { return String(x || '').replace(/\s+/g, ' ').trim().toLowerCase(); };
              var _qn = _stripDirectiveMarkers(_askParsed.question || '');
              if (_qn && _norm(finalReply).indexOf(_norm(_qn)) === -1) finalReply = finalReply ? (finalReply + '\n\n' + _qn) : _qn;
              var _optsClean = (_askParsed.options || []).map(_stripDirectiveMarkers).filter(Boolean);
              if (_optsClean.length) finalReply += '\n\n' + _optsClean.map(function (o) { return '- ' + o; }).join('\n');
              finalReply = _stripDirectiveMarkers(finalReply);
            }
            // Robust download: when the backend sends a structured download, rebuild a clean link from
            // it so the download is never lost to markdown/stream quirks (this is the reliable path).
            if (evt.download && evt.download.url) {
              finalReply = finalReply.replace(/\[Download[^\]]*\]\([^)]*\)/gi, '').replace(/\n{3,}/g, '\n\n').trim();
              finalReply += '\n\n[\u2193 Download ' + (evt.download.name || 'file') + '](' + evt.download.url + ')';
              // The bubble was captured BEFORE this, so a document request that returns a file
              // and no prose rendered an EMPTY bubble with the download link nowhere in sight.
              // Rebuild the bubble text with the link included.
              _frBubble = _frBubble
                ? _frBubble.replace(/\[Download[^\]]*\]\([^)]*\)/gi, '').trim() + '\n\n[\u2193 Download ' + (evt.download.name || 'file') + '](' + evt.download.url + ')'
                : ('Your file is ready.\n\n[\u2193 Download ' + (evt.download.name || 'file') + '](' + evt.download.url + ')');
            }
            _addBubble();
            var _fr = finalReply, _bub = bubble, _t = time, _pa = evt.pm_action, _srcs = (evt.sources || []);
            var _finalizeBubble = function() {
              // Question renders inline (option B). When real options exist, add tappable
              // chips beneath so the user can answer in one tap instead of retyping —
              // which is what stopped the clarify loop.
              if (_askParsed && _askParsed.options && _askParsed.options.length) {
                try {
                  _renderQuickReplies(_bub, _askParsed.options);
                  var _chips = document.querySelectorAll('.eoh-qr-chip').length;
                  console.log('[EOH] quick replies rendered — ' + _askParsed.options.length
                    + ' options, ' + _chips + ' chips now in DOM');
                } catch (e) { console.error('[EOH] quick replies FAILED:', e); }
              } else {
                console.log('[EOH] no options to render (askParsed: ' + (_askParsed ? 'yes but empty' : 'null') + ')');
              }
              // _renderNextButton intentionally disabled — the "Continue" affordance was
              // redundant with the inline prompt + quick replies and caused confusion.
              // Only auto-detect prose choices when there's NO clarify widget — otherwise the
              // question renders twice (widget + a second button set).
              if (!_askParsed) { try { _renderChoiceButtons(_fr); } catch (_) {} }
              var metaEl = _bub.querySelector('.mmeta');
              if (metaEl) {
                var _rt = _fr.replace(/"/g,'&quot;').replace(/\n/g,' ');
                metaEl.innerHTML = '<span class="mtime">' + _t + '</span>'
                  + '<button class="mcopy" onclick="copyMsg(this)">Copy</button>'
                  + '<button class="mreply" data-txt="' + _rt.substring(0,200) + '" onclick="replyToMsg(this)" title="Reply">&#8617;</button>'
                  + '<button class="mspeak" data-txt="' + _rt.substring(0, window._voiceReplyMaxChars||1500) + '" onclick="speakBtn(this)" title="Play / Stop voice">&#128266;</button>'
                  + '<button class="mshare" onclick="shareMsg(this)" title="Share"><svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-2px"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.6" y1="13.5" x2="15.4" y2="17.5"/><line x1="15.4" y1="6.5" x2="8.6" y2="10.5"/></svg></button>';
              }
              msgs.scrollTop = msgs.scrollHeight;
              // Outputs feature hook — sources UI, per-message actions, code highlight
              try { if (typeof window.eohOnMessageComplete === 'function') window.eohOnMessageComplete(_bub, { reply: _fr, sources: _srcs }); else _eohRenderVisuals(_bub, { reply: _fr, sources: _srcs }); } catch (_) {}
              try { window._eohLastSources = (_srcs && _srcs.length) ? _srcs : null; } catch (_) {}
              // Pass the RAW reply (with EXPORT_TRIGGER intact) to the callback — NOT the display-
              // cleaned _fr. The callback strips the trigger itself; if we pass the cleaned text the
              // trigger is gone and the export never fires (root cause of "no file" when the model
              // puts the trigger inline/first, e.g. Arabic). The bubble already shows cleaned text.
              onStreamDone((_rawFinalForRecovery && /EXPORT_TRIGGER:/i.test(_rawFinalForRecovery)) ? _rawFinalForRecovery : _fr, null, _pa);
            };
            // Guard: never render a blank bubble. If the stream completed with no usable
            // text (backend returned an empty reply, or the whole payload was stripped),
            // say so plainly and log the raw payload so the cause is diagnosable.
            // DIAGNOSTIC: a suspiciously short answer means the reply was truncated upstream.
            // Log the RAW payload (head + tail) so we can see exactly what the backend sent
            // and whether a directive/marker was cut off mid-emission.
            try {
              var _rawDbg = String(_rawFinalForRecovery || '');
              if (_rawDbg.length < 400) {
                console.warn('[EOH] SHORT REPLY (' + _rawDbg.length + ' chars) — raw head: '
                  + JSON.stringify(_rawDbg.slice(0, 300))
                  + ' | raw tail: ' + JSON.stringify(_rawDbg.slice(-150))
                  + ' | bubble: ' + String(_frBubble || '').length + ' chars'
                  + ' | clarify: ' + (_askParsed ? (_askParsed.options || []).length + ' opts' : 'none')
                  + ' | markers: ' + (/\[\[/.test(_rawDbg) ? 'PRESENT' : 'none'));
              }
            } catch (_) {}
            var _askUsable = !!(_askParsed && _askParsed.options && _askParsed.options.length
                                && String(_askParsed.question || '').trim());
            if (!_askUsable) _askParsed = null;   // don't suppress the guard on an unusable clarify
            var _hasTriggerOnly = /EXPORT_TRIGGER:(pdf|docx|xlsx|pptx|resume|txt)/i.test(String(_rawFinalForRecovery || ''));
            if (_hasTriggerOnly && !String(_frBubble || '').trim()) { _frBubble = 'Generating your file\u2026'; }
            if (!String(_frBubble || '').trim() && !_askParsed && !(evt.download && evt.download.url) && !_hasTriggerOnly) {
              try {
                console.error('[EOH] EMPTY REPLY — raw length: ' + String(_rawFinalForRecovery || '').length
                  + ' | first 200: ' + JSON.stringify(String(_rawFinalForRecovery || '').slice(0, 200)));
              } catch (_) {}
              _frBubble = 'That response came back empty. Send it again \u2014 if it keeps happening, '
                        + 'try rephrasing the question or shortening the conversation.';
              _fr = _frBubble;
            }
            if (typeof window._eohTwFinish === 'function') {
              window._eohTwFinish(_frBubble, _finalizeBubble);
            } else {
              var _cs2 = _eohCursorSrc || _getLogoSrc();
              if (bubbleEl) bubbleEl.innerHTML = formatMarkdown(_frBubble) + (_cs2 ? '<span class="stream-cursor"><img src="' + _cs2 + '"></span>' : '<span class="stream-cursor">&#9642;</span>');
              setTimeout(_finalizeBubble, 700);
            }
            return;
          }
        } catch(_) {}
      }
    }
    // Stream ended without done event — use accumulated
    if (accumulated && bubbleEl) {
      _addBubble();
      if (typeof window._eohTwFinish === 'function') {
        window._eohTwFinish(accumulated, function() { onStreamDone(accumulated, null); });
      } else {
        var _ecs = _eohCursorSrc || _getLogoSrc();
        bubbleEl.innerHTML = formatMarkdown(accumulated) + (_ecs ? '<span class="stream-cursor"><img src="' + _ecs + '"></span>' : '<span class="stream-cursor">&#9642;</span>');
        setTimeout(function() { bubbleEl.innerHTML = formatMarkdown(accumulated); _eohRenderVisuals(bubbleEl, { reply: accumulated }); onStreamDone(accumulated, null); }, 700);
      }
    } else {
      onStreamDone(accumulated || '', null);
    }
  } catch(fetchErr) {
    // User pressed Stop — keep whatever streamed so far, no error.
    if (fetchErr && (fetchErr.name === 'AbortError' || /abort/i.test(fetchErr.message||''))) {
      if (accumulated && bubbleEl) {
        try { bubbleEl.innerHTML = formatMarkdown(accumulated); } catch(_){}
        onStreamDone(accumulated, null);
      } else {
        try { bubble.remove(); } catch(_){}
        // nothing generated before Stop — release state via sendMsg's finally, no empty bubble
      }
      return;
    }
    bubble.remove();
    onStreamDone(null, fetchErr.message);
  }
}


// ── Image voting ──────────────────────────────────────────────────────────────

// ── Star rating system ────────────────────────────────────────────────────────
// localStorage cache keyed by session+type+ref
var _ratingCache = (function(){
  try { return JSON.parse(localStorage.getItem('eoh_ratings')||'{}'); } catch(_){ return {}; }
})();
function _saveRatingCache(){ try{ localStorage.setItem('eoh_ratings', JSON.stringify(_ratingCache)); }catch(_){} }
function _getRatingKey(type, ref){ return type + ':' + (ref||'').substring(0,60); }

function renderStars(type, contextRef, vendor, product) {
  var ref    = (contextRef||'').substring(0,120);
  var rkey   = _getRatingKey(type, ref);
  var stored = _ratingCache[rkey] || 0;
  var uid    = 'sr' + Math.random().toString(36).substr(2,6);
  var stars  = '';
  for (var n = 1; n <= 5; n++) {
    stars += '<span class="eoh-star'+(stored >= n ? ' lit rated' : '')+'" data-n="'+n+'" '
      + (stored ? '' : 'onmouseover="hoverStars(this,'+n+')" onmouseout="unhoverStars(this)" onclick="submitRating(this,'+n+')" ')
      + '>★</span>';
  }
  var thanksStyle = stored ? 'opacity:1' : 'opacity:0';
  var thanksText  = stored ? (stored+'★ rated') : 'Thanks!';
  return '<div class="eoh-stars" id="'+uid+'" data-type="'+type+'" data-ref="'+encodeURIComponent(ref)+'" data-vendor="'+(vendor||'')+'" data-product="'+(product||'')+'">'
    + '<span class="eoh-stars-label">Rate:</span>'
    + '<div class="eoh-star-row">'+stars+'</div>'
    + '<span class="eoh-stars-thanks" style="'+thanksStyle+'">'+thanksText+'</span>'
    + '</div>';
}

function hoverStars(el, n) {
  var row = el.closest('.eoh-star-row');
  if (!row || row.querySelector('.eoh-star.rated')) return;
  row.querySelectorAll('.eoh-star').forEach(function(s,i){ s.classList.toggle('hover', i < n); });
}
function unhoverStars(el) {
  var row = el.closest('.eoh-star-row');
  if (!row) return;
  row.querySelectorAll('.eoh-star').forEach(function(s){ s.classList.remove('hover'); });
}


// ── Single floating rating bar — appears once at bottom after AI responds ─────
var _lastRatingRef  = '';   // the user's question that generated the last reply
var _lastRatingVendor = '';
var _lastRatingProduct = '';

function showRatingBar(userQuestion, vendor, product, ratingType) {
  // Check both localStorage (instant cross-tab) and window flag (from DB on load)
  var _off = localStorage.getItem('eoh_ratings_off') === '1'
    || window._ratingsEnabled === false;
  if (_off) {
    var _bar = document.getElementById('eoh-rating-bar');
    if (_bar) { _bar.style.opacity = '0'; _bar.innerHTML = ''; }
    return;
  }
  _lastRatingRef     = (userQuestion || '').substring(0, 120);
  _lastRatingVendor  = vendor  || S.vendor  || '';
  _lastRatingProduct = product || S.product || '';
  var bar = document.getElementById('eoh-rating-bar');
  if (!bar) return;
  var rkey    = _getRatingKey(ratingType || 'chat', _lastRatingRef);
  var stored  = _ratingCache[rkey] || 0;
  var locked  = stored > 0;
  var stars = '';
  var _rt = ratingType || 'chat';
  for (var n = 1; n <= 5; n++) {
    var _lit = stored >= n;
    var _evts = locked ? '' : ('onmouseover="rbHover(this,' + n + ')" onmouseout="rbUnhover(this)" onclick="rbRate(this,' + n + ',\'' + _rt + '\')" ');
    stars += '<span class="rb-star' + (_lit ? ' rb-lit' : '') + '" data-n="' + n + '" ' + _evts + 'style="cursor:' + (locked ? 'default' : 'pointer') + '">★</span>';
  }
    bar.dataset.type    = ratingType || 'chat';
  bar.dataset.locked  = locked ? '1' : '';
  bar.innerHTML = '<span class="rb-label">Rate this response:</span>'
    + '<span class="rb-stars">' + stars + '</span>'
    + '<span class="rb-thanks" style="opacity:'+(locked?'1':'0')+'">'+( locked ? stored+'★' : 'Thanks!' )+'</span>';
  bar.style.opacity = '1';
  bar.style.pointerEvents = '';
}

function rbHover(el, n) {
  var row = el.closest('.rb-stars') || el.parentElement;
  row.querySelectorAll('.rb-star').forEach(function(s,i){ s.classList.toggle('rb-hover', i < n); });
}
function rbUnhover(el) {
  var row = el.closest('.rb-stars') || el.parentElement;
  row.querySelectorAll('.rb-star').forEach(function(s){ s.classList.remove('rb-hover'); });
}

async function rbRate(el, stars, ratingType) {
  // Re-read from localStorage in case admin toggled (updated via storage event)
  if (localStorage.getItem('eoh_ratings_off') === '1') return;
  if (window._ratingsEnabled === false) return;
  var bar = document.getElementById('eoh-rating-bar');
  if (!bar || bar.dataset.locked) return;
  // Lock visually
  bar.dataset.locked = '1';
  bar.querySelectorAll('.rb-star').forEach(function(s,i){
    s.classList.remove('rb-hover');
    s.classList.toggle('rb-lit', i < stars);
    s.style.cursor = 'default';
    s.onmouseover = null; s.onmouseout = null; s.onclick = null;
  });
  var thanks = bar.querySelector('.rb-thanks');
  if (thanks) { thanks.textContent = stars + '★'; setTimeout(function(){ thanks.style.opacity = '1'; }, 80); }
  // Persist locally
  var rkey = _getRatingKey(ratingType || 'chat', _lastRatingRef);
  _ratingCache[rkey] = stars;
  _saveRatingCache();
  // Send to backend
  if (!S || !S.token) return;
  try {
    var _rRes = await window.fetch(API + '/profile/rate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + S.token },
      body: JSON.stringify({
        type:        ratingType || 'chat',
        stars:       stars,
        content_ref: _lastRatingRef,
        vendor:      _lastRatingVendor,
        product:     _lastRatingProduct,
        session_id:  S_sessionId || null,
      })
    });
    var _rData = await _rRes.json().catch(function(){ return {}; });
    console.log('[Rating] POST /profile/rate →', _rRes.status, _rData);
  } catch(e) { console.warn('[Rating]', e.message); }
}

async function submitRating(el, stars) {
  if (window._ratingsEnabled === false) return;
  var wrap = el.closest('.eoh-stars');
  if (!wrap) return;
  // Lock visually immediately
  wrap.querySelectorAll('.eoh-star').forEach(function(s,i){
    s.classList.add('rated'); s.classList.toggle('lit', i < stars);
    s.onmouseover = null; s.onmouseout = null; s.onclick = null;
  });
  var thanks = wrap.querySelector('.eoh-stars-thanks');
  if (thanks) { thanks.textContent = stars+'★ rated'; setTimeout(function(){ thanks.style.opacity='1'; }, 80); }
  // Persist to localStorage
  var rkey = _getRatingKey(wrap.dataset.type, decodeURIComponent(wrap.dataset.ref||''));
  _ratingCache[rkey] = stars;
  _saveRatingCache();
  if (!S || !S.token) return;
  try {
    await window.fetch(API + '/profile/rate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + S.token },
      body: JSON.stringify({
        type:        wrap.dataset.type,
        stars:       stars,
        content_ref: decodeURIComponent(wrap.dataset.ref||''),
        vendor:      wrap.dataset.vendor || (S.vendor||''),
        product:     wrap.dataset.product || (S.product||''),
        session_id:  S_sessionId || null,
      })
    });
  } catch(e) { console.warn('[Rating]', e.message); }
}

// ── Vote persistence via localStorage (survives page refresh) ────────────────
var _imgVoteCache = (function() {
  try { return JSON.parse(localStorage.getItem('eoh_img_votes') || '{}'); } catch(_) { return {}; }
})();
function _saveVoteCache() {
  try { localStorage.setItem('eoh_img_votes', JSON.stringify(_imgVoteCache)); } catch(_) {}
}
function _getStoredVote(url) { return _imgVoteCache[url] ? _imgVoteCache[url].vote : 0; }
function _setStoredVote(url, vote, likes) {
  if (vote === 0) { delete _imgVoteCache[url]; }
  else { _imgVoteCache[url] = { vote: vote, likes: likes || 0, ts: Date.now() }; }
  _saveVoteCache();
}

// Apply stored votes to any rendered image cards
function applyStoredVotes() {
  document.querySelectorAll('.eoh-img-vote').forEach(function(bar) {
    var urlEl = bar.querySelector('[data-img-url]');
    if (!urlEl) return;
    var url = urlEl.dataset.imgUrl;
    var stored = _imgVoteCache[url];
    if (!stored) return;
    var btns = bar.querySelectorAll('.eoh-vote-btn');
    var likeBtn = btns[0], dislikeBtn = btns[1];
    var countEl = likeBtn ? likeBtn.querySelector('.eoh-vote-count') : null;
    if (stored.vote === 1  && likeBtn)    { likeBtn.classList.add('liked'); likeBtn.dataset.voted = '1'; }
    if (stored.vote === -1 && dislikeBtn) { dislikeBtn.classList.add('disliked'); dislikeBtn.dataset.voted = '-1'; }
    if (countEl && stored.likes > 0) countEl.textContent = stored.likes;
  });
}

async function submitImgRating(el, stars, metaB64) {
  if (window._ratingsEnabled === false) return;
  var meta = {};
  try { meta = JSON.parse(decodeURIComponent(escape(atob(metaB64)))); } catch(_){}
  // Lock star row visually — el is a span inside a span row inside the rating div
  var starRow = el.parentElement;
  if (starRow) starRow.querySelectorAll('span').forEach(function(s,i){
    s.style.color  = i < stars ? '#f59e0b' : '#3a4560';
    s.style.cursor = 'default';
    s.onmouseover  = null; s.onmouseout = null; s.onclick = null;
    s.dataset.lit  = i < stars ? '1' : '';
  });
  // Show thanks - next sibling of starRow
  var thanks = starRow ? starRow.nextElementSibling : null;
  if (thanks) setTimeout(function(){ thanks.style.opacity = '1'; }, 100);
  // Persist locally
  var rkey = _getRatingKey('image', meta.url||'');
  _ratingCache[rkey] = stars;
  _saveRatingCache();
  if (!S || !S.token) return;
  try {
    await window.fetch(API + '/profile/rate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + S.token },
      body: JSON.stringify({
        type: 'image', stars: stars,
        content_ref: meta.url || '',
        vendor: meta.vendor || (S.vendor||''),
        product: meta.product || (S.product||''),
        session_id: S_sessionId || null,
      })
    });
  } catch(e) { console.warn('[ImgRating]', e.message); }
}

async function voteImage(btn, vote, metaB64) {
  // Parse metadata
  var meta = {};
  try { meta = JSON.parse(decodeURIComponent(escape(atob(metaB64)))); } catch(_) {}
  if (!meta.url) return;

  // ── Find vote bar elements ───────────────────────────────────────────────
  var voteBar    = btn.closest('.eoh-img-vote');
  var allBtns    = voteBar ? voteBar.querySelectorAll('.eoh-vote-btn') : [];
  var likeBtn    = allBtns[0] || null;
  var dislikeBtn = allBtns[1] || null;
  var countEl    = likeBtn ? likeBtn.querySelector('.eoh-vote-count') : null;

  // Toggle: clicking same vote removes it
  var prevVote    = _getStoredVote(meta.url) || (btn.dataset.voted ? parseInt(btn.dataset.voted) : 0);
  var currentVote = prevVote === vote ? 0 : vote;

  // ── Apply visual state immediately ──────────────────────────────────────
  if (likeBtn)    { likeBtn.classList.toggle('liked',      currentVote === 1);  likeBtn.dataset.voted    = currentVote === 1  ? '1' : ''; }
  if (dislikeBtn) { dislikeBtn.classList.toggle('disliked', currentVote === -1); dislikeBtn.dataset.voted = currentVote === -1 ? '-1': ''; }

  // Brief pulse animation (doesn't replace innerHTML — just adds temporary class)
  if (currentVote !== 0) {
    btn.style.transform = 'scale(1.25)';
    setTimeout(function(){ btn.style.transform = ''; }, 200);
  }

  // ── Persist locally immediately ──────────────────────────────────────────
  var currentLikes = countEl ? (parseInt(countEl.textContent) || 0) : 0;
  if (currentVote === 1)  currentLikes++;
  if (prevVote    === 1)  currentLikes = Math.max(0, currentLikes - 1); // undo
  if (currentVote === 0 && prevVote !== 1) currentLikes = Math.max(0, currentLikes);
  _setStoredVote(meta.url, currentVote, currentLikes);
  if (countEl) countEl.textContent = currentLikes > 0 ? currentLikes : '';

  if (currentVote === 0) return; // undo — skip API

  // ── API call ──────────────────────────────────────────────────────────────
  if (!S || !S.token) return; // visual already done

  try {
    var res = await window.fetch(API + '/profile/image-vote', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + S.token },
      body: JSON.stringify({
        url: meta.url, title: meta.title, t_code: meta.t_code,
        vendor: meta.vendor, product: meta.product,
        source: meta.source, query: meta.query || '', vote: currentVote
      })
    });
    if (res.ok) {
      var d = await res.json();
      var serverLikes = d.likes || 0;
      // Update with server's authoritative count
      _setStoredVote(meta.url, currentVote, serverLikes);
      if (countEl) countEl.textContent = serverLikes > 0 ? serverLikes : '';
    }
  } catch(e) { console.warn('[Vote]', e.message); }
}


function copyCodeBlock(btn) {
  var code = btn.closest('pre') ? btn.closest('pre').querySelector('code') : null;
  if (!code) return;
  navigator.clipboard.writeText(code.innerText || code.textContent || '').then(function() {
    btn.textContent = '✓ Copied';
    setTimeout(function() { btn.textContent = 'Copy'; }, 1500);
  }).catch(function() {});
}

// ── Typing indicator & stream cursor ─────────────────────────────────────────
// Full implementations live here. eoh-fdstyle.js can override these by setting
// window.* globals before this file loads — but this file always works standalone.

// ── Status animation (sequence-ID, no shared flag) ────────────────────────────
if (typeof window._animSeq === 'undefined') window._animSeq = 0;
if (typeof window._statusMsgs === 'undefined') window._statusMsgs = [
  'Analyzing your question', 'Searching documentation',
  'Finding information', 'Preparing response'
];
if (typeof window._animateStatus === 'undefined') {
  window._animateStatus = function(elId) {
    var mySeq = ++window._animSeq;
    var mi = 0, ci = 0;
    function type() {
      if (window._animSeq !== mySeq) return;
      var el = document.getElementById(elId);
      if (!el) return;
      var msg = window._statusMsgs[mi];
      if (ci <= msg.length) {
        el.textContent = msg.substring(0, ci++);
        setTimeout(type, 50);
      } else {
        setTimeout(function() { mi = (mi+1) % window._statusMsgs.length; ci = 0; type(); }, 1500);
      }
    }
    type();
  };
}
if (typeof window._stopStatusAnim === 'undefined') {
  window._stopStatusAnim = function() { window._animSeq++; };
}

// ── Logo src — grabbed immediately + multiple fallbacks ──────────────────────
if (typeof window._eohCursorSrc === 'undefined') window._eohCursorSrc = '';
if (typeof window._getLogoSrc === 'undefined') {
  window._getLogoSrc = function() {
    if (window._eohCursorSrc) return window._eohCursorSrc;
    // Try every possible source in order
    var src = '';
    // 1. main-logo element src property (fully resolved URL)
    var ml = document.getElementById('main-logo');
    if (ml && ml.src && ml.src.length > 10 && ml.src !== window.location.href) src = ml.src;
    // 2. logo-img class (same element, different selector)
    if (!src) { var li = document.querySelector('.logo-img'); if (li && li.src && li.src.length > 10 && li.src !== window.location.href) src = li.src; }
    // 3. window._chatLogo set by async logo loader
    if (!src && window._chatLogo && window._chatLogo.length > 10) src = window._chatLogo;
    // 4. welcome-logo fallback
    if (!src) { var wl = document.getElementById('welcome-logo'); if (wl && wl.src && wl.src.length > 10 && wl.src !== window.location.href) src = wl.src; }
    if (src) window._eohCursorSrc = src;
    return window._eohCursorSrc;
  };
  // Grab immediately (script loads after DOM is ready)
  window._getLogoSrc();
  // Also retry after async logo loader may have run
  setTimeout(window._getLogoSrc, 500);
  setTimeout(window._getLogoSrc, 1500);
  // Watch for logo changes (when _chatLogo is set asynchronously)
  Object.defineProperty(window, '_chatLogo', {
    set: function(v) { window._eohCursorSrc = v || window._eohCursorSrc; },
    get: function() { return window._eohCursorSrc; },
    configurable: true
  });
}

// ── showTyping / removeTyping ─────────────────────────────────────────────────
if (typeof window.showTyping === 'undefined') {
  window.showTyping = function() {
    var m = document.getElementById('msgs');
    if (!m) return;
    var el = document.createElement('div');
    el.className = 'msg assistant'; el.id = 'typing';
    var logoSrc = window._getLogoSrc();
    el.innerHTML =
      '<div class="mav"><img src="' + logoSrc + '" alt="AI"></div>' +
      '<div class="mbody"><div class="msender">EOH</div>' +
      '<div class="eoh-pre-dots">' +
      '<div class="tdots"><span></span><span></span><span></span></div>' +
      '<span class="eoh-status" id="eoh-status-text"></span>' +
      '</div></div>';
    m.appendChild(el); m.scrollTop = m.scrollHeight;
    window._animateStatus('eoh-status-text');
  };
}
if (typeof window.removeTyping === 'undefined') {
  window.removeTyping = function() {
    window._stopStatusAnim();
    var t = document.getElementById('typing'); if (t) t.remove();
  };
}

// ── Typewriter engine ─────────────────────────────────────────────────────────
if (typeof window._eohTwInit === 'undefined') {
  var _tw = { shown:'', queue:'', active:false, bubble:null, msgs:null, done:false, onDone:null };
  window._eohTw = _tw;
  function _twCursorHtml() {
    var cs = (window._getLogoSrc ? window._getLogoSrc() : '') || window._eohCursorSrc || '';
    return cs ? '<span class="stream-cursor"><img src="' + cs + '"></span>'
               : '<span class="stream-cursor">&#9646;</span>';
  }
  function _twRun() {
    if (!_tw.queue.length) {
      _tw.active = false;
      if (_tw.done && _tw.onDone) { var cb = _tw.onDone; _tw.onDone = null; cb(); }
      return;
    }
    _tw.active = true;
    var ch = _tw.queue.charAt(0);
    _tw.queue = _tw.queue.slice(1);
    _tw.shown += ch;
    if (_tw.bubble) {
      _tw.bubble.innerHTML = _twSimpleRender(_tw.shown) + _twCursorHtml();
      if (_tw.msgs) _tw.msgs.scrollTop = _tw.msgs.scrollHeight;
    }
    var delay = 6;
    if (ch === '.' || ch === '!' || ch === '?') delay += 60;
    else if (ch === ',' || ch === ':' || ch === ';') delay += 25;
    else if (ch === '\n') delay += 40;
    setTimeout(_twRun, delay);
  }
  function _twSimpleRender(text) {
    var s = text.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/\*\*([^*]+)\*\*/g,'<strong>$1</strong>')
      .replace(/\*([^*]+)\*/g,'<em>$1</em>')
      .replace(/`([^`]+)`/g,'<code>$1</code>');
    s = s.replace(/\n\n/g,'</p><p>').replace(/\n/g,'<br>');
    return '<p>' + s + '</p>';
  }
  window._eohTwInit = function(bubbleEl, msgsEl) {
    _tw.shown=''; _tw.queue=''; _tw.active=false; _tw.done=false; _tw.onDone=null;
    _tw.bubble=bubbleEl; _tw.msgs=msgsEl||document.getElementById('msgs');
  };
  window._eohTwFeed = function(full) {
    var nc = full.slice(_tw.shown.length + _tw.queue.length);
    if (!nc) return;
    _tw.queue += nc;
    if (!_tw.active) _twRun();
  };
  window._eohTwFinish = function(finalText, onDone) {
    _tw.done = true;
    function _showFinal() {
      if (!_tw.bubble) { if (onDone) onDone(); return; }
      var html = (typeof formatMarkdown === 'function') ? formatMarkdown(finalText) : _twSimpleRender(finalText);
      _tw.bubble.innerHTML = html + _twCursorHtml();
      if (_tw.msgs) _tw.msgs.scrollTop = _tw.msgs.scrollHeight;
      var bEl = _tw.bubble;
      setTimeout(function() {
        if (bEl) bEl.innerHTML = (typeof formatMarkdown === 'function') ? formatMarkdown(finalText) : _twSimpleRender(finalText);
        if (onDone) onDone();
      }, 700);
    }
    if (!_tw.active && !_tw.queue.length) { _showFinal(); }
    // (skip threshold removed — all messages type letter by letter)
    else { _tw.onDone = _showFinal; }
  };
}

// ── Sources toggle ────────────────────────────────────────────────────────────
if (typeof window.toggleSrc === 'undefined') {
  window.toggleSrc = function(id) { var e=document.getElementById(id); if(e) e.classList.toggle('open'); };
}

function copyMsg(btn) {
  navigator.clipboard.writeText(btn.closest('.mbody').querySelector('.mbubble').innerText)
    .then(function() { showToast('Copied to clipboard', 'success', 2000); })
    .catch(function() { showToast('Copy failed — try selecting text manually', 'error'); });
  btn.textContent = 'Copied';
  setTimeout(function() { btn.textContent = 'Copy'; }, 2000);
}

function shareMsg(btn) {
  var text = btn.closest('.mbody').querySelector('.mbubble').innerText || '';
  var trimmed = text.trim().substring(0, 500) + (text.length > 500 ? '...' : '');
  var url  = window.location.href;
  // Try native Web Share API (mobile + modern desktop)
  if (navigator.share) {
    navigator.share({ title: 'EOH AI Response', text: trimmed, url: url })
      .catch(function() {}); // user cancelled — no error needed
    return;
  }
  // Fallback: copy shareable text to clipboard
  var shareText = trimmed + '\n\n— via ERP Online Hub AI: ' + url;
  navigator.clipboard.writeText(shareText).then(function() {
    btn.innerHTML = '&#10003;';
    setTimeout(function() { btn.innerHTML = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-2px"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.6" y1="13.5" x2="15.4" y2="17.5"/><line x1="15.4" y1="6.5" x2="8.6" y2="10.5"/></svg>'; }, 2000);
  }).catch(function() {
    alert('Could not share: ' + trimmed);
  });
}

function replyToMsg(btn) {
  var text = btn.getAttribute('data-txt') || '';
  var short = text.replace(/<[^>]*>/g,'').substring(0, 100).trim();
  if (!short) return;
  // Show reply quote above input
  var inputArea = document.getElementById('text-input-area');
  var existing = document.getElementById('reply-quote-bar');
  if (existing) existing.remove();
  var bar = document.createElement('div');
  bar.className = 'reply-quote';
  bar.id = 'reply-quote-bar';
  bar.innerHTML = '<span style="flex:1">Replying to: <em>' + short + (text.length > 100 ? '...' : '') + '</em></span><span class="rq-close" onclick="cancelReply()">&times;</span>';
  inputArea.insertBefore(bar, inputArea.firstChild);
  // Store reply context
  S._replyContext = short;
  // Focus input
  var inp = document.getElementById('msg-input');
  if (inp) inp.focus();
}

function cancelReply() {
  var bar = document.getElementById('reply-quote-bar');
  if (bar) bar.remove();
  S._replyContext = null;
}

// -- FILE ATTACH ---------------------------------------------------------------
function toggleAttachMenu() {
  if (!S.user || !S.token) { showModal('login'); return; }
  var m = document.getElementById('attach-menu');
  var isOpen = m.classList.contains('open');
  if (isOpen) { m.classList.remove('open'); return; }
  m.classList.add('open');
  setTimeout(function() {
    document.addEventListener('click', function h(e) {
      var btn = document.getElementById('attach-btn');
      if (!m.contains(e.target) && e.target !== btn && !btn.contains(e.target)) {
        m.classList.remove('open');
      }
      document.removeEventListener('click', h);
    });
  }, 100);
}

// Strip base64 blobs from extracted document content — prevents images rendering in chat
function _sanitizeContent(text) {
  if (!text) return text;
  // Remove data:image/... base64 blobs (can come from AI model responses)
  text = text.replace(/data:[a-z]+\/[a-z+]+;base64,[A-Za-z0-9+/=]{100,}/g, '[image removed]');
  // Remove markdown images with base64
  text = text.replace(/!\[[^\]]*\]\(data:[^)]+\)/g, '[image removed]');
  // Remove raw base64 strings longer than 200 chars with no spaces (likely binary)
  text = text.replace(/[A-Za-z0-9+/=]{200,}/g, function(m) {
    return m.includes(' ') ? m : '[binary data removed]';
  });
  return text;
}

async function handleFile(event) {
  if (!S.user || !S.token) { showModal('login'); return; }
  var files = Array.from(event.target.files || []);
  if (!files.length) return;
  // Process files sequentially
  for (var _fi = 0; _fi < files.length; _fi++) {
    await _handleSingleFile(files[_fi]);
  }
  event.target.value = '';
}

async function _handleSingleFile(file) {
  if (!file) return;

  // ── Fetch upload config from backend (cached 5 min in S._uploadConfig) ──
  if (!S._uploadConfig || Date.now() - (S._uploadConfigTime || 0) > 300000) {
    try {
      var _cfgRes = await window.fetch(API + '/upload/config', { headers: {'Authorization':'Bearer '+(S.token||'')} });
      if (_cfgRes.ok) {
        S._uploadConfig = await _cfgRes.json();
        S._uploadConfigTime = Date.now();
      }
    } catch(_) {}
  }
  var _cfg = S._uploadConfig || { max_size_mb:10, allowed_types:['.pdf','.docx','.xlsx','.pptx','.png','.jpg','.jpeg','.csv','.txt'], file_content_max_chars:40000, max_files_per_msg:5, file_history_turns:3, max_message_chars:8000 };
  var _maxBytes     = (_cfg.max_size_mb || 10) * 1024 * 1024;
  var _allowedTypes = (_cfg.allowed_types || ['.pdf','.docx','.xlsx','.pptx','.png','.jpg','.jpeg','.csv','.txt']);
  var _maxFilesPerMsg = parseInt(_cfg.max_files_per_msg||5);
  // Apply textarea maxlength from admin setting
  var _taCfg = document.getElementById('chat-ta');
  if (_taCfg && _cfg.max_message_chars) _taCfg.maxLength = parseInt(_cfg.max_message_chars)||8000;

  // ── Validate extension ────────────────────────────────────────────────────
  var ext = '.' + file.name.split('.').pop().toLowerCase();
  if (!_allowedTypes.includes(ext)) {
    document.getElementById('ufile-name').textContent = file.name;
    document.getElementById('ufile-size').textContent = '❌ File type not allowed. Allowed: ' + _allowedTypes.join(', ');
    document.getElementById('upload-bar').style.display = 'flex';
    return;
  }

  // ── Validate size ─────────────────────────────────────────────────────────
  if (file.size > _maxBytes) {
    var _sizeMb = (file.size / (1024 * 1024)).toFixed(1);
    document.getElementById('ufile-name').textContent = file.name;
    document.getElementById('ufile-size').textContent = '❌ File too large (' + _sizeMb + 'MB). Max allowed: ' + _cfg.max_size_mb + 'MB';
    document.getElementById('upload-bar').style.display = 'flex';
    return;
  }

  // Multi-file limit check
  if (!S.filesAttached) S.filesAttached = [];
  var _totalAttached = (S.filesAttached||[]).length + (S.filesContent||[]).length;
  if (_totalAttached >= _maxFilesPerMsg) {
    document.getElementById('ufile-name').textContent = 'Max '+_maxFilesPerMsg+' files per message';
    document.getElementById('ufile-size').textContent = '❌ Remove a file first to add another';
    document.getElementById('upload-bar').style.display = 'flex';
    return;
  }
  S.file = file;
  S.fileReading = true;
  document.getElementById('send-btn').disabled = true;
  document.getElementById('ufile-name').textContent = file.name;
  var _fszLabel = file.size > 500*1024 ? (file.size/1024/1024).toFixed(1)+' MB' : (file.size/1024).toFixed(1)+' KB';
  document.getElementById('ufile-size').textContent = '⏳ Sending to server... ('+_fszLabel+')';
  document.getElementById('upload-bar').style.display = 'flex';

  var extBase = ext.replace('.','');
  // txt/csv/md go through the SAME server path as pdf/docx: /upload/extract stores the
  // file (attKey) and content enters docState — so the AI keeps the file across turns
  // and the backend can edit the actual file.
  var binaryExts = ['pdf','doc','docx','xls','xlsx','png','jpg','jpeg','webp','gif','pptx','txt','csv','md'];

  if (binaryExts.indexOf(extBase) !== -1) {
    // For images, store base64 for embedding in exports
    var imageExts = ['png','jpg','jpeg','webp','gif'];
    if (imageExts.indexOf(extBase) !== -1) {
      var imgReader = new FileReader();
      imgReader.onload = function(e) {
        S.fileBase64 = e.target.result;
        S.lastImageBase64 = e.target.result;
        S.lastImageExt = ext;
        S.fileExt = ext;
        // Also add to filesContent for consistent vision handling
        if (!S.filesContent) S.filesContent = [];
        S.filesContent.push({ name: file.name, base64: e.target.result, ext: ext });
        // Separate logo from content images. In a RESUME conversation an uploaded photo
        // is the CV profile photo (contentImage), never a company logo.
        var msgLower = (document.getElementById('chat-ta') ? document.getElementById('chat-ta').value : '').toLowerCase();
        var _resumeCtx = (typeof _isResumeConversation === 'function' && _isResumeConversation())
          || /\b(cv|resume|r\u00e9sum\u00e9|profile photo|my photo|headshot|my picture)\b/i.test(msgLower);
        var isLogoUpload = !_resumeCtx && (!S.logoBase64 || msgLower.includes('logo') || msgLower.includes('brand'));
        if (isLogoUpload && !S.logoBase64) {
          S.logoBase64 = e.target.result;
          S.logoExt = ext;
        } else {
          // Content image (CV photo, screenshot, diagram, etc.)
          S.contentImageBase64 = e.target.result;
          S.contentImageExt = ext;
        }
      };
      imgReader.readAsDataURL(file);
    }
    // Send to backend for extraction/description
    try {
      var formData = new FormData();
      formData.append('file', file);
      if (S_sessionId) formData.append('sessionId', S_sessionId);   // link uploaded file to this session in the registry
      var res = await window.fetch(API + '/upload/extract', {
        method: 'POST',
        headers: {'Authorization': 'Bearer ' + (S.token || '')},
        body: formData
      });
      var d = await res.json();
      if (res.ok && d.content) {
        // Backend already truncates to fileContentMaxChars — use as-is
        S.fileContent = d.content;
        try { if (_cvLooksLikeResume(d.content)) _updateResumeState(d.content, 'uploaded'); } catch(_){}
        try { _updateDocState(file.name || d.filename || 'document', d.content); } catch(_){}
        // Only push to filesAttached for documents — images use filesContent/vision path
        var _isImgExt = ['png','jpg','jpeg','webp','gif'].indexOf(ext.replace('.','')) !== -1;
        if (!_isImgExt) {
          if (!S.filesAttached) S.filesAttached = [];
          var _safeContent = _sanitizeContent(d.content);
        S.filesAttached.push({ name:file.name, size:file.size, type:ext.replace('.','').toUpperCase(), content:_safeContent, chars:_safeContent.length, truncated:!!d.truncated, _file:file, mime:(d.storageMime||file.type||''), attKey:(d.storageKey||null) });
        }
        S.fileReading = false;
        document.getElementById('send-btn').disabled = false;
        if (S._sendQueued) { S._sendQueued = false; setTimeout(function(){ try { sendMsg(); } catch(_){} }, 80); }
        var _fc = (S.filesAttached||[]).length;
        var _ic = (S.filesContent||[]).length;
        var _totalFiles = _fc + _ic;
        document.getElementById('ufile-name').textContent = '';
        document.getElementById('ufile-size').textContent = '✅ Ready'+(_totalFiles>1?(' · '+_totalFiles+' files'):'')+(d.truncated?' ⚠️ truncated':'');
        renderAttachments();
      } else {
        var _errMsg = d.error || 'Could not extract content';
        var _hint = d.allowed ? ' Allowed: ' + d.allowed.join(', ') : '';
        S.fileContent = '[File: ' + file.name + ' - ' + _errMsg + ']';
        S.fileReading = false; S._sendQueued = false;
        document.getElementById('send-btn').disabled = false;
        document.getElementById('ufile-name').textContent = file.name;
        document.getElementById('ufile-size').textContent = '⚠️ ' + _errMsg + _hint;
      }
    } catch(e) {
      var _isTimeout = (e.message||'').toLowerCase().includes('timeout')||(e.message||'').toLowerCase().includes('failed to fetch');
      S.fileContent = '[File: '+file.name+' — could not extract: '+(e.message||'unknown error')+']';
      S.fileReading = false;
      document.getElementById('send-btn').disabled = false;
      document.getElementById('ufile-name').textContent = file.name;
      document.getElementById('ufile-size').textContent = _isTimeout ? '⏱️ Server timeout — filename sent, content not read' : '⚠️ '+(e.message||'Upload error');
    }
  } else {
    // Text file - read directly
    var reader = new FileReader();
    reader.onload = function(e) {
      var _txtMax = parseInt((_cfg&&_cfg.file_content_max_chars)||40000);
      S.fileContent = e.target.result.substring(0, _txtMax);
      if (e.target.result.length > _txtMax) S.fileContent += '\n[Truncated at '+_txtMax+' chars]';
      if (!S.filesAttached) S.filesAttached = [];
      S.filesAttached.push({ name:file.name, size:file.size, type:ext.replace('.',''), content:S.fileContent, chars:S.fileContent.length, truncated:e.target.result.length>_txtMax, _file:file, mime:(file.type||'') });
      S.fileReading = false;
      document.getElementById('send-btn').disabled = false;
        if (S._sendQueued) { S._sendQueued = false; setTimeout(function(){ try { sendMsg(); } catch(_){} }, 80); }
      document.getElementById('ufile-name').textContent = file.name;
      document.getElementById('ufile-size').textContent = '(' + (file.size/1024).toFixed(1) + ' KB) ✓ Ready';
      renderAttachments();
    };
    reader.onerror = function() {
      S.fileContent = '[Could not read: ' + file.name + ']';
      S.fileReading = false;
      document.getElementById('send-btn').disabled = false;
      document.getElementById('ufile-name').textContent = file.name;
    };
    reader.readAsText(file);
  }
}

// ── External context attach — used by eoh-chat-inputs.js (@-context) ─────────
// Registers a compiled context document (e.g. a PM project's details, tasks,
// meetings, files and emails) as an attachment, exactly like an uploaded doc,
// so the AI reads it and it persists across turns. Content is already text.
window.eohAttachContext = function(name, content) {
  try {
    if (!content) return false;
    if (!S.user || !S.token) { showModal('login'); return false; }
    if (!S.filesAttached) S.filesAttached = [];
    var _cfg = S._uploadConfig || {};
    var _maxFiles = parseInt(_cfg.max_files_per_msg || 5);
    var _total = (S.filesAttached || []).length + ((S.filesContent || []).length);
    if (_total >= _maxFiles) { alert('Max ' + _maxFiles + ' attachments per message. Remove one first.'); return false; }
    var _safe = (typeof _sanitizeContent === 'function') ? _sanitizeContent(content) : content;
    S.filesAttached.push({ name: name || 'Context', size: _safe.length, type: 'CONTEXT',
      content: _safe, chars: _safe.length, truncated: false, _file: null, mime: 'text/markdown', attKey: null });
    S.fileContent = _safe;
    try { _updateDocState(name || 'Context', _safe); } catch (_) {}
    try { renderAttachments(); } catch (_) {}
    var _bar = document.getElementById('upload-bar'); if (_bar) _bar.style.display = 'flex';
    var _sb = document.getElementById('send-btn'); if (_sb) _sb.disabled = false;
    return true;
  } catch (e) { return false; }
};

function removeFile() {
  S.file = null; S.fileContent = null; S.fileBase64 = null; S.fileExt = null;
  S.files = []; S.filesContent = []; S.filesAttached = [];
  S.fileReading = false;
  // Also re-enable send button in case it was left disabled
  var sb = document.getElementById('send-btn');
  if (sb) sb.disabled = false;
  document.getElementById('upload-bar').style.display='none';
  var th = document.getElementById('upload-thumbs'); if (th) th.innerHTML = '';
  var dc = document.getElementById('upload-docs'); if (dc) dc.innerHTML = '';
}

// -- MULTI-IMAGE HANDLER (up to 20) ------------------------------------------
// Compress image to max 800px and JPEG quality 0.7 for faster AI processing
function compressImage(b64, maxSize, callback, quality) {
  var img = new Image();
  img.onload = function() {
    var w = img.width, h = img.height;
    if (w > maxSize || h > maxSize) {
      var ratio = Math.min(maxSize / w, maxSize / h);
      w = Math.round(w * ratio); h = Math.round(h * ratio);
    }
    var canvas = document.createElement('canvas');
    canvas.width = w; canvas.height = h;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, w, h);
    callback(canvas.toDataURL('image/jpeg', quality || 0.75));
  };
  img.onerror = function() { callback(b64); };
  img.src = b64;
}

async function handleMultiImages(event) {
  var files = Array.from(event.target.files || []);
  if (!files.length) return;
  if (files.length > 20) { alert('Maximum 20 images allowed.'); files = files.slice(0, 20); }
  event.target.value = '';
  S.files = S.files || []; S.filesContent = S.filesContent || [];
  S.fileReading = true;
  document.getElementById('send-btn').disabled = true;
  document.getElementById('upload-bar').style.display = 'flex';
  document.getElementById('ufile-name').textContent = '';
  document.getElementById('ufile-size').textContent = '* Reading ' + files.length + ' image(s)...';
  var thumbsEl = document.getElementById('upload-thumbs');
  var processed = 0;
  for (var i = 0; i < files.length; i++) {
    (function(file, idx) {
      var reader = new FileReader();
      reader.onload = function(e) {
        var rawB64 = e.target.result;
        // Compress for AI vision - adaptive size based on count
        var maxPx = files.length <= 2 ? 1200 : files.length <= 4 ? 800 : 600;
        var imgQuality = files.length <= 2 ? 0.75 : files.length <= 4 ? 0.6 : 0.5;
        compressImage(rawB64, maxPx, function(compressedB64) {
          S.files.push(file);
          S.filesContent.push({ name: file.name, base64: compressedB64, ext: 'jpeg' });
          if (!S.logoBase64 && idx === 0) { S.logoBase64 = rawB64; S.logoExt = file.name.split('.').pop().toLowerCase(); }
          S.contentImageBase64 = rawB64; S.contentImageExt = file.name.split('.').pop().toLowerCase();
          processed++;
          if (processed >= files.length) {
            S.fileReading = false; document.getElementById('send-btn').disabled = false;
            if (S._sendQueued) { S._sendQueued = false; setTimeout(function(){ try { sendMsg(); } catch(_){} }, 80); }
            document.getElementById('ufile-size').textContent = S.filesContent.length + ' image(s) ✓ Ready';
            S.fileContent = S.filesContent.map(function(f, i) { return '[Image ' + (i + 1) + ': ' + f.name + ']'; }).join('\n');
            S.fileBase64 = S.filesContent[0].base64; S.fileExt = 'jpeg'; S.file = S.files[0];
            renderAttachments();
          }
        }, imgQuality);
      };
      reader.readAsDataURL(file);
    })(files[i], i);
  }
}
function removeOneFile(idx, el) {
  if (el) el.remove(); S.filesContent.splice(idx, 1); S.files.splice(idx, 1);
  if (!S.filesContent.length) { removeFile(); return; }
  document.getElementById('ufile-size').textContent = S.filesContent.length + ' image(s) ✓ Ready';
  S.fileContent = S.filesContent.map(function(f, i) { return '[Image ' + (i + 1) + ': ' + f.name + ']'; }).join('\n');
  S.fileBase64 = S.filesContent[0].base64; S.file = S.files[0];
}

// ── Unified attachment preview — rebuilds document chips + image thumbs from state.
// Each file shows separately with its own × remove, so the user can review and remove
// individual files BEFORE sending. Rebuilding from state (not from a captured index)
// keeps removal correct regardless of the order files are removed in.
function renderAttachments() {
  var bar = document.getElementById('upload-bar');
  var docsEl = document.getElementById('upload-docs');
  var thumbsEl = document.getElementById('upload-thumbs');
  var nameEl = document.getElementById('ufile-name');
  var docs = S.filesAttached || [];
  var imgs = S.filesContent || [];
  var esc = (typeof _esc === 'function') ? _esc : function(x){ return String(x==null?'':x); };
  if (docsEl) {
    docsEl.innerHTML = '';
    docs.forEach(function(f, i) {
      var kb = f.size ? (f.size/1024).toFixed(0)+' KB' : '';
      var meta = [f.type||'', kb].filter(Boolean).join(' · ') + (f.truncated ? ' ⚠️' : '');
      var chip = document.createElement('div');
      chip.className = 'upload-doc-chip';
      chip.innerHTML = '<span class="udoc-ic">📄</span>'
        + '<span class="udoc-text"><span class="udoc-name" title="'+esc(f.name)+'">'+esc(f.name)+'</span>'
        + '<span class="udoc-meta">'+esc(meta)+'</span></span>'
        + '<button class="udoc-x" title="Remove" onclick="removeDoc('+i+')">×</button>';
      docsEl.appendChild(chip);
    });
  }
  if (thumbsEl) {
    thumbsEl.innerHTML = '';
    imgs.forEach(function(f, i) {
      var wrap = document.createElement('div');
      wrap.className = 'upload-thumb-wrap';
      wrap.innerHTML = '<img src="'+f.base64+'" class="upload-thumb" title="'+esc(f.name)+'">'
        + '<button class="upload-thumb-x" title="Remove" onclick="removeImg('+i+')">×</button>';
      thumbsEl.appendChild(wrap);
    });
  }
  var total = docs.length + imgs.length;
  if (nameEl) nameEl.textContent = total > 1 ? (total + ' files attached') : (docs[0] ? docs[0].name : (imgs[0] ? imgs[0].name : ''));
  if (bar) bar.style.display = total ? 'flex' : 'none';
}

function removeDoc(i) {
  if (!S.filesAttached) return;
  S.filesAttached.splice(i, 1);
  if (!(S.filesAttached && S.filesAttached.length) && !(S.filesContent && S.filesContent.length)) { removeFile(); return; }
  renderAttachments();
}

function removeImg(i) {
  if (!S.filesContent) return;
  S.filesContent.splice(i, 1);
  if (S.files) S.files.splice(i, 1);
  if (!(S.filesContent && S.filesContent.length) && !(S.filesAttached && S.filesAttached.length)) { removeFile(); return; }
  if (S.filesContent.length) {
    S.fileBase64 = S.filesContent[0].base64; S.file = S.files && S.files[0];
    S.fileContent = S.filesContent.map(function(f, k){ return '[Image '+(k+1)+': '+f.name+']'; }).join('\n');
  }
  renderAttachments();
}

// ── Persistent chat attachments (images + documents) ───────────────────────────
// Uploaded files are sent as in-memory base64 and are stripped when a session is saved,
// so they vanish from history. These helpers store each attachment to the backend
// (Supabase storage, 90-day retention) and keep a small {key} reference on the message,
// so images and documents reappear — and stay downloadable — when an old chat is reopened.
function _readFileB64(file) {
  return new Promise(function(resolve) {
    try { var r = new FileReader(); r.onload = function(e){ resolve(e.target.result); }; r.onerror = function(){ resolve(null); }; r.readAsDataURL(file); }
    catch(_) { resolve(null); }
  });
}

async function _uploadChatAttachment(base64, name, mime) {
  try {
    if (!S.token || !base64) return null;
    var r = await window.fetch(API + '/upload/attachment', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + S.token },
      body: JSON.stringify({ fileBase64: base64, fileName: name || 'file', mimeType: mime || '' })
    });
    if (!r.ok) { console.warn('[attach] upload failed', r.status); return null; }
    var d = await r.json();
    if (!d || !d.key) return null;
    var isImg = (mime || '').indexOf('image') === 0;
    return { kind: isImg ? 'image' : 'doc', key: d.key, name: d.name || name || 'file', mime: d.mime || mime || '', size: d.size || 0 };
  } catch (e) { console.warn('[attach] upload error', e.message); return null; }
}

// Upload a message's images + documents in PARALLEL, then attach the refs to the message object
// and re-save so they persist. Runs in the background — never blocks the AI response.
async function _persistMsgAttachments(msgObj, images, docs, domEl) {
  try {
    var direct = [];   // refs already stored server-side (documents via /upload/extract)
    var jobs = [];     // uploads still needed (images, or docs that have no server key yet)
    (images || []).forEach(function(im) {
      var b64 = im && (im.data || im.base64); if (!b64) return;
      var mime = 'image/' + String(im.ext || 'png').replace('jpg', 'jpeg');
      jobs.push(_uploadChatAttachment(b64, im.name || 'image', mime));
    });
    for (var i = 0; i < (docs || []).length; i++) {
      var dc = docs[i]; if (!dc) continue;
      if (dc.attKey) {  // already stored during text extraction — just reference it
        direct.push({ kind: 'doc', key: dc.attKey, name: dc.name || 'document', mime: dc.mime || '', size: dc.size || 0 });
        continue;
      }
      var b64d = dc.raw || (dc._file ? await _readFileB64(dc._file) : null);
      if (b64d) jobs.push(_uploadChatAttachment(b64d, dc.name || 'document', dc.mime || 'application/octet-stream'));
    }
    var uploaded = jobs.length ? (await Promise.all(jobs)).filter(Boolean) : [];
    var refs = direct.concat(uploaded);
    if (refs.length) {
      msgObj.attachments = (msgObj.attachments || []).concat(refs);
      if (S.user && S.token) { try { saveCurrentSession(true); } catch(_){} }
      // Render the download chip / thumbnail onto the live message immediately, so the user can
      // download right after sending (not only after a reload).
      if (domEl) { try { _renderHistAttachments(msgObj, domEl); } catch(_){} }
    }
  } catch (e) { console.warn('[attach] persist error', e.message); }
}

// Resolve a stored attachment key to a short-lived signed URL.
async function _resolveAttUrl(key, dlName) {
  try {
    var u = API + '/upload/attachment/' + key + (dlName ? ('?name=' + encodeURIComponent(dlName)) : '');
    var r = await window.fetch(u, { headers: { 'Authorization': 'Bearer ' + S.token } });
    if (!r.ok) return null;
    var d = await r.json();
    return (d && d.signedUrl) ? d.signedUrl : null;
  } catch(_) { return null; }
}

// Render a loaded message's stored attachments (image thumbnails + document download chips).
function _renderHistAttachments(m, containerEl) {
  if (!m || !m.attachments || !m.attachments.length || !containerEl) return;
  var bubble = containerEl.querySelector('.mbubble') || containerEl.querySelector('.mbody') || containerEl;
  var wrap = document.createElement('div');
  wrap.style.cssText = 'display:flex;flex-wrap:wrap;gap:8px;margin-top:8px';
  m.attachments.forEach(function(att) {
    if (!att || !att.key) return;
    var isImg = att.kind === 'image' || (att.mime || '').indexOf('image') === 0;
    if (isImg) {
      var im = document.createElement('img');
      im.alt = att.name || 'image';
      im.title = att.name || 'image';
      im.style.cssText = 'max-width:160px;max-height:160px;border-radius:8px;border:1px solid var(--border);cursor:pointer;object-fit:cover';
      _resolveAttUrl(att.key).then(function(url){ if (url) { im.src = url; im.onclick = function(){ window.open(url, '_blank'); }; } });
      wrap.appendChild(im);
    } else {
      var chip = document.createElement('button');
      chip.style.cssText = 'display:inline-flex;align-items:center;gap:6px;padding:6px 10px;background:var(--bg3,rgba(255,255,255,.05));border:1px solid var(--border);border-radius:8px;color:var(--text);font-size:12px;cursor:pointer';
      chip.innerHTML = '\uD83D\uDCC4 <span>' + _esc(att.name || 'document') + '</span> \u2193';
      chip.onclick = async function() {
        chip.disabled = true; var old = chip.innerHTML; chip.innerHTML = 'Loading...';
        var url = await _resolveAttUrl(att.key, att.name || 'document');
        if (url) {
          // Same-tab download. The server sends Content-Disposition: attachment, so the file
          // downloads without navigating away — and because it is not a popup, the browser
          // does not block it even though it follows an await.
          var a = document.createElement('a'); a.href = url; a.download = att.name || 'document';
          document.body.appendChild(a); a.click(); a.remove();
        } else { try { showToast('Attachment unavailable (it may have expired)', 'info', 3000); } catch(_){} }
        chip.disabled = false; chip.innerHTML = old;
      };
      wrap.appendChild(chip);
    }
  });
  if (wrap.children.length) bubble.appendChild(wrap);
}

// -- EXPORT --------------------------------------------------------------------
// ── Export toolbar button modal ───────────────────────────────────────────────
// ── Help modal ───────────────────────────────────────────────────────────────
function openHelpModal() {
  var ex = document.getElementById('eoh-help-modal'); if (ex) { ex.remove(); return; }
  var overlay = document.createElement('div');
  overlay.id = 'eoh-help-modal';
  overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.7);z-index:9999;display:flex;align-items:center;justify-content:center;padding:20px';

  var shortcuts = [
    ['Ctrl + Enter',    'Send message'],
    ['Ctrl + N',        'New chat'],
    ['Ctrl + /',        'Open slash command menu'],
    ['Escape',          'Close menus / modals'],
    ['/image [query]',  'Search ERP screenshots'],
    ['/search [query]', 'Web search'],
    ['/export',         'Export conversation'],
    ['/help',           'What can EOH do?'],
  ];

  function _sec(icon, title, items) {
    return '<div style="margin-bottom:18px">'
      + '<div style="display:flex;align-items:center;gap:7px;margin-bottom:9px;padding-bottom:6px;border-bottom:1px solid var(--border)">'
      +   '<span style="font-size:16px">' + icon + '</span>'
      +   '<span style="font-size:11px;font-weight:700;color:var(--text);text-transform:uppercase;letter-spacing:.08em">' + title + '</span>'
      + '</div>'
      + '<div style="display:flex;flex-direction:column;gap:4px">'
      + items.map(function(it) {
          return '<div style="display:flex;align-items:flex-start;gap:8px;padding:5px 8px;border-radius:6px;background:var(--bg3)">'
            + '<span style="color:var(--gl);font-size:13px;flex-shrink:0;margin-top:1px">›</span>'
            + '<span style="font-size:12px;color:var(--muted);line-height:1.5">' + it + '</span>'
            + '</div>';
        }).join('')
      + '</div></div>';
  }

  var html = '<div style="background:var(--bg2);border:1px solid var(--border2);border-radius:14px;width:100%;max-width:520px;padding:28px;position:relative;max-height:90vh;overflow-y:auto">'
    + '<button onclick="document.getElementById(\'eoh-help-modal\').remove()" style="position:absolute;top:12px;right:14px;background:none;border:none;color:var(--muted);font-size:18px;cursor:pointer">✕</button>'
    + '<div style="font-size:17px;font-weight:700;color:var(--text);margin-bottom:2px">EOH AI — Feature Guide</div>'
    + '<div style="font-size:12px;color:var(--dim);margin-bottom:22px">ERP Online Hub · AI Support Platform</div>'

    // Error diagnosis & system issues
    + _sec('🔧', 'Error Diagnosis & System Issues', [
        'Paste any error message or screenshot — get step-by-step resolution',
        'SAP posting period, authorization, ABAP dump, failed jobs, locked accounts',
        'Oracle Fusion, Dynamics 365, Workday, Odoo, NetSuite and 50+ ERP errors',
        'Root cause analysis with exact menu paths, T-codes and config steps',
      ])

    // Configuration
    + _sec('⚙️', 'Configuration & Setup', [
        'Step-by-step configuration guides for any ERP module or feature',
        'Organizational structure, chart of accounts, company codes, plants',
        'Roles, authorization objects, security profiles and user management',
        'Workflow rules, approval chains, business rules and process automation',
      ])

    // Business logic & localization
    + _sec('🌍', 'Business Logic & Localization', [
        'Country-specific tax rules, VAT, withholding tax and statutory compliance',
        'Payroll localization — Saudi Arabia, UAE, Egypt, India, UK, US and more',
        'Chart of accounts aligned to local GAAP / IFRS requirements',
        'Currency revaluation, intercompany transactions and consolidation logic',
      ])

    // Reports & data analysis
    + _sec('📊', 'Reports, Data Analysis & BI', [
        'Build custom reports, queries, variants and layouts in any ERP tool',
        'SAP S/4HANA embedded analytics, Fiori analytical apps, CDS views',
        'Oracle OTBI, Financial Reporting Studio, SmartView and EPM reports',
        'Data extraction, pivot analysis, KPI dashboards and trend interpretation',
      ])

    // Documents
    + _sec('📄', 'Document Generation', [
        'Export any conversation to PDF, Word, Excel or PowerPoint — type "export to PDF"',
        'Business Blueprint, functional spec, test scripts, training manuals',
        'Data migration templates, master data upload sheets, cutover plans',
        'Project plans, go-live checklists, UAT scripts and sign-off documents',
      ])

    // Live screen & voice
    + _sec('🎤', 'Voice & Live Screen Analysis', [
        'Click Voice in the toolbar for hands-free conversation mode',
        'Speak in 14 languages — English, Arabic, German, French, Spanish and more',
        'Live Screen: share your screen and get real-time AI guidance on what you see',
        'AI reads visible fields, T-codes, error codes and guides you live',
      ])

    // Images & screenshots
    + _sec('🖼', 'ERP Screenshots & Visuals', [
        'Type "show me PA30 screen" or "/image [query]" for ERP UI screenshots',
        'Attach your own screenshots for analysis — AI reads field values and errors',
        'Upload PDF, Word, Excel, PowerPoint or CSV for document analysis',
        'Take a photo or capture your screen directly from the attach menu',
      ])

    // Shortcuts
    + '<div style="margin-bottom:6px">'
    + '<div style="display:flex;align-items:center;gap:7px;margin-bottom:9px;padding-bottom:6px;border-bottom:1px solid var(--border)">'
    +   '<span style="font-size:16px">⌨️</span>'
    +   '<span style="font-size:11px;font-weight:700;color:var(--text);text-transform:uppercase;letter-spacing:.08em">Keyboard Shortcuts</span>'
    + '</div>'
    + '<div style="display:grid;grid-template-columns:1fr 1fr;gap:5px">'
    + shortcuts.map(function(r) {
        return '<div style="display:flex;align-items:center;gap:7px;padding:5px 8px;background:var(--bg3);border-radius:6px">'
          + '<code style="font-size:10px;color:var(--gl);background:rgba(10,138,95,.1);padding:1px 6px;border-radius:3px;font-family:monospace;white-space:nowrap">' + r[0] + '</code>'
          + '<span style="font-size:11px;color:var(--muted)">' + r[1] + '</span></div>';
      }).join('')
    + '</div></div>'
    + '</div>';

  overlay.innerHTML = html;
  document.body.appendChild(overlay);
  overlay.addEventListener('click', function(e) { if (e.target === overlay) overlay.remove(); });
}

function openExportModal() {
  if (!S.user) { showModal('login'); return; }
  var ex = document.getElementById('eoh-export-modal');
  if (ex) ex.remove();
  var overlay = document.createElement('div');
  overlay.id = 'eoh-export-modal';
  overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.7);z-index:9999;display:flex;align-items:center;justify-content:center;padding:20px';
  overlay.innerHTML = '<div style="background:var(--bg2);border:1px solid var(--border2);border-radius:14px;width:100%;max-width:380px;padding:28px;position:relative">'
    + '<button onclick="document.getElementById(\'eoh-export-modal\').remove()" style="position:absolute;top:12px;right:12px;background:none;border:none;color:var(--muted);font-size:18px;cursor:pointer;line-height:1">✕</button>'
    + '<div style="font-size:15px;font-weight:700;color:var(--text);margin-bottom:6px">Export Conversation</div>'
    + '<div style="font-size:12px;color:var(--dim);margin-bottom:20px">Download as a formatted document</div>'
    + '<div style="margin-bottom:18px">'
    +   '<label style="display:block;font-size:11px;color:var(--dim);margin-bottom:6px;font-weight:600">Document type</label>'
    +   '<select id="eoh-doctype" style="width:100%;padding:10px 12px;background:var(--bg3);border:1px solid var(--border);border-radius:10px;color:var(--text);font-size:13px;cursor:pointer;outline:none">'
    +     _docTypeOptions()
    +   '</select>'
    +   '<div style="font-size:10px;color:var(--dim);margin-top:5px;line-height:1.4">Auto-detect reads your conversation. Pick a type to force a specific ERP template (PDF / Word / Excel).</div>'
    + '</div>'
    + '<div style="display:flex;flex-direction:column;gap:10px">'
    + _exportBtn('pdf',  '📄', 'PDF',              'Best for sharing & printing'  )
    + _exportBtn('docx', '📝', 'Word (.docx)',      'Editable in Microsoft Word'   )
    + _exportBtn('xlsx', '📊', 'Excel (.xlsx)',     'Data & tables in spreadsheet' )
    + _exportBtn('pptx', '🖼', 'PowerPoint (.pptx)','Presentation slides'         )
    + '</div>'
    + '<div style="margin-top:16px;font-size:11px;color:var(--dim);text-align:center">The AI will generate a professional document from your conversation</div>'
    + '</div>';
  document.body.appendChild(overlay);
  // Close on backdrop click
  overlay.addEventListener('click', function(e) { if (e.target === overlay) overlay.remove(); });
}
function _exportBtn(fmt, icon, label, sub) {
  return '<button onclick="var _dt=document.getElementById(\'eoh-doctype\');var _dv=_dt?_dt.value:\'auto\';document.getElementById(\'eoh-export-modal\').remove();doExport(\'' + fmt + '\',null,null,_dv)"'
    + ' style="display:flex;align-items:center;gap:12px;padding:12px 16px;background:var(--bg3);border:1px solid var(--border);border-radius:10px;cursor:pointer;width:100%;text-align:left;color:var(--text);transition:border-color .15s"'
    + ' onmouseover="this.style.borderColor=\'var(--gl)\'" onmouseout="this.style.borderColor=\'var(--border)\'">'
    + '<span style="font-size:22px">' + icon + '</span>'
    + '<div><div style="font-size:13px;font-weight:600">' + label + '</div>'
    + '<div style="font-size:11px;color:var(--dim)">' + sub + '</div></div>'
    + '</button>';
}

// Document-type options for the export modal. Keys MUST match ERP_DOC_TEMPLATES in routes/export.js.
// 'auto' = let the backend keyword-detect from the conversation.
function _docTypeOptions() {
  var groups = [
    ['',              [['auto', 'Auto-detect (from conversation)']]],
    ['Resume / CV',   [['resume', 'Resume / CV']]],
    ['Initiation',    [['project-charter', 'Project Charter'], ['sow', 'Statement of Work (SOW)']]],
    ['Planning',      [['project-plan', 'Project Plan'], ['resource-plan', 'Resource Plan']]],
    ['Blueprint',     [['bbp', 'Business Blueprint (BBP)'], ['functional-spec', 'Functional Specification (FS)'], ['technical-spec', 'Technical Specification (TS)'], ['config-document', 'Configuration Document'], ['gap-analysis', 'Gap Analysis']]],
    ['Communication', [['mom', 'Minutes of Meeting (MOM)'], ['action-log', 'Action Item Log'], ['raid-log', 'RAID Log'], ['status-report', 'Status Report']]],
    ['Testing',       [['test-plan', 'Test Plan'], ['test-script', 'Test Script / Test Case'], ['defect-log', 'Defect Log'], ['uat-signoff', 'UAT Sign-off']]],
    ['Training',      [['training-plan', 'Training Plan'], ['training-material', 'Training Material / User Manual']]],
    ['Go-Live',       [['cutover-plan', 'Cutover Plan'], ['data-migration', 'Data Migration Plan'], ['golive-checklist', 'Go-Live Readiness Checklist']]],
    ['Post Go-Live',  [['hypercare', 'Hypercare Plan'], ['lessons-learned', 'Lessons Learned']]],
    ['Governance',    [['change-request', 'Change Request (CR) Form']]]
  ];
  var html = '';
  groups.forEach(function(g) {
    var label = g[0], opts = g[1];
    if (label) html += '<optgroup label="' + label + '">';
    opts.forEach(function(o) {
      html += '<option value="' + o[0] + '"' + (o[0] === 'auto' ? ' selected' : '') + '>' + o[1] + '</option>';
    });
    if (label) html += '</optgroup>';
  });
  return html;
}

// ── Toast notification system ─────────────────────────────────────────────────
function showToast(msg, type, duration) {
  var ex = document.getElementById('eoh-toast'); if (ex) ex.remove();
  var c = { info:{bg:'var(--bg2)',border:'var(--border2)',icon:'ℹ️'}, success:{bg:'#0a2e1e',border:'#0a8a5f66',icon:'✅'}, error:{bg:'#2e0a0a',border:'#ef444466',icon:'❌'}, loading:{bg:'var(--bg2)',border:'var(--border2)',icon:'⏳'} }[type||'info'];
  var t = document.createElement('div');
  t.id = 'eoh-toast';
  t.style.cssText = 'position:fixed;bottom:28px;left:50%;transform:translateX(-50%);z-index:99999;background:'+c.bg+';border:1px solid '+c.border+';border-radius:10px;padding:10px 18px;font-size:13px;color:var(--text);display:flex;align-items:center;gap:10px;box-shadow:0 6px 24px rgba(0,0,0,.4);min-width:220px;max-width:420px';
  t.innerHTML = '<span>'+c.icon+'</span><span>'+msg+'</span>';
  if (!document.getElementById('eoh-toast-style')) {
    var s = document.createElement('style'); s.id='eoh-toast-style';
    s.textContent='@keyframes eoh-ti{from{opacity:0;transform:translateX(-50%) translateY(8px)}to{opacity:1;transform:translateX(-50%) translateY(0)}}#eoh-toast{animation:eoh-ti .2s ease}';
    document.head.appendChild(s);
  }
  document.body.appendChild(t);
  if (duration !== 0) setTimeout(function(){ if(t.parentNode) t.remove(); }, duration||3500);
  return t;
}

var _exportInProgress = false;
// Hide an [[ASK...]] or [[DIDYOUMEAN...]] marker (complete or still streaming in) from displayed text.
// Remove directive markers themselves ([[DIDYOUMEAN: / [[ASK: / [[NEXT: and stray ]]) from text
// that is about to be shown or saved. Root cause of raw markers in saved chats: a partial
// directive (model wrote prose after the marker instead of JSON) survived every parser.
function _stripDirectiveMarkers(t) {
  return String(t || '')
    .replace(/\[\[\s*NEXT\s*:[\s\S]*?\]\]/gi, '')          // complete [[NEXT: {...}]] block
    .replace(/\[\[\s*NEXT\s*:[\s\S]*$/i, '')                // unclosed NEXT block at the end
    .replace(/\{\s*"intro"\s*:[\s\S]*?"options"\s*:[\s\S]*?\]\s*\}/g, '')   // bare JSON body left by a lost marker
    .replace(/\[\[\s*(?:DIDYOUMEAN|ASK|NEXT)\s*:?\s*/gi, '')
    .replace(/\]\]/g, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
function _hideAskForDisplay(t) {
  return String(t || '')
    .replace(/\[\[\s*NEXT\s*:[\s\S]*?\]\]/gi, '')
    .replace(/\[\[\s*NEXT\s*:[\s\S]*$/i, '')
    .replace(/\[\[DIDYOUMEAN:[\s\S]*?\]\]/gi, '')
    .replace(/\[\[DIDYOUMEAN:[\s\S]*$/i, '')
    .replace(/\[\[ASK:[\s\S]*?\]\]/gi, '')
    .replace(/\[\[ASK:[\s\S]*$/i, '')
    .replace(/\[\[(?:D(?:I(?:D(?:Y(?:O(?:U(?:M(?:E(?:A(?:N:?)?)?)?)?)?)?)?)?)?|A(?:S(?:K:?)?)?)?\s*$/i, '');
}
// Collapse a paragraph repeated verbatim — the model writes its clarifying question
// twice (prose + directive) and both copies survived into the saved history.
function _dedupeParas(text) {
  var parts = String(text || '').split(/\n{2,}/);
  var seen = {}, out = [];
  for (var i = 0; i < parts.length; i++) {
    var key = parts[i].replace(/\s+/g, ' ').trim().toLowerCase();
    if (!key) continue;
    if (key.length > 15 && seen[key]) continue;
    seen[key] = 1;
    out.push(parts[i].trim());
  }
  return out.join('\n\n');
}

// LENIENT clarify parser — last resort when the strict parsers fail.
// A truncated or slightly malformed directive (very common when the stream is cut)
// otherwise loses its options entirely: the directive is stripped from the bubble and
// nothing replaces it, leaving a dangling "…let me clarify which direction:" with no
// choices. This scrapes whatever labels are present without needing valid JSON.
function _parseClarifyLenient(raw) {
  var t = String(raw || '');
  // Accept the bracket-less pipe form too — markers are sometimes stripped upstream,
  // and without this the raw "Question? | Opt | Opt | recommended:true" reached the user.
  var _hasMarker = /\[\[(?:ASK|DIDYOUMEAN)/i.test(t);
  var _pipeForm  = /\?[^\n]*\|[^\n]+/.test(t) || /\|\s*(?:recommended|allow_freetext)\s*[:=]/i.test(t);
  if (!_hasMarker && !_pipeForm) return null;
  var opts = [], m;
  // DIDYOUMEAN payload: pull every "label":"…" even if the JSON never closed.
  var reLabel = /"label"\s*:\s*"((?:[^"\\]|\\.)*)"/gi;
  while ((m = reLabel.exec(t)) !== null) {
    var v = m[1]; try { v = JSON.parse('"' + m[1] + '"'); } catch (_) {}
    v = String(v).trim();
    if (v && opts.indexOf(v) === -1) opts.push(v);
  }
  var q = '';
  var qi = t.match(/"intro"\s*:\s*"((?:[^"\\]|\\.)*)"/i);
  if (qi) { try { q = JSON.parse('"' + qi[1] + '"'); } catch (_) { q = qi[1]; } }
  // [[ASK: question | option | option  (possibly unclosed)
  if (!opts.length) {
    var a = t.match(/\[\[ASK:\s*([\s\S]*?)(?:\]\]|$)/i);
    if (a && a[1] && a[1].indexOf('|') !== -1) {
      var parts = a[1].split('|').map(function (x) { return x.trim(); }).filter(Boolean);
      if (parts.length >= 2) { q = q || parts.shift(); opts = parts; }
    }
  }
  // Bracket-less pipe form: "Question? | Option | Option | recommended:true"
  // (seen in production when the directive markers are stripped upstream).
  if (!opts.length) {
    var line = t.split(/\n/).map(function (x) { return x.trim(); })
                .filter(function (x) { return x.indexOf('|') !== -1 && /\?/.test(x); })[0];
    if (line) {
      var seg = line.split('|').map(function (x) { return x.trim(); }).filter(Boolean);
      if (seg.length >= 2) { q = q || seg.shift(); opts = seg; }
    }
  }
  // Drop directive metadata that is not a user-facing choice.
  opts = opts.filter(function (o) {
    return !/^(recommended|allow_freetext|freetext|hint|default|priority)\s*[:=]/i.test(String(o).trim());
  });
  opts = opts.slice(0, 6);
  if (!opts.length) return null;
  return { question: (q || 'Which would you like?').trim(), options: opts };
}

// Recover readable text from a MALFORMED clarify directive (truncated stream, invalid JSON).
// _hideAskForDisplay strips unclosed [[ASK]]/[[DIDYOUMEAN]] blocks, but the parsers only accept
// well-formed ones — so without this a broken directive left a completely EMPTY bubble.
function _recoverClarifyText(raw) {
  var t = _stripDirectiveMarkers(raw);
  // Pull the intro out of a partial DIDYOUMEAN payload if it's there.
  var m = t.match(/"intro"\s*:\s*"((?:[^"\\]|\\.)*)"/i);
  if (m && m[1]) { try { return JSON.parse('"' + m[1] + '"'); } catch (_) { return m[1]; } }
  // Or the question part of a partial [[ASK: question | opt | opt
  var a = t.match(/\[\[ASK:\s*([^|\]]{3,300})/i);
  if (a && a[1]) return a[1].trim();
  // Last resort: return ONLY the leading question, never the raw directive body.
  // Dumping the internals produced user-visible garbage like
  //   "What aspect...? | Configure a Payroll Area | ... | recommended:true"
  var plain = t.replace(/\[\[(?:ASK|DIDYOUMEAN):?/gi, ' ').replace(/\]\]/g, ' ')
               .replace(/[{}\[\]"]/g, ' ').replace(/\s{2,}/g, ' ').trim();
  if (plain.indexOf('|') !== -1) plain = plain.split('|')[0].trim();   // question only
  plain = plain.replace(/\b(?:recommended|allow_freetext|freetext|hint)\s*[:=]\s*\w+/gi, '').trim();
  return plain.length > 8 ? plain.slice(0, 300) : '';
}

// Parse a [[DIDYOUMEAN: {"intro":"…","options":[{"label":"…"}]}]] block into {question, options[]}.
// [[NEXT: {"intro":"...","options":[{"label":"..."}]}]] — anticipated next actions after an answer.
// Rendered as chips exactly like a clarifier; the text body must never reach the bubble.
function _parseNextBlock(text) {
  var m = String(text || '').match(/\[\[\s*NEXT\s*:\s*([\s\S]*?)\]\]/i)
       || String(text || '').match(/(\{\s*"intro"\s*:[\s\S]*?"options"\s*:[\s\S]*?\]\s*\})/);
  if (!m) return null;
  try {
    var o = JSON.parse(m[1].trim());
    var opts = (o.options || []).map(function (x) { return x && x.label ? String(x.label) : String(x || ''); }).filter(function (x) { return x.length; });
    if (!opts.length) return null;
    return { question: String(o.intro || '').trim(), options: opts.slice(0, 6), isNext: true };
  } catch (_) { return null; }
}
function _parseDidYouMean(text) {
  var m = String(text || '').match(/\[\[DIDYOUMEAN:\s*([\s\S]*?)\]\]/i);
  if (!m) return null;
  try {
    var o = JSON.parse(m[1].trim());
    var opts = (o.options || []).map(function (x) { return x && x.label ? String(x.label) : String(x || ''); }).filter(function (x) { return x.length; });
    if (!opts.length) return null;
    return { question: (o.intro || 'Which would you like?').trim(), options: opts.slice(0, 6) };
  } catch (_) { return null; }
}
function _cqEsc(x) { return String(x == null ? '' : x).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
// Parse an [[ASK: question | opt | opt | opt]] block into {question, options[]}.
function _parseAskBlock(text) {
  var m = String(text || '').match(/\[\[ASK:([\s\S]*?)\]\]/i);
  if (!m) return null;
  var parts = m[1].split('|').map(function (x) { return x.trim(); })
    .filter(function (x) { return x.length && !/^(recommended|allow_freetext|freetext|hint|default|priority)\s*[:=]/i.test(x); });
  if (parts.length < 2) return null;               // need a question + at least one option
  var q = parts.shift();
  return { question: q, options: parts.slice(0, 4) };
}
// Render the AI's clarifying question as tappable options + Skip (typing still works).
function _renderClarify(ask) {
  var c = document.getElementById('msgs');
  // Never render an empty panel: a malformed directive that parsed into a blank question
  // with no options produced a Continue box containing only its label.
  if (!c || !ask || !ask.options || !ask.options.length || !String(ask.question || '').trim()) return;
  // "Continue" panel: the follow-up question is a decision point, not a sentence buried
  // in prose. Styling lives in eoh-ui.css (.eoh-cont*) so it stays theme-aware.
  var wrap = document.createElement('div');
  wrap.className = 'eoh-clarify eoh-cont';
  var html = '<div class="eoh-cont-label">\u21b3 Continue</div>'
           + '<div class="eoh-cont-q">' + _cqEsc(ask.question) + '</div>'
           + '<div class="eoh-cont-opts">';
  ask.options.forEach(function (opt, i) {
    var n = (i + 1) < 10 ? ('0' + (i + 1)) : String(i + 1);
    html += '<button class="eoh-cont-opt eoh-cq-opt" data-i="' + i + '">'
          +   '<span class="eoh-cont-n">' + n + '</span>'
          +   '<span class="eoh-cont-t">' + _cqEsc(opt) + '</span>'
          +   '<span class="eoh-cont-arr" aria-hidden="true">\u2192</span>'
          + '</button>';
  });
  html += '</div>'
        + '<button class="eoh-cont-skip eoh-cq-skip">Ask something else instead</button>';
  wrap.innerHTML = html;
  c.appendChild(wrap);
  c.scrollTop = c.scrollHeight;
  function lock() { wrap.querySelectorAll('button').forEach(function (b) { b.disabled = true; }); wrap.classList.add('is-answered'); }
  wrap.querySelectorAll('.eoh-cq-opt').forEach(function (b) {
    b.onclick = function () { var t = ask.options[parseInt(b.getAttribute('data-i'), 10)]; lock(); sendMsg_fromWelcome(t); };
  });
  var sk = wrap.querySelector('.eoh-cq-skip');
  if (sk) sk.onclick = function () { lock(); sendMsg_fromWelcome('Skip \u2014 proceed with your best assumption.'); };
  // Belt and braces: if nothing actionable ended up inside, remove the panel entirely
  // rather than leaving an empty box on screen that can't be clicked.
  if (!wrap.querySelector('.eoh-cq-opt')) {
    try { console.warn('[EOH] clarify panel had no options \u2014 removed'); } catch (_) {}
    wrap.classList.add('is-empty');
    try { wrap.remove(); } catch (_) {}
  }
}
// Quick replies: tappable chips rendered directly under the answer's prompt bar.
// Deliberately simple — appended to the message element itself, so there is no separate
// panel that can survive on its own or attach to the wrong message.
function _renderQuickReplies(bubbleEl, options) {
  if (!options || !options.length) { console.warn('[EOH] quick replies: no options'); return; }
  // Resolve a host even when the bubble element wasn't passed or the expected
  // wrapper isn't there — silently returning was leaving the user with no options.
  var host = null;
  try {
    if (bubbleEl && bubbleEl.closest) host = bubbleEl.closest('.mbody') || bubbleEl.closest('.msg') || bubbleEl.parentNode;
    else if (bubbleEl) host = bubbleEl.parentNode;
    if (!host) {
      var all = document.querySelectorAll('#msgs .msg.assistant');
      var last = all[all.length - 1];
      host = last ? (last.querySelector('.mbody') || last) : document.getElementById('msgs');
    }
  } catch (_) { host = document.getElementById('msgs'); }
  if (!host) { console.error('[EOH] quick replies: no host element found'); return; }
  if (host.querySelector && host.querySelector('.eoh-qr')) { console.log('[EOH] quick replies already present'); return; }
  var wrap = document.createElement('div');
  wrap.className = 'eoh-qr';
  options.slice(0, 6).forEach(function (o) {
    var t = String(o || '').trim(); if (!t) return;
    var b = document.createElement('button');
    b.className = 'eoh-qr-chip'; b.type = 'button'; b.textContent = t;
    b.onclick = function () {
      wrap.querySelectorAll('button').forEach(function (x) { x.disabled = true; });
      wrap.classList.add('is-answered');
      sendMsg_fromWelcome(t);
    };
    wrap.appendChild(b);
  });
  if (!wrap.children.length) return;
  // Insert BEFORE the meta row when it is a direct child of host; otherwise insert
  // relative to meta's own parent. Calling host.insertBefore(wrap, meta) when meta is a
  // grandchild throws NotFoundError and the chips never appear.
  try {
    var meta = host.querySelector ? host.querySelector('.mmeta') : null;
    if (meta && meta.parentNode) meta.parentNode.insertBefore(wrap, meta);
    else host.appendChild(wrap);
  } catch (e) {
    try { host.appendChild(wrap); } catch (e2) { console.error('[EOH] quick replies insert failed:', e2); }
  }
}

// Turn an offered set of choices in ANY assistant message into tappable buttons.
// Fires when the message presents a short list of options the user is meant to pick from
// (e.g. "Do you want me to: - Regenerate the CV - Regenerate the guide - Adjust something").
// Deliberately conservative so it doesn't fire on ordinary bulleted explanations.
function _renderChoiceButtons(text) {
  // Disabled — replaced by the Guided Answers outcome gate. These scraped chips
  // are redundant now. Reversible: set window._eohEnableChoiceButtons = true.
  if (!window._eohEnableChoiceButtons) return;
  var t = String(text || '');
  var c = document.getElementById('msgs'); if (!c) return;
  if (c.lastElementChild && c.lastElementChild.classList && c.lastElementChild.classList.contains('eoh-choices')) return;

  var lines = t.split('\n');
  // 1) Find a "question/offer" lead-in: a line ending with ':' that invites a choice,
  //    or a question mark, immediately followed by a bullet/number list.
  var offerRe = /(do you want|would you like|which (one|option|would)|shall i|should i|choose|pick|select|how would you like|what would you like|prefer|options?:)\b/i;
  // 2) Collect consecutive list items after it.
  var items = [], startIdx = -1;
  for (var i = 0; i < lines.length; i++) {
    var ln = lines[i].trim();
    var m = ln.match(/^(?:[-*•]|\d+[.)])\s+(.*\S)\s*$/);
    if (m) {
      if (startIdx === -1) {
        // require an offer lead-in within the 3 lines above the first bullet
        var lead = lines.slice(Math.max(0, i - 3), i).join(' ');
        if (!offerRe.test(lead) && !offerRe.test(ln)) continue;
        startIdx = i;
      }
      items.push(m[1]);
    } else if (startIdx !== -1 && ln === '') {
      continue;            // blank line inside the list is fine
    } else if (startIdx !== -1) {
      break;               // list ended
    }
  }
  // Only render for a small, genuine choice set.
  if (items.length < 2 || items.length > 6) return;

  // Clean each option into a short button label + the text to send.
  function _clean(s) {
    return s.replace(/\*\*/g, '').replace(/[`_]/g, '')
            .replace(/\s*[—-]\s*.*$/, '')     // drop trailing explanation after a dash
            .replace(/[?.]+\s*$/, '')          // drop trailing punctuation
            .trim();
  }
  var opts = items.map(function (s) {
    var raw = s.trim();
    // If the option has a **bolded** action phrase, use THAT as the concise label.
    var bold = (raw.match(/\*\*(.+?)\*\*/) || [])[1];
    var full = raw.replace(/\*\*/g, '').replace(/[`_]/g, '').trim();
    var label = bold ? bold.trim() : _clean(raw);
    if (label.length > 46) label = label.slice(0, 44).replace(/\s\S*$/, '') + '…';
    return { label: label || full.slice(0, 44), send: full };
  }).filter(function (o) { return o.label && o.label.length > 1; });
  if (opts.length < 2) return;

  var wrap = document.createElement('div');
  wrap.className = 'eoh-choices';
  wrap.style.cssText = 'margin:6px 0 16px;display:flex;flex-wrap:wrap;gap:6px';
  var BTN = 'background:var(--bg3,#111a2b);border:1px solid var(--border,#22304a);color:var(--text,#e6edf5);padding:9px 15px;border-radius:10px;cursor:pointer;font-size:13px;font-weight:600;font-family:inherit;transition:filter .12s,opacity .12s';
  opts.forEach(function (o) {
    var b = document.createElement('button');
    b.className = 'eoh-choice-btn';
    b.style.cssText = BTN;
    b.textContent = o.label;
    b.onmouseover = function () { b.style.filter = 'brightness(1.12)'; };
    b.onmouseout = function () { b.style.filter = 'none'; };
    b.onclick = function () {
      wrap.querySelectorAll('button').forEach(function (x) { x.disabled = true; x.style.opacity = (x === b ? '1' : '.5'); });
      sendMsg_fromWelcome(o.send);
    };
    wrap.appendChild(b);
  });
  c.appendChild(wrap);
  c.scrollTop = c.scrollHeight;
}

// Detect a staged-delivery continuation prompt ("Stage X of Y — type Next to continue",
// or "type Next to continue", or "(When ready, type Next…)") in a finished assistant
// message and append a clickable Next button. Uses theme CSS vars so it matches every theme.
function _renderNextButton(text) {
  var t = String(text || '');
  var re = /\b(?:type|say|reply(?:\s+with)?|press|click|send)\s+["'\u201c\u201d]?next["'\u201c\u201d]?\s+to\s+continue\b/i;
  var reStage = /stage\s+(\d+)\s+of\s+(\d+)/i;
  if (!re.test(t) && !/\bnext\b\s+to\s+continue/i.test(t)) return;
  var c = document.getElementById('msgs'); if (!c) return;
  // avoid double-injecting if the last child is already a next-wrap
  if (c.lastElementChild && c.lastElementChild.classList && c.lastElementChild.classList.contains('eoh-next')) return;
  var label = 'Next';
  var sm = t.match(reStage);
  if (sm) { var cur = parseInt(sm[1], 10), tot = parseInt(sm[2], 10); if (cur && tot && cur < tot) label = 'Next \u2014 Stage ' + (cur + 1) + ' of ' + tot; }
  var wrap = document.createElement('div');
  wrap.className = 'eoh-next';
  wrap.style.cssText = 'margin:4px 0 16px';
  var BTN = 'display:inline-flex;align-items:center;gap:8px;background:var(--green,#0fb574);border:1px solid var(--green,#0fb574);color:#fff;padding:10px 22px;border-radius:10px;cursor:pointer;font-size:13.5px;font-weight:600;font-family:inherit;transition:filter .12s,opacity .12s';
  wrap.innerHTML = '<button class="eoh-next-btn" style="' + BTN + '">Continue \u2192 <span style="opacity:.85;font-weight:500">' + label + '</span></button>';
  c.appendChild(wrap);
  c.scrollTop = c.scrollHeight;
  var b = wrap.querySelector('.eoh-next-btn');
  b.onmouseover = function () { b.style.filter = 'brightness(1.08)'; };
  b.onmouseout = function () { b.style.filter = 'none'; };
  b.onclick = function () {
    wrap.querySelectorAll('button').forEach(function (x) { x.disabled = true; x.style.opacity = '.55'; });
    sendMsg_fromWelcome('Next');
  };
}
// ── Canonical document state (client mirror of backend doc-state.js) ───────────
// Remembers ANY uploaded file's text so every request carries it and the AI never
// loses a file from an earlier turn. Newest-first, deduped by name, capped.
function _updateDocState(name, text) {
  try {
    var t = String(text || ''); if (t.trim().length < 80) return;
    var fname = String(name || 'document');
    var st = (S.docState && Array.isArray(S.docState.docs)) ? S.docState : { docs: [], version: 0 };
    // drop any existing entry with the same name (case-insensitive), then unshift newest
    st.docs = st.docs.filter(function(d){ return (d.name||'').toLowerCase() !== fname.toLowerCase(); });
    st.docs.unshift({ name: fname, text: t.slice(0, 16000), updatedAt: new Date().toISOString() });
    if (st.docs.length > 4) st.docs = st.docs.slice(0, 4);
    st.version = (st.version || 0) + 1;
    st.updatedAt = new Date().toISOString();
    S.docState = st;
  } catch (_) {}
}

// ── Canonical CV state (client mirror of backend resume-state.js) ──────────────
// Keeps S.resumeState in sync so every request carries the full current CV and the
// AI never loses it. Mirrors the backend's looksLikeResume/extractName logic.
function _cvLooksLikeResume(text) {
  var t = String(text || ''); if (t.length < 120) return false; var h = 0;
  if (/professional summary|summary of qualifications|profile/i.test(t)) h++;
  if (/work experience|professional experience|employment history|work history/i.test(t)) h++;
  if (/education|academic/i.test(t)) h++;
  if (/skills|competenc|proficienc/i.test(t)) h++;
  if (/\b(19|20)\d{2}\b/.test(t)) h++;
  return h >= 2;
}
function _cvExtractName(text) {
  var t = String(text || '');
  var m = t.match(/^\s*#{0,2}\s*([A-Z][A-Za-z.'-]+(?:\s+[A-Z][A-Za-z.'-]+){0,3})\s*$/m);
  if (m) return m[1].trim();
  var first = (t.split('\n').map(function(s){return s.trim();}).filter(Boolean)[0]) || '';
  return first.replace(/^#+\s*/, '').slice(0, 60);
}
function _updateResumeState(text, source) {
  try {
    if (!_cvLooksLikeResume(text)) return;
    var t = String(text).trim().slice(0, 20000);
    var prev = S.resumeState;
    S.resumeState = {
      hasResume: true,
      text: t,
      source: source || (prev && prev.hasResume ? 'revised' : 'generated'),
      subjectName: _cvExtractName(t) || (prev && prev.subjectName) || '',
      updatedAt: new Date().toISOString(),
      version: (prev && prev.version ? prev.version : 0) + 1
    };
  } catch (_) {}
}


// Detect whether the current conversation is about a resume/CV (so exports ask for format).
function _isResumeConversation() {
  try {
    var h = (S.history || []);
    // The most recent user message decides intent. An ERP/document request is never a resume.
    var lastUser = '';
    for (var j = h.length - 1; j >= 0; j--) { if (h[j] && h[j].role === 'user') { lastUser = ((h[j].content) || '') + ''; break; } }
    if (/\b(module|t-?code|tcode|transaction|config|customi[sz]ing|fiori|abap|idoc|workflow|overview|report|blueprint|process|integration|master data|migration|spec)\b/i.test(lastUser)) return false;
    if (/\b(mo|mm|sd|fi|co|pp|pm|qm|wm|ewm|hcm|hr|ps|le|tm)\s*module\b/i.test(lastUser)) return false;
    // Otherwise require a recent (last 3 turns) resume signal, not stale history.
    var recent = h.slice(-3);
    for (var i = recent.length - 1; i >= 0; i--) {
      var c = ((recent[i] && recent[i].content) || '') + '';
      if (/professional summary|work experience|employment history|core competencies|curriculum vitae/i.test(c)) return true;
      if (/(^|[^a-z\u00e9])(resume|r\u00e9sum\u00e9|cv)([^a-z\u00e9]|$)/i.test(c)) return true;
    }
  } catch (_) {}
  return false;
}
// In-chat chooser — Style → Length → Charts → Format, driven by the admin config.
var _resumeOptsCache = null;
function _fetchResumeOptions(cb) {
  if (_resumeOptsCache) { cb(_resumeOptsCache); return; }
  var fallback = { styles: [{key:'clean',label:'Clean'},{key:'modern',label:'Modern'},{key:'classic',label:'Classic'},{key:'formal',label:'Formal'}], onepage: true, visuals: true };
  try {
    fetch(API + '/export/resume-options').then(function (r) { return r.json(); }).then(function (d) {
      _resumeOptsCache = (d && d.styles && d.styles.length) ? d : fallback; cb(_resumeOptsCache);
    }).catch(function () { cb(fallback); });
  } catch (_) { cb(fallback); }
}
function _renderFormatChooser(onDone) {
  var c = document.getElementById('msgs'); if (!c) return;
  if (document.getElementById('eoh-fmt-chooser')) return;
  _fetchResumeOptions(function (opts) {
    if (document.getElementById('eoh-fmt-chooser')) return;
    var BTN = 'background:var(--bg3);border:1px solid var(--border);color:var(--text);padding:9px 16px;border-radius:10px;cursor:pointer;font-size:13px;font-weight:600;font-family:inherit;margin:3px 5px 3px 0';
    var LBL = '<div style="font-size:12px;color:var(--muted);margin:10px 0 6px">';
    var wrap = document.createElement('div');
    wrap.id = 'eoh-fmt-chooser';
    wrap.style.cssText = 'margin:4px 0 16px';
    c.appendChild(wrap);
    var sel = { style: '', depth: 'detailed', visuals: false, visualTier: 'balanced' };

    function step(title, buttons, onPick) {
      var div = document.createElement('div');
      var html = LBL + title + '</div>';
      buttons.forEach(function (b, i) { html += '<button class="eoh-cq-s" data-i="' + i + '" style="' + BTN + (b.dim ? ';opacity:.85' : '') + '">' + b.label + '</button>'; });
      div.innerHTML = html;
      wrap.appendChild(div);
      c.scrollTop = c.scrollHeight;
      div.querySelectorAll('.eoh-cq-s').forEach(function (el) {
        el.onclick = function () {
          div.querySelectorAll('.eoh-cq-s').forEach(function (x) { x.disabled = true; x.style.opacity = (x === el ? '1' : '.45'); });
          onPick(buttons[parseInt(el.getAttribute('data-i'), 10)]);
        };
      });
    }
    function _finish(fmt) {
      // If the queue provided an onDone, hand the choices back to IT so the queue owns
      // generation + sequencing (no race). Otherwise export directly (single-CV case).
      if (typeof onDone === 'function') {
        onDone({ fmt: fmt, style: sel.style, depth: sel.depth, visuals: sel.visuals, visualTier: sel.visualTier });
      } else {
        doExport(fmt, null, null, 'resume', sel.style, sel.depth, sel.visuals, sel.visualTier);
      }
    }
    function stepFormat() {
      step('Choose a format:', [
        { label: '\uD83D\uDCC4 PDF', v: 'pdf' },
        { label: '\uD83D\uDCDD Word (DOCX)', v: 'docx' },
      ], function (b) { _finish(b.v); });
    }
    function stepVisualLevel() {
      step('How visual should this CV be?  (more graphics = less formal)', [
        { label: 'Minimal', v: 'minimal' },
        { label: 'Balanced', v: 'balanced' },
        { label: 'Data-rich', v: 'data-rich' },
      ], function (b) { sel.visualTier = b.v; stepFormat(); });
    }
    function stepVisuals() {
      if (!opts.visuals) { stepFormat(); return; }
      step('Add charts drawn from your data?', [
        { label: '\uD83D\uDCCA With charts', v: true },
        { label: 'Text only', v: false },
      ], function (b) { sel.visuals = b.v; if (b.v) { stepVisualLevel(); } else { stepFormat(); } });
    }
    function stepDepth() {
      if (!opts.onepage) { stepVisuals(); return; }
      step('How detailed?', [
        { label: 'Detailed (full)', v: 'detailed' },
        { label: 'One-page (condensed)', v: 'onepage' },
      ], function (b) { sel.depth = b.v; stepVisuals(); });
    }
    var styleBtns = opts.styles.map(function (t) { return { label: t.label, v: t.key }; });
    styleBtns.push({ label: 'Surprise me', v: '', dim: true });
    step('Choose a style:', styleBtns, function (b) { sel.style = b.v; stepDepth(); });
  });
}
async function doExport(fmt, imgBase64, imgExt, docType, resumeStyle, resumeDepth, resumeVisuals, resumeVisualTier) {
  // In Resume mode, any export is a resume — force the resume docType (unless the
  // user explicitly picked a different type) so it renders as a CV, not an ERP report.
  var _resumeExport = (docType === 'resume' || docType === 'cv');
  if (_exportInProgress) { showToast('Export already in progress — please wait', 'info', 3000); return; }
  if (!S.history.length) { addMsg('assistant','No conversation to export yet.',null); return; }
  if (!S.user) { showUpgrade('docs', '🔐 SIGN IN REQUIRED TO EXPORT - Create a free account to get started'); return; }
  if (isPlanExpired()) { showExpiredPopup(); return; }
  if (!checkDocLimit()) return;
  _exportInProgress = true;
  addMsg('assistant', 'Generating your ' + fmt.toUpperCase() + ' file...', null);
  showToast('Preparing ' + fmt.toUpperCase() + '…', 'loading', 0);

  // Collect ALL images from conversation: uploaded + search results
  var allChatImages = [];
  // 1. User uploaded images (base64)
  if (S._lastUploadedImages && S._lastUploadedImages.length > 0) {
    S._lastUploadedImages.forEach(function(b64) {
      if (b64 && b64.length > 100) allChatImages.push(b64);
    });
  }
  // 2. Search result images (URLs from AI responses)
  S.history.forEach(function(m) {
    if (m.role === 'assistant' && m.content) {
      var imgRe = /!\[[^\]]*\]\((https?:\/\/[^)]+)\)/g;
      var match;
      while ((match = imgRe.exec(m.content)) !== null) {
        allChatImages.push(match[1]); // URL string
      }
    }
  });
  console.log('[Export] Collected', allChatImages.length, 'images for export');

  try {
    // Rotate progress messages so user knows it's still working (can take 20-40s)
    var _exportMsgs = [
      'Preparing ' + fmt.toUpperCase() + '…',
      'Analyzing conversation…',
      'Structuring content…',
      'Generating document…',
      'Applying formatting…',
      'Almost ready…',
    ];
    var _exportMsgIdx = 0;
    var _exportTicker = setInterval(function() {
      _exportMsgIdx = (_exportMsgIdx + 1) % _exportMsgs.length;
      var t = document.getElementById('eoh-toast');
      if (t) t.querySelector('span:last-child').textContent = _exportMsgs[_exportMsgIdx];
    }, 5000);

    var res = await window.fetch(API + '/export', {
      method: 'POST',
      headers: {'Content-Type':'application/json','Authorization':'Bearer ' + S.token},
      body: JSON.stringify({
        // Include extracted file text (uploaded CV/PDF lives in _fileContent, not content),
        // exactly like the chat path does — otherwise the backend never sees the CV.
        messages: (S.history || []).map(function (m) {
          // Surface the exported CV draft (or attached file text) as content so revision
      // requests after an export can see the full resume, not just "Generated file".
      return { role: m.role, content: (m._resumeDraft || m._fileContent || m.content || '') };
        }),
        vendor: S.vendor,
        product: S.product,
        format: fmt,
        resumeState: S.resumeState || null,   // canonical CV — backend uses it as source of truth
        docState: S.docState || null,
        docType: docType || null,
        resumeTemplate: resumeStyle || null,
        resumeDepth: resumeDepth || null,
        resumeVisuals: !!resumeVisuals,
        resumeVisualTier: resumeVisualTier || null,
        fileId: S.lastFileId || null,
        userId: S.user.id,
        sessionId: S_sessionId || null,
        logoBase64: S.logoBase64 || null,
        logoExt: S.logoExt || null,
        contentImageBase64: S.contentImageBase64 || imgBase64 || null,
        contentImageExt: S.contentImageExt || imgExt || null,
        chatImages: allChatImages.length > 0 ? allChatImages : null
      })
    });
    if (!res.ok) {
      var errData = await res.json().catch(function(){return {};});
      var _expErr = errData.error || ('Export failed with status ' + res.status);
      addMsg('assistant', '⚠️ ' + _expErr, null);
      clearInterval(_exportTicker);
      _exportInProgress = false;
      return;
    }

    // Parse SSE stream or JSON response
    var d = {};
    var _ct = res.headers.get('content-type') || '';
    if (_ct.includes('text/event-stream')) {
      var _reader = res.body.getReader(); var _dec = new TextDecoder(); var _buf = '';
      var _done = false;
      while (!_done) {
        var _rd = await _reader.read(); if (_rd.done) break;
        _buf += _dec.decode(_rd.value, { stream: true });
        var _lines = _buf.split('\n'); _buf = _lines.pop();
        for (var _li = 0; _li < _lines.length; _li++) {
          var _ln = _lines[_li].trim();
          if (!_ln.startsWith('data: ')) continue;
          try {
            var _ev = JSON.parse(_ln.slice(6));
            if (_ev.heartbeat) continue; // server keepalive — ignore
            if (_ev.progress) {
              var _t = document.getElementById('eoh-toast');
              if (_t) { var _ts = _t.querySelector('span:last-child'); if(_ts) _ts.textContent = _ev.progress; }
            }
            if (_ev.done || _ev.file || _ev.error) { d = _ev; _done = true; break; }
          } catch(_) {}
        }
      }
    } else {
      d = await res.json().catch(function(){ return {}; });
    }

    // If AI wants to discuss first
    if (d.discussion) {
      addMsg('assistant', d.reply, null);
      S.history.push({ role: 'assistant', content: d.reply });
      if (d.fileId) S.lastFileId = d.fileId;
      saveNow();
      return;
    }

    // Check if file data exists
    if (!d.file) {
      addMsg('assistant', 'Export returned no file. ' + (d.error || 'Please try again.'), null);
      return;
    }
    // Convert base64 to blob for download
    var byteChars = atob(d.file);
    var byteArr = new Uint8Array(byteChars.length);
    for (var bi = 0; bi < byteChars.length; bi++) byteArr[bi] = byteChars.charCodeAt(bi);
    var blob = new Blob([byteArr], { type: d.mimeType });
    var url = URL.createObjectURL(blob);
    var exportId = d.exportId || null;
    var fname = d.fileName || ((S.vendor||'ERP') + '-' + (S.product||'Report') + '-' + Date.now() + '.' + fmt).replace(/[\/\\:*?"<>|\s]+/g, '-');
    S.lastExportFmt = fmt;
    S.lastFileId = d.fileId || exportId || null;
    S.contentImageBase64 = null; S.contentImageExt = null;
    // Show download link card
    var m = document.getElementById('msgs');
    var el = document.createElement('div');
    el.className = 'msg assistant';
    var logoSrc = document.getElementById('main-logo') ? document.getElementById('main-logo').src : '';
    var icon = fmt==='pptx' ? '&#127912;' : fmt==='docx' ? '&#128196;' : fmt==='xlsx' ? '&#128202;' : '&#128196;';
    var color = fmt==='pptx' ? '#C0382B' : fmt==='docx' ? '#2B579A' : fmt==='xlsx' ? '#217346' : '#0A8A5F';
    el.innerHTML = '<div class="mav"><img src="' + logoSrc + '" alt="EOH"></div>'
      + '<div class="mbody"><div class="msender">EOH</div>'
      + '<div class="mbubble" style="padding:0;overflow:hidden">'
      + '<div style="padding:14px 16px;border-bottom:1px solid rgba(255,255,255,.06)">'
      + '<div style="font-size:13px;color:#e8edf5;margin-bottom:4px">&#10003; Your file is ready to download</div>'
      + '<div style="font-size:11px;color:#7d8ba3">' + fname + '</div></div>'
      + '<div style="padding:12px 16px;display:flex;gap:10px;align-items:center">'
      + '<span style="font-size:28px">' + icon + '</span>'
      + '<div style="flex:1"><div style="font-size:13px;font-weight:600;color:#e8edf5">' + fmt.toUpperCase() + ' Document</div>'
      + '<div style="font-size:11px;color:#7d8ba3">' + (S.vendor||'') + ' ' + (S.product||'') + '</div></div>'
      + '<a href="' + url + '" download="' + fname + '" style="padding:9px 20px;background:linear-gradient(135deg,' + color + ',#0A4FCC);color:white;border-radius:6px;text-decoration:none;font-size:13px;font-weight:600;white-space:nowrap">&#8595; Download</a>'
      + '</div></div>'
      + '<div class="mmeta"><span class="mtime">' + new Date().toLocaleTimeString([],{hour:'2-digit',minute:'2-digit'}) + '</span></div>'
    + renderStars('export', fname, S.vendor||'', S.product||'')
    + '</div>';
    m.appendChild(el);
    m.scrollTop = m.scrollHeight;
    clearInterval(_exportTicker);
    _exportInProgress = false;
    showToast(fmt.toUpperCase() + ' ready — click Download', 'success');

    // ★ Push history FIRST with exportFile metadata
    S.history.push({
      role: 'assistant',
      content: '\ud83d\udcce Generated ' + fmt.toUpperCase() + ' file: ' + fname,
      // Keep the generated CV text (hidden from display) so a follow-up like "make it
      // more formal" has the full resume to revise instead of "no prior text visible".
      _resumeDraft: (d && d.resumeContent) ? d.resumeContent : undefined,
      timestamp: new Date().toISOString(),
      exportFile: {
        exportId: exportId,
        storageUrl: d.storageUrl || null,
        fileName: fname,
        format: fmt,
        mimeType: blob.type || 'application/octet-stream'
      }
    });
    // Refresh the canonical CV state with the freshly generated CV so the NEXT export
    // (e.g. after "change the format") uses this current version, never a stale one.
    try { if (d && d.resumeContent) _updateResumeState(d.resumeContent, 'revised'); } catch(_){}
    // ★ THEN increment + save (so exportFile is included in the save)
    incrementDoc();
    saveNow();
    // Multi-file queue: if more files are pending (e.g. "export both files"), run the next one.
    try {
      if (S._exportQueue && typeof S._exportQueue.run === 'function') {
        var _q = S._exportQueue; S._exportQueue = null;
        setTimeout(function(){ try { _q.run(); } catch(_){} }, 1200);
      }
    } catch(_){}
  } catch(e) { console.error('[Export]', e); clearInterval(_exportTicker); _exportInProgress = false; showToast('Export failed — ' + (e.message||'unknown error'), 'error'); addMsg('assistant','Export error: ' + (e.message || 'Unknown error') + '. Please try again.',null);
    // even on failure, don't strand the rest of the queue
    try { if (S._exportQueue && typeof S._exportQueue.run === 'function') { var _q2 = S._exportQueue; S._exportQueue = null; setTimeout(function(){ try { _q2.run(); } catch(_){} }, 1200); } } catch(_){}
  }
}


// -- TTS TEXT CLEANER - strips code, symbols, markdown for natural speech --
// ═══════════════════════════════════════════════════════════════════════════════
// condenseForSpeech(fullText, lang) — Produces the SPOKEN version of a long answer.
// The DISPLAY always shows the full text; this only shapes what is READ ALOUD.
// It reads headings + prose (the meaning), and SUMMARIZES structural bulk instead of
// reading it verbatim: tables → "a table comparing X, Y, Z is shown"; code → "the code
// is on screen"; long lists → first items + "and more on screen". Targets ~40-70% of
// the original length depending on how much structural bulk there is, with natural
// bridge phrases so nothing sounds cut off. The full idea is always conveyed.
// ═══════════════════════════════════════════════════════════════════════════════
var _SPEAK_BRIDGES = {
  en: { table: 'A table {cols} is shown on screen.', tableNoCols: 'A detailed table is shown on screen.',
        code: 'The related code is shown on screen.', more: 'and more, shown on screen',
        listMore: 'The remaining points are listed on screen.' },
  ar: { table: '\u064a\u0648\u062c\u062f \u062c\u062f\u0648\u0644 {cols} \u0645\u0639\u0631\u0648\u0636 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629.', tableNoCols: '\u064a\u0648\u062c\u062f \u062c\u062f\u0648\u0644 \u062a\u0641\u0635\u064a\u0644\u064a \u0645\u0639\u0631\u0648\u0636 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629.',
        code: '\u0627\u0644\u0643\u0648\u062f \u0630\u0648 \u0627\u0644\u0635\u0644\u0629 \u0645\u0639\u0631\u0648\u0636 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629.', more: '\u0648\u0627\u0644\u0645\u0632\u064a\u062f \u0645\u0639\u0631\u0648\u0636 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629', listMore: '\u0628\u0642\u064a\u0629 \u0627\u0644\u0646\u0642\u0627\u0637 \u0645\u062f\u0631\u062c\u0629 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629.' }
};
function _speakBridge(code, key) { var g = _SPEAK_BRIDGES[code] || _SPEAK_BRIDGES.en; return g[key] || _SPEAK_BRIDGES.en[key]; }

function condenseForSpeech(fullText, lang) {
  if (!fullText) return '';
  var code = String(lang || 'en').toLowerCase().split('-')[0];
  if (/[\u0600-\u06FF]/.test(fullText)) code = 'ar';
  if (!_SPEAK_BRIDGES[code]) code = 'en';

  var lines = fullText.split('\n');
  var out = [];
  var i = 0;
  while (i < lines.length) {
    var line = lines[i];

    // 1) Fenced code block → one short spoken note, skip the body.
    if (/^\s*```/.test(line)) {
      i++;
      while (i < lines.length && !/^\s*```/.test(lines[i])) i++;
      i++; // closing fence
      out.push(_speakBridge(code, 'code'));
      continue;
    }

    // 2) Markdown table → read the column headers, skip the rows.
    if (line.indexOf('|') !== -1 && i + 1 < lines.length && /^\s*\|?[\s:|-]+\|?\s*$/.test(lines[i + 1])) {
      var headers = line.split('|').map(function(c){ return c.trim(); }).filter(function(c){ return c.length; });
      // consume the whole table
      i += 2;
      while (i < lines.length && lines[i].indexOf('|') !== -1) i++;
      if (headers.length) {
        var colsPhrase = (code === 'ar' ? '\u0628\u0623\u0639\u0645\u062f\u0629 ' : 'with columns for ') + _joinList(headers, code);
        out.push(_speakBridge(code, 'table').replace('{cols}', colsPhrase));
      } else {
        out.push(_speakBridge(code, 'tableNoCols'));
      }
      continue;
    }

    // 3) Long bullet/numbered list → read first 3 items, summarize the rest.
    if (/^\s*([-*•]|\d+[.)])\s+/.test(line)) {
      var items = [];
      while (i < lines.length && /^\s*([-*•]|\d+[.)])\s+/.test(lines[i])) {
        items.push(lines[i].replace(/^\s*([-*•]|\d+[.)])\s+/, '').trim());
        i++;
      }
      if (items.length <= 4) {
        items.forEach(function(it){ out.push(it); });
      } else {
        for (var k = 0; k < 3; k++) out.push(items[k]);
        out.push(_speakBridge(code, 'listMore'));
      }
      continue;
    }

    // 4) Headings → keep (they are the structure/signposts), strip the marker.
    if (/^\s*#{1,6}\s+/.test(line)) { out.push(line.replace(/^\s*#{1,6}\s+/, '').trim()); i++; continue; }

    // 5) Prose / everything else → keep as-is.
    out.push(line);
    i++;
  }

  var spoken = out.join('\n');

  // Length guard: if the condensed version is still >70% of the original, trim the longest
  // remaining paragraphs (keep headings + first sentences) until it fits ~65%.
  var target = Math.round(fullText.length * (window._voiceSpeakMaxPct || 0.70));
  if (spoken.length > target) {
    var paras = spoken.split(/\n{2,}/);
    // shorten the longest paragraphs to their first 1-2 sentences
    paras = paras.map(function(p){
      if (p.length < 220) return p;
      var sents = p.match(/[^.!?]+[.!?]+/g);
      if (sents && sents.length > 2) return sents.slice(0, 2).join(' ').trim();
      return p;
    });
    spoken = paras.join('\n\n');
  }
  return spoken;
}
function _joinList(arr, code) {
  if (arr.length === 1) return arr[0];
  var and = (code === 'ar') ? ' \u0648 ' : ' and ';
  return arr.slice(0, -1).join(', ') + and + arr[arr.length - 1];
}

// Everything spoken passes through cleanForTTS and nothing else uses it, so this is the
// one safe place to simplify speech without touching what the chat window displays.
// Option lists, hints and directive scaffolding are meaningless by ear — the user cannot
// hold them in mind or answer them quickly — so they are removed from SPEECH only.

function _voiceSimplify(t) {
  t = String(t || '');
  // Directive blocks, closed or unterminated.
  t = t.replace(/\[\[(?:ASK|DIDYOUMEAN):[\s\S]*?\]\]/gi, ' ')
       .replace(/\[\[(?:ASK|DIDYOUMEAN):[\s\S]*$/i, ' ');
  // JSON scaffolding, including its value so no stray "false" is left behind.
  t = t.replace(/[,;]?\s*"?(?:allow_freetext|recommended|default|priority)"?\s*:\s*(?:true|false|\d+)/gi, ' ')
       .replace(/[,;]?\s*"?(?:intro|label|options)"?\s*:\s*/gi, ' ');
  // Hints are UI guidance, never spoken.
  t = t.replace(/^[\s\-*\u2022]*hint\s*:.*$/gim, ' ')
       .replace(/[,;]?\s*\bhint\s*:\s*[^\n.]*/gi, ' ');
  // Bullet and numbered option lines.
  t = t.split(/\r?\n/).filter(function (l) {
    return !/^\s*(?:[-*\u2022\u2023\u25cf]|\d{1,2}[.)])\s+/.test(l);
  }).join('\n');
  // A list intro left dangling once its list is gone.
  t = t.replace(/(?:^|\n)[^\n]*\b(?:are you looking to|did you mean to|would you like to|you can choose|options?)\s*:\s*$/gim, ' ');
  t = t.replace(/[{}\[\]"]/g, ' ').replace(/\s{2,}/g, ' ').trim();

  return t;
}

function cleanForTTS(text) {
  // Simplify FIRST, so option lists never reach the speech pipeline.
  var _simplified = _voiceSimplify(text);
  if (_simplified) text = _simplified;
  var _src = String(text || '')
    // [[DIDYOUMEAN: {json}]] → speak the intro + the option labels naturally (never the raw JSON).
    .replace(/\[\[DIDYOUMEAN:\s*([\s\S]*?)\]\]/gi, function (_m, body) {
      try {
        var o = JSON.parse(body.trim());
        var intro = (o.intro || '').trim();
        var opts = (o.options || []).map(function (x) { return x && x.label ? String(x.label).trim() : String(x || '').trim(); }).filter(Boolean);
        var spoken = intro;
        // Do not read a list of options aloud — by the third the listener has lost the
        // first. Speak only the question. This affects SPEECH only; the chat window
        // still renders the options as tappable choices.
        if (!intro && opts.length) spoken = 'Which of those did you mean?';
        return ' ' + spoken + ' ';
      } catch (_) { return ' '; }
    })
    // [[ASK: question | opt | opt]] → speak the question and options.
    .replace(/\[\[ASK:\s*([\s\S]*?)\]\]/gi, function (_m, body) {
      var parts = body.split('|').map(function (x) { return x.trim(); }).filter(Boolean);
      if (!parts.length) return ' ';
      var q = parts.shift();
      return ' ' + q + ' ';   // question only — options are shown on screen, not spoken
    })
    // Any stray export trigger must never be spoken.
    .replace(/\[?\[?EXPORT_TRIGGER:[^\]]*\]?\]?/gi, ' ');
  var s0 = _src
    // Staged-delivery markers: speak naturally instead of reading dashes/quotes literally.
    .replace(/—?\s*Stage\s+(\d+)\s+of\s+(\d+)\s*—?\s*type\s+"?Next"?\s+to\s+continue\s*—?/gi, ' That is stage $1 of $2. Say Next to continue. ')
    .replace(/—?\s*Configuration complete\s*—?/gi, ' That completes the configuration. ')
    .replace(/\(When ready,\s*type\s+"?Next"?\s+to continue from Stage\s+(\d+)\.?\)/gi, ' Say Next when you want to continue from stage $1. ');
  var s = s0
    .replace(/\uFFFD/g, '')                                   // broken replacement char
    .replace(/[\u{1F000}-\u{1FFFF}]/gu, '')                    // emoji / pictographs / symbols
    .replace(/[\u{2600}-\u{27BF}]/gu, '')                      // misc symbols + dingbats
    .replace(/[\u{2B00}-\u{2BFF}\u{2300}-\u{23FF}]/gu, '')     // arrows/technical (keep ↔? no — voice reads it oddly)
    .replace(/[\u{FE00}-\u{FE0F}\u{200D}\u{20E3}]/gu, '')      // variation selectors, ZWJ, keycap
    .replace(/[\u{D800}-\u{DFFF}]/gu, '')                      // lone/broken surrogate halves → the � box
    .replace(/[ \t]{2,}/g, ' ');
  // Remove code blocks completely
  s = s.replace(/```[\s\S]*?```/g, ' (code block omitted) ');
  // Remove inline code content
  s = s.replace(/`([^`]+)`/g, function(m, code) {
    // Keep T-codes and short references readable
    if (code.length <= 12 && /^[A-Z0-9_/-]+$/i.test(code)) return code;
    return ' code reference ';
  });
  // Remove HTML tags
  s = s.replace(/<[^>]*>/g, '');
  // Remove markdown images
  s = s.replace(/!\[[^\]]*\]\([^)]+\)/g, '');
  // Convert markdown links to just text
  s = s.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');
  // Remove markdown headers markers but keep text
  s = s.replace(/#{1,6}\s*/g, '');
  // Remove bold/italic markers
  s = s.replace(/\*\*\*([^*]+)\*\*\*/g, '$1');
  s = s.replace(/\*\*([^*]+)\*\*/g, '$1');
  s = s.replace(/\*([^*]+)\*/g, '$1');
  // Remove horizontal rules
  s = s.replace(/^---+$/gm, '');
  // Remove table pipes
  s = s.replace(/\|/g, ', ');
  s = s.replace(/^[\s,-]+$/gm, '');
  // Remove blockquote markers
  s = s.replace(/^>\s*/gm, '');
  // Remove bullet markers
  s = s.replace(/^[-•]\s*/gm, '');
  // Remove numbered list markers
  s = s.replace(/^\d+[.)]\s*/gm, '');
  // Remove emoji numbers (1️⃣ etc) but keep meaning
  s = s.replace(/[0-9]️⃣/g, function(m) { return m.charAt(0) + '. '; });
  // Remove remaining emojis that are just decorative
  s = s.replace(/[📋📌💡⚠️✅❌🔧📊📝🎯⭐🚀📎📂🔍📈📉🔑🏷️]/g, '');
  // Clean special characters not meant to be spoken
  s = s.replace(/[{}\[\]<>\\\/|~^`@#$%&+=]/g, ' ');
  // Fix double periods/spaces
  s = s.replace(/\.{2,}/g, '.');
  s = s.replace(/\s{2,}/g, ' ');
  // Add natural pauses
  s = s.replace(/:\s/g, ': ... ');
  // Clean up
  s = s.replace(/\n+/g, '. ').replace(/\s+/g, ' ').trim();
  return s;
}

// -- AUTO LANGUAGE DETECTION from text --
function detectLanguage(text) {
  if (!text || text.length < 5) return 'en-US';
  var sample = text.substring(0, 200);
  // Arabic
  if (/[\u0600-\u06FF\u0750-\u077F]/.test(sample)) return 'ar-SA';
  // Chinese
  if (/[\u4E00-\u9FFF]/.test(sample)) return 'zh-CN';
  // Japanese
  if (/[\u3040-\u309F\u30A0-\u30FF]/.test(sample)) return 'ja-JP';
  // Korean
  if (/[\uAC00-\uD7AF]/.test(sample)) return 'ko-KR';
  // Hindi/Devanagari
  if (/[\u0900-\u097F]/.test(sample)) return 'hi-IN';
  // Thai
  if (/[\u0E00-\u0E7F]/.test(sample)) return 'th-TH';
  // Russian/Cyrillic
  if (/[\u0400-\u04FF]/.test(sample)) return 'ru-RU';
  // Greek
  if (/[\u0370-\u03FF]/.test(sample)) return 'el-GR';
  // Hebrew
  if (/[\u0590-\u05FF]/.test(sample)) return 'he-IL';
  // Turkish special chars
  if (/[ÇçĞğİıÖöŞşÜü]/.test(sample) && /\b(bir|ve|bu|için|ile|olan)\b/i.test(sample)) return 'tr-TR';
  // German
  if (/\b(und|der|die|das|ist|ein|nicht|für|mit|auf)\b/i.test(sample)) return 'de-DE';
  // French
  if (/\b(les|des|une|est|que|dans|pour|avec|sur|pas)\b/i.test(sample)) return 'fr-FR';
  // Spanish
  if (/\b(los|las|una|del|por|con|para|como|más|pero)\b/i.test(sample)) return 'es-ES';
  // Portuguese
  if (/\b(uma|dos|das|para|com|por|não|mais|como|são)\b/i.test(sample)) return 'pt-BR';
  // Italian
  if (/\b(gli|una|del|per|con|che|non|sono|come|più)\b/i.test(sample)) return 'it-IT';
  // Dutch
  if (/\b(een|het|van|zijn|dat|met|voor|niet|ook)\b/i.test(sample)) return 'nl-NL';
  // Polish
  if (/[ąćęłńóśźżĄĆĘŁŃÓŚŹŻ]/.test(sample)) return 'pl-PL';
  // Default English
  return 'en-US';
}

// ── Global speak-session counter — prevents overlapping TTS loops ─────────────
var _activeSpeakId = 0;

async function speakText(text) {
  if (!S.user) return;
  // ── Check voice limit before speaking ──
  // Clamp used to limit to handle old over-counted data gracefully
  var _vu  = getUsage(); var _vl = getLimits();
  var _vuVoiceClamped = _vl.voice > 0 ? Math.min(_vu.voice || 0, _vl.voice) : (_vu.voice || 0);
  if ((_vl.voice || 0) > 0 && _vuVoiceClamped >= _vl.voice) {
    if (S.voiceOn) { endInlineVoice(); }
    return;
  }
  stopAudio();                       // kills any previous loop + increments ID
  var _myId = _activeSpeakId;        // capture MY id — if it changes, I must stop
  var _voiceOnAtStart = S.voiceOn;   // remember if voice mode was ON — used to gate mid-play stop
  _isAISpeaking = true;              // block VAD mic immediately — even during fetch delay
  try {
    // Clean the FULL text — no length truncation here
    var clean = cleanForTTS(text);
    if (!clean) return;

    var detectedLang = S._chatLang || detectLanguage(clean);
    var choice = S._voiceChoice || ('cloud:' + (window._voiceDefaultVoice || 'Kore'));
    var speed  = S._voiceSpeed  || window._voiceDefaultSpeed || 1.0;

    // ── Split into sentence-boundary chunks ≤ 4800 chars, total max 20,000 chars ──
    var _chunks = (function splitChunks(txt, maxLen) {
      var sentences = txt.match(/[^.!?\n]+[.!?\n]*|[^.!?\n]+$/g) || [txt];
      var out = [], cur = '';
      sentences.forEach(function(s) {
        if ((cur + s).length > maxLen) {
          if (cur) out.push(cur.trim());
          // If single sentence > maxLen, split at commas/semicolons
          if (s.length > maxLen) {
            var parts = s.match(/.{1,3800}(?:[,;]|$)/g) || [s];
            parts.forEach(function(p) { out.push(p.trim()); });
          } else { cur = s; }
        } else { cur += s; }
      });
      if (cur.trim()) out.push(cur.trim());
      return out.filter(function(ch){ return ch.length > 0; });
    })(clean, window._voiceChunkMaxChars || 4800);

    // ── Voice limit gate — check remaining BEFORE counting or playing ──
    var _ttsLimits    = getLimits();
    var _ttsVoiceLim  = _ttsLimits.voice || 0;
    // Clamp used to limit — old over-count data must never block new sessions
    var _ttsVoiceUsed = _ttsVoiceLim > 0
      ? Math.min(S.voiceMinsUsed || 0, _ttsVoiceLim)
      : (S.voiceMinsUsed || 0);
    var _ttsRemaining = _ttsVoiceLim > 0 ? Math.max(0, _ttsVoiceLim - _ttsVoiceUsed) : Infinity;

    // If no minutes left at all → stop immediately, don't play
    if (_ttsVoiceLim > 0 && _ttsRemaining <= 0) {
      updateLimits(); // refresh UI to show limit state
      return;
    }

    // Estimate mins for full text
    var _ttsWords = clean.split(' ').length;
    var _ttsMins  = parseFloat((_ttsWords / 150).toFixed(3));

    // Clamp: only count what we're actually allowed to play
    var _ttsMinsToCharge = _ttsVoiceLim > 0 ? Math.min(_ttsMins, _ttsRemaining) : _ttsMins;

    // If clamped → truncate text to match the time budget then re-chunk
    if (_ttsVoiceLim > 0 && _ttsMins > _ttsRemaining) {
      var _maxWords = Math.floor(_ttsRemaining * 150);
      clean = clean.split(' ').slice(0, _maxWords).join(' ');
      // Re-chunk using the same algorithm as above (no lookbehind — works in all browsers)
      var _sentences = clean.match(/[^.!?\n]+[.!?\n]*|[^.!?\n]+$/g) || [clean];
      var _rOut = [], _rCur = '';
      _sentences.forEach(function(s) {
        var _rcMax = window._voiceChunkMaxChars || 4800;
      if ((_rCur + s).length > _rcMax) {
          if (_rCur) _rOut.push(_rCur.trim());
          if (s.length > _rcMax) { var _rParts = s.match(/.{1,3800}(?:[,;]|$)/g) || [s]; _rParts.forEach(function(p) { _rOut.push(p.trim()); }); _rCur = ''; }
          else { _rCur = s; }
        } else { _rCur += s; }
      });
      if (_rCur.trim()) _rOut.push(_rCur.trim());
      _chunks = _rOut.filter(function(ch) { return ch.length > 0; });
    }

    // Now commit only the clamped amount
    S.voiceMinsUsed = parseFloat((_ttsVoiceUsed + _ttsMinsToCharge).toFixed(3));
    if (S.user) S.user.voiceMinsUsed = S.voiceMinsUsed;
    saveUsage();
    updateLimits();
    syncAllUsageToServer();
    syncIncrementToServer('voice', {mins: _ttsMinsToCharge});
    // Bug-2 fix (live voice display): the authoritative voice minutes are recorded
    // server-side by /voice/speak's record_usage RPC, which commits a moment later.
    // Pull the true value shortly after so the on-screen counter reflects it live,
    // instead of only correcting after a manual refresh. One-shot, debounced.
    clearTimeout(window._voiceResyncTimer);
    window._voiceResyncTimer = setTimeout(function(){
      if (typeof syncUsageFromServer === 'function') syncUsageFromServer().then(function(){ updateLimits(); }).catch(function(){});
    }, 1500);

    // ── Play each chunk sequentially — stop if user presses mic ──
    var _speakAbort = false;
    S._speakTextAbort = function() { _speakAbort = true; /* stopAudio handles cleanup — do NOT call it here (circular) */ };

    if (choice.startsWith('cloud:')) {
      var cv = choice.replace('cloud:','');

      // ── Helper: fetch one chunk and return a blob URL (or null on failure) ──
      var _ttsFailMsg = null;
      var _fetchChunk = async function(txt) {
        if (_activeSpeakId !== _myId) return null;
        // Same gate on the speakText path — there are TWO routes to the TTS API and both
        // must strip option lists, or one of them speaks them.
        try {
          var _s2 = _voiceSimplify(txt);
          if (_s2 && _s2.trim()) txt = _s2;
          if (!String(txt || '').trim()) return null;
          console.log('%c[SPEAK] ' + txt, 'color:#0fb574');
          window._eohSpokenText = (window._eohSpokenText || '') + ' ' + txt;
        } catch (_) {}
        try {
          var r = await window.fetch(API + '/voice/speak', {
            method: 'POST',
            headers: {'Content-Type':'application/json','Authorization':'Bearer '+S.token},
            body: JSON.stringify({text: txt, voice: cv, speed: speed, lang: detectedLang})
          });
          if (_activeSpeakId !== _myId) return null;
          if (!r.ok) {
            try { var _ej=await r.json(); _ttsFailMsg=_ej.error||('Voice error '+r.status); } catch(_){ _ttsFailMsg='Voice unavailable ('+r.status+')'; }
            return null;
          }
          var ct = r.headers.get('content-type') || '';
          if (!ct.includes('audio')) return null;
          var bl = await r.blob();
          if (_activeSpeakId !== _myId) return null;
          return URL.createObjectURL(bl);
        } catch(_fe) { _ttsFailMsg = 'Voice connection failed'; return null; }
      };

      // ── Helper: play a blob URL and wait for it to finish ──
      var _playUrl = function(url) {
        return new Promise(function(resolve) {
          if (_activeSpeakId !== _myId) { URL.revokeObjectURL(url); resolve(); return; }
          S.audio = new Audio(url);
          S.audio.playbackRate = speed;
          S.speaking = true;
          S.audio.onplaying = function(){ if (S.voiceOn && typeof setVState === 'function') setVState('speaking'); try { if (window._vtiming && !window._vtiming.spoke) { window._vtiming.spoke = true; console.log('[voice-timing] TTS first audio: ' + Math.round(performance.now()-window._vtiming.tts) + 'ms  |  TOTAL to speak: ' + Math.round(performance.now()-window._vtiming.t0) + 'ms'); } } catch(e){} }; // animate + timing only when real audio starts
          S.audio.play().catch(function(){});
          var _chk = setInterval(function() {
            if (_speakAbort || (_voiceOnAtStart && S.voiceOn === false)) {
              clearInterval(_chk);
              S.audio.pause(); S.audio.src = '';
              URL.revokeObjectURL(url); resolve();
            }
          }, 200);
          S.audio.onended = function() { clearInterval(_chk); S.speaking=false; URL.revokeObjectURL(url); resolve(); };
          S.audio.onerror = function() { clearInterval(_chk); S.speaking=false; URL.revokeObjectURL(url); resolve(); };
        });
      };

      // ── Prefetch pipeline: fetch chunk[i+1] while chunk[i] is playing ──────
      // Start fetching the very first chunk immediately
      var _nextFetch = _chunks.length > 0 ? _fetchChunk(_chunks[0]) : Promise.resolve(null);

      for (var _ci = 0; _ci < _chunks.length; _ci++) {
        // Stop if: manually aborted, OR voice mode was on and user turned it off, OR superseded by new speak
        if (_speakAbort || (_voiceOnAtStart && S.voiceOn === false) || _activeSpeakId !== _myId) break;

        // Wait for current chunk audio to be ready
        var _url = await _nextFetch;
        if (_activeSpeakId !== _myId) { break; } // aborted while waiting for fetch

        // Immediately start fetching the NEXT chunk in parallel
        if (_ci + 1 < _chunks.length && !_speakAbort && !(_voiceOnAtStart && S.voiceOn === false)) {
          _nextFetch = _fetchChunk(_chunks[_ci + 1]);
        } else {
          _nextFetch = Promise.resolve(null);
        }

        // Play current chunk (next chunk is downloading in background)
        if (_url) {
          await _playUrl(_url);
        }
      }
    }
    // Browser TTS permanently disabled — cloud only.
    if (_ttsFailMsg && !_speakAbort && _activeSpeakId === _myId) {
      var _tr = document.getElementById('vi-transcript');
      if (_tr) { _tr.textContent = _ttsFailMsg + ' — reply shown in chat'; setTimeout(function(){ if(_tr) _tr.textContent='Speak anytime...'; }, 4000); }
    }
    S.speaking = false; S._speakTextAbort = null;
    _isAISpeaking = false;
  } catch(e) { console.error('TTS error',e); _isAISpeaking = false; }
}

async function speakBtn(btn) {
  // If already speaking anything — stop it
  // stopAudio() increments _activeSpeakId which kills any running speakText loop
  if (S.speaking || _isAISpeaking || S._speakTextAbort) {
    stopAudio();
    document.querySelectorAll('.mspeak.speaking').forEach(function(b) { b.classList.remove('speaking'); });
    // If THIS button was the one playing, just stop (toggle off)
    if (btn.classList.contains('speaking')) return;
    // Brief settle — stopAudio already cleared the loop synchronously
  }
  // Mark this button active and play
  document.querySelectorAll('.mspeak.speaking').forEach(function(b) { b.classList.remove('speaking'); });
  btn.classList.add('speaking');
  await speakText(btn.getAttribute('data-txt'));
  btn.classList.remove('speaking');
}

function stopAudio() {
  _activeSpeakId++;          // invalidate any running speakText loop instantly
  if (S.audio) { S.audio.pause(); S.audio.src = ''; S.audio = null; }
  if ('speechSynthesis' in window) window.speechSynthesis.cancel();
  // Null FIRST before calling — prevents circular stopAudio ↔ _speakTextAbort loop
  var _abort = S._speakTextAbort;
  S._speakTextAbort = null;
  if (_abort) { try { _abort(); } catch(_) {} }
  S.speaking = false;
  // Note: do NOT clear _isAISpeaking here — speakText sets it true right after calling stopAudio
  // _isAISpeaking is cleared by speakText on finish, or by voiceInterruptInline/forceEndVoice
  document.querySelectorAll('.mspeak.speaking').forEach(function(b) { b.classList.remove('speaking'); });
}

// -- LANGUAGE DROPDOWN for voice + AI responses -------------------------------
function onLangSelect(sel) {
  var lang = sel.value;
  S._chatLang = lang; S._voiceLang = lang;
  var vbSel = document.getElementById('vb-chat-lang');
  if (vbSel) vbSel.value = lang;
}
function closeLangDrop() {
  var menu = document.getElementById('lang-drop-menu');
  var btn  = document.getElementById('vb-lang-pill');
  if (menu) menu.classList.remove('open');
  if (btn)  btn.classList.remove('open');
}
window.closeLangDrop = closeLangDrop;

// ── Shared helper: position a fixed dropdown below a trigger button ───────────
function _posDropMenu(menu, triggerBtn, menuW) {
  if (!menu || !triggerBtn) return;
  menuW = menuW || 260;
  var rect = triggerBtn.getBoundingClientRect();
  var left = Math.max(8, Math.min(rect.left, window.innerWidth - menuW - 8));
  menu.style.left   = left + 'px';
  menu.style.top    = (rect.bottom + 6) + 'px';
  menu.style.bottom = 'auto';
  menu.style.minWidth = menuW + 'px';
}

// ── Voice dropdown ────────────────────────────────────────────────────────────
function toggleVoiceDrop(e) {
  if (e) e.stopPropagation();
  var menu = document.getElementById('voice-drop-menu');
  var btn  = document.getElementById('vb-voice-pill');
  if (!menu) return;
  if (menu.classList.contains('open')) { closeVoiceDrop(); return; }
  closeAllVbDrops();
  _posDropMenu(menu, btn, 260);
  // Populate voice list from vb-lang select
  _populateVoiceDrop();
  menu.classList.add('open');
  if (btn) btn.classList.add('open');
  setTimeout(function() {
    document.addEventListener('click', function _vdc(e2) {
      if (!menu.contains(e2.target) && (!btn || !btn.contains(e2.target))) {
        closeVoiceDrop(); document.removeEventListener('click', _vdc);
      }
    });
  }, 10);
}
function closeVoiceDrop() {
  var menu = document.getElementById('voice-drop-menu');
  var btn  = document.getElementById('vb-voice-pill');
  if (menu) menu.classList.remove('open');
  if (btn)  btn.classList.remove('open');
}
function _populateVoiceDrop() {
  var list = document.getElementById('voice-drop-list');
  var sel  = document.getElementById('vb-lang');
  if (!list) return;
  if (!sel || sel.options.length === 0) {
    list.innerHTML = '<div class="vb-drop-loading">Loading voices…</div>';
    setTimeout(_populateVoiceDrop, 600); return;
  }
  var curVal = S._voiceChoice || sel.value || '';
  list.innerHTML = '';
  var voiceDescriptions = {
    'Aoede':'Bright Female','Charon':'Informative Male','Fenrir':'Excitable Male',
    'Kore':'Professional Female','Leda':'Youthful Female','Orus':'Firm Male',
    'Perseus':'Calm Male','Puck':'Upbeat Male','Schedar':'Calm Male',
    'Vesta':'Bright Female','Zephyr':'Bright Female','Achelous':'Soft Male',
    'Autonoe':'Bright Female','Callirrhoe':'Easy-going Female','Despina':'Smooth Female',
    'Erinome':'Clear Female','Gacrux':'Smooth Male','Iapetus':'Clear Male',
    'Keid':'Firm Male','Laomedeia':'Upbeat Female','Narvi':'Easy-going Male',
    'Pulcherrima':'Calm Female','Rasalgethi':'Informative Male','Sadachbia':'Lively Female',
    'Sadaltager':'Knowledgeable Male','Sulafat':'Warm Male','Umbriel':'Easy-going Male',
    'Vindemiatrix':'Gentle Female','Zubenelgenubi':'Casual Male',
    'alloy':'Neutral','nova':'Warm Female','echo':'Deep Male',
    'onyx':'Authoritative Male','shimmer':'Gentle Female','fable':'Expressive Female'
  };
  var genderIcon = function(desc) {
    if (!desc) return '🎙';
    var d = desc.toLowerCase();
    if (d.includes('female') || d.includes('woman')) return '👩';
    if (d.includes('male') || d.includes('man')) return '👨';
    return '🎙';
  };
  for (var i = 0; i < sel.options.length; i++) {
    var opt = sel.options[i];
    if (!opt.value || opt.value === 'cloud:auto') {
      if (opt.value === 'cloud:auto') {
        var autoBtn = document.createElement('button');
        autoBtn.className = 'vb-voice-opt' + (curVal === 'cloud:auto' ? ' active' : '');
        autoBtn.innerHTML = '<span class="vb-voice-name">🌐 Auto</span><span class="vb-voice-desc">By language</span>';
        autoBtn.style.gridColumn = 'span 2';
        (function(v, b){ b.onclick = function(){ setVoice(v, b); }; })('cloud:auto', autoBtn);
        list.appendChild(autoBtn);
      }
      continue;
    }
    var rawName = opt.value.replace('cloud:', '');
    var capName = rawName.charAt(0).toUpperCase() + rawName.slice(1);
    var desc = voiceDescriptions[capName] || voiceDescriptions[rawName] || opt.textContent || rawName;
    var btn2 = document.createElement('button');
    btn2.className = 'vb-voice-opt' + (opt.value === curVal ? ' active' : '');
    btn2.innerHTML = '<span class="vb-voice-name">' + genderIcon(desc) + ' ' + capName + '</span>'
                   + '<span class="vb-voice-desc">' + desc + '</span>';
    (function(v, b){ b.onclick = function(){ setVoice(v, b); }; })(opt.value, btn2);
    list.appendChild(btn2);
  }
  if (!list.children.length) list.innerHTML = '<div class="vb-drop-loading">No voices available</div>';
}
function setVoice(val, btn) {
  S._voiceChoice = val;
  var sel = document.getElementById('vb-lang');
  if (sel) sel.value = val;
  document.querySelectorAll('.vb-voice-opt').forEach(function(b){ b.classList.toggle('active', b === btn); });
  // Update pill label
  var lbl = document.getElementById('vb-voice-pill-lbl');
  if (lbl && btn) {
    var name = btn.querySelector('.vb-voice-name');
    lbl.textContent = name ? name.textContent.replace(/^[^\w]+/, '').split(' ')[0] : 'Voice';
  }
  closeVoiceDrop();
}
window.toggleVoiceDrop = toggleVoiceDrop;
window.closeVoiceDrop  = closeVoiceDrop;
window.setVoice        = setVoice;

// ── Speed dropdown ────────────────────────────────────────────────────────────
function toggleSpeedDrop(e) {
  if (e) e.stopPropagation();
  var menu = document.getElementById('speed-drop-menu');
  var btn  = document.getElementById('vb-speed-pill');
  if (!menu) return;
  if (menu.classList.contains('open')) { closeSpeedDrop(); return; }
  closeAllVbDrops();
  _posDropMenu(menu, btn, 240);
  menu.classList.add('open');
  if (btn) btn.classList.add('open');
  setTimeout(function() {
    document.addEventListener('click', function _sdc(e2) {
      if (!menu.contains(e2.target) && (!btn || !btn.contains(e2.target))) {
        closeSpeedDrop(); document.removeEventListener('click', _sdc);
      }
    });
  }, 10);
}
function closeSpeedDrop() {
  var menu = document.getElementById('speed-drop-menu');
  var btn  = document.getElementById('vb-speed-pill');
  if (menu) menu.classList.remove('open');
  if (btn)  btn.classList.remove('open');
}
function setSpeed(btn) {
  var val = parseFloat(btn.dataset.val);
  S._voiceSpeed = val;
  var sel = document.getElementById('vb-speed');
  if (sel) sel.value = String(val);
  if (S.audio) { try { S.audio.playbackRate = val; } catch(_) {} }
  document.querySelectorAll('.vb-speed-opt').forEach(function(b){
    b.classList.toggle('vb-speed-active', b === btn);
  });
  var lbl = document.getElementById('vb-speed-pill-lbl');
  if (lbl) lbl.textContent = (val === 1 ? '1×' : val + '×');
  closeSpeedDrop();
}
function closeAllVbDrops() {
  closeLangDrop(); closeVoiceDrop(); closeSpeedDrop();
}
window.toggleSpeedDrop = toggleSpeedDrop;
window.closeSpeedDrop  = closeSpeedDrop;
window.setSpeed        = setSpeed;
window.closeAllVbDrops = closeAllVbDrops;

function toggleLangDrop(e) {
  if (e) e.stopPropagation();
  var menu = document.getElementById('lang-drop-menu');
  // Trigger is the voice bar pill
  var btn  = document.getElementById('vb-lang-pill');
  if (!menu) return;
  if (menu.classList.contains('open')) { closeLangDrop(); return; }
  closeAllVbDrops();
  _posDropMenu(menu, btn, 280);
  menu.classList.add('open');
  if (btn) btn.classList.add('open');
  setTimeout(function() {
    document.addEventListener('click', function _ldc(e2) {
      if (!menu.contains(e2.target) && (!btn || !btn.contains(e2.target))) {
        closeLangDrop(); document.removeEventListener('click', _ldc);
      }
    });
  }, 10);
}

function setLang(btn) {
  var val = btn.dataset.val, lbl = btn.dataset.lbl;
  // Update all label refs
  var vbLbl = document.getElementById('vb-lang-pill-lbl');
  if (vbLbl) vbLbl.textContent = lbl;
  // Sync hidden selects
  ['lang-select','vb-chat-lang'].forEach(function(id){
    var el = document.getElementById(id); if (el) el.value = val;
  });
  // Update active states
  document.querySelectorAll('.lang-opt').forEach(function(b){
    b.classList.toggle('lang-opt-active', b === btn);
  });
  S._chatLang = val; S._voiceLang = val;
  localStorage.setItem('eoh_chat_lang', val);
  closeLangDrop();
}
window.toggleLangDrop = toggleLangDrop;
window.setLang = setLang;

// Auto-detect language from typed text and update dropdown
function autoDetectInputLang(text) {
  if (!text || text.length < 10) return;
  var detected = detectLanguage(text);
  if (detected !== 'en-US' && detected !== S._chatLang) {
    S._chatLang = detected;
    S._voiceLang = detected;
    var sel = document.getElementById('lang-select');
    if (sel) {
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].value === detected) { sel.selectedIndex = i; break; }
      }
    }
    console.log('[Lang] Auto-detected:', detected);
  }
}

// -- SPEECH-TO-TEXT (STT) ------------------------------------------------------
function toggleSpeech() {
  var micBtn = document.getElementById('mic-btn');
  if (!micBtn) return;
  if (!('webkitSpeechRecognition' in window) && !('SpeechRecognition' in window)) {
    addMsg('assistant','Voice not supported in this browser. Use Chrome for best results.'); return;
  }
  if (S.recording && S.recognition) { S.recognition.stop(); return; }

  var SpeechRec = window.SpeechRecognition || window.webkitSpeechRecognition;
  S.recognition = new SpeechRec();
  S.recognition.continuous = true;
  S.recognition.interimResults = true;
  S.recognition.lang = S._chatLang || S._voiceLang || 'en-US';
  var silenceTimer = null;
  var fullText = '';

  S.recognition.onstart = function() {
    S.recording = true;
    micBtn.classList.add('recording');
    micBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f87171" stroke-width="2.5"><rect x="6" y="4" width="12" height="16" rx="2"/></svg>';
    micBtn.title = 'Stop recording';
  };

  S.recognition.onresult = function(e) {
    clearTimeout(silenceTimer);
    fullText = '';
    var interim = '';
    for (var i = 0; i < e.results.length; i++) {
      if (e.results[i].isFinal) fullText += e.results[i][0].transcript;
      else interim += e.results[i][0].transcript;
    }
    var ta = document.getElementById('chat-ta');
    if (ta) ta.value = fullText + interim;
    // Stop after 2s silence - just finalize text, do NOT send
    silenceTimer = setTimeout(function() { if (S.recognition) S.recognition.stop(); }, 2000);
  };

  S.recognition.onerror = function(e) {
    console.error('STT error:', e.error);
    resetMicBtn(micBtn);
  };

  S.recognition.onend = function() {
    clearTimeout(silenceTimer);
    resetMicBtn(micBtn);
    // Just put final text in the box - user presses Enter to send
    var ta = document.getElementById('chat-ta');
    if (ta && fullText.trim()) ta.value = fullText.trim();
  };

  S.recognition.start();
}

function resetMicBtn(btn) {
  S.recording = false;
  if (!btn) btn = document.getElementById('mic-btn');
  if (btn) {
    btn.classList.remove('recording');
    btn.innerHTML = '&#127908;';
    btn.title = 'Voice input';
  }
}

// -- VOICE MODE ---------------------------------------------------------------
// VAD + MediaRecorder → send audio to /voice/chat → TTS reply
// ===============================================================================
var _vWaveBars = [], _vWaveInt = null, _vState = 'idle';
var _audioContext = null, _analyser = null, _micSource = null, _micStream = null;
var _dataArray = null, _isListening = false, _isAISpeaking = false;
var _silenceTimer = null, _mediaRecorder = null, _audioChunks = [];
var _speechStartTime = 0;

function toggleInlineVoice() {
  if (!S.user || !S.token) { showModal('login'); return; }
  if (S.voiceOn) { endInlineVoice(); return; }
  if (!checkVoiceLimit()) return;
  S.voiceOn = true;
  startLimTicker(); // ensure ticker is running for voice counter
  document.getElementById('voice-bar').classList.add('on');
  document.getElementById('voice-input-bar').classList.add('on');
  document.getElementById('text-input-area').style.display = 'none';
  var btn = document.getElementById('voice-btn');
  if (btn) { btn.style.background = 'linear-gradient(135deg,#0ea5e9,#6366f1)'; btn.style.color = '#fff'; btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="vertical-align:-2px"><path d="M12 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3z"/><path d="M19 10v2a7 7 0 01-14 0v-2"/></svg> Voice ON'; }
  var vtb = document.getElementById('voice-toggle-btn'); if (vtb) vtb.classList.add('active');
  var wEl = document.getElementById('vb-wave'); wEl.innerHTML = ''; _vWaveBars = [];
  for (var i = 0; i < 16; i++) { var b = document.createElement('div'); b.className = 'vb-wave-bar'; wEl.appendChild(b); _vWaveBars.push(b); }
  // _initLangStrip and _initSpeedStrip disabled — selects hidden in HTML
  populateVoiceSelector();
  initVoice();
}

function endInlineVoice() {
  S.voiceOn = false; _vfTone('close'); _vfStopOpener(); teardownVoice(); stopAudio(); _isAISpeaking = false; if (typeof _stopThinkTone === 'function') _stopThinkTone();
  clearInterval(_vWaveInt); clearTimeout(_silenceTimer);
  // Reset mute state
  window._micMuted = false;
  var muteBtn = document.getElementById('vi-mute-btn');
  if (muteBtn) { muteBtn.classList.remove('muted'); muteBtn.innerHTML = '&#128263; Mute'; }
  // Reset hold state
  if (typeof _holdSpeakReset === 'function') _holdSpeakReset();
  document.getElementById('voice-bar').classList.remove('on');
  document.getElementById('voice-input-bar').classList.remove('on');
  document.getElementById('text-input-area').style.display = '';
  document.getElementById('vi-mic').classList.remove('active');
  document.getElementById('vi-transcript').textContent = '';
  var btn = document.getElementById('voice-btn');
  if (btn) { btn.style.background = ''; btn.style.color = ''; btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="vertical-align:-2px"><path d="M12 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3z"/><path d="M19 10v2a7 7 0 01-14 0v-2"/></svg> Voice'; }
  var vtb = document.getElementById('voice-toggle-btn'); if (vtb) vtb.classList.remove('active');
}

// ── Think timer ────────────────────────────────────────────────────────────
var _thinkTimerInt=null, _thinkStart=0;
// ── Thinking pulse (Web Audio, no asset) — a soft, warm two-note pulse that repeats gently while
//    processing, and stops the instant the answer speaks. Calm + quiet, not a drone, not one blip. ──
var _thinkTone = { ctx:null, timer:null, on:false, i:0 };
function _thinkPulse(){
  try {
    var ctx = _thinkTone.ctx; if (!ctx) return;
    var t = ctx.currentTime;
    // alternate two soft notes so it feels alive (thinking), not a repeated beep
    var freqs = [392, 523];
    var o = ctx.createOscillator(); o.type = 'sine'; o.frequency.value = freqs[_thinkTone.i % 2]; _thinkTone.i++;
    var lp = ctx.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 1300;  // rounded, warm
    var g = ctx.createGain();
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(0.03, t + 0.04);   // low volume, soft attack (no click)
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.34); // smooth fade
    o.connect(lp); lp.connect(g); g.connect(ctx.destination);
    o.start(t); o.stop(t + 0.36);
  } catch(e){}
}
function _startThinkTone(){
  if (window._voiceBridgeActive) return;   // a spoken bridge is already covering the gap — no tone
  if (_thinkTone.on) return;
  try {
    var Ctx = window.AudioContext || window.webkitAudioContext; if (!Ctx) return;
    if (!_thinkTone.ctx) _thinkTone.ctx = new Ctx();
    if (_thinkTone.ctx.state === 'suspended') { try { _thinkTone.ctx.resume(); } catch(e){} }
    _thinkTone.on = true; _thinkTone.i = 0;
    _thinkPulse();                                    // first pulse right away
    _thinkTone.timer = setInterval(_thinkPulse, 850); // calm, quiet repeat
  } catch(e){}
}
function _stopThinkTone(){
  if (!_thinkTone.on) return;
  _thinkTone.on = false;
  try { if (_thinkTone.timer) clearInterval(_thinkTone.timer); } catch(e){}
  _thinkTone.timer = null;
}
function _startThinkTimer(){
  _thinkStart=Date.now();
  var el=document.getElementById('vb-speak-timer');
  if(el){el.style.display='inline';el.style.color='#f59e0b';el.textContent='Loading AI voice... 0s';}
  clearInterval(_thinkTimerInt);
  _thinkTimerInt=setInterval(function(){
    var s=Math.floor((Date.now()-_thinkStart)/1000);
    var el2=document.getElementById('vb-speak-timer');
    if(!el2)return;
    el2.textContent=(_vState==='speaking'?'Speaking... ':'Loading AI voice... ')+s+'s';
  },1000);
}
function _stopThinkTimer(){
  clearInterval(_thinkTimerInt);_thinkTimerInt=null;
  var el=document.getElementById('vb-speak-timer');
  if(el){el.style.display='none';el.textContent='';}
}

function setVState(st) {
  _vState = st;
  var dot=document.getElementById('vb-dot'),lbl=document.getElementById('vb-state'),mic=document.getElementById('vi-mic');
  dot.className='vb-dot '+st; clearInterval(_vWaveInt);
  _vWaveBars.forEach(function(b){b.style.height='4px';});
  if(st==='idle'){
    lbl.textContent='Ready — speak anytime';
    mic.classList.remove('active');mic.classList.remove('interrupting');
    _stopThinkTimer(); _stopThinkTone();
  } else if(st==='listening'){
    lbl.textContent='Listening...';
    mic.classList.remove('interrupting');mic.classList.add('active');
    _stopThinkTimer(); _stopThinkTone();
    _vWaveInt=setInterval(function(){_vWaveBars.forEach(function(b){b.style.height=(4+Math.random()*16)+'px';});},80);
  } else if(st==='processing'){
    lbl.textContent='Processing...';
    mic.classList.remove('active');mic.classList.remove('interrupting');
    _startThinkTimer();
    _vWaveInt=setInterval(function(){_vWaveBars.forEach(function(b,i){b.style.height=(4+Math.abs(Math.sin(Date.now()/200+i))*12)+'px';});},40);
  } else if(st==='thinking'){
    lbl.textContent='Thinking...';
    mic.classList.remove('active');mic.classList.remove('interrupting');
    if(!_thinkTimerInt) _startThinkTimer();
    _vWaveInt=setInterval(function(){_vWaveBars.forEach(function(b,i){b.style.height=(4+Math.sin(Date.now()/300+i*0.4)*8)+'px';});},50);
  } else if(st==='speaking'){
    lbl.textContent='Tap mic to interrupt';
    mic.classList.remove('active');mic.classList.add('interrupting');
    var el=document.getElementById('vb-speak-timer');
    if(el){el.style.color='#0fb574';el.style.display='inline';}
    if(!_thinkTimerInt)_startThinkTimer(); _stopThinkTone();
    _vWaveInt=setInterval(function(){_vWaveBars.forEach(function(b){b.style.height=(4+Math.random()*14)+'px';});},60);
  }
}

// -- VOICE SELECTOR - admin TTS provider only ---------------------------------
function populateVoiceSelector() {
  var sel = document.getElementById('vb-lang'); if (!sel) return;
  window.fetch(API+'/voice/config',{headers:{'Authorization':'Bearer '+S.token}})
  .then(function(r){return r.json();}).then(function(cfg) {
    var prov = cfg.provider || cfg.tts_provider || 'browser'; S._ttsProvider=prov; sel.innerHTML='';
    var voices=[];

    if (prov === 'gemini' && cfg.gemini_voices && cfg.gemini_voices.length) {
      // HD voices - clean generic labels
      var voiceDescriptions = {
        'Aoede':'Bright Female','Charon':'Informative Male','Fenrir':'Excitable Male',
        'Kore':'Professional Female','Leda':'Youthful Female','Orus':'Firm Male',
        'Perseus':'Calm Male','Puck':'Upbeat Male','Schedar':'Calm Male',
        'Vesta':'Bright Female','Zephyr':'Bright Female','Achelous':'Soft Male',
        'Autonoe':'Bright Female','Callirrhoe':'Easy-going Female','Despina':'Smooth Female',
        'Erinome':'Clear Female','Gacrux':'Smooth Male','Iapetus':'Clear Male',
        'Keid':'Firm Male','Laomedeia':'Upbeat Female','Narvi':'Easy-going Male',
        'Pulcherrima':'Calm Female','Rasalgethi':'Informative Male','Sadachbia':'Lively Female',
        'Sadaltager':'Knowledgeable Male','Sulafat':'Warm Male','Umbriel':'Easy-going Male',
        'Vindemiatrix':'Gentle Female','Zubenelgenubi':'Casual Male'
      };
      var grp = document.createElement('optgroup'); grp.label = 'EOH HD Voices';
      cfg.gemini_voices.forEach(function(v) {
        var o = document.createElement('option'); o.value = 'cloud:' + v;
        o.textContent = voiceDescriptions[v] || v;
        grp.appendChild(o);
      });
      sel.appendChild(grp);
      // Auto option first
      var autoOpt = document.createElement('option'); autoOpt.value = 'cloud:auto'; autoOpt.textContent = 'Auto (by language)';
      sel.insertBefore(autoOpt, sel.firstChild);
      sel.value = S._voiceChoice || ('cloud:' + (window._voiceDefaultVoice || 'Kore')); S._voiceChoice = sel.value;

    } else if(prov==='openai') {
      voices=[['alloy','Neutral Voice'],['nova','Warm Female'],['echo','Deep Male'],['onyx','Authoritative Male'],['shimmer','Gentle Female'],['fable','Expressive Female']];
    } else if(prov==='google') {
      voices=[
        ['en-US-Neural2-C','English Female'],['en-US-Neural2-D','English Male'],
        ['ar-XA-Wavenet-A','Arabic Female'],['ar-XA-Wavenet-B','Arabic Male'],
        ['de-DE-Neural2-A','German Female'],['es-ES-Neural2-A','Spanish Female'],
        ['fr-FR-Neural2-A','French Female'],['ja-JP-Neural2-B','Japanese Female'],
        ['zh-CN-Neural2-A','Chinese Female'],['ko-KR-Neural2-A','Korean Female'],
        ['tr-TR-Wavenet-A','Turkish Female'],['ru-RU-Wavenet-A','Russian Female'],
        ['hi-IN-Neural2-A','Hindi Female'],['pt-BR-Neural2-A','Portuguese Female']
      ];
    }

    if(voices.length){
      var grp=document.createElement('optgroup');grp.label='Voices';
      voices.forEach(function(v){var o=document.createElement('option');o.value='cloud:'+v[0];o.textContent=v[1];grp.appendChild(o);});
      sel.appendChild(grp);
      var def=prov==='openai'?'cloud:nova':'cloud:'+voices[0][0];
      sel.value=S._voiceChoice||def;S._voiceChoice=sel.value;
    }

    if (false && !sel.options.length) {
      // Browser voices permanently disabled — cloud TTS only
      var bv=[];
      if(!bv.length&&'speechSynthesis' in window){window.speechSynthesis.onvoiceschanged=function(){populateVoiceSelector();};return;}
      var langs={};
      bv.forEach(function(v){var c=v.lang.substring(0,5),l=v.name.replace('Microsoft ','').replace('Google ','').replace(' Online (Natural)','').replace(' Desktop','').replace('Microsoft Server Speech Text to Speech Voice ','').replace(/\(.+?\)/g,'').trim();if(l.length>25)l=l.substring(0,23)+'…';if(!langs[c])langs[c]=[];langs[c].push({name:v.name,label:l,lang:c});});
      Object.keys(langs).sort().forEach(function(c){var g=document.createElement('optgroup');g.label=({'en':'English','ar':'Arabic','fr':'French','de':'German','es':'Spanish','pt':'Portuguese','ja':'Japanese','ko':'Korean','zh':'Chinese','hi':'Hindi'})[c.substring(0,2)]||c;langs[c].forEach(function(v){var o=document.createElement('option');o.value='browser:'+v.name;o.textContent=v.label;o.setAttribute('data-lang',v.lang);g.appendChild(o);});sel.appendChild(g);});
      if(S._voiceChoice){try{sel.value=S._voiceChoice;}catch(e){}}
      if(!sel.value&&sel.options.length){sel.value=sel.options[0].value;S._voiceChoice=sel.value;}
    }
  }).catch(function(){ /* voice config failed — no browser fallback */ });
  setTimeout(function() {
    var sel = document.getElementById('vb-lang');
    if (sel && S._voiceChoice) {
      var lbl = document.getElementById('vb-voice-pill-lbl');
      if (lbl) {
        for (var i = 0; i < sel.options.length; i++) {
          if (sel.options[i].value === S._voiceChoice) {
            var rawN = sel.options[i].value.replace('cloud:','');
            lbl.textContent = rawN.charAt(0).toUpperCase() + rawN.slice(1);
            break;
          }
        }
      }
    }
  }, 500);
}
function onVoiceLangChange(){var s=document.getElementById('vb-lang');S._voiceChoice=s.value;var o=s.options[s.selectedIndex];if(o&&o.getAttribute('data-lang'))S._voiceLang=o.getAttribute('data-lang');}
function onChatLangChange(){var s=document.getElementById('vb-chat-lang');S._chatLang=s.value;S._voiceLang=s.value;console.log('[Voice] Chat language:',s.value);}

// ── Collapsible language strip (Fix 12) ─────────────────────────────────────
var _LANG_ALL = [
  {code:'en-US',label:'EN',name:'English'},{code:'ar-SA',label:'AR',name:'Arabic'},
  {code:'es-ES',label:'ES',name:'Español'},{code:'fr-FR',label:'FR',name:'Français'},
  {code:'de-DE',label:'DE',name:'Deutsch'},{code:'pt-BR',label:'PT',name:'Português'},
  {code:'ru-RU',label:'RU',name:'Русский'},{code:'zh-CN',label:'ZH',name:'中文'},
  {code:'ja-JP',label:'JA',name:'日本語'},{code:'ko-KR',label:'KO',name:'한국어'},
  {code:'tr-TR',label:'TR',name:'Türkçe'},{code:'hi-IN',label:'HI',name:'हिन्दी'},
  {code:'it-IT',label:'IT',name:'Italiano'},{code:'nl-NL',label:'NL',name:'Nederlands'},
];
var _langStripExpanded = false;

// ── Voice speed strip — visible buttons in HUD (Fix 20) ─────────────────────
function _initSpeedStrip() { /* disabled — use voice settings panel */ }

function _initLangStrip() { /* disabled — use voice settings panel */ }

// =============================================================================
// INIT MIC - echo cancellation + AudioContext + MediaRecorder
// =============================================================================
var _vRafId = null;

async function initVoice() {
  if (_audioContext && _audioContext.state !== 'closed') {
    if (!_isAISpeaking && !_vRafId) _vRafId = requestAnimationFrame(detectVoice);
    return;
  }
  try {
    _micStream = await navigator.mediaDevices.getUserMedia({
      audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true }
    });
    _audioContext = new AudioContext();
    _analyser = _audioContext.createAnalyser();
    _micSource = _audioContext.createMediaStreamSource(_micStream);
    _analyser.fftSize = 2048;
    _dataArray = new Uint8Array(_analyser.fftSize);
    _micSource.connect(_analyser);

    var _mimeType = MediaRecorder.isTypeSupported('audio/webm;codecs=opus') ? 'audio/webm;codecs=opus' : 'audio/webm';
    _mediaRecorder = new MediaRecorder(_micStream, { mimeType: _mimeType });
    _mediaRecorder.ondataavailable = function(e) { if (e.data && e.data.size > 0) _audioChunks.push(e.data); };
    _mediaRecorder.onstop = sendToBackend;

    _vRafId = requestAnimationFrame(detectVoice);
    setVState('idle');
    document.getElementById('vi-transcript').textContent = 'Speak anytime...';
    _vfConfig(true).then(function(){ _vfTone('open'); _vfPrewarm(); });   // voice-filler-v1: mic open → tone + pre-generate opener

    // Probe once whether Deepgram live-streaming STT is available (admin-selected + key).
    // If yes, startRecording() streams to Deepgram; if not, it uses the clip-upload path.
    try { _dgProbe(); } catch(e) {}

    // Resume mic when user returns to this tab
    document.addEventListener('visibilitychange', onVisibilityChange);
  } catch(e) {
    document.getElementById('vi-transcript').textContent = 'Mic error: ' + e.message;
  }
}

function onVisibilityChange() {
  if (!S.voiceOn) return;
  if (document.visibilityState === 'visible') {
    // User came back to this tab - resume AudioContext and mic
    if (_audioContext && _audioContext.state === 'suspended') {
      _audioContext.resume().then(function() {
        console.log('[Voice] AudioContext resumed');
        if (!_isAISpeaking && _vState !== 'processing') {
          setVState('idle');
          document.getElementById('vi-transcript').textContent = 'Speak anytime...';
          detectVoice();
        }
      });
    }
  }
}

function teardownVoice() {
  document.removeEventListener('visibilitychange', onVisibilityChange);
  if (_vRafId) { cancelAnimationFrame(_vRafId); _vRafId = null; }
  clearTimeout(_silenceTimer); _silenceTimer = null; _isListening = false;
  if (_mediaRecorder && _mediaRecorder.state === 'recording') { try{_mediaRecorder.stop();}catch(e){} }
  _mediaRecorder = null;
  if (_micSource) { try{_micSource.disconnect();}catch(e){} _micSource=null; }
  if (_audioContext&&_audioContext.state!=='closed') { try{_audioContext.close();}catch(e){} }
  _audioContext=null; _analyser=null; _dataArray=null;
  if (_micStream) { _micStream.getAudioTracks().forEach(function(t){t.enabled=true;t.stop();}); _micStream=null; }
  _isAISpeaking=false;
}

// =============================================================================
// VAD - Voice Activity Detection
// =============================================================================
function detectVoice() {
  if (!_analyser || !S.voiceOn) return;
  // Hard-stop the mic loop when voice limit is reached
  var _dv_u=getUsage();var _dv_l=getLimits();
  if((_dv_l.voice||0)>0&&_dv_u.voice>=_dv_l.voice){
    if(S.voiceOn){endInlineVoice();}
    return;
  }
  _analyser.getByteTimeDomainData(_dataArray);
  var volume = 0;
  for (var i = 0; i < _dataArray.length; i++) volume += Math.abs(_dataArray[i] - 128);
  volume = volume / _dataArray.length;

  if ((_vState === 'idle' || _vState === 'listening') && !_isAISpeaking && !window._micMuted) {
    if (volume > (window._voiceVolumeThreshold || 8)) {
      clearTimeout(_silenceTimer); _silenceTimer = null;
      if (!_isListening) { _speechStartTime = Date.now(); startRecording(); }
    } else {
      if (_isListening && !_silenceTimer && !window._holdSpeakMode && !_dg.active) {
        var spokeDuration = Date.now() - _speechStartTime;
        if (spokeDuration > (window._voiceMinSpeechMs || 800)) {
          _silenceTimer = setTimeout(stopRecording, window._voiceSilenceMs || 1500);
        }
      }
    }
  }
  _vRafId = requestAnimationFrame(detectVoice);
}

// =============================================================================
// RECORDING
// =============================================================================
// =============================================================================
// STAGE 1 — STREAMING STT (live Deepgram WebSocket). Falls back to clip upload.
// =============================================================================
// _dg holds the live streaming session. When Deepgram is the admin-selected STT
// provider, we stream mic audio to Deepgram over a WebSocket and get partial
// transcripts in real time — instead of recording a whole clip and uploading it.
var _dg = { ws:null, rec:null, transcript:'', final:'', active:false, sttMin:200, ttsMin:50, fired:false, checked:false, available:false, session:0, endTimer:null, prewarmed:false };

// ── Live transcript now renders in its own #vi-transcript-panel (above the mic, styled in CSS),
//    so the mic never shifts while you speak. JS just writes text and keeps it scrolled to newest.
function _vShowLive(txt) {
  var el = document.getElementById('vi-transcript');
  if (el) el.textContent = txt || 'Listening...';
  var panel = document.getElementById('vi-transcript-panel');
  if (panel) panel.scrollTop = panel.scrollHeight;
}
function _vClearLive() { /* panel styling is static now; nothing to reset */ }

// Pre-warm: as soon as enough words are in, mark it. We DON'T fire a second generation
// (that would double-answer); this simply lets the pipeline know a send is imminent so the
// final _dgFire hands off instantly. Kept as a hook for future server-side pre-warm.
function _dgPrewarm(partial) { if (_dg.prewarmed) return; _dg.prewarmed = true; /* reserved: server pre-warm ping */ }

// Ask the backend once whether Deepgram streaming is available (and get the
// short-lived token + admin thresholds). Cached for the session.
async function _dgProbe() {
  if (_dg.checked && _dg.available) return true;   // only cache a POSITIVE result
  _dg.checked = true;
  try {
    var r = await window.fetch(API + '/voice/deepgram-token', { headers: { 'Authorization': 'Bearer ' + S.token } });
    var d = await r.json();
    _dg.available = !!(d && d.enabled && d.token);
    if (_dg.available) { _dg.sttMin = d.stt_min_chars || 200; _dg.ttsMin = d.tts_min_chars || 50; window._ttsMinChars = _dg.ttsMin; }
    else { console.log('[voice] Deepgram streaming not available (' + ((d && (d.provider || d.error)) || 'off') + ') — will retry next turn'); }
  } catch (e) { _dg.available = false; }
  return _dg.available;
}

// Open a fresh Deepgram socket for one utterance. Returns true if streaming started.
async function _dgStart() {
  // Fully tear down any prior session before starting a new one (prevents turn-2 races).
  _dgAbort();
  _dg.fired = false; _dg.active = false; _dg.transcript = ''; _dg.final = ''; _dg.prewarmed = false;
  var mySession = (_dg.session = (_dg.session || 0) + 1);   // tag this turn
  try {
    // Reuse a still-valid cached token instead of minting a new one every turn (cuts a network hop).
    var d;
    if (_dg.tokenCache && _dg.tokenCache.exp > Date.now() + 3000) {
      d = _dg.tokenCache.data;
    } else {
      var r = await window.fetch(API + '/voice/deepgram-token', { headers: { 'Authorization': 'Bearer ' + S.token } });
      d = await r.json();
      if (d && d.enabled && d.token) {
        var _ttlMs = ((d.expires_in || 30) * 1000);
        _dg.tokenCache = { data: d, exp: Date.now() + Math.max(5000, _ttlMs - 5000) };  // refresh 5s before expiry
      }
    }
    if (!d || !d.enabled || !d.token) return false;
    if (mySession !== _dg.session) return false;             // superseded while fetching token
    _dg.sttMin = d.stt_min_chars || 200; _dg.ttsMin = d.tts_min_chars || 50; window._ttsMinChars = _dg.ttsMin;
    // Language MUST be passed or Deepgram guesses and mis-hears words. Use the real voice lang.
    var lang = (S._voiceLang || window._voiceLang || 'en-US');
    var dgLang = String(lang).split('-')[0].toLowerCase();  // Deepgram wants 'en', 'es', 'ar'...
    var epMs2 = window._voiceEndpointMs || 800;
    // Formatting flags. smart_format over-corrects ERP terms/codes, so it defaults OFF; punctuation
    // stays on (helpful and safe). Both admin-tunable via window flags. keyterm boosts your ERP
    // vocabulary so Deepgram transcribes those terms correctly instead of "correcting" them wrong.
    var _sf = (window._voiceSmartFormat === true) ? 'true' : 'false';
    var _num = (window._voiceNumerals === true) ? 'true' : 'false';
    var _kt = '';
    if (window._voiceKeyterms && window._voiceKeyterms.length) {
      _kt = window._voiceKeyterms.map(function(k){ return '&keyterm=' + encodeURIComponent(k); }).join('');
    }
    var qs = 'model=' + encodeURIComponent(d.model || 'nova-3')
      + '&language=' + encodeURIComponent(dgLang)
      + '&smart_format=' + _sf + '&punctuate=true&numerals=' + _num + '&interim_results=true' + _kt
      + '&vad_events=true&utterance_end_ms=1000&endpointing=' + epMs2 + '';
    var url = 'wss://api.deepgram.com/v1/listen?' + qs;
    // Deepgram accepts the token via subprotocol: ['token', <access_token>]
    var ws = new WebSocket(url, ['token', d.token]);
    _dg.ws = ws; _dg.transcript = ''; _dg.final = ''; _dg.fired = false; _dg.active = true;

    var _pending = [];   // buffer audio captured before the socket finishes opening
    try {
      var mt0 = MediaRecorder.isTypeSupported('audio/webm;codecs=opus') ? 'audio/webm;codecs=opus' : 'audio/webm';
      _dg.rec = new MediaRecorder(_micStream, { mimeType: mt0 });
      _dg.rec.ondataavailable = function(e) {
        if (!e.data || e.data.size === 0) return;
        if (ws.readyState === 1) { if (_pending.length) { _pending.forEach(function(b){ try{ws.send(b);}catch(_){}}); _pending = []; } ws.send(e.data); }
        else if (ws.readyState === 0) { _pending.push(e.data); }   // socket still opening — buffer, don't lose it
      };
      _dg.rec.start(150);   // start capturing NOW (before onopen) so the first words are never dropped
    } catch (e) { /* if immediate start fails, onopen will start it */ }

    ws.onopen = function() {
      if (mySession !== _dg.session) { try { ws.close(); } catch(e){} return; }
      // Recorder already started above; flush anything buffered during connection.
      try {
        if (!_dg.rec || _dg.rec.state !== 'recording') {
          var mt = MediaRecorder.isTypeSupported('audio/webm;codecs=opus') ? 'audio/webm;codecs=opus' : 'audio/webm';
          _dg.rec = new MediaRecorder(_micStream, { mimeType: mt });
          _dg.rec.ondataavailable = function(e) { if (e.data && e.data.size > 0 && ws.readyState === 1) ws.send(e.data); };
          _dg.rec.start(150);
        }
        if (_pending.length) { _pending.forEach(function(b){ try{ws.send(b);}catch(_){}}); _pending = []; }
      } catch (e) { _dgAbort(); }
    };

    ws.onmessage = function(ev) {
      if (mySession !== _dg.session) return;
      var m; try { m = JSON.parse(ev.data); } catch (e) { return; }
      // Deepgram UtteranceEnd = a genuine pause detected via utterance_end_ms. Use ONLY this
      // (not the twitchy speech_final, which fires on tiny mid-sentence pauses and cuts you off).
      if (m && m.type === 'UtteranceEnd') { _dgArmEnd(); return; }
      if (!m || !m.channel || !m.channel.alternatives || !m.channel.alternatives[0]) return;
      var text = m.channel.alternatives[0].transcript || '';
      if (m.is_final) { if (text) { _dg.final = (_dg.final + ' ' + text).trim(); } _dg.transcript = _dg.final; }
      else { _dg.transcript = (_dg.final + ' ' + text).trim(); }
      var full = _dg.transcript;
      // Live: stream words into the responsive live-transcript panel (wraps + grows, both screens).
      _vShowLive(full);
      // Also mirror into the chat input so the text is captured on send.
      var ta = document.getElementById('chat-ta') || document.getElementById('chat-input') || document.getElementById('ta');
      if (ta) { ta.value = full; try { ta.dispatchEvent(new Event('input')); } catch(e){} }
      // Any new speech cancels a pending end — you're still talking.
      if (text && text.trim()) { if (_dg.endTimer) { clearTimeout(_dg.endTimer); _dg.endTimer = null; } }
      // INCREMENTAL EARLY-SEND: once enough has accumulated, pre-warm generation (see _dgPrewarm).
      if (!_dg.fired && !_dg.prewarmed && full.length >= (_dg.sttMin || 200)) { _dgPrewarm(full); }
    };
    // End the turn only after a real, sustained silence (configurable). Not on brief pauses.
    function _dgArmEnd() {
      if (_dg.fired || window._holdSpeakMode) return;
      if (_dg.endTimer) clearTimeout(_dg.endTimer);
      _dg.endTimer = setTimeout(function(){
        if (!_dg.fired && !window._holdSpeakMode && _dg.transcript.trim().length > 0) _dgFire();
      }, window._voiceEndSilenceMs || 1400);
    }
    _dg._armEnd = _dgArmEnd;
    ws.onerror = function() { if (mySession === _dg.session && !_dg.fired) _dgAbort(); };
    ws.onclose = function() { /* do not auto-fire on close; ending is handled by UtteranceEnd/hold/VAD */ };
    return true;
  } catch (e) { return false; }
}

// Send the accumulated transcript to the AI pipeline (once).
function _dgFire() {
  if (_dg.fired) return;
  _dg.fired = true;
  // Streaming-turn timing starts NOW (you stopped talking). Measures chat + first-audio latency.
  window._vtiming = { t0: performance.now(), stt: performance.now(), streaming: true };
  window._voiceBridgeActive = false;
  if (_dg.endTimer) { clearTimeout(_dg.endTimer); _dg.endTimer = null; }
  var text = (_dg.transcript || _dg.final || '').trim();
  _dgStopMic();               // stop feeding audio immediately
  try { if (_dg.ws && _dg.ws.readyState <= 1) _dg.ws.close(); } catch(e){}   // close socket now (no delay)
  _dg.active = false;
  if (!text) { setVState('idle'); var el0=document.getElementById('vi-transcript'); if(el0) el0.textContent='Speak anytime...'; return; }
  _vfTone('close'); _vfPlayOpener();   // voice-filler-v1: 0ms opener at end-of-speech
  setVState('thinking');
  _vClearLive();
  var el = document.getElementById('vi-transcript'); if (el) el.textContent = 'Thinking...';
  // The user's words are now committed to the chat as a normal message; clear the mirror input.
  var _ta = document.getElementById('chat-ta') || document.getElementById('chat-input') || document.getElementById('ta');
  if (_ta) { _ta.value = ''; try { _ta.dispatchEvent(new Event('input')); } catch(e){} }
  // Hand off IMMEDIATELY — generation + streaming TTS start now (Stage 2/3).
  handleVoiceTranscript(text);
}
function _dgStopMic() { try { if (_dg.rec && _dg.rec.state === 'recording') _dg.rec.stop(); } catch(e){} _dg.rec = null; }
function _dgAbort() { _dg.active = false; if (_dg.endTimer) { clearTimeout(_dg.endTimer); _dg.endTimer = null; } _dgStopMic(); try { if (_dg.ws && _dg.ws.readyState <= 1) _dg.ws.close(); } catch(e){} _dg.ws = null; }

var _vfRecStartedAt = 0;   // voice-filler-v2: when the current clip recording began (gates the instant opener)
function startRecording() {
  _vfRecStartedAt = Date.now();
  if (_isListening) return;                       // already capturing this turn
  if (!_dg.available && (!_mediaRecorder || _mediaRecorder.state === 'recording')) return;
  _isListening = true; _audioChunks = [];
  // Try live Deepgram streaming first; on any failure, fall back to clip recording.
  if (_dg.available) {
    _dgStart().then(function(ok){
      if (ok) { setVState('listening'); }
      else { try { _mediaRecorder.start(); setVState('listening'); } catch(e) { _isListening = false; } }
    });
    return;
  }
  try { _mediaRecorder.start(); } catch(e) { _isListening = false; return; }
  setVState('listening');
  // Not on streaming yet — re-check Deepgram in the background so a later turn can upgrade to
  // streaming without needing a page reload (recovers if the provider was fixed after page load).
  if (!_dg.available) { try { _dgProbe(); } catch(e){} }
}
function stopRecording() {
  _isListening = false; clearTimeout(_silenceTimer); _silenceTimer = null;
  // Streaming path: end-of-speech → flush the transcript (or let onclose fire it).
  if (_dg.active) { if (!_dg.fired) _dgFire(); return; }
  if (!_mediaRecorder || _mediaRecorder.state !== 'recording') return;
  try { _mediaRecorder.stop(); } catch(e) {}
}

// =============================================================================
// SEND AUDIO TO BACKEND → get AI reply → TTS
// =============================================================================
async function sendToBackend() {
  if (!_audioChunks.length || !S.voiceOn) { setVState('idle'); return; }
  var blob = new Blob(_audioChunks, { type: 'audio/webm' }); _audioChunks = [];
  if (blob.size < 2000) { setVState('idle'); document.getElementById('vi-transcript').textContent = 'Speak anytime...'; return; }
  // voice-filler-v2: instant opener only when there was real speech — not a noise blip that tripped the VAD.
  // (~4 KB/s for Opus webm: 8 KB ≈ 2 s of audio.) Otherwise the opener spoke on its own after background noise.
  var _vfRecDur = _vfRecStartedAt ? Date.now() - _vfRecStartedAt : 0;
  if (_vfRecDur >= 2000 && blob.size >= 8000) { _vfTone('close'); _vfPlayOpener(); }
  else console.log('[voice-filler] short clip (' + _vfRecDur + 'ms, ' + blob.size + 'B) — waiting for STT before speaking');

  setVState('processing');
  document.getElementById('vi-transcript').textContent = 'Transcribing...';

  try {
    var reader = new FileReader();
    reader.onloadend = async function() {
      try {
        var base64 = reader.result.split(',')[1];

        // Step 1: Transcribe audio via /voice/chat
        var chatLang = S._chatLang || 'en-US';
        window._vtiming = { t0: performance.now(), stt: performance.now() };
        var sttRes = await window.fetch(API + '/voice/chat', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + S.token },
          body: JSON.stringify({ audio: base64, mimeType: 'audio/webm', lang: chatLang })
        });
        var sttData = await sttRes.json();
        var text = (sttData.transcript || '').trim();

        if (!text) {
          document.getElementById('vi-transcript').textContent = sttData.error || 'Could not hear. Speak again...';
          setVState('idle'); return;
        }
        // Hand off to the shared pipeline (also used by the live Deepgram streaming path).
        await handleVoiceTranscript(text);
        return;
      } catch(e) {
        console.error('[Voice]', e);
        document.getElementById('vi-transcript').textContent = 'Error: ' + e.message;
        _isAISpeaking = false;
        if (_micStream) { _micStream.getAudioTracks().forEach(function(t){t.enabled=true;}); }
        setVState('idle');
      }
    };
    reader.readAsDataURL(blob);
  } catch(e) {
    console.error('[Voice] sendToBackend error:', e);
    setVState('idle');
  }
}

// =============================================================================
// STAGE 3 — STREAMING TTS QUEUE. Accepts sentences AS THEY ARRIVE and plays them
// gaplessly. push(text) enqueues + kicks the pump; done() marks the stream ended.
// =============================================================================

// =============================================================================
// VOICE INSTANT FILLER + MIC TONES (build voice-filler-v1)
// Stage 1 of the two-stage filler: an AI-generated opener (fresh wording each
// time) is pre-generated at mic-open via /voice-filler/lines + /voice/speak and
// played at 0ms when the user stops talking. Stage 2 (smart /voice/ack) and the
// watchdog are unchanged, except the watchdog now draws fresh AI lines too.
// All limits come from admin (/voice-filler/config); per-plan on/off included.
// =============================================================================
var _vf = { cfg: null, cfgAt: 0, openers: [], watch: [], spoken: [], gen: null, wgen: null,
            audio: null, playing: null, lang: '', voice: '' };
window._vfOpenerPlayed = false;

function _vfLang() {
  var l = String(S._chatLang || 'en').toLowerCase().split('-')[0];
  return l || 'en';
}
function _vfVoiceKey() {
  var vc = S._voiceChoice || ('cloud:' + (window._voiceDefaultVoice || 'Kore'));
  return vc + '|' + (S._voiceSpeed || window._voiceDefaultSpeed || 1.0);
}
async function _vfConfig(force) {
  if (!force && _vf.cfg && Date.now() - _vf.cfgAt < 60000) return _vf.cfg;
  try {
    var r = await window.fetch(API + '/voice-filler/config', { headers: { 'Authorization': 'Bearer ' + (S.token || '') } });
    var d = await r.json();
    if (d && !d.error) { _vf.cfg = d; _vf.cfgAt = Date.now(); }
  } catch (e) { /* keep last cfg */ }
  return _vf.cfg;
}
async function _vfFetchLines(kind, count) {
  var r = await window.fetch(API + '/voice-filler/lines', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + (S.token || '') },
    body: JSON.stringify({ lang: _vfLang(), kind: kind, count: count, avoid: _vf.spoken.slice(-50) })
  });
  var d = await r.json();
  return (d && Array.isArray(d.lines)) ? d.lines : [];
}
// TTS through the normal /voice/speak path so provider, voice, speed and MINUTES are handled there.
async function _vfTTS(text) {
  var vc = S._voiceChoice || ('cloud:' + (window._voiceDefaultVoice || 'Kore'));
  var voice = vc.indexOf('cloud:') === 0 ? vc.replace('cloud:', '') : (window._voiceDefaultVoice || 'Kore');
  var speed = S._voiceSpeed || window._voiceDefaultSpeed || 1.0;
  var r = await window.fetch(API + '/voice/speak', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + (S.token || '') },
    body: JSON.stringify({ text: text, voice: voice, speed: speed, lang: S._chatLang || 'en-US' })
  });
  var ct = r.headers.get('content-type') || '';
  if (!r.ok || ct.indexOf('audio') === -1) return null;
  var b = await r.blob();
  return URL.createObjectURL(b);
}
function _vfFlushIfStale() {
  var key = _vfLang() + '|' + _vfVoiceKey();
  if (_vf.lang !== key) {
    _vf.openers.forEach(function (o) { try { URL.revokeObjectURL(o.url); } catch (e) {} });
    _vf.openers = []; _vf.watch = []; _vf.lang = key;
  }
}
// Pre-generate openers (called at mic-open and after each use). Keeps up to 2 ready clips.
async function _vfPrewarm() {
  if (!S.voiceOn || !S.token) return;
  var cfg = await _vfConfig();
  if (!cfg || !cfg.enabled || !cfg.prewarm) return;
  _vfFlushIfStale();
  var ttl = (cfg.ttl_s || 600) * 1000;
  _vf.openers = _vf.openers.filter(function (o) { return Date.now() - o.at < ttl; });
  if (_vf.openers.length >= 2 || _vf.gen) return;
  _vf.gen = (async function () {
    try {
      var lines = await _vfFetchLines('opener', cfg.batch_size || 4);
      for (var i = 0; i < lines.length && _vf.openers.length < 2; i++) {
        if (!S.voiceOn) break;
        var url = await _vfTTS(lines[i]);
        if (url) _vf.openers.push({ text: lines[i], url: url, at: Date.now() });
      }
      // Cache remaining generated openers as text-only (TTS'd on demand next time)
      for (var j = 0; j < lines.length; j++) { if (!_vf.openers.some(function (o) { return o.text === lines[j]; })) _vf.openers.push({ text: lines[j], url: null, at: Date.now() }); }
      console.log('[voice-filler] prewarmed ' + _vf.openers.filter(function (o) { return o.url; }).length + ' opener clip(s)');
    } catch (e) { console.warn('[voice-filler] prewarm failed:', e.message); }
    _vf.gen = null;
  })();
  // Also top up watchdog lines (text only) so the 2s filler has fresh wording
  if (cfg.watchdog_ai && !_vf.watch.length && !_vf.wgen) {
    _vf.wgen = _vfFetchLines('watchdog', 6).then(function (l) { _vf.watch = l; _vf.wgen = null; }).catch(function () { _vf.wgen = null; });
  }
}
// Play a ready opener NOW (0ms). Returns true if something started playing.
function _vfPlayOpener() {
  window._vfOpenerPlayed = false;
  if (!_vf.cfg || !_vf.cfg.enabled) return false;
  _vfFlushIfStale();
  var idx = -1;
  for (var i = 0; i < _vf.openers.length; i++) { if (_vf.openers[i].url) { idx = i; break; } }
  if (idx === -1) { _vfPrewarm(); return false; }
  var o = _vf.openers.splice(idx, 1)[0];
  _vf.spoken.push(o.text); if (_vf.spoken.length > 50) _vf.spoken.shift();
  console.log('%c[SPEAK] ' + o.text + ' (instant opener)', 'color:#0fb574');
  window._eohSpokenText = (window._eohSpokenText || '') + ' ' + o.text;
  _isAISpeaking = true; window._vfOpenerPlayed = true; window._voiceBridgeActive = true;
  var a = new Audio(o.url); a.playbackRate = S._voiceSpeed || window._voiceDefaultSpeed || 1.0;
  _vf.audio = a;
  _vf.playing = new Promise(function (resolve) {
    var done = function () { try { URL.revokeObjectURL(o.url); } catch (e) {} if (_vf.audio === a) _vf.audio = null; _vf.playing = null; resolve(); };
    a.onended = done; a.onerror = done;
    a.onplaying = function () { if (S.voiceOn && typeof setVState === 'function') setVState('speaking'); };
    a.play().catch(done);
  });
  _vfPrewarm();   // refill in the background for the next turn
  return true;
}
function _vfStopOpener() {
  if (_vf.audio) { try { _vf.audio.pause(); _vf.audio.src = ''; } catch (e) {} _vf.audio = null; }
  _vf.playing = null; window._vfOpenerPlayed = false;
}
// Watchdog line: fresh AI line when available, else the static pool.
function _vfWatchdogLine(code) {
  if (_vf.watch.length) {
    var t = _vf.watch.shift();
    _vf.spoken.push(t); if (_vf.spoken.length > 50) _vf.spoken.shift();
    if (_vf.watch.length < 2 && _vf.cfg && _vf.cfg.watchdog_ai && !_vf.wgen) {
      _vf.wgen = _vfFetchLines('watchdog', 6).then(function (l) { _vf.watch = _vf.watch.concat(l); _vf.wgen = null; }).catch(function () { _vf.wgen = null; });
    }
    return t;
  }
  return (typeof _watchdogLine === 'function') ? _watchdogLine(code) : '';
}
// ── Mic tones: simple modern-call two-note chime (WebAudio, no files) ────────
var _vfToneCtx = null;
function _vfTone(kind) {
  try {
    var cfg = _vf.cfg; if (!cfg || !cfg.mic_tones || !cfg.mic_tones.enabled) return;
    var vol = Math.max(0.05, Math.min(1, parseFloat(cfg.mic_tones.volume) || 0.35));
    var soft = cfg.mic_tones.style === 'soft';
    if (!_vfToneCtx) _vfToneCtx = new (window.AudioContext || window.webkitAudioContext)();
    if (_vfToneCtx.state === 'suspended') _vfToneCtx.resume();
    var ctx = _vfToneCtx, t0 = ctx.currentTime;
    var notes = kind === 'open' ? [660, 880] : [880, 660];      // rising = open, falling = close
    var dur = soft ? 0.11 : 0.08, gap = soft ? 0.12 : 0.09;
    notes.forEach(function (f, i) {
      var o = ctx.createOscillator(), g = ctx.createGain();
      o.type = 'sine'; o.frequency.value = f;
      var st = t0 + i * gap;
      g.gain.setValueAtTime(0.0001, st);
      g.gain.exponentialRampToValueAtTime(vol, st + 0.012);
      g.gain.exponentialRampToValueAtTime(0.0001, st + dur);
      o.connect(g); g.connect(ctx.destination);
      o.start(st); o.stop(st + dur + 0.02);
    });
  } catch (e) { /* tones are best-effort */ }
}
window._vfPrewarm = _vfPrewarm; window._vfPlayOpener = _vfPlayOpener; window._vfTone = _vfTone;

function makeStreamTTS(opts) {
  opts = opts || {};
  var voice = opts.voice, speed = opts.speed || 1.0, lang = opts.lang;
  var myId = _activeSpeakId;                 // tie to the current speak session
  var q = [];                                // pending sentence chunks
  var fetching = null;                       // in-flight prefetch (blobURL promise)
  var playing = false, ended = false, aborted = false, firstAudio = false;
  var _gapWait = 0, _answerAudioStarted = false, _bridgePending = 0, _watchInFlight = false, _bridgeAudioPlayed = false;
  var resolveAll; var allDone = new Promise(function(r){ resolveAll = r; });

  function _fetch(txt) {
    // LAST GATE before anything is spoken. Whatever route the text arrived by, option
    // lists, hints and directive scaffolding are removed here — nothing can bypass it.
    try {
      var _s = _voiceSimplify(txt);
      if (_s && _s.trim()) txt = _s;
      if (!String(txt || '').trim()) return Promise.resolve(null);   // nothing left to say
      console.log('%c[SPEAK] ' + txt, 'color:#0fb574');
      window._eohSpokenText = (window._eohSpokenText || '') + ' ' + txt;
    } catch (_) {}
    return window.fetch(API + '/voice/speak', {
      method: 'POST',
      headers: { 'Content-Type':'application/json', 'Authorization':'Bearer '+S.token },
      body: JSON.stringify({ text: txt, voice: voice, speed: speed, lang: lang })
    }).then(function(r){
      if (aborted || _activeSpeakId !== myId) return null;
      var ct = r.headers.get('content-type') || '';
      if (!r.ok || !ct.includes('audio')) return null;
      return r.blob().then(function(b){ return URL.createObjectURL(b); });
    }).catch(function(){ return null; });
  }
  function _play(url) {
    return new Promise(function(resolve){
      if (aborted || _activeSpeakId !== myId) { URL.revokeObjectURL(url); resolve(); return; }
      if (_vf.playing) { _vf.playing.then(function(){ _play(url).then(resolve); }); return; }   // let the instant opener finish first
      S.audio = new Audio(url); S.audio.playbackRate = speed; S.speaking = true;
      S.audio.onplaying = function(){
        if (S.voiceOn && typeof setVState === 'function') setVState('speaking');
        if (!firstAudio) { firstAudio = true; try { if (window._vtiming && !window._vtiming.spoke) { window._vtiming.spoke = true; console.log('[voice-timing] TTS first audio: ' + Math.round(performance.now()-window._vtiming.tts) + 'ms  |  TOTAL to speak: ' + Math.round(performance.now()-window._vtiming.t0) + 'ms'); } } catch(e){} }
      };
      S.audio.play().catch(function(){});
      var chk = setInterval(function(){ if (aborted || (S.voiceOn === false)) { clearInterval(chk); try{S.audio.pause();}catch(e){} URL.revokeObjectURL(url); resolve(); } }, 150);
      S.audio.onended = function(){ clearInterval(chk); S.speaking=false; URL.revokeObjectURL(url); resolve(); };
      S.audio.onerror = function(){ clearInterval(chk); S.speaking=false; URL.revokeObjectURL(url); resolve(); };
    });
  }
  async function pump() {
    if (playing) return; playing = true;
    while (!aborted && _activeSpeakId === myId) {
      if (!q.length) {
        if (ended) break;                    // nothing queued and stream finished
        // SMART WATCHDOG: if the queue stays empty for >2s while the turn is still active, speak a
        // varied professional "still working" line so silence never exceeds ~2s. Only kicks in once
        // some audio (bridge or answer) has already begun, so it never fires at the very start.
        _gapWait += 40;
        var _maxSil = (_vf.cfg && _vf.cfg.max_silence_ms) || window._voiceMaxSilenceMs || 2000;   // admin: voice_filler_max_silence_ms
        if (_gapWait >= _maxSil && !_watchInFlight && (_answerAudioStarted || _bridgeAudioPlayed || window._vfOpenerPlayed)) {
          _watchInFlight = true;
          var _wl = _vfWatchdogLine(opts.code || 'en');
          if (_wl) { _bridgePending++; q.push(_wl); if (!fetching) fetching = _fetch(q[0]); }
          _gapWait = 0;
        }
        await new Promise(function(r){ setTimeout(r, 40); });   // wait for more sentences
        continue;
      }
      _gapWait = 0; _watchInFlight = false;
      var txt = q.shift();
      // Track whether this is bridge/watchdog audio vs the real answer.
      if (_bridgePending > 0) { _bridgePending--; _bridgeAudioPlayed = true; } else { _answerAudioStarted = true; window._voiceBridgeActive = false; }
      // Prefetch this one (or reuse an already-started prefetch), and prefetch the next in parallel.
      var urlP = fetching || _fetch(txt); fetching = null;
      var url = await urlP;
      if (q.length && !fetching) fetching = _fetch(q[0]);  // warm the next while this plays (guard: push() may already have started it — was double-charging TTS)
      if (url) await _play(url);
    }
    playing = false;
    if (typeof _stopThinkTone === 'function') _stopThinkTone();
    resolveAll();
  }
  return {
    push: function(txt){ txt = (txt||'').trim(); if (!txt || aborted) return; q.push(txt); if (!fetching && q.length === 1) fetching = _fetch(q[0]); pump(); },
    pushBridge: function(txt){ txt = (txt||'').trim(); if (!txt || aborted) return; _bridgePending++; q.push(txt); if (!fetching && q.length === 1) fetching = _fetch(q[0]); pump(); },
    dropPendingBridge: function(){
      // Remove not-yet-played filler sentences from the front of the queue (keep answer items).
      // Called when the real answer is ready — the currently-playing sentence finishes, then the
      // answer plays next, so filler never over-talks the answer but there is still no gap.
      var removed = 0;
      while (_bridgePending > 0 && q.length > 0) { q.shift(); _bridgePending--; removed++; }
      if (removed && fetching) { fetching = null; if (q.length) fetching = _fetch(q[0]); }
    },
    done: function(){ ended = true; if (!playing) pump(); },
    abort: function(){ aborted = true; try{ if(S.audio){S.audio.pause();} }catch(e){} resolveAll(); },
    wait: function(){ return allDone; }
  };
}

// =============================================================================
// SHARED: transcript → /chat (SSE, streamed) → TTS (streamed sentence-by-sentence).
// Called by BOTH streaming STT and clip upload.
// =============================================================================
// ── Instant voice bridge: a short, relevant spoken acknowledgment built from the user's own
//    message, played immediately to cover the wait while the real answer generates. No API call.
//    Covers ALL supported voice languages; falls back to English for anything unlisted. ──
var _lastBridgeIdx = -1;
var _BRIDGE_LINES = {
  en: {
    build: ['Sure, I can prepare that for you now.',
            'Got it, let me put that together for you.'],
    ask:   ['Good question, let me explain that clearly.',
            'Sure, let me walk you through that.'],
    gen:   ['Alright, let me get that ready for you.',
            'On it, one moment.']
  },
  ar: {
    build: ['\u0645\u0645\u062a\u0627\u0632\u060c \u0633\u0623\u062c\u0647\u0651\u0632 \u0644\u0643 \u0630\u0644\u0643 \u0627\u0644\u0622\u0646 \u0628\u062f\u0642\u0629 \u0648\u0648\u0636\u0648\u062d\u060c \u0648\u0633\u0623\u0639\u0631\u0636 \u0627\u0644\u0628\u064a\u0627\u0646\u0627\u062a \u0627\u0644\u0645\u0637\u0644\u0648\u0628\u0629 \u0628\u0634\u0643\u0644 \u0645\u0646\u0638\u0651\u0645 \u0648\u0633\u0647\u0644 \u0627\u0644\u062a\u0637\u0628\u064a\u0642 \u0645\u0628\u0627\u0634\u0631\u0629 \u0641\u064a \u0627\u0644\u0646\u0638\u0627\u0645. \u0623\u0645\u0647\u0644\u0646\u064a \u0644\u062d\u0638\u0629.',
            '\u0623\u0643\u064a\u062f\u060c \u0633\u0623\u0639\u062f\u0651 \u0644\u0643 \u0627\u0644\u0628\u064a\u0627\u0646\u0627\u062a \u0627\u0644\u0645\u0637\u0644\u0648\u0628\u0629 \u0628\u0634\u0643\u0644 \u0635\u062d\u064a\u062d \u0648\u0645\u0646\u0638\u0651\u0645 \u062d\u062a\u0649 \u062a\u0633\u062a\u0637\u064a\u0639 \u062a\u0637\u0628\u064a\u0642\u0647\u0627 \u0628\u0633\u0647\u0648\u0644\u0629. \u0623\u0639\u0645\u0644 \u0639\u0644\u0649 \u062a\u062c\u0647\u064a\u0632\u0647\u0627 \u0627\u0644\u0622\u0646.'],
    ask:   ['\u0633\u0624\u0627\u0644 \u062c\u064a\u062f\u060c \u062f\u0639\u0646\u064a \u0623\u0648\u0636\u0651\u062d \u0644\u0643 \u0630\u0644\u0643 \u0628\u062f\u0642\u0629 \u0648\u062e\u0637\u0648\u0629 \u0628\u062e\u0637\u0648\u0629 \u062d\u062a\u0649 \u062a\u0643\u0648\u0646 \u0627\u0644\u0625\u062c\u0627\u0628\u0629 \u0633\u0647\u0644\u0629 \u0627\u0644\u0641\u0647\u0645. \u0623\u062c\u0647\u0651\u0632\u0647\u0627 \u0627\u0644\u0622\u0646.',
            '\u0623\u0643\u064a\u062f\u060c \u0633\u0623\u0634\u0631\u062d \u0644\u0643 \u0647\u0630\u0627 \u0628\u0637\u0631\u064a\u0642\u0629 \u0648\u0627\u0636\u062d\u0629 \u0648\u0635\u062d\u064a\u062d\u0629. \u0623\u0645\u0647\u0644\u0646\u064a \u0644\u062d\u0638\u0629.'],
    gen:   ['\u062a\u0645\u0627\u0645\u060c \u0623\u0639\u0645\u0644 \u0639\u0644\u0649 \u0630\u0644\u0643 \u0627\u0644\u0622\u0646 \u0648\u0623\u062d\u0631\u0635 \u0623\u0646 \u064a\u0643\u0648\u0646 \u062f\u0642\u064a\u0642\u0627\u064b \u0648\u0648\u0627\u0636\u062d\u0627\u064b. \u0623\u0645\u0647\u0644\u0646\u064a \u0644\u062d\u0638\u0629.',
            '\u062d\u0627\u0636\u0631\u060c \u0623\u062c\u0647\u0651\u0632 \u0644\u0643 \u0627\u0644\u062a\u0641\u0627\u0635\u064a\u0644 \u0627\u0644\u0622\u0646 \u0628\u0634\u0643\u0644 \u0645\u0646\u0638\u0651\u0645 \u0648\u0635\u062d\u064a\u062d.']
  },
  es: {
    build: ['Por supuesto, voy a preparar exactamente lo que pediste, de forma precisa y clara para que sea fácil de entender y aplicar directamente en tu sistema. Dame un momento mientras lo preparo.',
            'Claro, lo voy a crear correctamente, asegurándome de que cada detalle sea exacto y esté bien organizado para que puedas implementarlo sin problemas. Un momento, por favor.'],
    ask:   ['Buena pregunta. Déjame explicártelo con claridad y de forma precisa para que puedas aplicarlo con confianza. Estoy reuniendo los detalles ahora.',
            'Claro, puedo explicarte eso. Lo presentaré paso a paso para que sea claro y correcto. Dame un momento para prepararlo bien.'],
    gen:   ['De acuerdo, déjame preparar eso para ti de forma precisa y clara. Estoy organizando los detalles ahora.',
            'Enseguida. Estoy reuniendo la información correctamente. Dame un momento.']
  },
  fr: {
    build: ['Bien sûr, je vais préparer exactement ce que vous avez demandé, de manière précise et claire pour que ce soit facile à comprendre et à appliquer directement dans votre système. Un instant, je prépare cela.',
            'Très bien, je vais créer cela correctement en veillant à ce que chaque détail soit exact et bien organisé pour que vous puissiez l’implémenter sans difficulté. Un moment s’il vous plaît.'],
    ask:   ['Bonne question. Laissez-moi vous expliquer cela clairement et avec précision pour que vous puissiez l’appliquer en toute confiance. Je rassemble les détails maintenant.',
            'Bien sûr, je peux vous expliquer cela. Je vais le présenter étape par étape pour que ce soit clair et correct. Un instant pour bien préparer.'],
    gen:   ['D’accord, laissez-moi préparer cela pour vous, de façon précise et claire. J’organise les détails maintenant.',
            'Tout de suite. Je rassemble les informations correctement. Un petit instant.']
  },
  de: {
    build: ['Natürlich, ich bereite genau das vor, worum Sie gebeten haben, präzise und klar, damit es leicht verständlich und direkt in Ihrem System anwendbar ist. Einen Moment, ich stelle das zusammen.',
            'Gerne, ich erstelle das korrekt und achte darauf, dass jedes Detail stimmt und gut strukturiert ist, damit Sie es problemlos umsetzen können. Einen Augenblick bitte.'],
    ask:   ['Gute Frage. Ich erkläre Ihnen das klar und präzise, damit Sie es sicher anwenden können. Ich stelle die Details gerade zusammen.',
            'Natürlich, das kann ich Ihnen erklären. Ich lege es Schritt für Schritt dar, damit es klar und korrekt ist. Einen Moment bitte.'],
    gen:   ['In Ordnung, ich bereite das für Sie vor, präzise und klar. Ich ordne die Details gerade.',
            'Sofort. Ich stelle die Informationen korrekt zusammen. Einen Moment bitte.']
  },
  pt: {
    build: ['Com certeza, vou preparar exatamente o que você pediu, de forma precisa e clara para que seja fácil de entender e aplicar diretamente no seu sistema. Um momento enquanto preparo.',
            'Claro, vou criar isso corretamente, garantindo que cada detalhe esteja certo e bem organizado para você implementar sem dificuldade. Um momento, por favor.'],
    ask:   ['Boa pergunta. Deixe-me explicar isso com clareza e precisão para que você possa aplicar com confiança. Estou reunindo os detalhes agora.',
            'Claro, posso explicar isso. Vou apresentar passo a passo para que fique claro e correto. Um momento para preparar bem.'],
    gen:   ['Certo, deixe-me preparar isso para você, de forma precisa e clara. Estou organizando os detalhes agora.',
            'Já estou nisso. Estou reunindo as informações corretamente. Um momento.']
  },
  ru: {
    build: ['\u041a\u043e\u043d\u0435\u0447\u043d\u043e, \u044f \u043f\u043e\u0434\u0433\u043e\u0442\u043e\u0432\u043b\u044e \u0438\u043c\u0435\u043d\u043d\u043e \u0442\u043e, \u0447\u0442\u043e \u0432\u044b \u043f\u0440\u043e\u0441\u0438\u043b\u0438, \u0442\u043e\u0447\u043d\u043e \u0438 \u043f\u043e\u043d\u044f\u0442\u043d\u043e, \u0447\u0442\u043e\u0431\u044b \u044d\u0442\u043e \u043b\u0435\u0433\u043a\u043e \u043f\u0440\u0438\u043c\u0435\u043d\u0438\u0442\u044c. \u041e\u0434\u043d\u0443 \u043c\u0438\u043d\u0443\u0442\u0443.'],
    ask:   ['\u0425\u043e\u0440\u043e\u0448\u0438\u0439 \u0432\u043e\u043f\u0440\u043e\u0441. \u041f\u043e\u0437\u0432\u043e\u043b\u044c\u0442\u0435 \u043e\u0431\u044a\u044f\u0441\u043d\u0438\u0442\u044c \u044d\u0442\u043e \u044f\u0441\u043d\u043e \u0438 \u0442\u043e\u0447\u043d\u043e. \u0421\u0435\u0439\u0447\u0430\u0441 \u0441\u043e\u0431\u0435\u0440\u0443 \u0434\u0435\u0442\u0430\u043b\u0438.'],
    gen:   ['\u0425\u043e\u0440\u043e\u0448\u043e, \u0441\u0435\u0439\u0447\u0430\u0441 \u043f\u043e\u0434\u0433\u043e\u0442\u043e\u0432\u043b\u044e \u044d\u0442\u043e \u0434\u043b\u044f \u0432\u0430\u0441. \u041e\u0434\u043d\u0443 \u043c\u0438\u043d\u0443\u0442\u0443.']
  },
  zh: {
    build: ['\u597d\u7684\uff0c\u6211\u4f1a\u6309\u60a8\u7684\u8981\u6c42\u51c6\u5907\u597d\uff0c\u5185\u5bb9\u51c6\u786e\u6e05\u6670\uff0c\u4fbf\u4e8e\u60a8\u76f4\u63a5\u5728\u7cfb\u7edf\u4e2d\u5e94\u7528\u3002\u8bf7\u7a0d\u7b49\u7247\u523b\u3002'],
    ask:   ['\u597d\u95ee\u9898\u3002\u6211\u4f1a\u6e05\u695a\u51c6\u786e\u5730\u4e3a\u60a8\u89e3\u91ca\uff0c\u8ba9\u60a8\u80fd\u653e\u5fc3\u5e94\u7528\u3002\u6211\u6b63\u5728\u6574\u7406\u7ec6\u8282\u3002'],
    gen:   ['\u597d\u7684\uff0c\u6211\u73b0\u5728\u4e3a\u60a8\u51c6\u5907\uff0c\u786e\u4fdd\u51c6\u786e\u6e05\u6670\u3002\u8bf7\u7a0d\u7b49\u3002']
  },
  ja: {
    build: ['\u3082\u3061\u308d\u3093\u3067\u3059\u3002\u3054\u8981\u671b\u306e\u5185\u5bb9\u3092\u6b63\u78ba\u3067\u5206\u304b\u308a\u3084\u3059\u304f\u6e96\u5099\u3057\u307e\u3059\u306e\u3067\u3001\u5c11\u3005\u304a\u5f85\u3061\u304f\u3060\u3055\u3044\u3002'],
    ask:   ['\u826f\u3044\u8cea\u554f\u3067\u3059\u306d\u3002\u5206\u304b\u308a\u3084\u3059\u304f\u6b63\u78ba\u306b\u8aac\u660e\u3057\u307e\u3059\u3002\u4eca\u8a73\u7d30\u3092\u307e\u3068\u3081\u3066\u3044\u307e\u3059\u3002'],
    gen:   ['\u627f\u77e5\u3057\u307e\u3057\u305f\u3002\u4eca\u3054\u7528\u610f\u3057\u307e\u3059\u306e\u3067\u3001\u5c11\u3005\u304a\u5f85\u3061\u304f\u3060\u3055\u3044\u3002']
  },
  ko: {
    build: ['\ubb3c\ub860\uc785\ub2c8\ub2e4. \uc694\uccad\ud558\uc2e0 \ub0b4\uc6a9\uc744 \uc815\ud655\ud558\uace0 \uba85\ud655\ud558\uac8c \uc900\ube44\ud574 \ub4dc\ub9ac\uaca0\uc2b5\ub2c8\ub2e4. \uc7a0\uc2dc\ub9cc \uae30\ub2e4\ub824 \uc8fc\uc138\uc694.'],
    ask:   ['\uc88b\uc740 \uc9c8\ubb38\uc785\ub2c8\ub2e4. \uba85\ud655\ud558\uace0 \uc815\ud655\ud558\uac8c \uc124\uba85\ud574 \ub4dc\ub9ac\uaca0\uc2b5\ub2c8\ub2e4. \uc9c0\uae08 \uc815\ub9ac\ud558\uace0 \uc788\uc2b5\ub2c8\ub2e4.'],
    gen:   ['\uc54c\uaca0\uc2b5\ub2c8\ub2e4. \uc9c0\uae08 \uc900\ube44\ud574 \ub4dc\ub9ac\uaca0\uc2b5\ub2c8\ub2e4. \uc7a0\uc2dc\ub9cc\uc694.']
  },
  tr: {
    build: ['Elbette, istediğiniz şeyi tam olarak hazırlayacağım; doğru ve net bir şekilde, sisteminizde doğrudan uygulayabilmeniz için düzenli olarak sunacağım. Bir dakika lütfen.'],
    ask:   ['Güzel soru. Bunu net ve doğru bir şekilde açıklayayım, güvenle uygulayabilmeniz için. Şimdi ayrıntıları topluyorum.'],
    gen:   ['Tamam, bunu sizin için hazırlıyorum; doğru ve net olacak. Bir dakika lütfen.']
  },
  hi: {
    build: ['\u092c\u093f\u0932\u094d\u0915\u0941\u0932, \u092e\u0948\u0902 \u0906\u092a\u0915\u0940 \u092e\u093e\u0902\u0917 \u0915\u0947 \u0905\u0928\u0941\u0938\u093e\u0930 \u0938\u091f\u0940\u0915 \u0914\u0930 \u0938\u094d\u092a\u0937\u094d\u091f \u0930\u0942\u092a \u0938\u0947 \u0924\u0948\u092f\u093e\u0930 \u0915\u0930\u0924\u093e \u0939\u0942\u0901\u0964 \u0915\u0943\u092a\u092f\u093e \u090f\u0915 \u0915\u094d\u0937\u0923 \u092a\u094d\u0930\u0924\u0940\u0915\u094d\u0937\u093e \u0915\u0930\u0947\u0902\u0964'],
    ask:   ['\u0905\u091a\u094d\u091b\u093e \u092a\u094d\u0930\u0936\u094d\u0928\u0964 \u092e\u0948\u0902 \u0907\u0938\u0947 \u0938\u094d\u092a\u0937\u094d\u091f \u0914\u0930 \u0938\u091f\u0940\u0915 \u0930\u0942\u092a \u0938\u0947 \u0938\u092e\u091d\u093e\u0924\u093e \u0939\u0942\u0901\u0964 \u092e\u0948\u0902 \u0905\u092d\u0940 \u0935\u093f\u0935\u0930\u0923 \u0924\u0948\u092f\u093e\u0930 \u0915\u0930 \u0930\u0939\u093e \u0939\u0942\u0901\u0964'],
    gen:   ['\u0920\u0940\u0915 \u0939\u0948, \u092e\u0948\u0902 \u0905\u092d\u0940 \u0906\u092a\u0915\u0947 \u0932\u093f\u090f \u092f\u0939 \u0924\u0948\u092f\u093e\u0930 \u0915\u0930\u0924\u093e \u0939\u0942\u0901\u0964 \u090f\u0915 \u0915\u094d\u0937\u0923\u0964']
  },
  it: {
    build: ['Certo, preparo esattamente ciò che hai chiesto, in modo preciso e chiaro così da poterlo applicare direttamente nel tuo sistema. Un momento, lo sto preparando.'],
    ask:   ['Buona domanda. Lascia che te lo spieghi in modo chiaro e preciso, così da poterlo applicare con sicurezza. Sto raccogliendo i dettagli.'],
    gen:   ['Va bene, lo preparo per te in modo preciso e chiaro. Sto organizzando i dettagli.']
  },
  nl: {
    build: ['Zeker, ik bereid precies voor wat u vroeg, nauwkeurig en duidelijk zodat het gemakkelijk toe te passen is in uw systeem. Een moment, ik zet het klaar.'],
    ask:   ['Goede vraag. Laat me het duidelijk en nauwkeurig uitleggen zodat u het met vertrouwen kunt toepassen. Ik verzamel nu de details.'],
    gen:   ['Goed, ik maak dat voor u klaar, nauwkeurig en duidelijk. Ik orden de details nu.']
  }
};
// Pull the subject/topic out of the user's message (strip question words + fillers, keep the meat).
// Used to make the spoken filler reference what they actually asked, in their own words.
function _extractTopic(text, code) {
  var raw = (text || '').trim().replace(/[?.!]+$/,'');
  if (code === 'en') {
    var s = raw.replace(/^(please\s+)?(can|could|would|will)\s+you\s+/i,'')
               .replace(/^(how\s+(do|can|would|should)\s+i|how\s+to|what\s+is|what\s+are|what'?s|tell me about|explain|show me|give me|i\s+(want|need|would like)\s+to|help me\s+(with)?)\s+/i,'')
               .replace(/^(the|a|an)\s+/i,'').trim();
    // keep it to a reasonable phrase length
    var w = s.split(/\s+/); if (w.length > 12) s = w.slice(0, 12).join(' ');
    return s;
  }
  // For non-English, echoing the raw phrase back is natural enough and stays in-language.
  var w2 = raw.split(/\s+/); return (w2.length > 12) ? w2.slice(0,12).join(' ') : raw;
}

// Smart openings that echo the user's {topic} and lead INTO the answer (answer-compatible).
// withTopic = used when a topic was extracted; noTopic = graceful fallback. First line kept short
// so Gemini synthesizes the first audio as fast as possible.
var _BRIDGE_SMART = {
  en: { withTopic: ['Sure, on {topic}, let me get that right for you.', 'Good one, for {topic}, let me lay it out clearly.', 'Absolutely, about {topic}, here is what matters.'],
        noTopic:   ['Sure, let me get that right for you.', 'Good question, let me lay this out clearly.', 'Absolutely, here is what matters.'] },
  ar: { withTopic: ['\u0628\u062e\u0635\u0648\u0635 {topic}\u060c \u062f\u0639\u0646\u064a \u0623\u0648\u0636\u0651\u062d\u0647\u0627 \u0644\u0643 \u0628\u062f\u0642\u0629.', '\u0633\u0624\u0627\u0644 \u062c\u064a\u062f\u060c \u0639\u0646 {topic}\u060c \u0633\u0623\u0634\u0631\u062d\u0647\u0627 \u0628\u0648\u0636\u0648\u062d.'],
        noTopic:   ['\u062f\u0639\u0646\u064a \u0623\u0648\u0636\u0651\u062d \u0644\u0643 \u0630\u0644\u0643 \u0628\u062f\u0642\u0629.', '\u0633\u0624\u0627\u0644 \u062c\u064a\u062f\u060c \u0633\u0623\u0634\u0631\u062d\u0647\u0627 \u0628\u0648\u0636\u0648\u062d.'] },
  es: { withTopic: ['Claro, sobre {topic}, déjame explicártelo bien.', 'Buena pregunta, sobre {topic}, te lo aclaro.'], noTopic: ['Claro, déjame explicártelo bien.', 'Buena pregunta, te lo aclaro.'] },
  fr: { withTopic: ['Bien sûr, concernant {topic}, laissez-moi bien vous l’expliquer.', 'Bonne question, sur {topic}, je vous détaille cela.'], noTopic: ['Bien sûr, laissez-moi bien vous l’expliquer.', 'Bonne question, je vous détaille cela.'] },
  de: { withTopic: ['Klar, zu {topic}, lassen Sie es mich genau erklären.', 'Gute Frage, zu {topic}, ich lege es dar.'], noTopic: ['Klar, lassen Sie es mich genau erklären.', 'Gute Frage, ich lege es dar.'] },
  pt: { withTopic: ['Claro, sobre {topic}, deixe-me explicar direito.', 'Boa pergunta, sobre {topic}, vou esclarecer.'], noTopic: ['Claro, deixe-me explicar direito.', 'Boa pergunta, vou esclarecer.'] },
  ru: { withTopic: ['\u041a\u043e\u043d\u0435\u0447\u043d\u043e, \u043f\u043e {topic} \u0441\u0435\u0439\u0447\u0430\u0441 \u043e\u0431\u044a\u044f\u0441\u043d\u044e.', '\u0425\u043e\u0440\u043e\u0448\u0438\u0439 \u0432\u043e\u043f\u0440\u043e\u0441, \u043f\u043e {topic}.'], noTopic: ['\u041a\u043e\u043d\u0435\u0447\u043d\u043e, \u0441\u0435\u0439\u0447\u0430\u0441 \u043e\u0431\u044a\u044f\u0441\u043d\u044e.', '\u0425\u043e\u0440\u043e\u0448\u0438\u0439 \u0432\u043e\u043f\u0440\u043e\u0441.'] },
  zh: { withTopic: ['\u597d\u7684\uff0c\u5173\u4e8e{topic}\uff0c\u6211\u6765\u4e3a\u60a8\u8bb2\u6e05\u695a\u3002', '\u597d\u95ee\u9898\uff0c\u5173\u4e8e{topic}\u3002'], noTopic: ['\u597d\u7684\uff0c\u6211\u6765\u4e3a\u60a8\u8bb2\u6e05\u695a\u3002', '\u597d\u95ee\u9898\u3002'] },
  ja: { withTopic: ['{topic}\u306b\u3064\u3044\u3066\u3001\u308f\u304b\u308a\u3084\u3059\u304f\u3054\u8aac\u660e\u3057\u307e\u3059\u3002', '\u826f\u3044\u8cea\u554f\u3067\u3059\u306d\u3001{topic}\u306b\u3064\u3044\u3066\u3067\u3059\u306d\u3002'], noTopic: ['\u308f\u304b\u308a\u3084\u3059\u304f\u3054\u8aac\u660e\u3057\u307e\u3059\u3002', '\u826f\u3044\u8cea\u554f\u3067\u3059\u306d\u3002'] },
  ko: { withTopic: ['{topic}\uc5d0 \ub300\ud574 \uba85\ud655\ud558\uac8c \uc124\uba85\ud574 \ub4dc\ub9ac\uaca0\uc2b5\ub2c8\ub2e4.', '\uc88b\uc740 \uc9c8\ubb38\uc785\ub2c8\ub2e4, {topic}\uc5d0 \ub300\ud574\uc11c\uc694.'], noTopic: ['\uba85\ud655\ud558\uac8c \uc124\uba85\ud574 \ub4dc\ub9ac\uaca0\uc2b5\ub2c8\ub2e4.', '\uc88b\uc740 \uc9c8\ubb38\uc785\ub2c8\ub2e4.'] },
  tr: { withTopic: ['Tabii, {topic} konusunu net bir şekilde açıklayayım.', 'Güzel soru, {topic} hakkında.'], noTopic: ['Tabii, net bir şekilde açıklayayım.', 'Güzel soru.'] },
  hi: { withTopic: ['\u091c\u0930\u0942\u0930, {topic} \u0915\u0947 \u092c\u093e\u0930\u0947 \u092e\u0947\u0902 \u0938\u094d\u092a\u0937\u094d\u091f \u0930\u0942\u092a \u0938\u0947 \u092c\u0924\u093e\u0924\u093e \u0939\u0942\u0901\u0964', '\u0905\u091a\u094d\u091b\u093e \u092a\u094d\u0930\u0936\u094d\u0928, {topic} \u0915\u0947 \u092c\u093e\u0930\u0947 \u092e\u0947\u0902\u0964'], noTopic: ['\u091c\u0930\u0942\u0930, \u0938\u094d\u092a\u0937\u094d\u091f \u0930\u0942\u092a \u0938\u0947 \u092c\u0924\u093e\u0924\u093e \u0939\u0942\u0901\u0964', '\u0905\u091a\u094d\u091b\u093e \u092a\u094d\u0930\u0936\u094d\u0928\u0964'] },
  it: { withTopic: ['Certo, su {topic}, lascia che te lo spieghi bene.', 'Buona domanda, su {topic}.'], noTopic: ['Certo, lascia che te lo spieghi bene.', 'Buona domanda.'] },
  nl: { withTopic: ['Zeker, over {topic}, laat me het duidelijk uitleggen.', 'Goede vraag, over {topic}.'], noTopic: ['Zeker, laat me het duidelijk uitleggen.', 'Goede vraag.'] }
};

// Smart WATCHDOG pool: varied professional "still working" phrases spoken when a >2s silence appears
// mid-turn. Rotating, never-repeating, sounds like an expert working — not a stalling loop.
var _WATCHDOG_LINES = {
  en: ['Let me make sure this is precise for you.', 'I am cross-checking the details now.', 'Almost there, just organizing this clearly.', 'Pulling the exact specifics together.', 'One moment while I confirm this is accurate.', 'I want this to be exactly right for you.'],
  ar: ['\u0623\u062a\u0623\u0643\u0651\u062f \u0645\u0646 \u062f\u0642\u0629 \u0630\u0644\u0643 \u0644\u0643.', '\u0623\u0631\u0627\u062c\u0639 \u0627\u0644\u062a\u0641\u0627\u0635\u064a\u0644 \u0627\u0644\u0622\u0646.', '\u0627\u0642\u062a\u0631\u0628\u062a\u060c \u0623\u0646\u0638\u0651\u0645\u0647\u0627 \u0628\u0648\u0636\u0648\u062d.', '\u0623\u062c\u0645\u0639 \u0627\u0644\u062a\u0641\u0627\u0635\u064a\u0644 \u0627\u0644\u062f\u0642\u064a\u0642\u0629.', '\u0644\u062d\u0638\u0629 \u0631\u064a\u062b\u0645\u0627 \u0623\u062a\u0623\u0643\u0651\u062f \u0645\u0646 \u0635\u062d\u062a\u0647\u0627.'],
  es: ['Déjame asegurarme de que sea preciso.', 'Estoy verificando los detalles ahora.', 'Casi listo, organizándolo con claridad.', 'Reuniendo los detalles exactos.'],
  fr: ['Je m’assure que c’est précis pour vous.', 'Je vérifie les détails maintenant.', 'Presque terminé, j’organise cela clairement.', 'Je rassemble les détails exacts.'],
  de: ['Ich stelle sicher, dass es genau ist.', 'Ich prüfe gerade die Einzelheiten.', 'Fast fertig, ich ordne es klar.', 'Ich sammle die genauen Details.'],
  pt: ['Deixe-me garantir que esteja preciso.', 'Estou verificando os detalhes agora.', 'Quase lá, organizando com clareza.', 'Reunindo os detalhes exatos.'],
  ru: ['\u0423\u0431\u0435\u0436\u0434\u0430\u044e\u0441\u044c, \u0447\u0442\u043e \u044d\u0442\u043e \u0442\u043e\u0447\u043d\u043e.', '\u0421\u0435\u0439\u0447\u0430\u0441 \u043f\u0440\u043e\u0432\u0435\u0440\u044f\u044e \u0434\u0435\u0442\u0430\u043b\u0438.', '\u041f\u043e\u0447\u0442\u0438 \u0433\u043e\u0442\u043e\u0432\u043e.'],
  zh: ['\u6211\u786e\u4fdd\u51c6\u786e\u65e0\u8bef\u3002', '\u6b63\u5728\u6838\u5bf9\u7ec6\u8282\u3002', '\u5feb\u597d\u4e86\uff0c\u6b63\u5728\u6574\u7406\u3002'],
  ja: ['\u6b63\u78ba\u304b\u3069\u3046\u304b\u78ba\u8a8d\u3057\u3066\u3044\u307e\u3059\u3002', '\u8a73\u7d30\u3092\u7167\u5408\u3057\u3066\u3044\u307e\u3059\u3002', '\u3082\u3046\u3059\u3050\u3067\u3059\u3002'],
  ko: ['\uc815\ud655\ud55c\uc9c0 \ud655\uc778\ud558\uace0 \uc788\uc2b5\ub2c8\ub2e4.', '\uc138\ubd80 \uc0ac\ud56d\uc744 \ub300\uc870\ud558\uace0 \uc788\uc2b5\ub2c8\ub2e4.', '\uac70\uc758 \ub2e4 \ub410\uc2b5\ub2c8\ub2e4.'],
  tr: ['Doğru olduğundan emin oluyorum.', 'Ayrıntıları şimdi kontrol ediyorum.', 'Neredeyse hazır, düzenliyorum.'],
  hi: ['\u092e\u0948\u0902 \u0938\u0941\u0928\u093f\u0936\u094d\u091a\u093f\u0924 \u0915\u0930 \u0930\u0939\u093e \u0939\u0942\u0901 \u0915\u093f \u092f\u0939 \u0938\u091f\u0940\u0915 \u0939\u0948\u0964', '\u092e\u0948\u0902 \u0905\u092d\u0940 \u0935\u093f\u0935\u0930\u0923 \u091c\u093e\u0902\u091a \u0930\u0939\u093e \u0939\u0942\u0901\u0964', '\u0932\u0917\u092d\u0917 \u0939\u094b \u0917\u092f\u093e\u0964'],
  it: ['Mi assicuro che sia preciso.', 'Sto verificando i dettagli ora.', 'Quasi fatto, sto organizzando.'],
  nl: ['Ik zorg dat het nauwkeurig is.', 'Ik controleer nu de details.', 'Bijna klaar, ik orden het.']
};
var _lastWatchIdx = -1;
function _watchdogLine(code) {
  var pool = _WATCHDOG_LINES[code] || _WATCHDOG_LINES.en;
  var i = Math.floor(Math.random() * pool.length);
  if (i === _lastWatchIdx && pool.length > 1) i = (i + 1) % pool.length;
  _lastWatchIdx = i;
  return pool[i];
}

function _makeVoiceBridge(text, lang) {
  var t = (text || '').toLowerCase().trim();
  if (!t || t.length < 3) return '';
  // Greetings / small talk → NO bridge. A social reply is instant; filler would sound wrong.
  if (/^(hi|hey|hello|yo|sup|hiya)\b/.test(t)
      || /\bhow('?s| is| are)\b.*\b(it going|you|things|your day)\b/.test(t)
      || /\b(good morning|good evening|good afternoon|what'?s up|whats up|how'?s it going)\b/.test(t)
      || /^(thanks|thank you|thankyou|cheers|nice|cool|great|awesome|ok|okay)\b/.test(t)) {
    return '';
  }
  // Resolve the 2-letter language code (from lang like 'es-ES', or Arabic script detection).
  var code = String(lang || 'en').toLowerCase().split('-')[0];
  if (/[\u0600-\u06FF]/.test(text)) code = 'ar';
  if (!_BRIDGE_LINES[code]) code = 'en';

  var wantsBuild = /\b(create|generate|build|make|write|prepare|draft|design|export|document|report|pdf|deck|presentation|table|list)\b/.test(t)
                || /\u0623\u0646\u0634\u0626|\u0627\u0639\u0645\u0644|\u062c\u0647\u0632|\u0627\u0643\u062a\u0628|\u0627\u0646\u0634\u0627\u0621|\u0645\u0633\u062a\u0646\u062f|\u062a\u0642\u0631\u064a\u0631/.test(text);
  var isQuestion = /\b(how|what|why|when|where|which|who|can you|could you|is it|are there|do i|should i|explain|difference)\b/.test(t)
                || /\u0643\u064a\u0641|\u0645\u0627\u0630\u0627|\u0644\u0645\u0627\u0630\u0627|\u0645\u062a\u0649|\u0623\u064a\u0646|\u0647\u0644|\u0627\u0634\u0631\u062d|\u0645\u0627 \u0647\u064a/.test(text) || t.indexOf('?') !== -1;

  // EVERY real question or request gets a filler now (only greetings skip). This guarantees speech
  // instead of silence. Short question → short smart line; complex/build → long filler.
  var wordCount = t.split(/\s+/).length;
  // Short, simple questions ("can you hear me?", "what is X", quick yes/no) are answered fast now
  // (voice brevity), so they need NO filler at all — just answer. Only substantive requests that
  // genuinely need search/thinking time get the filler. Build requests always qualify.
  var isSubstantive = wantsBuild || wordCount >= 7;
  if (!isSubstantive) return '';   // simple/short → answer directly, no filler, no ack
  var isComplex = wantsBuild || wordCount >= 10;

  var topic = _extractTopic(text, code);
  var tmpl = (_BRIDGE_SMART[code] || _BRIDGE_SMART.en);
  // The INSTANT opening does NOT echo the user's words — that would sound like copy-paste. It stays
  // generic-but-warm; the parallel /voice/ack sentence provides the real, understood acknowledgment.
  var openPool = tmpl.noTopic;
  var oi = Math.floor(Math.random() * openPool.length);
  if (oi === _lastBridgeIdx && openPool.length > 1) oi = (oi + 1) % openPool.length;
  _lastBridgeIdx = oi;
  var opening = openPool[oi];

  var out = [ opening ];
  if (isComplex) {
    // Long runway: add shuffled reassurance lines (topic-aware where the template allows).
    var fill = (_BRIDGE_FILL[code] || _BRIDGE_FILL.en).slice();
    for (var k = fill.length - 1; k > 0; k--) { var j = Math.floor(Math.random() * (k + 1)); var tmp = fill[k]; fill[k] = fill[j]; fill[j] = tmp; }
    out = out.concat(fill.slice(0, 3));
  }
  return out;   // ARRAY of sentences (1 for simple, ~4 for complex)
}

// Reassurance / "still preparing" lines used to extend the spoken filler until the answer is ready.
var _BRIDGE_FILL = {
  en: [
    'I am making sure the information is accurate and complete before I share it with you.',
    'I am organizing it clearly so it will be easy to follow and apply directly.',
    'Just a moment while I put the details together properly for you.',
    'I want to give you the correct answer, so I am checking the specifics now.',
    'I am structuring this step by step so it is straightforward to use in your system.'],
  ar: [
    '\u0623\u062a\u0623\u0643\u0651\u062f \u0627\u0644\u0622\u0646 \u0645\u0646 \u062f\u0642\u0629 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062a \u0648\u0627\u0643\u062a\u0645\u0627\u0644\u0647\u0627 \u0642\u0628\u0644 \u0623\u0646 \u0623\u0642\u062f\u0651\u0645\u0647\u0627 \u0644\u0643.',
    '\u0623\u0631\u062a\u0651\u0628\u0647\u0627 \u0628\u0648\u0636\u0648\u062d \u062d\u062a\u0649 \u062a\u0643\u0648\u0646 \u0633\u0647\u0644\u0629 \u0627\u0644\u0645\u062a\u0627\u0628\u0639\u0629 \u0648\u0627\u0644\u062a\u0637\u0628\u064a\u0642.',
    '\u0644\u062d\u0638\u0629 \u0648\u0627\u062d\u062f\u0629 \u0631\u064a\u062b\u0645\u0627 \u0623\u062c\u0647\u0651\u0632 \u0644\u0643 \u0627\u0644\u062a\u0641\u0627\u0635\u064a\u0644 \u0628\u0634\u0643\u0644 \u0635\u062d\u064a\u062d.',
    '\u0623\u0631\u064a\u062f \u0623\u0646 \u0623\u0639\u0637\u064a\u0643 \u0627\u0644\u0625\u062c\u0627\u0628\u0629 \u0627\u0644\u0635\u062d\u064a\u062d\u0629\u060c \u0644\u0630\u0644\u0643 \u0623\u062a\u062d\u0642\u0651\u0642 \u0645\u0646 \u0627\u0644\u062a\u0641\u0627\u0635\u064a\u0644 \u0627\u0644\u0622\u0646.',
    '\u0623\u0646\u0638\u0651\u0645 \u0647\u0630\u0627 \u062e\u0637\u0648\u0629 \u0628\u062e\u0637\u0648\u0629 \u062d\u062a\u0649 \u064a\u0643\u0648\u0646 \u0633\u0647\u0644 \u0627\u0644\u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0641\u064a \u0646\u0638\u0627\u0645\u0643.'],
  es: [
    'Me aseguro de que la información sea precisa y completa antes de compartirla contigo.',
    'La estoy organizando con claridad para que sea fácil de seguir y aplicar directamente.',
    'Un momento mientras preparo los detalles correctamente para ti.',
    'Quiero darte la respuesta correcta, así que estoy verificando los detalles ahora.'],
  fr: [
    'Je m’assure que les informations sont exactes et complètes avant de vous les présenter.',
    'Je les organise clairement pour qu’elles soient faciles à suivre et à appliquer.',
    'Un instant pendant que je prépare correctement les détails pour vous.',
    'Je veux vous donner la bonne réponse, donc je vérifie les détails maintenant.'],
  de: [
    'Ich stelle sicher, dass die Informationen korrekt und vollständig sind, bevor ich sie Ihnen gebe.',
    'Ich ordne sie klar, damit sie leicht nachzuvollziehen und anzuwenden sind.',
    'Einen Moment, während ich die Details richtig für Sie zusammenstelle.',
    'Ich möchte Ihnen die richtige Antwort geben, daher prüfe ich jetzt die Einzelheiten.'],
  pt: [
    'Estou garantindo que a informação esteja precisa e completa antes de compartilhar com você.',
    'Estou organizando com clareza para que seja fácil de acompanhar e aplicar diretamente.',
    'Um momento enquanto preparo os detalhes corretamente para você.',
    'Quero dar a resposta certa, então estou verificando os detalhes agora.'],
  ru: [
    '\u042f \u0443\u0431\u0435\u0436\u0434\u0430\u044e\u0441\u044c, \u0447\u0442\u043e \u0438\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u044f \u0442\u043e\u0447\u043d\u0430\u044f \u0438 \u043f\u043e\u043b\u043d\u0430\u044f, \u043f\u0440\u0435\u0436\u0434\u0435 \u0447\u0435\u043c \u043f\u0440\u0435\u0434\u043e\u0441\u0442\u0430\u0432\u0438\u0442\u044c \u0435\u0451.',
    '\u042f \u043e\u0440\u0433\u0430\u043d\u0438\u0437\u0443\u044e \u0435\u0451 \u044f\u0441\u043d\u043e, \u0447\u0442\u043e\u0431\u044b \u0431\u044b\u043b\u043e \u043b\u0435\u0433\u043a\u043e \u043f\u0440\u0438\u043c\u0435\u043d\u0438\u0442\u044c.',
    '\u041e\u0434\u043d\u0443 \u043c\u0438\u043d\u0443\u0442\u0443, \u044f \u0433\u043e\u0442\u043e\u0432\u043b\u044e \u0434\u043b\u044f \u0432\u0430\u0441 \u0434\u0435\u0442\u0430\u043b\u0438.',
    '\u042f \u0445\u043e\u0447\u0443 \u0434\u0430\u0442\u044c \u0432\u0430\u043c \u0442\u043e\u0447\u043d\u044b\u0439 \u043e\u0442\u0432\u0435\u0442, \u043f\u043e\u044d\u0442\u043e\u043c\u0443 \u0441\u0435\u0439\u0447\u0430\u0441 \u043f\u0440\u043e\u0432\u0435\u0440\u044f\u044e \u0434\u0435\u0442\u0430\u043b\u0438.'],
  zh: [
    '\u6211\u6b63\u5728\u786e\u4fdd\u4fe1\u606f\u51c6\u786e\u5b8c\u6574\uff0c\u7136\u540e\u518d\u5448\u73b0\u7ed9\u60a8\u3002',
    '\u6211\u6b63\u5728\u6e05\u6670\u5730\u6574\u7406\uff0c\u65b9\u4fbf\u60a8\u76f4\u63a5\u7406\u89e3\u548c\u5e94\u7528\u3002',
    '\u8bf7\u7a0d\u7b49\uff0c\u6211\u6b63\u5728\u4e3a\u60a8\u6574\u7406\u7ec6\u8282\u3002',
    '\u6211\u60f3\u7ed9\u60a8\u51c6\u786e\u7684\u7b54\u6848\uff0c\u6240\u4ee5\u73b0\u5728\u6b63\u5728\u6838\u5b9e\u7ec6\u8282\u3002'],
  ja: [
    '\u60c5\u5831\u304c\u6b63\u78ba\u3067\u5b8c\u5168\u3067\u3042\u308b\u3053\u3068\u3092\u78ba\u8a8d\u3057\u3066\u304b\u3089\u304a\u4f1d\u3048\u3057\u307e\u3059\u3002',
    '\u5206\u304b\u308a\u3084\u3059\u304f\u6574\u7406\u3057\u3066\u3044\u307e\u3059\u306e\u3067\u3001\u3059\u3050\u306b\u6d3b\u7528\u3067\u304d\u307e\u3059\u3002',
    '\u5c11\u3005\u304a\u5f85\u3061\u304f\u3060\u3055\u3044\u3002\u8a73\u7d30\u3092\u6e96\u5099\u3057\u3066\u3044\u307e\u3059\u3002',
    '\u6b63\u78ba\u306a\u56de\u7b54\u3092\u304a\u4f1d\u3048\u3057\u305f\u3044\u306e\u3067\u3001\u4eca\u8a73\u7d30\u3092\u78ba\u8a8d\u3057\u3066\u3044\u307e\u3059\u3002'],
  ko: [
    '\uc815\ubcf4\uac00 \uc815\ud655\ud558\uace0 \uc644\uc804\ud55c\uc9c0 \ud655\uc778\ud55c \ud6c4 \uc54c\ub824\ub4dc\ub9ac\uaca0\uc2b5\ub2c8\ub2e4.',
    '\ubc14\ub85c \uc801\uc6a9\ud558\uc2e4 \uc218 \uc788\ub3c4\ub85d \uba85\ud655\ud558\uac8c \uc815\ub9ac\ud558\uace0 \uc788\uc2b5\ub2c8\ub2e4.',
    '\uc7a0\uc2dc\ub9cc\uc694, \uc138\ubd80 \uc0ac\ud56d\uc744 \uc900\ube44\ud558\uace0 \uc788\uc2b5\ub2c8\ub2e4.',
    '\uc815\ud655\ud55c \ub2f5\ubcc0\uc744 \ub4dc\ub9ac\uae30 \uc704\ud574 \uc9c0\uae08 \uc138\ubd80 \uc0ac\ud56d\uc744 \ud655\uc778\ud558\uace0 \uc788\uc2b5\ub2c8\ub2e4.'],
  tr: [
    'Bilgileri sizinle paylaşmadan önce doğru ve eksiksiz olduğundan emin oluyorum.',
    'Kolayca takip edip uygulayabilmeniz için net bir şekilde düzenliyorum.',
    'Ayrıntıları sizin için düzgünce hazırlarken bir dakika bekleyin.',
    'Size doğru cevabı vermek istiyorum, bu yüzden şimdi ayrıntıları kontrol ediyorum.'],
  hi: [
    '\u092e\u0948\u0902 \u091c\u093e\u0928\u0915\u093e\u0930\u0940 \u0938\u093e\u091d\u093e \u0915\u0930\u0928\u0947 \u0938\u0947 \u092a\u0939\u0932\u0947 \u0938\u0941\u0928\u093f\u0936\u094d\u091a\u093f\u0924 \u0915\u0930 \u0930\u0939\u093e \u0939\u0942\u0901 \u0915\u093f \u0935\u0939 \u0938\u091f\u0940\u0915 \u0914\u0930 \u092a\u0942\u0930\u094d\u0923 \u0939\u0948\u0964',
    '\u092e\u0948\u0902 \u0907\u0938\u0947 \u0938\u094d\u092a\u0937\u094d\u091f \u0930\u0942\u092a \u0938\u0947 \u0935\u094d\u092f\u0935\u0938\u094d\u0925\u093f\u0924 \u0915\u0930 \u0930\u0939\u093e \u0939\u0942\u0901 \u0924\u093e\u0915\u093f \u0907\u0938\u0947 \u0906\u0938\u093e\u0928\u0940 \u0938\u0947 \u0932\u093e\u0917\u0942 \u0915\u093f\u092f\u093e \u091c\u093e \u0938\u0915\u0947\u0964',
    '\u090f\u0915 \u0915\u094d\u0937\u0923, \u092e\u0948\u0902 \u0906\u092a\u0915\u0947 \u0932\u093f\u090f \u0935\u093f\u0935\u0930\u0923 \u0924\u0948\u092f\u093e\u0930 \u0915\u0930 \u0930\u0939\u093e \u0939\u0942\u0901\u0964',
    '\u092e\u0948\u0902 \u0906\u092a\u0915\u094b \u0938\u0939\u0940 \u0909\u0924\u094d\u0924\u0930 \u0926\u0947\u0928\u093e \u091a\u093e\u0939\u0924\u093e \u0939\u0942\u0901, \u0907\u0938\u0932\u093f\u090f \u0905\u092d\u0940 \u0935\u093f\u0935\u0930\u0923 \u091c\u093e\u0902\u091a \u0930\u0939\u093e \u0939\u0942\u0901\u0964'],
  it: [
    'Mi assicuro che le informazioni siano accurate e complete prima di condividerle con te.',
    'Le sto organizzando in modo chiaro così da essere facili da seguire e applicare.',
    'Un momento mentre preparo i dettagli correttamente per te.',
    'Voglio darti la risposta giusta, quindi sto verificando i dettagli ora.'],
  nl: [
    'Ik zorg ervoor dat de informatie nauwkeurig en volledig is voordat ik die met u deel.',
    'Ik orden het duidelijk zodat het gemakkelijk te volgen en toe te passen is.',
    'Een moment terwijl ik de details goed voor u voorbereid.',
    'Ik wil u het juiste antwoord geven, dus ik controleer nu de details.']
};

async function handleVoiceTranscript(text) {
  text = (text || '').trim();
  if (!text) { setVState('idle'); return; }
  try {
        // ── Query limit check before processing voice input ──
        if(!checkQueryLimit()){
          setVState('idle');
          document.getElementById('vi-transcript').textContent='Query limit reached. Please upgrade.';
          return;
        }
        // Show what user said
        document.getElementById('vi-transcript').textContent = text;
        S.history.push({ role: 'user', content: text });
        addMsg('user', text, null);
        incrementQuery();

        // Step 2: Send to /chat - same as typing (full system prompt, exports, everything)
        // ── Mute mic + set up the streaming TTS queue BEFORE generation, so audio can
        //    start the moment the first sentence is ready (overlap). ──
        if (_vRafId) { cancelAnimationFrame(_vRafId); _vRafId = null; }
        if (_isListening) {
          clearTimeout(_silenceTimer); _silenceTimer = null; _isListening = false;
          if (_mediaRecorder && _mediaRecorder.state === 'recording') { try { _mediaRecorder.stop(); } catch(e) {} }
          _audioChunks = [];
        }
        if (_micStream) { _micStream.getAudioTracks().forEach(function(t){ t.enabled = false; }); }
        _isAISpeaking = true;

        stopAudio();                                  // reset any prior playback + bump speak id
        var _ttsMin = window._ttsMinChars || 50;      // admin threshold: min chars before a chunk goes to TTS
        var _detLang = S._chatLang || detectLanguage(text);
        var _voiceChoice = S._voiceChoice || ('cloud:' + (window._voiceDefaultVoice || 'Kore'));
        var _cv = _voiceChoice.startsWith('cloud:') ? _voiceChoice.replace('cloud:','') : (window._voiceDefaultVoice || 'Kore');
        var _spd = S._voiceSpeed || window._voiceDefaultSpeed || 1.0;
        var _bridgeCode = String(_detLang || 'en').toLowerCase().split('-')[0];
        if (/[\u0600-\u06FF]/.test(text)) _bridgeCode = 'ar';
        var _stream = makeStreamTTS({ voice: _cv, speed: _spd, lang: _detLang, code: _bridgeCode });

        // ── INSTANT SPOKEN BRIDGE ──────────────────────────────────────────────
        // Speak a short, relevant acknowledgment the MOMENT the user finishes, so there is no
        // dead air while /chat connects + generates. Built on the client from the user's own
        // words (zero latency, no extra API call). The real answer streams in right after.
        if (window._voiceBridge !== false) {
          var _bridge = _makeVoiceBridge(text, _detLang);
          if (_bridge) {
            window._voiceBridgeActive = true;
            var _bl = (typeof _bridge === 'string') ? [_bridge] : _bridge;
            // Push the INSTANT opening now (first line only) so speech starts immediately —
            // unless the pre-generated AI opener already played at end-of-speech (voice-filler-v1).
            if (!window._vfOpenerPlayed) _stream.pushBridge(_bl[0]);
            // Fire the SMART ack in parallel — it understands the question (no word-echo) and returns
            // one natural sentence. When it lands (~1-2s), insert it as the next filler item, before
            // the remaining generic reassurance lines. If it fails/slow, the generic lines cover it.
            var _restLines = _bl.slice(1);
            var _ackDone = false;
            window.fetch(API + '/voice/ack', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + (S.token || '') },
              body: JSON.stringify({ text: text, lang: _detLang })
            }).then(function(r){ return r.json(); }).then(function(d){
              if (!_ackDone && d && d.ack && window._voiceBridgeActive) { console.log('[voice] smart ack:', d.ack); _stream.pushBridge(d.ack); }
              else if (!d || !d.ack) { console.log('[voice] smart ack empty (check fast_model config in admin)'); }
              _ackDone = true;
              for (var _ri = 0; _ri < _restLines.length; _ri++) { _stream.pushBridge(_restLines[_ri]); }
            }).catch(function(){
              _ackDone = true;
              for (var _ri = 0; _ri < _restLines.length; _ri++) { _stream.pushBridge(_restLines[_ri]); }
            });
            // Safety: if ack hasn't resolved in 2.8s, queue the generic lines so there's no gap.
            setTimeout(function(){ if (!_ackDone) { _ackDone = true; for (var _ri = 0; _ri < _restLines.length; _ri++) { _stream.pushBridge(_restLines[_ri]); } } }, 2800);
          }
        }

        // Send only recent history — NOT the entire conversation. Voice was shipping all 144+
        // turns every request, which ballooned the payload + server memory processing and made
        // connect time grow to 30s+. The backend also caps it, but capping here fixes the payload.
        // Staged delivery: if the user is continuing ("Next", "continue", "go on"...), send more
        // history so the AI still sees the earlier stages and never loses its place.
        var _isContinue = /^(ok\s+)?(next|continue|go on|more|proceed|next please|carry on|keep going)\b/i.test((text || '').trim());
        var _voiceHistTurns = _isContinue ? (window._voiceStageHistoryTurns || 20) : (window._voiceHistoryTurns || 8);
        var _voiceHist = (S.history || []).slice(-_voiceHistTurns);
        // Resolve the selected system/product, falling back to the last persisted selection so the
        // AI always knows "this system" — even if S.vendor/S.product got reset this session.
        var _vVendor = S.vendor || (function(){ try { return localStorage.getItem('eoh_last_vendor') || ''; } catch(e){ return ''; } })();
        var _vProduct = S.product || (function(){ try { return localStorage.getItem('eoh_last_product') || ''; } catch(e){ return ''; } })();
        var chatRes = await window.fetch(API + '/chat', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + (S.token || ''), 'Accept': 'text/event-stream' },
          body: JSON.stringify({ messages: _voiceHist, vendor: _vVendor, product: _vProduct, userId: S.user ? S.user.id : null, stream: true, source: 'voice', mem_session: S_memSession, sessionId: S_sessionId || null })
        });
        if (!chatRes.ok) {
          var _errD = await chatRes.json().catch(function(){return {};});
          document.getElementById('vi-transcript').textContent = _errD.error || 'Error';
          _stream.abort(); _isAISpeaking = false;
          if (_micStream) { _micStream.getAudioTracks().forEach(function(t){ t.enabled = true; }); }
          setVState('idle'); return;
        }
        try { if (window._vtiming) { var _lbl = window._vtiming.streaming ? 'transcript→chat-connected' : 'STT'; console.log('[voice-timing] ' + _lbl + ': ' + Math.round(performance.now()-window._vtiming.stt) + 'ms'); window._vtiming.chat = performance.now(); window._vtiming.tts = performance.now(); window._vtiming.firstTok = 0; } } catch(e){}

        var reply = '';
        var _spoken = 0;          // chars already flushed to TTS
        var _answerFlushed = false;   // becomes true when the first real answer sentence is queued
        var _ct = chatRes.headers.get('content-type') || '';

        // #2: live assistant bubble that TYPES character-by-character (like normal chat), via the
        // shared typewriter. Created on first chunk; fed as the answer streams; finalized at the end.
        var _liveEl = null, _twStarted = false;
        function _liveBubble(txt) {
          if (!_liveEl) {
            addMsg('assistant', '', null);
            var _all = document.querySelectorAll('.msg.assistant'); _liveEl = _all[_all.length - 1];
            var _bub = _liveEl ? _liveEl.querySelector('.mbubble') : null;
            if (_bub && typeof window._eohTwInit === 'function') { window._eohTwInit(_bub, document.getElementById('msgs')); _twStarted = true; }
          }
          txt = _hideAskForDisplay(txt);   // never show the raw [[ASK]]/[[DIDYOUMEAN]] JSON while streaming
          if (_twStarted && typeof window._eohTwFeed === 'function') { window._eohTwFeed(txt); }
          else { var _b = _liveEl && _liveEl.querySelector('.mbubble'); if (_b) { try { _b.innerHTML = formatMarkdown(txt); } catch(e){ _b.textContent = txt; } } }
          var _m = document.getElementById('msgs'); if (_m) _m.scrollTop = _m.scrollHeight;
        }
        // #3: long-search tone — only if the REAL answer hasn't started within a window AFTER the
        // bridge speech. Not before, and never overlapping the bridge. Cleared the moment a chunk lands.

        // Pull completed sentences out of the un-spoken tail once past the threshold. Structural
        // blocks (tables, code, long lists) are held until complete, then spoken CONDENSED via
        // condenseForSpeech — so voice conveys the idea without reading every cell/line. Prose
        // streams sentence-by-sentence as before (fast start, no silence).
        var _ttsGateHit = false;   // once a [[DIDYOUMEAN/ASK/NEXT block starts, stop feeding TTS (it renders as buttons)
        function _pushSpeak(txt) {
          if (!txt) return;
          if (!_ttsGateHit && /(?:\[\[\s*)?(?:DIDYOUMEAN|ASK|NEXT)\s*:/i.test(reply)) _ttsGateHit = true;
          if (_ttsGateHit) {
            // Speak only text that came BEFORE the block; the block itself (intro + options) is
            // rendered as buttons, and its intro is spoken once at the end (see _stream.done()).
            var _cut = txt.search(/(?:\[\[\s*)?(?:DIDYOUMEAN|ASK|NEXT)\s*:/i);
            if (_cut < 0) return;
            txt = txt.slice(0, _cut).trim(); if (!txt) return;
          }
          if (!_answerFlushed) { _answerFlushed = true; if (_stream.dropPendingBridge) _stream.dropPendingBridge(); }
          _stream.push(txt);
        }
        function _inStructBlock(s) {
          // Is the pending tail currently inside an unfinished code fence or table? If so, wait.
          var fences = (s.match(/```/g) || []).length;
          if (fences % 2 === 1) return true;                       // open code block
          var lines = s.split('\n'); var last = lines[lines.length - 1];
          if (last.indexOf('|') !== -1) return true;               // mid-table row (not yet newline-terminated)
          return false;
        }
        function _flushSentences(force) {
          var pending = reply.substring(_spoken);
          if (!pending) { if (force) _spoken = reply.length; return; }
          // If not forcing and we're mid-structure, wait for the block to complete.
          if (!force && _inStructBlock(pending)) return;
          // Does the pending text contain any structure worth condensing?
          var hasStruct = /```|(\n\s*\|.*\|)|(\n\s*([-*•]|\d+[.)])\s+.*\n\s*([-*•]|\d+[.)])\s+.*\n\s*([-*•]|\d+[.)])\s+)/.test('\n' + pending);
          if (hasStruct) {
            // Condense the whole pending block and speak it as complete units. Only do this once the
            // structure is closed (on force, or when a full block boundary is present).
            if (!force && _inStructBlock(pending)) return;
            var condensed = cleanForTTS(condenseForSpeech(pending, _detLang));
            if (condensed) { _pushSpeak(condensed); _spoken = reply.length; }
            else if (force) { _spoken = reply.length; }   // only skip if nothing to say AND stream is done
            return;
          }
          // Pure prose → stream sentence-by-sentence for fast start.
          var clean = cleanForTTS(pending);
          if (!clean) { if (force) _spoken = reply.length; return; }
          var re = /[^.!?\n]*[.!?\n]+/g, m, lastEnd = 0, out = '';
          while ((m = re.exec(pending)) !== null) {
            var seg = pending.substring(lastEnd, re.lastIndex);
            if ((out + seg).length >= 1) { out += seg; lastEnd = re.lastIndex; }
            if (cleanForTTS(out).length >= _ttsMin) {
              _pushSpeak(cleanForTTS(out)); _spoken += lastEnd; out = ''; lastEnd = 0; pending = reply.substring(_spoken); re.lastIndex = 0;
            }
          }
          // Flush any final partial sentence the loop left unspoken.
          if (out && cleanForTTS(out).trim()) { _pushSpeak(cleanForTTS(out)); _spoken += out.length; out = ''; }
          if (force) {
            var _remain = reply.substring(_spoken);
            var tail = cleanForTTS(condenseForSpeech(_remain, _detLang));
            if (tail) { _pushSpeak(tail); }
            _spoken = reply.length;
            try {
              var _spokenLen = (window._eohSpokenText || '').length;
              console.log('[EOH voice] spoke ~' + Math.round(100 * _spokenLen / Math.max(1, reply.length))
                + '% of the reply (' + _spokenLen + '/' + reply.length + ' chars)');
            } catch (_) {}
          }
        }

        if (_ct.includes('text/event-stream')) {
          var _reader = chatRes.body.getReader();
          var _dec = new TextDecoder();
          var _buf = '';
          var _sseReplyDone = false;
          while (true) {
            var _rd = await _reader.read();
            if (_rd.done || _sseReplyDone) break;
            _buf += _dec.decode(_rd.value, { stream: true });
            var _lines = _buf.split('\n');
            _buf = _lines.pop();
            for (var _li = 0; _li < _lines.length; _li++) {
              var _ln = _lines[_li].trim();
              if (!_ln.startsWith('data: ')) continue;
              try {
                var _ev = JSON.parse(_ln.slice(6));
                if (_ev.done) { if (_ev.reply) reply = _ev.reply; _sseReplyDone = true; break; }
                if (_ev.chunk) {
                  if (window._vtiming && !window._vtiming.firstTok) { window._vtiming.firstTok = 1; try { console.log('[voice-timing] AI first token: ' + Math.round(performance.now()-window._vtiming.chat) + 'ms'); } catch(e){} }
                  reply += _ev.chunk;
                  _liveBubble(reply);                                            // show the answer in chat AS IT STREAMS
                  _flushSentences(false);                                        // release sentences to speech as they arrive
                }
              } catch(_) {}
            }
          }
          _flushSentences(true);          // flush whatever remains
        } else {
          var chatData = await chatRes.json().catch(function(){return {};});
          reply = chatData.reply || '';
          _flushSentences(true);          // non-streaming backend: speak it all at once
        }
        // Clarifier turn: speak the question/intro once (options are buttons, never read aloud).
        if (_ttsGateHit) {
          try {
            var _gq = _parseDidYouMean(reply) || _parseAskBlock(reply);
            if (_gq && _gq.question) { if (_stream.dropPendingBridge) _stream.dropPendingBridge(); _stream.push(cleanForTTS(_gq.question)); }
          } catch (e) {}
        }
        _stream.done();

        if (!reply) {
          document.getElementById('vi-transcript').textContent = 'No response';
          _stream.abort(); _isAISpeaking = false;
          if (_micStream) { _micStream.getAudioTracks().forEach(function(t){ t.enabled = true; }); }
          setVState('idle'); return;
        }

        // Assemble final reply for history + chat bubble (strip export marker)
        // Detect a file-export request BEFORE stripping the marker, then actually generate the file.
        var _voiceExport = reply.match(/EXPORT_TRIGGER:(pdf|docx|xlsx|pptx)/i);
        reply = reply.replace(/[-]*\s*EXPORT_TRIGGER:(pdf|docx|xlsx|pptx)\s*[-]*/gi, '').trim();
        if (_voiceExport && typeof doExport === 'function') {
          var _vfmt = _voiceExport[1].toLowerCase();
          var _vb64 = S.lastImageBase64 || S.fileBase64 || null;
          var _vext = S.lastImageExt || S.fileExt || null;
          setTimeout(function(){ try { doExport(_vfmt, _vb64, _vext); } catch(e){ console.error('[Voice] export failed', e); } }, 400);
        }
        if (typeof _stopThinkTone === 'function') _stopThinkTone();   // real answer is here — kill any long-search tone
        // Parse any clarify directive, then strip it from what the bubble/history show (it renders as buttons).
        var _vClarify = _parseAskBlock(reply) || _parseDidYouMean(reply) || _parseNextBlock(reply) || _parseClarifyLenient(reply);
        var _replyClean = _hideAskForDisplay(reply).replace(/\n{3,}/g, '\n\n').trim();
        if (!_replyClean && !_vClarify) {
          _replyClean = _recoverClarifyText(reply);
          if (_replyClean) console.warn('[EOH] recovered text from malformed clarify directive (voice)');
        }
        if (!_replyClean && !_vClarify) {
          console.error('[EOH] EMPTY REPLY (voice) — raw length: ' + String(reply || '').length);
          _replyClean = 'That response came back empty. Please ask again.';
        }
        _replyClean = _stripDirectiveMarkers(_replyClean);
        var _replyForHistory = _replyClean;
        if (_vClarify && String(_vClarify.question || '').trim()) {
          var _vq = _stripDirectiveMarkers(_vClarify.question);
          if (!_replyClean.trim()) _replyClean = _vq;   // never duplicate the question
          var _vnorm = function (x) { return String(x || '').replace(/\s+/g, ' ').trim().toLowerCase(); };
          _replyForHistory = _replyClean;
          if (_vq && _vnorm(_replyForHistory).indexOf(_vnorm(_vq)) === -1) _replyForHistory += (_replyForHistory ? '\n\n' : '') + _vq;
          var _vopts = (_vClarify.options || []).map(_stripDirectiveMarkers).filter(Boolean);
          if (_vopts.length) _replyForHistory += '\n\n' + _vopts.map(function (o) { return '- ' + o; }).join('\n');
        }
        S.history.push({ role: 'assistant', content: _replyForHistory });
        // Finalize the live bubble (typed as it streamed). Use typewriter finish if it was started.
        if (_liveEl && _twStarted && typeof window._eohTwFinish === 'function') { window._eohTwFinish(_replyClean, null); }
        else if (_liveEl) { var _fb = _liveEl.querySelector('.mbubble'); if (_fb) { try { _fb.innerHTML = formatMarkdown(_replyClean); _eohRenderVisuals(_fb, { reply: _replyClean }); } catch(e){ _fb.textContent = _replyClean; } } }
        else { addMsg('assistant', _replyClean, null); }
        // Panel removed — question is folded into the reply text above (option B).
        // Save quietly — skip the sidebar reload (loadSessions) that was blocking the next voice
        // turn by 30s+ as the session list grew. History is still persisted; just no UI refetch.
        if (S.history && S.history.length >= 1 && S.user) { try { saveCurrentSession(true); } catch(e){} }
        showRatingBar(text || '', S.vendor, S.product, 'voice');
        var _disp = cleanForTTS(reply);
        document.getElementById('vi-transcript').textContent = _disp.substring(0,120) + (_disp.length>120?'…':'');

        // Wait for all queued audio to finish playing.
        await _stream.wait();
        window._voiceBridgeActive = false;

        // Bug-2 fix (live voice display, streaming path): voice minutes for this turn
        // are charged SERVER-SIDE by /voice/speak. The streaming TTS path doesn't touch
        // the local counter, so the on-screen usage only corrected after a manual refresh.
        // Now that the turn's audio is done (and the server has recorded it), pull the
        // authoritative usage so the counter updates live. One-shot, debounced.
        clearTimeout(window._voiceResyncTimer);
        window._voiceResyncTimer = setTimeout(function(){
          if (typeof syncUsageFromServer === 'function') syncUsageFromServer().then(function(){ if (typeof updateLimits === 'function') updateLimits(); }).catch(function(){});
        }, 800);

        // Echo-guard then reopen mic
        await new Promise(function(r){ setTimeout(r, window._voiceEchoGuardMs || 700); });
        S.speaking = false; _isAISpeaking = false;
        if (_micStream) { _micStream.getAudioTracks().forEach(function(t){ t.enabled = true; }); }
        if (S.voiceOn) {
          setVState('idle');
          document.getElementById('vi-transcript').textContent = 'Speak anytime...';
          _vRafId = requestAnimationFrame(detectVoice);
          _vfTone('open'); _vfPrewarm();   // voice-filler-v1: mic re-opened → tone + refill opener
        }

  } catch(e) {
    console.error('[Voice] handleVoiceTranscript', e);
    document.getElementById('vi-transcript').textContent = 'Error. Speak again...';
    _isAISpeaking = false;
    if (_micStream) { _micStream.getAudioTracks().forEach(function(t){t.enabled=true;}); }
    setTimeout(function(){ if (S.voiceOn) { setVState('idle'); if(!_vRafId)_vRafId=requestAnimationFrame(detectVoice); } }, 300);
  }
}

// =============================================================================
// TTS - speakReply routes through speakText (full pipeline: multi-chunk, prefetch, abort guard)
// =============================================================================
async function speakReply(text) {
  if (!text) return;
  setVState('thinking');   // animation flips to 'speaking' when audio actually begins (_playUrl)
  // speakText handles _isAISpeaking, _activeSpeakId, chunking and prefetch
  await speakText(text);
}


// -- MIC TOGGLE - interrupt AI ------------------------------------------------
function voiceMicToggle(){
  if(_isAISpeaking){
    if(S._speakTextAbort){try{S._speakTextAbort();}catch(e){}S._speakTextAbort=null;}
    stopAudio();_isAISpeaking=false;
    if(_micStream){_micStream.getAudioTracks().forEach(function(t){t.enabled=true;});}
    setVState('idle');
    document.getElementById('vi-transcript').textContent='Speak anytime...';
    if(!_vRafId)_vRafId=requestAnimationFrame(detectVoice);
  }
}
function voiceInterruptInline(){
  if(S._speakTextAbort){try{S._speakTextAbort();}catch(e){}S._speakTextAbort=null;}
  _vfStopOpener();stopAudio();_isAISpeaking=false;
  if(_micStream){_micStream.getAudioTracks().forEach(function(t){t.enabled=true;});}
  setVState('idle');
  document.getElementById('vi-transcript').textContent='Speak anytime...';
  if(!_vRafId)_vRafId=requestAnimationFrame(detectVoice);
}
function forceEndVoice(){
  if(S._speakTextAbort){try{S._speakTextAbort();}catch(e){}S._speakTextAbort=null;}
  stopAudio();_isAISpeaking=false;endInlineVoice();
}
function startBargeInListener(){}
function stopBargeInListener(){}
function stopVoiceListening(){stopRecording();}

// ── Manual REC mode — tap once to start, tap again to send ────────────────
var _recActive=false,_recTimer=null,_recAutoStop=null,_recStartTime=0;
var REC_MAX_MS=5*60*1000; // 5 min hard cap
function voiceRecToggle(){if(_isAISpeaking)return;if(_recActive){_stopRec(true);}else{_startRec();}}
window.voiceRecToggle=voiceRecToggle;

// ── Push-to-Talk: press = start recording, release = stop and send ─────────
function voiceRecPress(){if(_isAISpeaking)return;if(!_recActive){_startRec();}}
function voiceRecRelease(){if(_recActive){_stopRec(true);}}
window.voiceRecPress=voiceRecPress;
window.voiceRecRelease=voiceRecRelease;

// ── Hold-to-Speak toggle ───────────────────────────────────────────────────
// Click once  = mic locks open, VAD silence timer suppressed.
// Click again = stops immediately and sends everything spoken.
var _holdSpeakActive = false;
function voiceHoldToggle() {
  var btn = document.getElementById('vi-hold-btn');
  var tr  = document.getElementById('vi-transcript');
  if (_holdSpeakActive) {
    // Un-hold: stop and send (works for BOTH streaming and clip paths)
    _holdSpeakActive = false; window._holdSpeakMode = false;
    if (btn) { btn.classList.remove('held'); btn.title = 'Click to hold mic open'; }
    if (tr) tr.textContent = 'Sending...';
    if (_dg.active) { _isListening = false; if (!_dg.fired) _dgFire(); }                 // streaming: flush now
    else if (_mediaRecorder && _mediaRecorder.state === 'recording') { stopRecording(); }
    else if (_isListening) { _silenceTimer = setTimeout(stopRecording, 200); }
    else { if (tr) tr.textContent = 'Speak anytime...'; }
  } else {
    // Hold: lock mic open — auto-end is disabled while held (see _holdSpeakMode check in onmessage/VAD)
    if (_isAISpeaking || !S.voiceOn) return;
    _holdSpeakActive = true; window._holdSpeakMode = true;
    clearTimeout(_silenceTimer); _silenceTimer = null;
    _vfTone('open'); _vfPrewarm();   // voice-filler-v1: hold/lock mode → open tone + pre-generate opener
    if (btn) { btn.classList.add('held'); btn.title = 'Click to stop & send'; }
    if (tr) tr.textContent = 'Mic locked — speak, then click Hold to send.';
    // Start capturing if not already (streaming or clip — startRecording picks the right one)
    if (!_isListening && !_dg.active) { _speechStartTime = Date.now(); startRecording(); }
  }
}
function _holdSpeakReset() {
  if (!_holdSpeakActive) return;
  _holdSpeakActive = false; window._holdSpeakMode = false;
  var btn = document.getElementById('vi-hold-btn');
  if (btn) btn.classList.remove('held');
}
window.voiceHoldToggle = voiceHoldToggle;
window._holdSpeakReset = _holdSpeakReset;

// ── Mic Mute toggle ───────────────────────────────────────────────────────
// Mute: mic stays open but VAD stops capturing — no audio sent to AI.
// Unmute: VAD resumes immediately.
window._micMuted = false;
function voiceMicMuteToggle() {
  window._micMuted = !window._micMuted;
  var btn = document.getElementById('vi-mute-btn');
  var tr  = document.getElementById('vi-transcript');
  if (window._micMuted) {
    if (_isListening) { clearTimeout(_silenceTimer); _silenceTimer = null; stopRecording(); }
    if (_vRafId) { cancelAnimationFrame(_vRafId); _vRafId = null; }
    if (btn) { btn.classList.add('muted'); btn.innerHTML = '&#128263; Unmute'; btn.title = 'Unmute mic'; }
    if (tr) tr.textContent = 'Mic muted — click Unmute to resume.';
    setVState('idle');
  } else {
    if (btn) { btn.classList.remove('muted'); btn.innerHTML = '&#128263; Mute'; btn.title = 'Mute mic — your voice won\'t be captured'; }
    if (tr) tr.textContent = 'Speak anytime...';
    setVState('idle');
    if (S.voiceOn && !_vRafId) _vRafId = requestAnimationFrame(detectVoice);
  }
}
window.voiceMicMuteToggle = voiceMicMuteToggle;
function _startRec(){
  if(!_mediaRecorder||_recActive||_mediaRecorder.state==='recording')return;
  if(_vRafId){cancelAnimationFrame(_vRafId);_vRafId=null;}
  clearTimeout(_silenceTimer);_silenceTimer=null;_isListening=false;_audioChunks=[];
  try{_mediaRecorder.start();}catch(e){return;}
  _recActive=true;_recStartTime=Date.now();
  var btn=document.getElementById('vi-rec'),tmr=document.getElementById('vi-rec-timer'),trn=document.getElementById('vi-transcript');
  if(btn)btn.classList.add('active');if(tmr)tmr.style.display='block';
  if(trn)trn.textContent='Recording… tap ● to send';setVState('listening');_vfTone('open');_vfPrewarm();
  _recTimer=setInterval(function(){
    var ms=Date.now()-_recStartTime,s=Math.floor(ms/1000)%60,m=Math.floor(ms/60000);
    if(tmr)tmr.textContent=m+':'+(s<10?'0':'')+s;
    if(ms>=4.5*60*1000&&trn)trn.textContent='⚠️ 30s left — tap ● to send';
  },1000);
  _recAutoStop=setTimeout(function(){if(_recActive){_stopRec(true);}},REC_MAX_MS);
}
function _stopRec(send){
  if(!_recActive)return;
  _recActive=false;clearInterval(_recTimer);_recTimer=null;clearTimeout(_recAutoStop);_recAutoStop=null;
  var btn=document.getElementById('vi-rec'),tmr=document.getElementById('vi-rec-timer');
  if(btn)btn.classList.remove('active');if(tmr){tmr.style.display='none';tmr.textContent='0:00';}
  if(!send){
    if(_mediaRecorder&&_mediaRecorder.state==='recording'){var sv=_mediaRecorder.onstop;_mediaRecorder.onstop=null;try{_mediaRecorder.stop();}catch(e){}; _mediaRecorder.onstop=sv;}
    _audioChunks=[];setVState('idle');
    var t=document.getElementById('vi-transcript');if(t)t.textContent='Speak anytime...';
    if(!_vRafId)_vRafId=requestAnimationFrame(detectVoice);return;
  }
  if(_mediaRecorder&&_mediaRecorder.state==='recording'){try{_mediaRecorder.stop();}catch(e){}}
  setVState('processing');var t=document.getElementById('vi-transcript');if(t)t.textContent='Sending...';
}
function toggleVoiceMode(){toggleInlineVoice();}


// ==============================================================================
// LIVE SCREEN
// ==============================================================================

var _liveScreen = {active:false,stream:null,frameCount:0,muted:false,micRecog:null,liveAudio:null,speaking:false,abortCtrl:null,popup:null,startTime:null,_watcher:null};
// Remembered Live panel dimensions (width/height + side-rail width), persisted across sessions.
var _liveSizePref = (function(){ try{ return JSON.parse(localStorage.getItem('eoh_live_size')) || {}; }catch(e){ return {}; } })();
// Wire the header size buttons + side-rail toggle. Operates on the panel's OWN window
// (d.defaultView), so it works the same for Document-PiP and the fallback popup.
function _wireWinControls(d, isPip, ctrlWrap){
  var win = d.defaultView;
  var _rail = false, _preRail = null;
  function sz(){ return { w: win.innerWidth||_liveSizePref.w||380, h: win.innerHeight||_liveSizePref.h||640 }; }
  function availW(){ try{ return win.screen.availWidth||screen.availWidth||1920; }catch(e){ return 1920; } }
  function availH(){ try{ return win.screen.availHeight||screen.availHeight||1080; }catch(e){ return 1080; } }
  function persist(w,h,rw){ try{ _liveSizePref.w=w; _liveSizePref.h=h; if(rw)_liveSizePref.railW=rw; localStorage.setItem('eoh_live_size', JSON.stringify(_liveSizePref)); }catch(e){} }
  function resizeBy(dw,dh){
    try{
      if(_rail){
        var rw=Math.max(200,Math.min(560,(sz().w)+dw));
        win.resizeTo(rw, availH());
        try{ win.moveTo(availW()-rw-8, 0); }catch(_e){}
        persist((_preRail?_preRail.w:sz().w),(_preRail?_preRail.h:sz().h),rw);
      } else {
        var q=sz();
        var nw=Math.max(240,Math.min(availW(), q.w+dw));
        var nh=Math.max(320,Math.min(availH(), q.h+dh));
        win.resizeTo(nw,nh); persist(nw,nh);
      }
    }catch(e){ console.warn('[Live] resize not supported here:', e.message); }
  }
  function toggleRail(){
    _rail=!_rail;
    var rb=ctrlWrap.querySelector('[data-win="rail"]');
    if(_rail){
      _preRail=sz();
      d.body.classList.add('rail');
      var rw=(_liveSizePref.railW||300);
      try{ win.resizeTo(rw, availH()); win.moveTo(availW()-rw-8, 0); }catch(e){}
      if(rb){ rb.textContent='\u25AD'; rb.title='Exit side-rail mode'; }
    } else {
      d.body.classList.remove('rail');
      var ps=_preRail||{ w:(_liveSizePref.w||380), h:(_liveSizePref.h||640) };
      try{ win.resizeTo(ps.w, ps.h); }catch(e){}
      if(rb){ rb.textContent='\u25AF'; rb.title='Side-rail: full height, narrow width'; }
    }
  }
  ctrlWrap.addEventListener('click', function(e){
    var b=e.target.closest('[data-win]'); if(!b) return;
    e.stopPropagation();
    var a=b.getAttribute('data-win');
    if(a==='w-') resizeBy(-40,0);
    else if(a==='w+') resizeBy(40,0);
    else if(a==='h-') resizeBy(0,-60);
    else if(a==='h+') resizeBy(0,60);
    else if(a==='rail') toggleRail();
  });
}

function stopLiveAudio(){
  if(_liveScreen.abortCtrl){try{_liveScreen.abortCtrl.abort();}catch(e){}_liveScreen.abortCtrl=null;}
  if(_liveScreen.liveAudio){_liveScreen.liveAudio.pause();_liveScreen.liveAudio.src='';_liveScreen.liveAudio=null;}
  _liveScreen.speaking=false;
  if('speechSynthesis' in window)window.speechSynthesis.cancel();
  stopAudio();
}

function liveSpeak(text){
  if(_liveScreen.muted||!text||!_liveScreen.active)return;
  stopLiveAudio();
  var clean=cleanForTTS(text).substring(0, window._voiceLiveMaxChars || 2000);if(!clean)return;
  var lang=detectLanguage(clean);
  var cv=(S._voiceChoice||('cloud:'+(window._voiceDefaultVoice||'Kore'))).replace('cloud:','');
  _liveScreen.speaking=true;
  _liveScreen.abortCtrl=new AbortController();
  window.fetch(API+'/voice/speak',{method:'POST',headers:{'Content-Type':'application/json','Authorization':'Bearer '+S.token},
    body:JSON.stringify({text:clean,voice:cv,speed:S._voiceSpeed||1.0,lang:lang,source:'live'}),signal:_liveScreen.abortCtrl.signal
  }).then(function(r){if(!r.ok||!_liveScreen.active){_liveScreen.speaking=false;return;}
    var ct=r.headers.get('content-type')||'';if(!ct.includes('audio')){_liveScreen.speaking=false;return;}return r.blob();
  }).then(function(bl){if(!bl||_liveScreen.muted||!_liveScreen.active){_liveScreen.speaking=false;return;}
    var u=URL.createObjectURL(bl);_liveScreen.liveAudio=new Audio(u);_liveScreen.liveAudio.play();
    _liveScreen.liveAudio.onended=function(){URL.revokeObjectURL(u);_liveScreen.liveAudio=null;_liveScreen.speaking=false;};
    _liveScreen.liveAudio.onerror=function(){URL.revokeObjectURL(u);_liveScreen.liveAudio=null;_liveScreen.speaking=false;};
  }).catch(function(){_liveScreen.speaking=false;});
}

// Listen for messages from popup
window.addEventListener('message',function(e){
  var d=e.data;if(!d||!d.eoh)return;
  if(d.action==='ask'&&d.text)sendLiveQuestion(d.text,d.lang);
  if(d.action==='setLang'&&d.lang){S._chatLang=d.lang;S._voiceLang=d.lang;console.log('[Live] Lang set:',d.lang);}
  if(d.action==='mic')toggleLiveMic();
  if(d.action==='mute')toggleLiveMute();
  if(d.action==='stopvoice')stopLiveAudio();
  if(d.action==='screenshot')captureLiveScreenshot();
  if(d.action==='end')stopLiveScreen();
});

function buildLivePopup(){
  // Returns a wrapper object with .document, .closed, .close()
  // Uses Document Picture-in-Picture (always-on-top, works across apps)
  // Falls back to regular window.open if PiP not supported
  return null; // async — use buildLivePopupAsync instead
}

async function buildLivePopupAsync(){
  var LANGS=[
    {v:'ar-SA',l:'\u{1F1F8}\u{1F1E6} Arabic'},
    {v:'en-US',l:'\u{1F1FA}\u{1F1F8} English'},
    {v:'fr-FR',l:'\u{1F1EB}\u{1F1F7} French'},
    {v:'de-DE',l:'\u{1F1E9}\u{1F1EA} German'},
    {v:'es-ES',l:'\u{1F1EA}\u{1F1F8} Spanish'},
    {v:'pt-BR',l:'\u{1F1E7}\u{1F1F7} Portuguese'},
    {v:'ru-RU',l:'\u{1F1F7}\u{1F1FA} Russian'},
    {v:'zh-CN',l:'\u{1F1E8}\u{1F1F3} Chinese'},
    {v:'ja-JP',l:'\u{1F1EF}\u{1F1F5} Japanese'},
    {v:'ko-KR',l:'\u{1F1F0}\u{1F1F7} Korean'},
    {v:'tr-TR',l:'\u{1F1F9}\u{1F1F7} Turkish'},
    {v:'hi-IN',l:'\u{1F1EE}\u{1F1F3} Hindi'},
    {v:'it-IT',l:'\u{1F1EE}\u{1F1F9} Italian'},
    {v:'nl-NL',l:'\u{1F1F3}\u{1F1F1} Dutch'}
  ];

  var CSS='*{box-sizing:border-box;margin:0;padding:0}'
    +'body{font-family:-apple-system,BlinkMacSystemFont,sans-serif;background:#0f1019;color:#fff;padding:14px;overflow-y:auto;overflow-x:hidden}'
    +'.hdr{display:flex;align-items:center;gap:8px;position:sticky;top:0;z-index:30;background:#0f1019;margin:-14px -14px 10px;padding:12px 14px 10px;border-bottom:1px solid rgba(255,255,255,.08)}'
    +'.st-spin{display:inline-block;width:12px;height:12px;margin-left:2px;border:2px solid rgba(120,170,255,.3);border-top-color:#5b9dff;border-radius:50%;animation:stspin .7s linear infinite;vertical-align:middle}'
    +'@keyframes stspin{to{transform:rotate(360deg)}}'
    +'.dot{width:9px;height:9px;background:#ef4444;border-radius:50%;animation:p 1s infinite}'
    +'@keyframes p{0%,100%{opacity:1}50%{opacity:.3}}'
    +'.st{font-size:11px;color:#7dd3fc;opacity:.9;margin-left:auto}'
    +'h3{font-size:15px;font-weight:700}'
    +'.lang-row{display:flex;align-items:center;gap:6px;margin-bottom:9px}'
    +'.lang-lbl{font-size:10px;color:rgba(255,255,255,.4);white-space:nowrap;flex-shrink:0}'
    +'select{flex:1;padding:5px 8px;border-radius:7px;border:1px solid rgba(255,255,255,.15);background:rgba(255,255,255,.07);color:#fff;font-size:12px;outline:none;cursor:pointer}'
    +'select option{background:#1a1d2e;color:#fff}'
    +'.qr{display:flex;gap:6px;margin-bottom:8px}'
    +'input{flex:1;padding:9px 12px;border-radius:9px;border:1px solid rgba(255,255,255,.12);background:rgba(255,255,255,.06);color:#fff;font-size:13px;outline:none}'
    +'input:focus{border-color:rgba(239,68,68,.5)}'
    +'.ak{padding:9px 14px;border-radius:9px;border:none;background:#ef4444;color:#fff;font-size:12px;font-weight:700;cursor:pointer}'
    +'.ak:hover{background:#dc2626}'
    +'.note{font-size:10px;color:rgba(255,210,60,.75);background:rgba(255,210,60,.06);border:1px solid rgba(255,210,60,.18);border-radius:6px;padding:6px 10px;margin-bottom:9px;line-height:1.55;text-align:center}'
    +'.row{display:flex;gap:7px;margin-bottom:9px}'
    +'.b{flex:1;height:44px;border-radius:11px;border:1px solid rgba(255,255,255,.1);background:rgba(255,255,255,.05);color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:18px;transition:.15s}'
    +'.b:hover{background:rgba(255,255,255,.12)}'
    +'.b.on{background:rgba(239,68,68,.25);border-color:rgba(239,68,68,.5)}'
    +'.end{background:rgba(239,68,68,.08);border-color:rgba(239,68,68,.25);color:#ef4444;font-size:13px;font-weight:700}'
    +'.end:hover{background:rgba(239,68,68,.2)}'
    +'.ft{font-size:10px;color:rgba(255,255,255,.25);text-align:center;margin-top:8px}';

  function buildHTML(d,closeCallback){
    var style=d.createElement('style');style.textContent=CSS;d.head.appendChild(style);

    // Window size / side-rail control styling + rail layout
    var wcss=d.createElement('style');
    wcss.textContent=
      '.winctrls{display:flex;gap:3px;margin-left:8px;flex:0 0 auto}'
     +'.wc{width:22px;height:22px;border-radius:6px;border:1px solid rgba(255,255,255,.16);background:rgba(255,255,255,.06);color:#fff;font:700 11px -apple-system,sans-serif;cursor:pointer;padding:0;line-height:1;display:flex;align-items:center;justify-content:center}'
     +'.wc:hover{background:rgba(255,255,255,.18)}'
     +'.hdr{display:flex;align-items:center;gap:6px}'
     +'body.rail .winctrls .wc[data-win="h-"],body.rail .winctrls .wc[data-win="h+"]{display:none}'
     +'body.rail .note,body.rail .ft,body.rail #live-timer,body.rail .lang-lbl{display:none}'
     +'body.rail .row{flex-wrap:wrap}'
     +'body.rail .b{flex:1 1 42%;min-width:0}'
     +'body.rail .qr{flex-wrap:wrap}'
     +'body.rail .qr input{min-width:0;flex:1 1 100%}'
     +'body.rail #eohg-cap{font-size:11px}'
     +'body.rail #eohg-task{font-size:12px}';
    d.head.appendChild(wcss);

    // Header
    var hdr=d.createElement('div');hdr.className='hdr';
    var dot=d.createElement('span');dot.className='dot';hdr.appendChild(dot);
    var h3=d.createElement('h3');h3.textContent='EOH Live';hdr.appendChild(h3);
    var st=d.createElement('span');st.className='st';st.id='st';st.textContent='Ready';hdr.appendChild(st);var sp=d.createElement('span');sp.className='st-spin';sp.id='st-spin';sp.style.display='none';hdr.appendChild(sp);

    // Window size + side-rail toggle controls (top-right of the panel)
    var winctrls=d.createElement('div');winctrls.className='winctrls';
    [['w-','\u2013','Narrower'],['w+','+','Wider'],['h-','\u2191','Shorter'],['h+','\u2193','Taller'],['rail','\u25AF','Side-rail: full height, narrow width']].forEach(function(c){
      var b=d.createElement('button');b.className='wc';b.textContent=c[1];b.title=c[2];b.setAttribute('data-win',c[0]);winctrls.appendChild(b);
    });
    hdr.appendChild(winctrls);
    _wireWinControls(d,closeCallback,winctrls);
    d.body.appendChild(hdr);

    // Live session timer row
    var timerRow=d.createElement('div');timerRow.style.cssText='display:flex;align-items:center;justify-content:space-between;padding:5px 2px 8px;border-bottom:1px solid rgba(255,255,255,.06);margin-bottom:8px';
    var timerLbl=d.createElement('span');timerLbl.style.cssText='font-size:10px;color:rgba(255,255,255,.3)';timerLbl.textContent='⏱ Session';timerRow.appendChild(timerLbl);
    var timerVal=d.createElement('span');timerVal.id='live-timer';timerVal.style.cssText='font-size:11px;font-weight:700;font-variant-numeric:tabular-nums;color:rgba(255,255,255,.5)';timerVal.textContent='00:00';timerRow.appendChild(timerVal);
    d.body.appendChild(timerRow);

    // Language selector
    var langRow=d.createElement('div');langRow.className='lang-row';
    var langLbl=d.createElement('span');langLbl.className='lang-lbl';langLbl.textContent='\uD83C\uDF99\uFE0F Mic Lang:';
    langRow.appendChild(langLbl);
    var langSel=d.createElement('select');langSel.id='live-lang';
    var curLang=S._chatLang||'en-US';
    LANGS.forEach(function(lg){
      var op=d.createElement('option');op.value=lg.v;op.textContent=lg.l;
      if(lg.v===curLang||lg.v.split('-')[0]===curLang.split('-')[0])op.selected=true;
      langSel.appendChild(op);
    });
    langSel.addEventListener('change',function(){
      S._chatLang=langSel.value;S._voiceLang=langSel.value;
      console.log('[Live] Lang set:',langSel.value);
    });
    langRow.appendChild(langSel);
    d.body.appendChild(langRow);

    // Ask input row
    var qr=d.createElement('div');qr.className='qr';
    var qi=d.createElement('input');qi.id='q';qi.placeholder='Ask about your screen...';
    qr.appendChild(qi);
    var ab=d.createElement('button');ab.className='ak';ab.textContent='Ask';
    qr.appendChild(ab);
    d.body.appendChild(qr);

    // Note
    var note=d.createElement('div');note.className='note';
    note.innerHTML='\u23F1\uFE0F AI voice response takes <strong>1\u201310 sec</strong> while analyzing your screen.';
    d.body.appendChild(note);

    // Row 1 buttons
    var r1=d.createElement('div');r1.className='row';
    [['mic','\u{1F3A4}','Speak to AI'],['mute','\u{1F50A}','Mute AI'],['stopvoice','\u23F9','Stop voice']].forEach(function(cfg){
      var b=d.createElement('button');b.className='b';b.id=cfg[0];b.textContent=cfg[1];b.title=cfg[2];
      b.setAttribute('data-action',cfg[0]);r1.appendChild(b);
    });
    d.body.appendChild(r1);

    // Row 2 buttons
    var r2=d.createElement('div');r2.className='row';
    var ssB=d.createElement('button');ssB.className='b';ssB.id='ss';ssB.textContent='\u{1F4F8}';ssB.title='Screenshot';
    ssB.setAttribute('data-action','screenshot');r2.appendChild(ssB);
    var endB=d.createElement('button');endB.className='b end';endB.id='endbtn';endB.textContent='End Session';
    endB.setAttribute('data-action','end');r2.appendChild(endB);
    d.body.appendChild(r2);

    var ft=d.createElement('div');ft.className='ft';ft.textContent='Always on top \u2022 Drag to reposition';
    d.body.appendChild(ft);

    // Wire events — directly call parent functions (same JS context for PiP, postMessage for fallback)
    ab.addEventListener('click',function(){
      var v=qi.value.trim();if(!v)return;qi.value='';qi.focus();
      var lang=langSel.value;
      if(closeCallback){S._chatLang=lang;S._voiceLang=lang;sendLiveQuestion(v,lang);}
      else{window.opener.postMessage({eoh:true,action:'ask',text:v,lang:lang},window.location.origin);}
    });
    qi.addEventListener('keydown',function(e){
      if(e.key==='Enter'){var v=qi.value.trim();if(!v)return;qi.value='';qi.focus();
        var lang=langSel.value;
        if(closeCallback){S._chatLang=lang;S._voiceLang=lang;sendLiveQuestion(v,lang);}
        else{window.opener.postMessage({eoh:true,action:'ask',text:v,lang:lang},window.location.origin);}
      }
    });
    d.body.addEventListener('click',function(e){
      var btn=e.target.closest('[data-action]');if(!btn)return;
      var action=btn.getAttribute('data-action');
      var lang=langSel.value;
      if(closeCallback){
        // Direct calls — same JS context as parent
        S._chatLang=lang;S._voiceLang=lang;
        if(action==='mic')toggleLiveMic();
        else if(action==='mute')toggleLiveMute();
        else if(action==='stopvoice')stopLiveAudio();
        else if(action==='screenshot')captureLiveScreenshot();
        else if(action==='end'){stopLiveScreen();}  // stopLiveScreen handles popup.close() itself
      } else {
        window.opener.postMessage({eoh:true,action:action,lang:lang},window.location.origin);
      }
    });

    // EOH Live Guide: inject preview + caption bar + step controls + "Guide me"
    // EOH Live Guide + Live Screen panel: mount into this popup document.
    // If the guide client (live-screen-guide.client.js) or the understanding layer
    // (eoh-live-screen.js) hasn't finished loading yet, the popup would silently come up
    // with the OLD bare UI. Retry briefly until they're available, and log the outcome.
    (function _mountGuideWhenReady(){
      var tries = 0;
      (function attempt(){
        tries++;
        try {
          if (window.EOHGuide) {
            window.EOHGuide.mountPanel(d);
            try {
              var _ls = !!(d.getElementById && d.getElementById('eohls-panel'));
              console.log('[Live] guide mounted (attempt ' + tries + ') — Live Screen panel: ' + (_ls ? 'YES' : 'NO (understanding layer not active)'));
            } catch(_) {}
            return;
          }
        } catch(e){ console.warn('[Live] guide mount error:', e.message); return; }
        if (tries < 40) setTimeout(attempt, 150);
        else console.warn('[Live] EOHGuide never loaded — check live-screen-guide.client.js is deployed (dotted asset name).');
      })();
    })();

    // Ensure the panel scrolls so tall content never hides the mic/End row
    try { d.documentElement.style.height='100%'; d.body.style.height='100%'; d.body.style.overflowY='auto'; d.body.style.overflowX='hidden'; }catch(e){}
  }

  // ── Try Document Picture-in-Picture (always on top, works across apps) ──
  if(window.documentPictureInPicture){
    try{
      var pipWin=await window.documentPictureInPicture.requestWindow({width:(_liveSizePref.w||380),height:(_liveSizePref.h||640)});
      var d=pipWin.document;
      d.title='EOH Live';
      buildHTML(d,function(){try{pipWin.close();}catch(e){}});
      // pipWin.closed is a real property, wrap in compatible object
      var wrapper={
        document:d,
        get closed(){return !window.documentPictureInPicture.window;},
        close:function(){try{pipWin.close();}catch(e){}},
        _isPiP:true
      };
      pipWin.addEventListener('pagehide',function(){stopLiveScreen();});
      console.log('[Live] Using Document PiP — always on top');
      return wrapper;
    }catch(e){
      console.warn('[Live] PiP failed:',e.message,'— falling back to popup');
    }
  }

  // ── Fallback: regular window.open ──
  var pw=(_liveSizePref.w||380),ph=(_liveSizePref.h||640),px=window.screen.width-pw-50,py=window.screen.height-ph-100;
  var w=window.open('about:blank','EOH_Live','width='+pw+',height='+ph+',left='+px+',top='+py+',toolbar=no,menubar=no,scrollbars=no,resizable=yes');
  if(!w)return null;
  var d=w.document;
  d.title='EOH Live';
  buildHTML(d,null);
  var parentOrigin=window.location.origin;
  console.log('[Live] Using fallback popup window');
  return w;
}



async function startLiveScreen(){
  if(!S.user||!S.token){showModal('login');return;}
  if(_liveScreen.active){stopLiveScreen();return;}
  // ── PLAN CHECK ──
  var planKey=(S.user&&S.user.plan)||'free';
  var hasLive=(getLimits().screen>0)||(VOICE_CONFIG[planKey]&&!!VOICE_CONFIG[planKey].live);
    if(isPlanExpired()){showExpiredPopup();return;}
  if(!hasLive){showUpgrade('screen','📹 LIVE SCREEN NOT INCLUDED — Upgrade to use Live Screen');return;}
  var _sUsage=getUsage();var _sLimits=getLimits();
  if((_sLimits.screen||0)>0&&(_sUsage.screen||0)>=_sLimits.screen){
    showUpgrade('screen','📹 LIVE SCREEN LIMIT REACHED — '+Math.floor(_sUsage.screen)+'/'+_sLimits.screen+' mins used this month');return;
  }
  try{_liveScreen.stream=await navigator.mediaDevices.getDisplayMedia({video:{frameRate:{ideal:1,max:5},width:{ideal:1280},height:{ideal:720}}});}catch(e){return;}
  _liveScreen.active=true;_liveScreen.frameCount=0;_liveScreen.startTime=Date.now();
  startLimTicker(); // ensure ticker is running for live counter
  stopAudio();if('speechSynthesis' in window)window.speechSynthesis.cancel();

  _liveScreen.popup=await buildLivePopupAsync();
  if(!_liveScreen.popup){addMsg('assistant','Could not open EOH Live panel. Please allow popups or use Chrome 116+ for the always-on-top mode.',null);stopLiveScreen();return;}

  ['live-header-btn','live-btn'].forEach(function(id){var b=document.getElementById(id);if(b){b.style.background='rgba(239,68,68,.15)';b.style.color='#ef4444';b.style.borderColor='#ef4444';}});
  var isPiP=_liveScreen.popup._isPiP;
  addMsg('assistant',isPiP
    ?'Live Screen active — EOH Live is now always on top. Switch to any app and use the mic freely.'
    :'Live Screen active. Drag the EOH Live window to your desktop. Use mic or type to ask about your screen.',null);
  _liveScreen.stream.getVideoTracks()[0].addEventListener('ended',stopLiveScreen);
  // ── LIVE USAGE POLLING — check limit every 15s while session is active ──
  var _liveWatcher=setInterval(function(){
    if(!_liveScreen.active){clearInterval(_liveWatcher);return;}
    var _u=getUsage();var _l=getLimits();
    if((_l.screen||0)>0&&(_u.screen||0)>=_l.screen){
      clearInterval(_liveWatcher);
      addMsg('assistant','⛔ Live Screen limit reached (≈'+Math.floor(_u.screen)+'/'+_l.screen+' mins). Session ended automatically.',null);
      stopLiveScreen();
    }
  },3000);
  _liveScreen._watcher=_liveWatcher;

  // ── Periodic screen DB save every 30s — survives mid-session refresh ──
  var _screenSaveInterval = setInterval(function() {
    if (!_liveScreen.active || !_liveScreen.startTime) { clearInterval(_screenSaveInterval); return; }
    var _elapsedMins = parseFloat(((Date.now() - _liveScreen.startTime) / 60000).toFixed(2));
    var _screenCap   = (getLimits().screen > 0) ? getLimits().screen * 2 : 120;
    var _toCommit    = parseFloat(Math.min((S_USAGE.screen || 0) + _elapsedMins, _screenCap).toFixed(2));
    if (_toCommit > (S_USAGE.screen || 0)) {
      window.fetch(API + '/profile/sync-usage', {
        method:  'POST',
        headers: {'Content-Type':'application/json', 'Authorization':'Bearer ' + S.token},
        body:    JSON.stringify({ screen_mins_used: _toCommit, client_reset_date: S._lastResetDate || null })
      }).catch(function(){});  // fire-and-forget — stopLiveScreen does the authoritative commit
      console.log('[Live] Periodic screen save:', _toCommit, 'mins');
    }
  }, 30000);
  _liveScreen._screenSaveInterval = _screenSaveInterval;

  // Watch for popup close (only needed for fallback window — PiP handles via pagehide)
  if(!isPiP){
    var popWatch=setInterval(function(){
      if(!_liveScreen.active){clearInterval(popWatch);return;}
      if(!_liveScreen.popup||_liveScreen.popup.closed){clearInterval(popWatch);stopLiveScreen();}
    },1000);
  }
}

async function sendLiveQuestion(qText,qLang){
  var question=qText||'';
  if(qLang){S._chatLang=qLang;S._voiceLang=qLang;}
  if(!question||!_liveScreen.active||!_liveScreen.stream)return;
  // If a Live Guide is running, treat this as a correction/note/question on the current step.
  if(window.EOHGuide && window.EOHGuide.plan){ window.EOHGuide.correct(question,qLang); return; }
  // ── Check screen limit before each frame ──
  var _sq=getUsage();var _sl=getLimits();
  if((_sl.screen||0)>0&&(_sq.screen||0)>=_sl.screen){
    addMsg('assistant','⛔ Live Screen limit reached ('+Math.floor(_sq.screen)+'/'+_sl.screen+' mins). Session ended.',null);
    stopLiveScreen();return;
  }
  stopLiveAudio();
  addMsg('user',question,null);S.history.push({role:'user',content:question});
  if(_liveScreen.popup&&!_liveScreen.popup.closed){try{_liveScreen.popup.document.getElementById('st').textContent='Analyzing...';}catch(e){}}
  try{
    var track=_liveScreen.stream.getVideoTracks()[0];
    if(!track||track.readyState!=='live'){stopLiveScreen();return;}
    var video=document.createElement('video');video.srcObject=_liveScreen.stream;video.muted=true;await video.play();
    var canvas=document.createElement('canvas');canvas.width=Math.min(video.videoWidth,1280);canvas.height=Math.min(video.videoHeight,720);
    canvas.getContext('2d').drawImage(video,0,0,canvas.width,canvas.height);video.pause();video.srcObject=null;
    var b64=canvas.toDataURL('image/jpeg',0.6);_liveScreen.frameCount++;
    showTyping();
    var res=await window.fetch(API+'/voice/screen',{method:'POST',headers:{'Content-Type':'application/json','Authorization':'Bearer '+S.token},
      body:JSON.stringify({image:b64,question:question,vendor:S.vendor,product:S.product,lang:S._chatLang||'en-US'})});
    removeTyping();var data=await res.json();
    if(_liveScreen.popup&&!_liveScreen.popup.closed){try{_liveScreen.popup.document.getElementById('st').textContent='Frame '+_liveScreen.frameCount;}catch(e){}}
    if(data.analysis){addMsg('assistant',data.analysis,null);S.history.push({role:'assistant',content:data.analysis});liveSpeak(data.analysis);}
    if(data.error&&data.error.includes('limit')){addMsg('assistant','Screen sharing limit reached.',null);stopLiveScreen();}
  }catch(e){removeTyping();addMsg('assistant','Analysis failed.',null);}
}

async function captureLiveScreenshot(){
  if(!_liveScreen.active||!_liveScreen.stream)return;
  try{
    var video=document.createElement('video');video.srcObject=_liveScreen.stream;video.muted=true;await video.play();
    var canvas=document.createElement('canvas');canvas.width=video.videoWidth;canvas.height=video.videoHeight;
    canvas.getContext('2d').drawImage(video,0,0);video.pause();video.srcObject=null;
    var b64=canvas.toDataURL('image/png');
    S._lastUploadedImages=[b64];S.filesContent=[{name:'live-screenshot.png',base64:b64,ext:'png'}];
    S.file=new File([b64],'live-screenshot.png');S.fileContent='[Screenshot from live screen]';
    document.getElementById('ufile-name').textContent='live-screenshot.png';
    document.getElementById('ufile-size').textContent='Ready';
    document.getElementById('upload-bar').style.display='flex';
    addMsg('assistant','Screenshot captured and attached to chat.',null);
  }catch(e){console.error('[Live]',e.message);}
}

function stopLiveScreen(){
  try { if(window.EOHGuide) window.EOHGuide.reset(); } catch(e){}
  // Guard: only run once per session
  if(!_liveScreen.active && !_liveScreen.stream) return;

  // ── Stop the watcher + periodic save interval first ──
  if(_liveScreen._watcher){clearInterval(_liveScreen._watcher);_liveScreen._watcher=null;}
  if(_liveScreen._screenSaveInterval){clearInterval(_liveScreen._screenSaveInterval);_liveScreen._screenSaveInterval=null;}

  // ── Commit elapsed time to usage before clearing startTime ──
  if(_liveScreen.startTime){
    var _rawMins = (Date.now() - _liveScreen.startTime) / 60000;
    // Sanity cap: never write more than plan limit × 2 or 120 mins absolute — prevents DB corruption
    var _screenCap = (getLimits().screen > 0) ? (getLimits().screen * 2) : 120;
    var mins = parseFloat(Math.min(_rawMins, _screenCap).toFixed(2));
    if(mins > 0 && mins < _screenCap){  // reject anything that exceeds cap (bad clock / bad startTime)
      S_USAGE.screen = parseFloat(((S_USAGE.screen || 0) + mins).toFixed(2));
      if(S.user) S.user.screenMinsUsed = S_USAGE.screen;
      saveUsage();
      // Persist IMMEDIATELY and directly (no 200ms debounce). The debounced
      // syncAllUsageToServer() could be dropped if the user refreshes/closes the tab
      // right after stopping — which is exactly why a 1-min session reverted to 0.
      // keepalive:true lets the browser finish the request even during page unload.
      if (S.user && S.token) {
        try {
          window.fetch(API + '/profile/sync-usage', {
            method:  'POST',
            keepalive: true,
            headers: {'Content-Type':'application/json', 'Authorization':'Bearer ' + S.token},
            body:    JSON.stringify({ screen_mins_used: parseFloat((S_USAGE.screen || 0).toFixed(2)), client_reset_date: S._lastResetDate || null })
          }).then(function(r){ return r.json(); }).then(function(d){
            if (d && d.ok && d.usage && d.usage.screen_mins_used !== undefined) {
              S_USAGE.screen = d.usage.screen_mins_used;
              if (S.user) S.user.screenMinsUsed = d.usage.screen_mins_used;
              saveUsage(); updateLimits();
            }
          }).catch(function(){});
        } catch(_) {}
      }
    }
    _liveScreen.startTime = null;
  }

  // ── Mark inactive immediately so re-entrant calls exit ──
  _liveScreen.active = false;
  _liveScreen.muted  = false;
  _liveScreen.speaking = false;

  // ── Stop audio + mic ──
  stopLiveAudio();
  if(_liveScreen.micRecog){try{_liveScreen.micRecog.stop();}catch(e){}_liveScreen.micRecog=null;}

  // ── Stop screen capture stream (this removes the browser share-screen indicator) ──
  if(_liveScreen.stream){
    try{_liveScreen.stream.getTracks().forEach(function(t){t.stop();});}catch(e){}
    _liveScreen.stream=null;
  }

  // ── Close popup / PiP window ──
  if(_liveScreen.popup){
    try{if(!_liveScreen.popup.closed)_liveScreen.popup.close();}catch(e){}
    _liveScreen.popup=null;
  }

  // ── Reset button styles ──
  ['live-header-btn','live-btn'].forEach(function(id){
    var b=document.getElementById(id);
    if(b){b.style.background='';b.style.color='';b.style.borderColor='';b.disabled=false;b.style.opacity='';}
  });

  var frames = _liveScreen.frameCount || 0;
  _liveScreen.frameCount = 0;
  updateLimits();
  addMsg('assistant','Live Screen ended. '+frames+' frames analyzed.',null);
}

function toggleLiveMute(){
  _liveScreen.muted=!_liveScreen.muted;
  if(_liveScreen.popup&&!_liveScreen.popup.closed){
    try{var b=_liveScreen.popup.document.getElementById('mute');
      b.textContent=_liveScreen.muted?'\u{1F507}':'\u{1F50A}';
      if(_liveScreen.muted)b.classList.add('on');else b.classList.remove('on');}catch(e){}
  }
  if(_liveScreen.muted)stopLiveAudio();
}

function toggleLiveMic(){
  var popBtn=null;
  if(_liveScreen.popup&&!_liveScreen.popup.closed){try{popBtn=_liveScreen.popup.document.getElementById('mic');}catch(e){}}
  // Stop AI voice immediately so user has clear space to speak
  stopLiveAudio();
  if(_liveScreen.micRecog){try{_liveScreen.micRecog.stop();}catch(e){}_liveScreen.micRecog=null;if(popBtn)popBtn.classList.remove('on');return;}
  var SR=window.SpeechRecognition||window.webkitSpeechRecognition;if(!SR)return;
  _liveScreen.micRecog=new SR();_liveScreen.micRecog.continuous=true;_liveScreen.micRecog.interimResults=true;
  // Empty string = browser auto-detects language from speech
  // Read language directly from popup dropdown — ensures correct lang e.g. Arabic
  var liveLangSel=null;
  if(_liveScreen.popup&&!_liveScreen.popup.closed){try{liveLangSel=_liveScreen.popup.document.getElementById('live-lang');}catch(e){}}
  var micLang=(liveLangSel&&liveLangSel.value)?liveLangSel.value:(S._chatLang||'en-US');
  _liveScreen.micRecog.lang=micLang;if(popBtn)popBtn.classList.add('on');
  console.log('[LiveMic] Using lang:',micLang);
  var silenceTimer=null,finalText='';
  _liveScreen.micRecog.onresult=function(e){
    clearTimeout(silenceTimer);var interim='';finalText='';
    for(var i=0;i<e.results.length;i++){if(e.results[i].isFinal)finalText+=e.results[i][0].transcript;else interim+=e.results[i][0].transcript;}
    // Auto-detect language from transcript and update S so AI replies in same language
    if(finalText.trim()){var detLang=detectLanguage(finalText);if(detLang&&detLang!==S._chatLang){S._chatLang=detLang;S._voiceLang=detLang;console.log('[LiveMic] Auto-detected lang:',detLang);}}
    if(_liveScreen.popup&&!_liveScreen.popup.closed){try{_liveScreen.popup.document.getElementById('q').value=finalText+interim;}catch(ex){}}
    silenceTimer=setTimeout(function(){if(finalText.trim()){if(_liveScreen.popup&&!_liveScreen.popup.closed){try{_liveScreen.popup.document.getElementById("q").value="";}catch(ex){}}sendLiveQuestion(finalText.trim());finalText="";}try{_liveScreen.micRecog.stop();}catch(ex){}},1500);
  };
  _liveScreen.micRecog.onend=function(){clearTimeout(silenceTimer);if(finalText.trim()){if(_liveScreen.popup&&!_liveScreen.popup.closed){try{_liveScreen.popup.document.getElementById("q").value="";}catch(ex){}}sendLiveQuestion(finalText.trim());}_liveScreen.micRecog=null;if(popBtn)popBtn.classList.remove("on");};
  _liveScreen.micRecog.onerror=function(err){clearTimeout(silenceTimer);
    // If auto-detect fails (lang=''), retry with user's current lang
    if(err.error==='language-not-supported'||err.error==='no-speech'){
      _liveScreen.micRecog=null;if(popBtn)popBtn.classList.remove('on');
      // Restart with explicit language
      var SR2=window.SpeechRecognition||window.webkitSpeechRecognition;if(!SR2)return;
      _liveScreen.micRecog=new SR2();_liveScreen.micRecog.continuous=true;_liveScreen.micRecog.interimResults=true;
      _liveScreen.micRecog.lang=S._chatLang||'en-US';if(popBtn)popBtn.classList.add('on');
      _liveScreen.micRecog.onresult=arguments.callee.caller;// reuse
      _liveScreen.micRecog.onerror=function(){_liveScreen.micRecog=null;if(popBtn)popBtn.classList.remove('on');};
      try{_liveScreen.micRecog.start();}catch(ex){}
    } else { _liveScreen.micRecog=null;if(popBtn)popBtn.classList.remove('on'); }
  };
  _liveScreen.micRecog.start();
}

// -- CAMERA --------------------------------------------------------------------
function openCamera() {
  var overlay = document.createElement('div');
  overlay.id = 'cam-overlay';
  overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.9);z-index:2000;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px';
  overlay.innerHTML = '<video id="cam-video" autoplay playsinline style="max-width:90vw;max-height:60vh;border-radius:10px;border:2px solid #0fb574"></video>'
    + '<div style="display:flex;gap:12px">'
    + '<button onclick="capturePhoto()" style="padding:12px 28px;background:linear-gradient(135deg,#0A8A5F,#0A4FCC);color:white;border:none;border-radius:8px;font-size:14px;font-weight:600;cursor:pointer">&#128247; Capture</button>'
    + '<button onclick="closeCamera()" style="padding:12px 28px;background:#1c2135;color:#e8edf5;border:1px solid rgba(255,255,255,.1);border-radius:8px;font-size:14px;cursor:pointer">Cancel</button>'
    + '</div>';
  document.body.appendChild(overlay);
  navigator.mediaDevices.getUserMedia({video: true}).then(function(stream) {
    document.getElementById('cam-video').srcObject = stream;
    window._camStream = stream;
  }).catch(function() { closeCamera(); alert('Camera access denied or not available.'); });
}

function capturePhoto() {
  var video = document.getElementById('cam-video');
  var canvas = document.createElement('canvas');
  canvas.width = video.videoWidth; canvas.height = video.videoHeight;
  canvas.getContext('2d').drawImage(video, 0, 0);
  closeCamera();
  canvas.toBlob(function(blob) {
    var file = new File([blob], 'camera-photo.png', {type: 'image/png'});
    S.file = file;
    document.getElementById('ufile-name').textContent = 'camera-photo.png';
    document.getElementById('ufile-size').textContent = '(' + (blob.size/1024).toFixed(1) + ' KB) ✓';
    document.getElementById('upload-bar').style.display = 'flex';
    // Upload camera photo for AI vision extraction
    var camForm = new FormData();
    camForm.append('file', file);
    window.fetch(API + '/upload/extract', {method:'POST', headers:{'Authorization':'Bearer '+(S.token||'')}, body:camForm})
      .then(function(r){return r.json();})
      .then(function(d){ if(d.content) S.fileContent = d.content; })
      .catch(function(){ S.fileContent = '[Camera photo - describe what you see]'; });
  }, 'image/png');
}

function closeCamera() {
  if (window._camStream) { window._camStream.getTracks().forEach(function(t) { t.stop(); }); window._camStream = null; }
  var o = document.getElementById('cam-overlay'); if (o) o.remove();
}

// -- SHARE CONVERSATION --------------------------------------------------------
function shareConversation() {
  if (!S.history.length) { alert('No conversation to share yet. Start chatting first!'); return; }
  var text = S.vendor + ' - ' + S.product + ' Support Chat\n\n'
    + S.history.map(function(m) {
        return (m.role === 'user' ? 'You: ' : 'AI: ') + m.content.substring(0, 200);
      }).join('\n\n');
  if (navigator.share) {
    navigator.share({title: 'ERP Online Hub - ' + S.product + ' Support', text: text});
  } else {
    navigator.clipboard.writeText(text).then(function() {
      alert('Conversation copied to clipboard! You can paste it anywhere.');
    }).catch(function() { alert('Could not copy. Please use the export option instead.'); });
  }
}


// -- SEND TO EMAIL -------------------------------------------------------------
function sendToEmail() {
  if (!S.history.length) { alert('No conversation to send yet.'); return; }
  var subject = encodeURIComponent('ERP Online Hub - ' + (S.vendor||'') + ' ' + (S.product||'') + ' Support Chat');
  var body = S.history.map(function(m) {
    return (m.role === 'user' ? 'YOU: ' : 'EOH AI: ') + m.content.substring(0, 500);
  }).join('%0A%0A');
  window.open('mailto:?subject=' + subject + '&body=' + body);
}

// -- GENERATE POWERPOINT VIA CHAT ----------------------------------------------
function detectPPTXIntent(msg) {
  var lower = msg.toLowerCase();
  var hasPPT = lower.includes('powerpoint') || lower.includes('pptx') || lower.includes('presentation') || lower.includes('slides');
  if (!hasPPT) return false;
  var keys = ['create','generate','make','build','prepare','design','write','produce'];
  for (var i = 0; i < keys.length; i++) { if (lower.includes(keys[i])) return true; }
  return false;
}




// ==============================================================================
// SESSION PERSISTENCE
// ==============================================================================

function saveNow() {
  if (S.history && S.history.length >= 1 && S.user) saveCurrentSession();
}

async function saveCurrentSession(skipRefresh) {
  if (!S.user || !S.token || !S.history || S.history.length === 0) return;
  if (_saving) { _pendingSave = true; _pendingSkip = !!skipRefresh; return; }
  _saving = true;
  _pendingSave = false;

  // Attach the latest cited sources to the newest assistant message so the
  // context drawer's resources persist across refresh (beats the render-hook race).
  try {
    if (window._eohLastSources && window._eohLastSources.length && S.history) {
      for (var _si = S.history.length - 1; _si >= 0; _si--) {
        if (S.history[_si].role === 'assistant') { if (!S.history[_si].sources) S.history[_si].sources = window._eohLastSources; break; }
      }
    }
  } catch (_) {}

  // ★ CRITICAL: Snapshot sessionId, history and context RIGHT NOW before any await.
  // Async delays (100ms retries, fetch latency) mean S_sessionId/S.history can change
  // by the time the fetch fires — causing session B's content to overwrite session A.
  var _snapSessionId = S_sessionId || null;
  var _snapVendor    = S.vendor  || 'SAP';
  var _snapProduct   = S.product || 'S/4HANA';
  var fullMessages = S.history.map(function(m) {
    var content = (m.content || '')
      .replace(/data:[a-z/]+;base64,[A-Za-z0-9+/=]{20,}/g, '[attachment]')
      .replace(/\u0000/g, '')
      .replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, '')
      .replace(/[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?<![\uD800-\uDBFF])[\uDC00-\uDFFF]/g, '');
    if (content.length > 15000) content = content.substring(0, 15000) + '\n[trimmed]';
    var msg = { role: m.role, content: content, timestamp: m.timestamp || new Date().toISOString() };
    if (m.file) msg.file = { name: m.file.name||'', size: m.file.size||0, type: m.file.type||'' };
    if (m.exportFile && typeof m.exportFile==='object') msg.exportFile = { fileName: m.exportFile.fileName||'', format: m.exportFile.format||'' };
    if (m.attachments && m.attachments.length) msg.attachments = m.attachments.map(function(a){ return { kind:a.kind, key:a.key, name:a.name, mime:a.mime, size:a.size }; });
    if (m.sources && m.sources.length) msg.sources = m.sources.map(function(s){ return { title:s.title||'', url:s.url||'', source:s.source||'' }; }).filter(function(s){ return s.url; }).slice(0,15);
    if (m._fileContent) { var _ft = String(m._fileContent); msg.fileText = _ft.length > 15000 ? _ft.substring(0,15000)+'\n[trimmed]' : _ft; }
    // Persist the exported CV draft so "make it formal" continuity survives a reload.
    if (m._resumeDraft) { var _rd = String(m._resumeDraft); msg.resumeDraft = _rd.length > 15000 ? _rd.substring(0,15000)+'\n[trimmed]' : _rd; }
    return msg;
  });
  var _payload;
  try { _payload = JSON.stringify({ sessionId: _snapSessionId, messages: fullMessages, vendor: _snapVendor, product: _snapProduct, resumeState: S.resumeState || null, docState: S.docState || null }); }
  catch(_je) { console.error('Session save skipped:', _je.message); _saving=false; return; }

  try {
    var res = await window.fetch(API + '/sessions', {
      method: 'POST',
      headers: {'Content-Type':'application/json','Authorization':'Bearer ' + S.token},
      body: _payload
    });
    if (res.ok) {
      var d = await res.json();
      // Only update S_sessionId if we saved the session that's currently active
      // (prevents overwriting S_sessionId after a session switch)
      if (d.session && (S_sessionId === _snapSessionId || !_snapSessionId)) {
        S_sessionId = d.session.id;
      }
      // Only refresh sidebar list when NOT just switching chats
      if (!skipRefresh) _debouncedRefresh();
    } else {
      console.error('Save failed:', res.status, await res.text().catch(function(){return '';}));
    }
  } catch(e) { console.error('Save error:', e); }
  finally {
    _saving = false;
    if (_pendingSave) {
      var sk = _pendingSkip;
      _pendingSave = false; _pendingSkip = false;
      setTimeout(function(){ saveCurrentSession(sk); }, 100);
    }
  }
}

// ★ Debounced sidebar refresh - prevents hammering the API
var _refreshTimer = null;
function _debouncedRefresh() {
  clearTimeout(_refreshTimer);
  _refreshTimer = setTimeout(loadSessions, 500);
}

// -- Load sessions list ------------------------------------------------------
async function loadSessions() {
  if (!S.user || !S.token) return;
  var el = document.getElementById('hlist');
  if (!el) return;
  // Show skeleton only if empty
  if (!_sessionsCache.length) {
    el.innerHTML = '<div style="padding:4px 0">';
    for (var sk=0; sk<4; sk++) el.innerHTML += '<div class="hist-skel-item"><div class="hist-skel-c"></div><div class="hist-skel-l"><div class="hist-skel-r" style="width:75%"></div><div class="hist-skel-r" style="width:45%"></div></div></div>';
    el.innerHTML += '</div>';
  }
  try {
    var res = await window.fetch(API + '/sessions', { headers: {'Authorization':'Bearer ' + S.token} });

    // 401: token expired → refresh once and retry
    if (res.status === 401) {
      var _srt = localStorage.getItem('eoh_rt');
      if (_srt) {
        try {
          var _srr = await window.fetch(API + '/auth/refresh', {
            method:'POST', headers:{'Content-Type':'application/json'},
            credentials: 'include',
            body: JSON.stringify({refresh_token: _srt})
          });
          var _srd = await _srr.json();
          if (_srd.token) {
            S.token = _srd.token; localStorage.setItem('eoh_t', _srd.token);
            if (_srd.refresh_token) localStorage.setItem('eoh_rt', _srd.refresh_token);
            if (_srd.user) { _mergeUser(_srd.user); localStorage.setItem('eoh_u', JSON.stringify(S.user)); }
            res = await window.fetch(API + '/sessions', { headers: {'Authorization':'Bearer ' + S.token} });
          }
        } catch(e2) { /* network error — fall through */ }
      }
    }

    if (!res.ok) { el.innerHTML = ''; return; }
    var d = await res.json();
    _sessionsCache = d.sessions || [];
    _renderList(_sessionsCache);
  } catch(e) { _sessionsCache = []; el.innerHTML = ''; }
}

// -- Search ------------------------------------------------------------------
function _onSearch(q) {
  _searchQ = (q||'').trim().toLowerCase();
  document.getElementById('hist-clear-btn').classList.toggle('on', _searchQ.length > 0);
  if (!_searchQ) { _renderList(_sessionsCache); return; }
  _renderList(_sessionsCache.filter(function(s) {
    return (s.title||'').toLowerCase().includes(_searchQ) || (s.last_message||'').toLowerCase().includes(_searchQ)
      || (s.vendor||'').toLowerCase().includes(_searchQ) || (s.product||'').toLowerCase().includes(_searchQ);
  }));
}
function _clearSearch() {
  var inp = document.getElementById('hist-search'); if (inp) inp.value = '';
  _searchQ = ''; document.getElementById('hist-clear-btn').classList.remove('on');
  _renderList(_sessionsCache);
}

// -- Render session list with date grouping ----------------------------------
function _renderList(sessions) {
  var el = document.getElementById('hlist');
  if (!el) return;
  el.innerHTML = '';

  var ft = document.getElementById('hist-footer');
  if (ft) { if (sessions.length) { ft.textContent = sessions.length + ' chat' + (sessions.length!==1?'s':''); ft.classList.add('on'); } else ft.classList.remove('on'); }

  if (!sessions.length) {
    el.innerHTML = '<div class="hist-empty">' + (_searchQ ? '&#128270; No results for "'+_searchQ+'"' : '&#128488; No chats yet<br>Start a conversation to see it here') + '</div>';
    return;
  }

  // Group by date
  var now = new Date(), today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  var yest = new Date(today); yest.setDate(yest.getDate()-1);
  var week = new Date(today); week.setDate(week.getDate()-7);
  var month = new Date(today); month.setDate(month.getDate()-30);
  var groups = {'Today':[],'Yesterday':[],'This Week':[],'This Month':[],'Older':[]};

  sessions.forEach(function(s) {
    var d = new Date(s.updated_at || s.created_at);
    if (d >= today) groups['Today'].push(s);
    else if (d >= yest) groups['Yesterday'].push(s);
    else if (d >= week) groups['This Week'].push(s);
    else if (d >= month) groups['This Month'].push(s);
    else groups['Older'].push(s);
  });

  ['Today','Yesterday','This Week','This Month','Older'].forEach(function(label) {
    if (!groups[label].length) return;
    var hdr = document.createElement('div'); hdr.className = 'hist-dg'; hdr.textContent = label;
    el.appendChild(hdr);
    groups[label].forEach(function(s) { el.appendChild(_buildItem(s)); });
  });
}

function _buildItem(s) {
  var el = document.createElement('div');
  el.className = 'ch-item' + (s.id === S_sessionId ? ' active' : '');
  el.dataset.sid = s.id;

  // Strip a leading attachment emoji (📎/📄) so file-started chats read cleanly in the list
  // ("📎 17.xlsx" → "17.xlsx") and don't clash with the vendor badge.
  var title = (s.title || 'New Chat').replace(/^\s*[\u{1F4CE}\u{1F4C4}\u{1F587}\uFE0F]+\s*/u, '').trim();
  title = (title || 'New Chat').substring(0, 42);
  var preview = (s.last_message || '').substring(0, 50);
  var count = s.message_count || 0;
  var icon = _vendorIcon(s.vendor);
  var d = new Date(s.updated_at || s.created_at);
  var date = _relDate(d);
  var pinHtml = s.pinned ? '<span class="ch-pin">&#128204;</span>' : '';
  var cntHtml = count > 0 ? '<span class="ch-cnt">' + count + '</span>' : '';

  el.innerHTML = '<div class="ch-icon">' + icon + '</div>'
    + '<div class="ch-body">'
    + '<div class="ch-title">' + _esc(title) + '</div>'
    + (preview ? '<div class="ch-preview">' + _esc(preview) + '</div>' : '')
    + '<div class="ch-meta"><span class="ch-date">' + date + '</span>' + pinHtml + cntHtml + '</div>'
    + '</div>'
    + '<div class="ch-actions"><button class="ch-act" onclick="event.stopPropagation();_showCtx(event,\'' + s.id + '\')" title="More">&#8943;</button></div>';

  el.addEventListener('click', function() { loadSession(s.id); });
  return el;
}

function _vendorIcon(v) {
  v = (v||'').toLowerCase();
  if (v.includes('sap')) return '<span style="color:#0FAAFF">SAP</span>';
  if (v.includes('oracle')) return '<span style="color:#F80000;font-size:8px">ORA</span>';
  if (v.includes('dynamic')) return '<span style="color:#00BCF2;font-size:8px">D365</span>';
  if (v.includes('odoo')) return '<span style="color:#714B67">ODO</span>';
  if (v.includes('workday')) return '<span style="color:#0875e1;font-size:8px">WD</span>';
  if (v.includes('netsuite')) return '<span style="color:#0072C6;font-size:8px">NS</span>';
  if (v.includes('sage')) return '<span style="color:#00D639">SGE</span>';
  if (v.includes('infor')) return '<span style="color:#FFD100">INF</span>';
  if (v.includes('epicor')) return '<span style="color:#E31937;font-size:8px">EPC</span>';
  if (v.includes('ifs')) return '<span style="color:#FF6600">IFS</span>';
  return '&#128172;';
}

function _relDate(d) {
  var now = new Date(), diff = now - d, mins = Math.floor(diff/60000);
  if (mins < 1) return 'now';
  if (mins < 60) return mins + 'm';
  var hrs = Math.floor(mins/60);
  if (hrs < 24) return hrs + 'h';
  var days = Math.floor(hrs/24);
  if (days < 7) return days + 'd';
  return d.toLocaleDateString([], {month:'short',day:'numeric'});
}

// -- Context menu ------------------------------------------------------------
function _showCtx(e, sid) {
  e.preventDefault(); e.stopPropagation(); _closeCtx();
  var s = _sessionsCache.find(function(x){return x.id===sid;});
  var pinLbl = (s && s.pinned) ? 'Unpin' : 'Pin to top';
  var m = document.createElement('div'); m.className='ch-ctx on'; m.id='ch-ctx';
  m.innerHTML = '<div class="ch-ctx-i" onclick="_renameSession(\''+sid+'\')">&#9998; Rename</div>'
    +'<div class="ch-ctx-i" onclick="_togglePin(\''+sid+'\')">&#128204; '+pinLbl+'</div>'
    +'<div class="ch-ctx-sep"></div>'
    +'<div class="ch-ctx-i red" onclick="deleteSession(\''+sid+'\')">&#128465; Delete</div>';
  m.style.left = Math.min(e.clientX, window.innerWidth-180)+'px';
  m.style.top = Math.min(e.clientY, window.innerHeight-150)+'px';
  document.body.appendChild(m); _ctxMenu = m;
  setTimeout(function(){document.addEventListener('click',_closeCtx,{once:true});},50);
}
function _closeCtx() { if (_ctxMenu){_ctxMenu.remove();_ctxMenu=null;} var o=document.getElementById('ch-ctx');if(o)o.remove(); }

async function _renameSession(sid) { _closeCtx(); var s=_sessionsCache.find(function(x){return x.id===sid;}); var t=prompt('Rename:',s?s.title:'');if(!t||!t.trim())return;
  try{await window.fetch(API+'/sessions/'+sid,{method:'PATCH',headers:{'Content-Type':'application/json','Authorization':'Bearer '+S.token},body:JSON.stringify({title:t.trim()})});loadSessions();}catch(e){} }

async function _togglePin(sid) { _closeCtx(); var s=_sessionsCache.find(function(x){return x.id===sid;});var v=s?!s.pinned:true;
  try{await window.fetch(API+'/sessions/'+sid,{method:'PATCH',headers:{'Content-Type':'application/json','Authorization':'Bearer '+S.token},body:JSON.stringify({pinned:v})});loadSessions();}catch(e){} }

async function deleteSession(sid) {
  _closeCtx();
  // Show custom confirmation instead of browser confirm()
  var overlay = document.createElement('div');
  overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:9999;display:flex;align-items:center;justify-content:center;padding:20px';
  overlay.innerHTML = '<div style="background:var(--bg2);border:1px solid var(--border2);border-radius:14px;width:100%;max-width:340px;padding:28px;text-align:center">'
    + '<div style="font-size:22px;margin-bottom:12px">🗑️</div>'
    + '<div style="font-size:15px;font-weight:700;color:var(--text);margin-bottom:8px">Delete this chat?</div>'
    + '<div style="font-size:12px;color:var(--dim);margin-bottom:24px">This cannot be undone.</div>'
    + '<div style="display:flex;gap:10px;justify-content:center">'
    + '<button id="_del-cancel" style="flex:1;padding:10px;background:var(--bg3);border:1px solid var(--border);border-radius:8px;color:var(--text);font-size:13px;cursor:pointer">Cancel</button>'
    + '<button id="_del-confirm" style="flex:1;padding:10px;background:#ef4444;border:none;border-radius:8px;color:#fff;font-size:13px;font-weight:600;cursor:pointer">Delete</button>'
    + '</div></div>';
  document.body.appendChild(overlay);
  overlay.querySelector('#_del-cancel').onclick = function() { overlay.remove(); };
  overlay.addEventListener('click', function(e) { if (e.target === overlay) overlay.remove(); });
  overlay.querySelector('#_del-confirm').onclick = async function() {
    overlay.remove();
    try {
      await window.fetch(API+'/sessions/'+sid, {method:'DELETE', headers:{'Authorization':'Bearer '+S.token}});
      if (S_sessionId === sid) { S_sessionId = null; resetChat(); }
      loadSessions();
      showToast('Chat deleted', 'info', 3000);
    } catch(e) { showToast('Delete failed — please try again', 'error'); }
  };
}

async function clearAllSessions() { if(!S.user||!S.token)return; if(!confirm('Delete ALL chat history?'))return;
  try{await window.fetch(API+'/sessions',{method:'DELETE',headers:{'Authorization':'Bearer '+S.token}});
    S_sessionId=null;_sessionsCache=[];_renderList([]);resetChat();}catch(e){} }

// -- Load a specific session - FIXED to restore all data ---------------------
async function loadSession(sessionId) {
  if (!S.user || !S.token) return;
  try {
    // Save current session ONCE before switching
    if (S_sessionId && S_sessionId !== sessionId && S.history && S.history.length >= 2) {
      _pendingSave = false;  // clear any queued saves before we start
      await saveCurrentSession(true);
    }
    // Prevent any queued saves from firing mid-load with wrong session data
    _pendingSave = false;


    var res = await window.fetch(API + '/sessions/' + sessionId, { headers: {'Authorization':'Bearer '+S.token} });
    if (!res.ok) return;
    var d = await res.json();
    var sess = d.session;
    if (!sess || !sess.messages) return;

    // ★ Fetch all stored export files for this session — activates download buttons
    // on ALL old messages even if exportFile metadata was never saved
    var _sessionExports = [];
    try {
      var _exRes = await window.fetch(API + '/sessions/' + sessionId + '/exports', {
        headers: {'Authorization':'Bearer ' + S.token}
      });
      if (_exRes.ok) {
        var _exData = await _exRes.json();
        _sessionExports = _exData.exports || [];
      }
    } catch(_) {}

    // Helper: find the stored export matching a filename
    function _findExport(fname) {
      if (!fname || !_sessionExports.length) return null;
      // Exact filename match first
      var exact = _sessionExports.find(function(e) { return e.filename === fname; });
      if (exact) return exact;
      // Format match as fallback (for old sessions where filename might differ slightly)
      var ext = fname.split('.').pop().toLowerCase();
      return _sessionExports.find(function(e) { return e.format === ext; }) || null;
    }

    S_sessionId = sess.id;
    S_memSession = _genMemId(); // switching conversations → fresh memory thread
    S.vendor = sess.vendor;
    S.resumeState = sess.resume_state || null;   // restore canonical CV so revisions/exports work after reload
    S.docState = sess.doc_state || null;         // restore canonical documents so any file survives reload
    S.product = sess.product;

    // ★ FIX: Restore full message objects including file + exportFile metadata
    S.history = sess.messages.map(function(m) {
      var msg = { role: m.role, content: m.content || '', timestamp: m.timestamp || '' };
      if (m.file) msg.file = m.file;
      if (m.exportFile) msg.exportFile = m.exportFile;
      if (m.attachments) msg.attachments = m.attachments;
      if (m.sources) msg.sources = m.sources;
      if (m.fileText) msg._fileContent = m.fileText;
      if (m.resumeDraft) msg._resumeDraft = m.resumeDraft;
      return msg;
    });

    // Activate chat UI — always enable textarea even if vendor/product missing
    var ta = document.getElementById('chat-ta');
    if (ta) { ta.disabled = false; }
    document.getElementById('send-btn').disabled = false;
    document.getElementById('limits-bar').classList.add('on');
    var wEl = document.getElementById('welcome'); if (wEl) wEl.style.display = 'none';

    if (sess.vendor && sess.product) {
      document.getElementById('tb-title').textContent = sess.vendor + ' \u2014 ' + sess.product;
      document.getElementById('tb-badge').textContent = 'ACTIVE';
      var _er=document.getElementById('exp-row');if(_er)_er.classList.add('on');
      document.getElementById('voice-btn').style.display = 'inline-flex';
      var vtb = document.getElementById('voice-toggle-btn'); if (vtb) vtb.style.display = 'flex';
      if (ta) ta.placeholder = 'Continue your ' + sess.vendor + ' ' + sess.product + ' chat...';
    } else {
      document.getElementById('tb-title').textContent = 'ERP AI Support';
      document.getElementById('tb-badge').textContent = 'ACTIVE';
      if (ta) ta.placeholder = 'Continue your conversation...';
    }

    // ★ FIX: Render messages properly - don't strip content aggressively
    var msgs = document.getElementById('msgs');
    msgs.innerHTML = '';
    sess.messages.forEach(function(m) {
      var content = (m.content || '').replace(/EXPORT_TRIGGER:\w+/gi, '').trim();
      var role = (m.role === 'user') ? 'user' : 'assistant';

      // ★ Render export file download card
      // If exportFile exists but has no exportId, try to find it from DB exports
      if (m.exportFile && !m.exportFile.exportId && m.exportFile.fileName) {
        var _found = _findExport(m.exportFile.fileName);
        if (_found) m.exportFile.exportId = _found.id;
      }
      if (m.exportFile && (m.exportFile.exportId || m.exportFile.storageUrl || m.exportFile.fileName)) {
        var ef = m.exportFile;
        var icon = ef.format==='pptx' ? '&#127912;' : ef.format==='docx' ? '&#128196;' : ef.format==='xlsx' ? '&#128202;' : '&#128196;';
        var color = ef.format==='pptx' ? '#C0382B' : ef.format==='docx' ? '#2B579A' : ef.format==='xlsx' ? '#217346' : '#0A8A5F';
        var logoSrc = document.getElementById('main-logo') ? document.getElementById('main-logo').src : '';
        var cardEl = document.createElement('div');
        cardEl.className = 'msg assistant';
        var btnId = 'dl-' + Math.random().toString(36).substr(2,8);
        cardEl.innerHTML = '<div class="mav"><img src="' + logoSrc + '" alt="EOH"></div>'
          + '<div class="mbody"><div class="msender">EOH</div>'
          + '<div class="mbubble" style="padding:0;overflow:hidden">'
          + '<div style="padding:14px 16px;border-bottom:1px solid rgba(255,255,255,.06)">'
          + '<div style="font-size:13px;color:#e8edf5;margin-bottom:4px">&#10003; File available for download</div>'
          + '<div style="font-size:11px;color:#7d8ba3">' + _esc(ef.fileName) + '</div></div>'
          + '<div style="padding:12px 16px;display:flex;gap:10px;align-items:center">'
          + '<span style="font-size:28px">' + icon + '</span>'
          + '<div style="flex:1"><div style="font-size:13px;font-weight:600;color:#e8edf5">' + (ef.format||'').toUpperCase() + ' Document</div>'
          + '<div style="font-size:11px;color:#7d8ba3">' + (sess.vendor||'') + ' ' + (sess.product||'') + '</div></div>'
          + '<button id="' + btnId + '" style="padding:9px 20px;background:linear-gradient(135deg,' + color + ',#0A4FCC);color:white;border:none;border-radius:6px;cursor:pointer;font-size:13px;font-weight:600;white-space:nowrap;font-family:var(--font)">&#8595; Download</button>'
          + '</div></div>'
          + '<div class="mmeta"><span class="mtime">' + new Date(m.timestamp || '').toLocaleTimeString([],{hour:'2-digit',minute:'2-digit'}) + '</span></div></div>';
        msgs.appendChild(cardEl);
        (function(eid, surl, fname, fmt, bid) {
          var btn = document.getElementById(bid);
          if (btn) btn.addEventListener('click', async function() {
            var userPlan = (S.user && S.user.plan) ? S.user.plan : 'free';
            var limits = PLAN_LIMITS[userPlan] || PLAN_LIMITS.free;
            if (!limits.fileDownload) {
              showUpgrade('docs', '\ud83d\udcc1 FILE DOWNLOAD is available on paid plans. Upgrade to download your files.');
              return;
            }
            btn.textContent = 'Loading...'; btn.disabled = true;
            try {
              var dd = null;
              // Try download by exportId
              if (eid) {
                var r = await window.fetch(API + '/sessions/download/' + eid, { headers: { 'Authorization': 'Bearer ' + S.token } });
                if (r.ok) dd = await r.json();
              }
              // Fallback: try by filename lookup
              if (!dd && fname) {
                var sidParam = S_sessionId ? '&session=' + encodeURIComponent(S_sessionId) : '';
                var r2 = await window.fetch(API + '/sessions/download-by-name?name=' + encodeURIComponent(fname) + sidParam, { headers: { 'Authorization': 'Bearer ' + S.token } });
                if (r2.ok) dd = await r2.json();
              }
              if (dd && dd.signedUrl) {
                var _a1 = document.createElement('a'); _a1.href = dd.signedUrl;
                _a1.download = dd.fileName || fname; _a1.target = '_blank';
                document.body.appendChild(_a1); _a1.click(); _a1.remove();
              } else if (dd && dd.file) {
                var byteChars = atob(dd.file);
                var byteArr = new Uint8Array(byteChars.length);
                for (var i = 0; i < byteChars.length; i++) byteArr[i] = byteChars.charCodeAt(i);
                var blob = new Blob([byteArr], { type: dd.mimeType || 'application/octet-stream' });
                var url = URL.createObjectURL(blob);
                var a = document.createElement('a'); a.href = url; a.download = dd.fileName || fname;
                document.body.appendChild(a); a.click(); a.remove();
                URL.revokeObjectURL(url);
              } else {
                var _em = (dd && dd.error) ? dd.error : 'File not in database';
                console.error('[Download] failed | exportId:', eid, '| fname:', fname, '| server:', _em);
                alert('Download failed: ' + _em);
              }
            } catch(e) { alert('Download failed. Please try again.'); }
            btn.textContent = '\u2193 Download'; btn.disabled = false;
          });
        })(ef.exportId, ef.storageUrl || null, ef.fileName, ef.format, btnId);
        return;
      }

      // ★ Detect export file messages by content pattern — always show download button
      var exportMatch = content.match(/\ud83d\udcce\s*Generated\s+(PPTX|PDF|DOCX|XLSX)\s+file:\s*(.+)/i);
      if (!exportMatch) exportMatch = content.match(/📎\s*Generated\s+(PPTX|PDF|DOCX|XLSX)\s+file:\s*(.+)/i);
      if (!exportMatch) exportMatch = content.match(/Generated\s+(PPTX|PDF|DOCX|XLSX)\s+file:\s*(.+)/i);
      if (exportMatch && role === 'assistant') {
        var eFmt = exportMatch[1].toLowerCase();
        var eFname = exportMatch[2].trim();
        var eIcon = eFmt==='pptx' ? '&#127912;' : eFmt==='docx' ? '&#128196;' : eFmt==='xlsx' ? '&#128202;' : '&#128196;';
        var eColor = eFmt==='pptx' ? '#C0382B' : eFmt==='docx' ? '#2B579A' : eFmt==='xlsx' ? '#217346' : '#0A8A5F';
        var eLogo = document.getElementById('main-logo') ? document.getElementById('main-logo').src : '';
        var eCard = document.createElement('div');
        eCard.className = 'msg assistant';
        var eBtnId = 'dl-old-' + Math.random().toString(36).substr(2,8);
        // Use exportId from exportFile if available, else fallback to filename lookup
        // Try to find the stored export for this message (even for sessions with no exportFile)
        var _dbExport = _findExport(eFname);
        var eExportId = (m.exportFile && m.exportFile.exportId)
          ? m.exportFile.exportId
          : (_dbExport ? _dbExport.id : null);
        eCard.innerHTML = '<div class="mav"><img src="' + eLogo + '" alt="EOH"></div>'
          + '<div class="mbody"><div class="msender">EOH</div>'
          + '<div class="mbubble" style="padding:0;overflow:hidden">'
          + '<div style="padding:14px 16px;border-bottom:1px solid rgba(255,255,255,.06)">'
          + '<div style="font-size:13px;color:#e8edf5;margin-bottom:4px">&#10003; File available for download</div>'
          + '<div style="font-size:11px;color:#7d8ba3">' + _esc(eFname) + '</div></div>'
          + '<div style="padding:12px 16px;display:flex;gap:10px;align-items:center">'
          + '<span style="font-size:28px">' + eIcon + '</span>'
          + '<div style="flex:1"><div style="font-size:13px;font-weight:600;color:#e8edf5">' + eFmt.toUpperCase() + ' Document</div>'
          + '<div style="font-size:11px;color:#7d8ba3">' + (sess.vendor||'') + ' ' + (sess.product||'') + '</div></div>'
          + '<button id="' + eBtnId + '" style="padding:9px 20px;background:linear-gradient(135deg,' + eColor + ',#0A4FCC);color:white;border:none;border-radius:6px;cursor:pointer;font-size:13px;font-weight:600;white-space:nowrap;font-family:var(--font)">&#8595; Download</button>'
          + '</div></div>'
          + '<div class="mmeta"><span class="mtime">' + new Date(m.timestamp || '').toLocaleTimeString([],{hour:'2-digit',minute:'2-digit'}) + '</span></div></div>';
        msgs.appendChild(eCard);
        // Wire download button — tries exportId first, then filename fallback
        (function(exportId, surl, fname, fmt, btnId, sid) {
          var btn = document.getElementById(btnId);
          if (!btn) return;
          btn.addEventListener('click', async function() {
            btn.textContent = 'Loading...'; btn.disabled = true;
            try {
              var dd = null;
              if (exportId) {
                var r = await window.fetch(API + '/sessions/download/' + exportId, { headers: { 'Authorization': 'Bearer ' + S.token } });
                if (r.ok) dd = await r.json();
              }
              if (!dd && fname) {
                var sidP = sid ? '&session=' + encodeURIComponent(sid) : '';
                var r2 = await window.fetch(API + '/sessions/download-by-name?name=' + encodeURIComponent(fname) + sidP, { headers: { 'Authorization': 'Bearer ' + S.token } });
                if (r2.ok) dd = await r2.json();
              }
              if (dd && dd.signedUrl) {
                var _a2 = document.createElement('a'); _a2.href = dd.signedUrl;
                _a2.download = dd.fileName || fname; _a2.target = '_blank';
                document.body.appendChild(_a2); _a2.click(); _a2.remove();
              } else if (dd && dd.file) {
                var bc = atob(dd.file);
                var ba = new Uint8Array(bc.length);
                for (var i = 0; i < bc.length; i++) ba[i] = bc.charCodeAt(i);
                var blob = new Blob([ba], { type: dd.mimeType || 'application/octet-stream' });
                var url = URL.createObjectURL(blob);
                var a = document.createElement('a'); a.href = url; a.download = dd.fileName || fname;
                document.body.appendChild(a); a.click(); a.remove();
                URL.revokeObjectURL(url);
              } else {
                var _em2 = (dd && dd.error) ? dd.error : 'File not in database';
                console.error('[Download] failed | exportId:', exportId, '| fname:', fname, '| server:', _em2);
                alert('Download failed: ' + _em2);
              }
            } catch(e) { alert('Download failed. Please try again.'); }
            btn.textContent = '\u2193 Download'; btn.disabled = false;
          });
        })(eExportId, m.exportFile ? (m.exportFile.storageUrl || null) : null, eFname, eFmt, eBtnId, S_sessionId);
        return;
      }

      // Regular message rendering
      var _hasAtt = !!(m.attachments && m.attachments.length);
      var fileAtt = null;
      // Clean up legacy messages that stored the full extracted file dump as content — show only
      // the user's question (or the filename), never the extracted text.
      if (role === 'user' && /^\[(File \d+:|Attached:)/.test(content)) {
        var _qIdx = content.lastIndexOf('\nQuestion:');
        content = _qIdx >= 0 ? content.substring(_qIdx + 10).trim() : '';
        if (!content && m.file && m.file.name) content = '\ud83d\udcce ' + m.file.name;
      }
      // Attachments render as download chips below; only show the plain file card when there are none.
      if (!_hasAtt && m.file && m.file.name) {
        fileAtt = { name: m.file.name };
      }
      if (!content && !fileAtt && !_hasAtt) return;
      addMsg(role, content || '', fileAtt);
      if (_hasAtt) { try { _renderHistAttachments(m, document.getElementById('msgs').lastElementChild); } catch(_){} }
    });

    msgs.scrollTop = msgs.scrollHeight;

    // Let standalone modules (guided cards, files/resources drawer) rebuild
    // themselves from the freshly-rendered conversation.
    try { if (typeof window.eohOnConversationRendered === 'function') window.eohOnConversationRendered(sess); } catch(_){}

    // Highlight active session
    document.querySelectorAll('.ch-item').forEach(function(el) {
      el.classList.toggle('active', el.dataset.sid === sessionId);
    });

    updateLimits();
    if (window.innerWidth < 768) closeSidebar();
  } catch(e) { console.error('loadSession error:', e); }
}

function _esc(s){return(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}

// ==============================================================================
// SERVER USAGE SYNC
// ==============================================================================



// ==============================================================================
// PROFILE & SUBSCRIPTION MODALS
// ==============================================================================

async function showProfileModal() {
  var acctMenu = document.getElementById('acct-menu');
  if (acctMenu) acctMenu.remove();
  var el = document.getElementById('profile-overlay');
  if (!el) return;
  el.style.display = 'flex';
  document.getElementById('profile-body').innerHTML = '<div style="text-align:center;padding:30px;color:#7d8ba3">Loading...</div>';
  if (!S.user || !S.token) {
    document.getElementById('profile-body').innerHTML = '<div style="text-align:center;padding:20px;color:#7d8ba3">Please sign in first</div>';
    return;
  }

  async function _fetchProfile(token) {
    return window.fetch(API + '/profile', { headers: {'Authorization': 'Bearer ' + token} });
  }

  try {
    var res = await _fetchProfile(S.token);

    // 401 = token expired — refresh and retry once
    if (res.status === 401) {
      var rt = localStorage.getItem('eoh_rt');
      if (rt) {
        var rr = await window.fetch(API + '/auth/refresh', {
          method: 'POST', headers: {'Content-Type':'application/json'},
          credentials: 'include',
          body: JSON.stringify({refresh_token: rt})
        });
        var rd = await rr.json();
        if (rd.token) {
          S.token = rd.token; localStorage.setItem('eoh_t', rd.token);
          if (rd.refresh_token) localStorage.setItem('eoh_rt', rd.refresh_token);
          if (rd.user) { _mergeUser(rd.user); localStorage.setItem('eoh_u', JSON.stringify(S.user)); }
          res = await _fetchProfile(S.token);
        }
      }
    }

    var d = await res.json();
    if (!res.ok) {
      document.getElementById('profile-body').innerHTML =
        '<div style="color:#f87171;text-align:center;padding:20px">Error: ' + (d.error || 'Could not load profile (' + res.status + ')') + '</div>';
      return;
    }

    var profile = d.profile || {};
    // Patch missing fields from S.user (covers inline-OAuth users whose DB row was just created)
    if (!profile.email    && S.user && S.user.email)                         profile.email    = S.user.email;
    if (!profile.plan     && S.user && S.user.plan)                          profile.plan     = S.user.plan;
    if (!profile.full_name && S.user && (S.user.fullName || S.user.name))    profile.full_name= S.user.fullName || S.user.name;
    if (!profile.phone    && S.user && S.user.phone)                         profile.phone    = S.user.phone;
    // Silently backfill name to DB if DB has null but we have it from auth metadata
    // Delay 2s to ensure GET /profile's auto-create upsert has fully committed first
    if (profile.full_name && (!d.profile || !d.profile.full_name) && !window._nameBackfilled) {
      window._nameBackfilled = true; // only once per session
      setTimeout(function() {
        window.fetch(API + '/profile', {
          method:'PATCH', headers:{'Content-Type':'application/json','Authorization':'Bearer '+S.token},
          body: JSON.stringify({full_name: profile.full_name})
        }).catch(function(){});
      }, 2000);
    }
    renderProfileForm(profile);

  } catch(e) {
    document.getElementById('profile-body').innerHTML =
      '<div style="color:#f87171;text-align:center;padding:20px">Failed to load profile. Check your connection.</div>';
    console.error('[EOH] showProfileModal error:', e);
  }
}

function usageMeterHtml(label, used, limit, color) {
  var pct = limit > 0 ? Math.min(100, Math.round(used / limit * 100)) : 0;
  var bar = pct > 80 ? '#f87171' : color;
  return '<div style="text-align:center">'
    + '<div style="font-size:20px;font-weight:700;color:#e8edf5">' + used
    + '<span style="font-size:12px;color:#7d8ba3">/' + limit + '</span></div>'
    + '<div style="font-size:11px;color:#7d8ba3;margin:3px 0 6px">' + label + '</div>'
    + '<div style="height:4px;background:#2d3f55;border-radius:2px">'
    + '<div style="height:4px;background:' + bar + ';border-radius:2px;width:' + pct + '%;transition:width 0.5s"></div>'
    + '</div></div>';
}

function renderProfileForm(p) {
  // Merge live limits from already-synced PLAN_LIMITS — never show wrong values
  var planKey2   = p.plan || (S.user && S.user.plan) || 'free';
  var liveLimits = getLimits();
  var qLimit = (p.queries_limit    > 0) ? p.queries_limit    : (liveLimits.queries || 0);
  var dLimit = (p.docs_limit       > 0) ? p.docs_limit       : (liveLimits.docs    || 0);
  var vLimit = (p.voice_mins_limit > 0) ? p.voice_mins_limit : (liveLimits.voice   || 0);
  var sLimit = (p.screen_mins_limit > 0) ? p.screen_mins_limit : (liveLimits.screen || 0);

  var planColor   = (planKey2 && planKey2 !== 'free') ? '#0fb574' : '#7d8ba3';
  var nameDisplay = p.full_name || (S.user && (S.user.fullName || S.user.name)) || 'User';
  var emailDisplay = p.email    || (S.user && S.user.email)    || '';
  var initials    = (nameDisplay[0] || 'U').toUpperCase();

  var memberSince = p.created_at ? new Date(p.created_at).toLocaleDateString([],{year:'numeric',month:'long'}) : null;
  var planExpiry  = (p.plan_expires_at && p.plan_expires_at !== null) ? new Date(p.plan_expires_at).toLocaleDateString([],{year:'numeric',month:'short',day:'numeric'}) : null;
  var trialEnd    = (p.trial_ends_at   && p.trial_ends_at   !== null) ? new Date(p.trial_ends_at).toLocaleDateString([],{year:'numeric',month:'short',day:'numeric'})   : null;
  var trialActive = !!(trialEnd && p.trial_ends_at && new Date(p.trial_ends_at) > new Date());

  var avatarUrl  = p.avatar_url || (S.user && (S.user.avatar || S.user.avatar_url)) || '';
  // Always render the initial span. After HTML is set, JS will swap in the photo.
  var avatarInner = '<span id="pf-av-init" style="font-size:26px;font-weight:700;color:#fff">' + initials + '</span>';

  var html = '<div style="display:flex;align-items:center;gap:16px;margin-bottom:20px;padding-bottom:18px;border-bottom:1px solid #2d3f55">'
    + '<div style="position:relative;flex-shrink:0;width:64px;height:64px">'
    + '<div id="pf-avatar-display" style="width:64px;height:64px;background:linear-gradient(135deg,#0070c0,#0040a0);border-radius:50%;display:flex;align-items:center;justify-content:center;overflow:hidden;cursor:pointer" onclick="document.getElementById(&quot;pf-avatar-input&quot;).click()" title="Click to change photo">'
    + avatarInner
    + '</div>'
    + '<div onclick="document.getElementById(&quot;pf-avatar-input&quot;).click()" style="position:absolute;bottom:0;right:0;width:20px;height:20px;background:#0070c0;border-radius:50%;display:flex;align-items:center;justify-content:center;cursor:pointer;border:2px solid #0a1520" title="Upload photo">&#9998;</div>'
    + '<input type="file" id="pf-avatar-input" accept="image/jpeg,image/png,image/webp,image/gif" style="display:none" onchange="uploadProfilePicture(this)">'
    + '<div id="pf-avatar-status" style="position:absolute;top:-4px;right:-4px;display:none;width:20px;height:20px;background:#0fb574;border-radius:50%;align-items:center;justify-content:center;font-size:10px;color:#fff">✓</div>'
    + '</div>'
    + '<div style="flex:1">'
    + '<div style="font-size:18px;font-weight:700;color:#e8edf5">' + nameDisplay + '</div>'    + '<div style="font-size:12px;color:#7d8ba3;margin-top:2px">' + emailDisplay + '</div>'    + '<div style="display:flex;gap:6px;flex-wrap:wrap;margin-top:7px;align-items:center">'    + '<span style="padding:2px 10px;background:' + planColor + '22;color:' + planColor + ';border:1px solid ' + planColor + '44;border-radius:20px;font-size:11px;font-weight:600">' + planKey2.toUpperCase() + ' PLAN</span>'    + (trialActive ? '<span style="padding:2px 10px;background:#f59e0b22;color:#f59e0b;border:1px solid #f59e0b44;border-radius:20px;font-size:11px;font-weight:600">⏳ TRIAL · ends ' + trialEnd + '</span>' : '')    + (planExpiry && !trialActive ? '<span style="padding:2px 10px;background:#ef444422;color:#ef4444;border:1px solid #ef444444;border-radius:20px;font-size:11px">Expires ' + planExpiry + '</span>' : '')    + (memberSince ? '<span style="font-size:10px;color:#4b5563">Member since ' + memberSince + '</span>' : '')    + '</div></div></div>'
    + '<div style="display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-bottom:20px">';

  var fields = [
    {id:'pf-name',    label:'Full Name', val: p.full_name  || (S.user && (S.user.fullName || S.user.name)) || ''},
    {id:'pf-email',   label:'Email',     val: emailDisplay, disabled: true},
    {id:'pf-company', label:'Company',   val: p.company    || ''},
    {id:'pf-title',   label:'Job Title', val: p.job_title  || ''},
    {id:'pf-phone',   label:'Phone',     val: p.phone      || (S.user && S.user.phone) || ''},
    {id:'pf-tz',      label:'Timezone',  val: p.timezone   || 'UTC'}
  ];
  fields.forEach(function(f) {
    var dis   = f.disabled ? ' disabled' : '';
    var bg    = f.disabled ? '#0a1020' : '#0f1923';
    var col   = f.disabled ? '#7d8ba3' : '#e8edf5';
    var focus = f.disabled ? '' : ' onfocus="this.style.borderColor=\'#0070c0\'" onblur="this.style.borderColor=\'#2d3f55\'"';
    html += '<div><label style="font-size:11px;color:#7d8ba3;display:block;margin-bottom:5px">' + f.label + '</label>'
      + '<input id="' + f.id + '" value="' + (f.val||'').replace(/"/g,'&quot;') + '"' + dis + focus
      + ' style="width:100%;background:' + bg + ';border:1px solid #2d3f55;border-radius:8px;padding:9px 12px;color:' + col + ';font-size:13px;box-sizing:border-box;outline:none"></div>';
  });
  html += '</div>';

  // Usage meters — use server limits, fall back to live synced PLAN_LIMITS
  var _vcPlan2    = VOICE_CONFIG[planKey2] || {};
  var hasLive2    = _planLimitsLoaded && !!_vcPlan2.live && (sLimit > 0);
  var gridCols    = hasLive2 ? 'repeat(4,1fr)' : 'repeat(3,1fr)';
  // Usage: normally MAX(DB, live local) so a just-sent action isn't erased by a stale
  // DB read. BUT if the server reports a reset newer than we've seen (admin reset / plan
  // change / cron), the local counters are pre-reset stale — trust the server (DB) values
  // and do NOT MAX, so a reset shows immediately here too (Step 4 / Option B consistency).
  var _pReset = p.usage_reset_date || null;
  var _modalResetNewer = _pReset && (!S._lastResetDate || new Date(_pReset).getTime() > new Date(S._lastResetDate).getTime());
  var _uQ, _uD, _uV, _uS;
  if (_modalResetNewer) {
    _uQ = p.messages_used || 0;
    _uD = p.docs_used     || 0;
    _uV = parseFloat((p.voice_mins_used  || 0).toFixed(1));
    _uS = parseFloat((p.screen_mins_used || 0).toFixed(1));
  } else {
    _uQ = Math.max(p.messages_used  || 0, S_USAGE.queries || 0);
    _uD = Math.max(p.docs_used      || 0, S_USAGE.docs    || 0);
    _uV = Math.max(parseFloat((p.voice_mins_used || 0).toFixed(1)), parseFloat((S.voiceMinsUsed || 0).toFixed(1)));
    _uS = Math.max(parseFloat((p.screen_mins_used || 0).toFixed(1)), parseFloat((S_USAGE.screen || 0).toFixed(1)));
  }

  html += '<div style="background:#0f1923;border:1px solid #2d3f55;border-radius:12px;padding:16px;margin-bottom:20px">'    + '<div style="font-size:11px;font-weight:600;color:#7d8ba3;margin-bottom:12px;letter-spacing:0.5px">USAGE THIS MONTH</div>'    + '<div style="display:grid;grid-template-columns:' + gridCols + ';gap:12px">'    + usageMeterHtml('Queries',    _uQ, qLimit, '#0070c0')    + usageMeterHtml('Exports',    _uD, dLimit, '#8B5CF6')    + usageMeterHtml('Voice Mins', _uV, vLimit, '#0fb574')    + (hasLive2 ? usageMeterHtml('Live Mins', _uS, sLimit, '#ef4444') : '')    + '</div></div>'

  // ── Appearance section ────────────────────────────────────────────────────
  var _curThemeIdx = _themeIdx;
  var _curFs = localStorage.getItem('eoh_font_size')    || '14';
  var _curFf = localStorage.getItem('eoh_font_family')  || 'default';
  var _themeOpts = _themes.map(function(t, i) {
    return '<option value="' + i + '"' + (i === _curThemeIdx ? ' selected' : '') + '>' + _themeLabels[i] + '</option>';
  }).join('');
  var _inputStyle = 'flex:1;padding:8px 10px;background:#1e2d3d;border:1px solid #2d3f55;border-radius:8px;color:#e8edf5;font-size:12px;cursor:pointer;outline:none';
  html += '<div style="background:#0f1923;border:1px solid #2d3f55;border-radius:12px;padding:16px;margin-bottom:20px">'
    + '<div style="font-size:11px;font-weight:600;color:#7d8ba3;margin-bottom:14px;letter-spacing:.5px">APPEARANCE</div>'
    // Theme row
    + '<div style="margin-bottom:12px">'
    + '<label style="font-size:11px;color:#7d8ba3;display:block;margin-bottom:6px;font-weight:600">Theme</label>'
    + '<select id="pf-theme-sel" style="' + _inputStyle + ';width:100%" onchange="_pfApplyTheme(this.value)">'
    + _themeOpts
    + '</select>'
    + '</div>'
    // Font row
    + '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px">'
    + '<div>'
    + '<label style="font-size:11px;color:#7d8ba3;display:block;margin-bottom:6px;font-weight:600">Font Size</label>'
    + '<select id="pf-fontsize-sel" style="' + _inputStyle + ';width:100%" onchange="setFontSize(this.value);var s=document.getElementById(\'font-size-sel\');if(s)s.value=this.value">'
    + ['12','14','16','18'].map(function(v){ var labels={'12':'Small','14':'Default','16':'Large','18':'X-Large'}; return '<option value="'+v+'"'+(v===_curFs?' selected':'')+'>'+labels[v]+'</option>'; }).join('')
    + '</select>'
    + '</div>'
    + '<div>'
    + '<label style="font-size:11px;color:#7d8ba3;display:block;margin-bottom:6px;font-weight:600">Font Family</label>'
    + '<select id="pf-fontfam-sel" style="' + _inputStyle + ';width:100%" onchange="setFontFamily(this.value);var s=document.getElementById(\'font-family-sel\');if(s)s.value=this.value">'
    + [['default','Default'],['serif','Serif'],['mono','Mono'],['dyslexic','Dyslexic']].map(function(p){ return '<option value="'+p[0]+'"'+(p[0]===_curFf?' selected':'')+'>'+p[1]+'</option>'; }).join('')
    + '</select>'
    + '</div>'
    + '</div>'
    + '</div>'

    + '<div id="pf-activity-section" style="background:#0f1923;border:1px solid #2d3f55;border-radius:12px;padding:16px;margin-bottom:20px">'
    + '<div style="font-size:11px;font-weight:600;color:#7d8ba3;margin-bottom:12px;letter-spacing:.5px">MY RECENT ACTIVITY</div>'
    + '<div id="pf-activity-list" style="font-size:12px;color:#7d8ba3;text-align:center;padding:12px">Loading…</div>'
    + '</div>'
    + '<div id="pf-2fa-container" style="margin-bottom:16px"></div>'

    + '<div style="background:#0f1923;border:1px solid #2d3f55;border-radius:12px;padding:16px;margin-bottom:20px">'
    + '<div style="font-size:11px;font-weight:600;color:#7d8ba3;margin-bottom:12px;letter-spacing:.5px">SECURITY</div>'
    + '<div style="display:flex;gap:10px;flex-wrap:wrap">'
    + '<button onclick="showChangePasswordModal()" style="padding:8px 16px;background:#1c2a3d;border:1px solid #2d3f55;border-radius:8px;color:#e8edf5;font-size:12px;cursor:pointer;font-family:var(--font)">Change Password</button>'
    + '<button onclick="showAcctSessions();closeProfileModal()" style="padding:8px 16px;background:#1c2a3d;border:1px solid #2d3f55;border-radius:8px;color:#e8edf5;font-size:12px;cursor:pointer;font-family:var(--font)">Active Sessions</button>'
    + '</div></div>'

    + '<div style="display:flex;gap:10px;justify-content:space-between;align-items:center">'
    + '<button onclick="doLogout()" style="padding:10px 18px;background:rgba(239,68,68,.1);border:1px solid rgba(239,68,68,.25);border-radius:8px;color:#f87171;font-size:13px;cursor:pointer;font-family:var(--font)">Sign Out</button>'
    + '<div style="display:flex;gap:10px">'
    + '<button onclick="closeProfileModal()" style="padding:10px 20px;background:#2d3f55;border:none;border-radius:8px;color:#e8edf5;font-size:13px;cursor:pointer">Cancel</button>'
    + '<button id="pf-save-btn" onclick="saveProfile()" class="mbtn" style="padding:10px 24px;border-radius:8px;font-size:13px;font-weight:600">Save Changes</button>'
    + '</div></div>';

  document.getElementById('profile-body').innerHTML = html;

  // ── Load My Activity (Fix 22) ─────────────────────────────────────────────
  (async function _loadActivity() {
    try {
      var actRes = await window.fetch(API + '/profile/activity', {
        headers: { 'Authorization': 'Bearer ' + S.token }
      });
      var actEl = document.getElementById('pf-activity-list');
      if (!actEl) return;
      if (!actRes.ok) { actEl.textContent = 'Activity unavailable.'; return; }
      var actData = await actRes.json();
      var items = actData.activity || actData.items || [];
      if (!items.length) { actEl.textContent = 'No recent activity.'; return; }
      var _actIcons = { login:'🔐', chat:'💬', export:'📄', voice:'🎤', upload:'📎', settings:'⚙️', billing:'💳' };
      actEl.innerHTML = items.slice(0, 10).map(function(a) {
        var icon = _actIcons[a.action] || '📝';
        var d = new Date(a.created_at);
        var when = d.toLocaleDateString([], { month:'short', day:'numeric' }) + ' ' + d.toLocaleTimeString([], { hour:'2-digit', minute:'2-digit' });
        return '<div style="display:flex;justify-content:space-between;align-items:center;padding:6px 0;border-bottom:1px solid #1e2d3d">'
          + '<span>' + icon + ' <span style="color:#e8edf5">' + _esc(a.description || a.action || '') + '</span></span>'
          + '<span style="color:#7d8ba3;font-size:10px;white-space:nowrap;margin-left:10px">' + when + '</span>'
          + '</div>';
      }).join('');
    } catch(_) {
      var actEl2 = document.getElementById('pf-activity-list');
      if (actEl2) actEl2.textContent = 'Activity unavailable.';
    }
  })();

  // ── Preload avatar photo and swap in after HTML is in DOM ──────────────
  if (avatarUrl) {
    var _pfDisp = document.getElementById('pf-avatar-display');
    var _pfInit = document.getElementById('pf-av-init');
    var _pfImg  = new Image();
    _pfImg.onload = function() {
      var disp = document.getElementById('pf-avatar-display');
      if (!disp) return;
      disp.style.background = 'none';
      disp.innerHTML = '';
      var img = document.createElement('img');
      img.src = avatarUrl;
      img.alt = '';
      img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;border-radius:50%';
      disp.appendChild(img);
    };
    _pfImg.onerror = function() { /* keep initial span showing */ };
    _pfImg.src = avatarUrl;
  }
}

async function uploadProfilePicture(input) {
  if (!input.files || !input.files[0]) return;
  var file = input.files[0];
  if (file.size > 1 * 1024 * 1024) { alert('Image too large. Max 1MB.'); return; }

  var display = document.getElementById('pf-avatar-display');
  var status  = document.getElementById('pf-avatar-status');
  if (display) display.style.opacity = '0.5';

  try {
    var base64 = await new Promise(function(resolve, reject) {
      var reader = new FileReader();
      reader.onload  = function(e) { resolve(e.target.result); };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

    var res = await window.fetch(API + '/profile/avatar', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + (S.token || '') },
      body: JSON.stringify({ imageBase64: base64, mimeType: file.type })
    });
    var d = await res.json();
    if (!res.ok) { if (display) display.style.opacity = '1'; alert(d.error || 'Upload failed'); return; }

    var url = d.avatar_url;
    if (display) display.style.opacity = '1';

    // Persist to S.user immediately
    if (S.user) {
      S.user.avatar     = url;
      S.user.avatar_url = url;
      try { localStorage.setItem('eoh_u', JSON.stringify(S.user)); } catch(_) {}
    }

    // Success tick
    if (status) { status.style.display = 'flex'; setTimeout(function() { status.style.display = 'none'; }, 2000); }

    // Preload once — on success update both modal and sidebar together
    var preload = new Image();
    preload.onload = function() {

      // ── Profile modal ──
      var disp = document.getElementById('pf-avatar-display');
      if (disp) {
        disp.style.background = 'none';
        disp.innerHTML = '';
        var mImg = document.createElement('img');
        mImg.src = url;
        mImg.alt = '';
        mImg.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;border-radius:50%';
        disp.appendChild(mImg);
      }

      // ── Sidebar #uav ──
      var uavEl = document.getElementById('uav');
      if (uavEl) {
        uavEl.style.background = 'none';
        uavEl.innerHTML = '';
        var uImg = document.createElement('img');
        uImg.src = url;
        uImg.alt = '';
        uImg.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;border-radius:50%';
        uavEl.appendChild(uImg);
      }
    };
    preload.onerror = function() { /* keep existing initial letter */ };
    preload.src = url;

    // Any other header avatar
    var headerAv = document.getElementById('user-avatar-img') || document.getElementById('header-avatar');
    if (headerAv) { headerAv.src = url; }

  } catch(e) {
    alert('Upload failed: ' + e.message);
    if (display) display.style.opacity = '1';
  }
}


async function saveProfile() {
  if (!S.token) { showProfileModal(); return; }
  var btn = document.getElementById('pf-save-btn');
  if (btn) { btn.textContent = 'Saving...'; btn.disabled = true; }
  try {
    var payload = {
      full_name: (document.getElementById('pf-name')    || {}).value || '',
      company:   (document.getElementById('pf-company') || {}).value || '',
      job_title: (document.getElementById('pf-title')   || {}).value || '',
      phone:     (document.getElementById('pf-phone')   || {}).value || '',
      timezone:  (document.getElementById('pf-tz')      || {}).value || 'UTC'
    };
    var res = await window.fetch(API + '/profile', {
      method: 'PATCH',
      headers: {'Content-Type':'application/json','Authorization':'Bearer ' + S.token},
      body: JSON.stringify(payload)
    });
    var d = await res.json();
    if (res.ok) {
      if (d.profile) {
        if (d.profile.full_name !== undefined) {
            S.user.fullName = d.profile.full_name;
            S.user.name     = d.profile.full_name;  // keep both in sync for OAuth users
          }
        if (d.profile.phone     !== undefined) S.user.phone    = d.profile.phone;
        S.user.company  = d.profile.company   || S.user.company;
        S.user.jobTitle = d.profile.job_title || S.user.jobTitle;
        S.user.timezone = d.profile.timezone  || S.user.timezone;
        localStorage.setItem('eoh_u', JSON.stringify(S.user));
        _origUpdateUserUI();
      }
      if (btn) { btn.textContent = '\u2713 Saved!'; btn.style.background = '#0fb574'; }
      setTimeout(function() {
        if (btn) { btn.textContent = 'Save Changes'; btn.style.background = 'linear-gradient(135deg,#0070c0,#0fb574)'; btn.style.opacity = '1'; btn.disabled = false; }
      }, 2000);
    } else {
      if (btn) { btn.textContent = 'Error: ' + (d.error || res.status); btn.disabled = false; }
      console.error('[EOH] saveProfile failed:', d.error || res.status);
    }
  } catch(e) {
    if (btn) { btn.textContent = 'Network Error'; btn.disabled = false; }
    console.error('[EOH] saveProfile exception:', e);
  }
}

async function showSubscriptionModal() {
  var acctMenu = document.getElementById('acct-menu');
  if (acctMenu) acctMenu.remove();
  var el = document.getElementById('subscription-overlay');
  if (!el) return;
  el.style.display = 'flex';
  document.getElementById('subscription-body').innerHTML = '<div style="text-align:center;padding:30px;color:#7d8ba3">Loading\u2026</div>';
  if (!S.user || !S.token) {
    document.getElementById('subscription-body').innerHTML = '<div style="text-align:center;padding:20px;color:#7d8ba3">Please sign in first</div>';
    return;
  }
  try {
    // Fetch both independently — one failure won't blank the other
    var subData = {}, payData = { payments: [] };
    try {
      var sr = await window.fetch(API + '/profile/subscription', {headers:{'Authorization':'Bearer '+S.token}});
      if (sr.ok) subData = await sr.json();
      // Silently backfill allow_redisplay on existing saved cards
      if (S.token) window.fetch(API + '/profile/fix-saved-cards', {method:'POST',headers:{'Authorization':'Bearer '+S.token}}).catch(function(){});
    } catch(e) { console.error('[EOH] subscription fetch:', e); }
    try {
      var pr = await window.fetch(API + '/profile/payment-history', {headers:{'Authorization':'Bearer '+S.token}});
      if (pr.ok) payData = await pr.json();
    } catch(e) { console.error('[EOH] payment-history fetch:', e); }
    renderSubscription(subData.subscription || {}, payData.payments || []);
  } catch(e) {
    document.getElementById('subscription-body').innerHTML = '<div style="color:#f87171;text-align:center;padding:20px">Failed to load billing data. Please try again.</div>';
  }
}


// ═══════════════════════════════════════════════════════════════════════════
// BILLING SYSTEM — 3 tabs: Plan · Payment Method · Billing Address
// ═══════════════════════════════════════════════════════════════════════════

var _billingTab = 'plan'; // active tab state
var _stripeInstance = null;
var _stripeElements = null;
var _stripeCardEl   = null;
var _subCache = {}; // cache subscription data while tabs are open

// ── Tab renderer ──────────────────────────────────────────────────────────
function renderSubscription(sub, payments) {
  _subCache = { sub: sub, payments: payments };
  _billingTab = 'plan';
  // Sync fresh expiry state from server back to S.user + localStorage
  if (S.user && sub) {
    // Use plan_expires_at as authoritative — status alone can't determine expiry
    var _expDate = sub.plan_expires_at ? new Date(sub.plan_expires_at) : null;
    var _reallyExpired = _expDate ? (_expDate < new Date()) : (sub.status === 'expired' || sub.is_expired);
    if (_reallyExpired) {
      S.user.isExpired           = true;
      S.user.subscriptionStatus  = 'expired';
      S.user.subscription_status = 'expired';
    } else {
      S.user.isExpired           = false;
      S.user.subscriptionStatus  = sub.status || null;
      S.user.subscription_status = sub.status || null;
    }
    if (sub.plan_expires_at) S.user.planExpiresAt  = sub.plan_expires_at;
    if (sub.plan)            S.user.plan            = sub.plan;
    try { localStorage.setItem('eoh_u', JSON.stringify(S.user)); } catch(_) {}
  }
  _renderBillingShell(sub);
  _renderBillingTab('plan');
}

function _renderBillingShell(sub) {
  var plan     = (sub && sub.plan) || 'free';
  var planCols = {free:'#7d8ba3',basic:'#0070c0',professional:'#0fb574',business:'#8B5CF6',manager:'#f59e0b',enterprise:'#ef4444'};
  var color    = planCols[plan] || '#7d8ba3';

  var html = '<div style="display:flex;gap:0;border-bottom:1px solid #2d3f55;margin-bottom:20px">';
  [['plan','📋 Plan'],['payment','💳 Payment Method'],['billing','🏠 Billing Info'],['history','📊 Usage History'],['sessions','🔐 Sessions']].forEach(function(t){
    var active = _billingTab === t[0];
    html += '<button id="btab-'+t[0]+'" onclick="_switchBillingTab(\''+t[0]+'\')" style="'
      + 'flex:1;padding:10px 6px;background:none;border:none;border-bottom:2px solid '
      + (active ? color : 'transparent') + ';color:'+(active?'#e8edf5':'#7d8ba3')
      + ';font-size:12px;font-weight:'+(active?'600':'400')+';cursor:pointer;transition:all 0.2s">'
      + t[1] + '</button>';
  });
  html += '</div><div id="billing-tab-body"></div>';
  document.getElementById('subscription-body').innerHTML = html;
}

function _switchBillingTab(tab) {
  _billingTab = tab;
  var sub = _subCache.sub || {};
  var plan = sub.plan || 'free';
  var planCols = {free:'#7d8ba3',basic:'#0070c0',professional:'#0fb574',business:'#8B5CF6',manager:'#f59e0b',enterprise:'#ef4444'};
  var color = planCols[plan] || '#7d8ba3';
  ['plan','payment','billing','history','sessions'].forEach(function(t){
    var btn = document.getElementById('btab-'+t);
    if (!btn) return;
    var active = t === tab;
    btn.style.borderBottomColor = active ? color : 'transparent';
    btn.style.color   = active ? '#e8edf5' : '#7d8ba3';
    btn.style.fontWeight = active ? '600' : '400';
  });
  _renderBillingTab(tab);
}

function _renderBillingTab(tab) {
  var body = document.getElementById('billing-tab-body');
  if (!body) return;
  if (tab === 'plan')    _renderPlanTab(body);
  if (tab === 'payment') _renderPaymentTab(body);
  if (tab === 'billing') _renderBillingAddressTab(body);
  if (tab === 'history')  _renderUsageHistoryTab(body);
  if (tab === 'sessions') _renderSessionsTab(body);
}

// ── TAB 1: Plan ──────────────────────────────────────────────────────────
function _renderPlanTab(body) {
  var sub      = _subCache.sub || {};
  var payments = _subCache.payments || [];
  var plan     = sub.plan || 'free';
  var planCols = {free:'#7d8ba3',basic:'#0070c0',professional:'#0fb574',business:'#8B5CF6',manager:'#f59e0b',enterprise:'#ef4444'};
  var color    = planCols[plan] || '#7d8ba3';
  var isFree   = plan === 'free';
  var stLabel  = isFree ? 'FREE PLAN' : (sub.status || 'inactive').toUpperCase();
  var stColor  = (sub.status==='active'||isFree)?'#0fb574':sub.status==='trialing'?'#f59e0b':sub.status==='past_due'?'#f59e0b':'#f87171';
  var pm       = sub.payment_method || {};

  // Subscription source → decides which controls and status the UI shows.
  var srcType  = sub.source || (isFree ? 'free' : (sub.stripe_subscription_id ? 'stripe' : (sub.via_bundle ? 'bundle' : 'admin')));
  var srcMeta  = ({
    stripe: { label: 'Stripe', icon: '💳', color: '#0fb574', note: 'Self-managed via Stripe' },
    bundle: { label: 'Company Bundle', icon: '&#127873;', color: '#818cf8', note: 'Activated via Company Bundle' },
    manual: { label: 'Manual Invoice', icon: '🧾', color: '#f59e0b', note: 'Invoiced by your administrator' },
    admin:  { label: 'Admin-Granted', icon: '🛠️', color: '#7d8ba3', note: 'Managed by your administrator' },
    free:   { label: 'Free', icon: '', color: '#7d8ba3', note: '' }
  })[srcType] || { label: '—', icon: '', color: '#7d8ba3', note: '' };
  var isStripe = srcType === 'stripe';

  // ── Date helpers ─────────────────────────────────────────────────────────
  function fmtDate(v) {
    if (!v) return '—';
    var d = new Date(v);
    return isNaN(d) ? '—' : d.toLocaleDateString([], {year:'numeric', month:'short', day:'numeric'});
  }
  var nextBilling  = fmtDate(sub.current_period_end);
  var planStarted  = fmtDate(sub.plan_started_at || sub.member_since);
  var planExpires  = fmtDate(sub.plan_expires_at);
  var memberSince  = fmtDate(sub.member_since);

  // Price label
  var priceLabel = sub.price ? '$' + sub.price + '/mo' : '';

  // ── Card ─────────────────────────────────────────────────────────────────
  var html = '<div style="background:#0f1923;border:1px solid #2d3f55;border-radius:12px;padding:20px;margin-bottom:16px">'
    + '<div style="display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:18px">'
    +   '<div>'
    +     '<div style="font-size:11px;color:#7d8ba3;letter-spacing:0.5px;margin-bottom:4px">CURRENT PLAN</div>'
    +     '<div style="font-size:26px;font-weight:800;color:#e8edf5">' + plan.toUpperCase() + '</div>'
    +     (priceLabel ? '<div style="font-size:13px;color:#7d8ba3;margin-top:2px">' + priceLabel + '</div>' : '')
    +     (isFree ? '<div style="font-size:12px;color:#4b5563;margin-top:2px">Always free · no credit card needed</div>' : '')
    +   '</div>'
    +   '<div style="text-align:right">'
    +     '<span style="padding:4px 14px;background:' + stColor + '22;color:' + stColor + ';border:1px solid ' + stColor + '44;border-radius:20px;font-size:12px;font-weight:700">' + stLabel + '</span>'
    +     (sub.cancel_at_period_end ? '<div style="font-size:11px;color:#f87171;margin-top:6px">⚠️ Cancels ' + nextBilling + '</div>' : '')
    +   '</div>'
    + '</div>'

    // ── 3-column date grid ──────────────────────────────────────────────────
    + '<div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px;margin-bottom:14px">'

    // Plan Start
    +   '<div style="background:#131e2e;border-radius:8px;padding:12px">'
    +     '<div style="font-size:10px;color:#7d8ba3;margin-bottom:4px;text-transform:uppercase;letter-spacing:0.4px">' + (isFree ? 'Member Since' : 'Plan Started') + '</div>'
    +     '<div style="font-size:13px;color:#e8edf5;font-weight:600">' + (isFree ? memberSince : planStarted) + '</div>'
    +   '</div>'

    // Expiry / Next Billing
    +   '<div style="background:#131e2e;border-radius:8px;padding:12px">'
    +     '<div style="font-size:10px;color:#7d8ba3;margin-bottom:4px;text-transform:uppercase;letter-spacing:0.4px">' + (isFree ? 'Plan Type' : 'Plan Expires') + '</div>'
    +     '<div style="font-size:13px;font-weight:600;' + (!isFree && sub.plan_expires_at && new Date(sub.plan_expires_at) < new Date(Date.now() + 3*86400000) ? 'color:#f87171' : 'color:#e8edf5') + '">'
    +       (isFree ? '<span style="color:#0fb574">Free Forever</span>' : planExpires)
    +     '</div>'
    +   '</div>'

    // Plan Source or Next Billing Date
    +   '<div style="background:#131e2e;border-radius:8px;padding:12px">'
    +     '<div style="font-size:10px;color:#7d8ba3;margin-bottom:4px;text-transform:uppercase;letter-spacing:0.4px">' + (isStripe ? 'Next Billing Date' : (isFree ? 'Plan Source' : 'Managed Via')) + '</div>'
    +     '<div style="font-size:13px;font-weight:600">' + (isFree ? '<span style="color:#7d8ba3">—</span>' : (isStripe ? '<span style="color:#e8edf5">' + nextBilling + '</span>' : '<span style="color:' + srcMeta.color + '">' + srcMeta.icon + ' ' + srcMeta.label + '</span>')) + '</div>'
    +   '</div>'

    + '</div>'

    // ── Payment method row ──────────────────────────────────────────────────
    + '<div style="background:#131e2e;border-radius:8px;padding:12px;margin-bottom:16px;display:flex;align-items:center;justify-content:space-between">'
    +   '<div>'
    +     '<div style="font-size:10px;color:#7d8ba3;margin-bottom:4px;text-transform:uppercase;letter-spacing:0.4px">Payment Method</div>'
    +     '<div style="font-size:13px;color:#e8edf5;font-weight:600">'
    +       (pm.brand ? '💳 ' + pm.brand.toUpperCase() + ' ···· ' + pm.last4 + '   ' + pm.exp : '<span style="color:#7d8ba3">No card on file</span>')
    +     '</div>'
    +   '</div>'
    +   (!pm.brand ? '<div style="font-size:11px;color:#0070c0;cursor:pointer" onclick="_switchBillingTab(&apos;payment&apos;)">+ Add card</div>' : '')
    + '</div>'

    // ── Action buttons (Stripe = Manage/Cancel; internal sources = status only) ──
    + '<div style="display:flex;gap:10px;flex-wrap:wrap;align-items:center">'
    +   (isStripe ? '<button onclick="openBillingPortal()" style="padding:9px 18px;background:linear-gradient(135deg,#0070c0,#0050a0);border:none;border-radius:8px;color:#fff;font-size:12px;font-weight:600;cursor:pointer">Manage Billing ↗</button>' : '')
    +   '<button onclick="closeSubscriptionModal();showUpgrade(null,null)" style="padding:9px 18px;background:#2d3f55;border:none;border-radius:8px;color:#e8edf5;font-size:12px;cursor:pointer">' + (plan==='free' ? 'Upgrade Plan' : 'Change Plan') + '</button>'
    +   (isStripe && !sub.cancel_at_period_end ? '<button onclick="confirmCancel()" style="padding:9px 18px;background:none;border:1px solid #f87171;border-radius:8px;color:#f87171;font-size:12px;cursor:pointer">Cancel Subscription</button>' : '')
    +   (!isFree && !isStripe ? '<span style="font-size:12px;color:' + srcMeta.color + ';display:inline-flex;align-items:center;gap:5px;padding:6px 10px;background:' + srcMeta.color + '18;border:1px solid ' + srcMeta.color + '33;border-radius:8px">' + srcMeta.icon + ' ' + srcMeta.note + '</span>' : '')
    + '</div>'
    + '</div>';

  // ── Invoice / Payment history ─────────────────────────────────────────────
  html += '<div style="font-size:12px;font-weight:600;color:#7d8ba3;margin-bottom:10px;letter-spacing:0.5px">INVOICE HISTORY</div>';

  if (!payments.length) {
    html += '<div style="text-align:center;padding:24px;color:#7d8ba3;background:#0f1923;border:1px solid #2d3f55;border-radius:10px">No invoices yet</div>';
  } else {
    html += '<div style="background:#0f1923;border:1px solid #2d3f55;border-radius:12px;overflow:hidden">'
      + '<table style="width:100%;border-collapse:collapse">'
      + '<thead><tr style="border-bottom:1px solid #2d3f55">'
      + '<th style="padding:10px 14px;text-align:left;font-size:11px;color:#7d8ba3;font-weight:600">DATE</th>'
      + '<th style="padding:10px 14px;text-align:left;font-size:11px;color:#7d8ba3;font-weight:600">PLAN</th>'
      + '<th style="padding:10px 14px;text-align:left;font-size:11px;color:#7d8ba3;font-weight:600">PERIOD</th>'
      + '<th style="padding:10px 14px;text-align:right;font-size:11px;color:#7d8ba3;font-weight:600">AMOUNT</th>'
      + '<th style="padding:10px 14px;text-align:center;font-size:11px;color:#7d8ba3;font-weight:600">STATUS</th>'
      + '<th style="padding:10px 14px;text-align:center;font-size:11px;color:#7d8ba3;font-weight:600">INVOICE</th>'
      + '</tr></thead><tbody>';

    payments.forEach(function(p, i) {
      var dt      = fmtDate(p.created_at);
      var amt     = '$' + ((p.amount || 0) / 100).toFixed(2);
      var sc      = p.status==='paid'?'#0fb574':p.status==='failed'?'#f87171':'#f59e0b';
      var bg      = i % 2 === 0 ? '' : 'background:#0a1525;';
      var pName   = (p.plan || p.description || '—'); pName = pName.charAt(0).toUpperCase() + pName.slice(1);
      var period  = (p.billing_period_start && p.billing_period_end)
        ? fmtDate(p.billing_period_start) + ' – ' + fmtDate(p.billing_period_end)
        : '—';

      html += '<tr style="' + bg + 'border-bottom:1px solid #1a2535">'
        + '<td style="padding:10px 14px;font-size:12px;color:#c9d3e0;white-space:nowrap">' + dt + '</td>'
        + '<td style="padding:10px 14px;font-size:12px;color:#c9d3e0">' + pName + '</td>'
        + '<td style="padding:10px 14px;font-size:11px;color:#7d8ba3;white-space:nowrap">' + period + '</td>'
        + '<td style="padding:10px 14px;font-size:13px;font-weight:600;color:#e8edf5;text-align:right">' + amt + '</td>'
        + '<td style="padding:10px 14px;text-align:center"><span style="padding:2px 8px;background:' + sc + '22;color:' + sc + ';border-radius:20px;font-size:10px;font-weight:600">' + (p.status||'—').toUpperCase() + '</span></td>'
        + '<td style="padding:10px 14px;text-align:center">'
        +   (p.invoice_url
              ? '<a href="' + p.invoice_url + '" target="_blank" rel="noopener" style="display:inline-flex;align-items:center;gap:4px;padding:4px 10px;background:#0d2240;border:1px solid #1e3a5f;border-radius:6px;color:#60a5fa;font-size:11px;font-weight:600;text-decoration:none;white-space:nowrap">View ↗</a>'
              : (p.receipt_url
                  ? '<a href="' + p.receipt_url + '" target="_blank" rel="noopener" style="display:inline-flex;align-items:center;gap:4px;padding:4px 10px;background:#0d2240;border:1px solid #1e3a5f;border-radius:6px;color:#60a5fa;font-size:11px;font-weight:600;text-decoration:none;white-space:nowrap">Receipt ↗</a>'
                  : '<span style="color:#4b5563">—</span>'))
        + '</td>'
        + '</tr>';
    });
    html += '</tbody></table></div>';
  }

  body.innerHTML = html;
}

// ── TAB 2: Payment Method ─────────────────────────────────────────────────
async function _renderPaymentTab(body) {
  var sub = _subCache.sub || {};
  var pm  = sub.payment_method || {};
  _savedCard = (pm.brand && pm.last4) ? { brand: pm.brand, last4: pm.last4, exp: pm.exp||'' } : null;


  var html = '<div style="max-width:480px;margin:0 auto">';

  // Current card display
  if (pm.brand && pm.last4) {
    html += '<div style="background:#0f1923;border:1px solid #2d3f55;border-radius:12px;padding:18px;margin-bottom:20px;display:flex;align-items:center;gap:14px">'
      + '<div style="width:52px;height:34px;background:linear-gradient(135deg,#1a3a6b,#0f2044);border-radius:6px;display:flex;align-items:center;justify-content:center;font-size:18px">\ud83d\udcb3</div>'
      + '<div style="flex:1">'
      + '<div style="font-size:14px;font-weight:600;color:#e8edf5">' + pm.brand.toUpperCase() + ' \u00b7\u00b7\u00b7\u00b7 ' + pm.last4 + '</div>'
      + '<div style="font-size:11px;color:#7d8ba3;margin-top:2px">Expires ' + (pm.exp||'') + '</div>'
      + '</div>'
      + '<span style="padding:3px 8px;background:#0fb57422;color:#0fb574;border:1px solid #0fb57444;border-radius:12px;font-size:10px;font-weight:600">DEFAULT</span>'
      + '</div>';
  }

  html += '<div style="background:#0f1923;border:1px solid #2d3f55;border-radius:12px;padding:20px">'
    + '<div style="font-size:13px;font-weight:600;color:#e8edf5;margin-bottom:4px">' + (pm.brand ? 'Update Payment Method' : 'Add Payment Method') + '</div>'
    + '<div style="font-size:11px;color:#7d8ba3;margin-bottom:16px">Your card is encrypted and secured by Stripe. We never store card numbers.</div>'
    // Name on card
    + '<div style="margin-bottom:12px">'
    + '<label style="font-size:11px;color:#7d8ba3;display:block;margin-bottom:5px">Name on Card</label>'
    + '<input id="pm-name" placeholder="John Smith" style="width:100%;background:#131e2e;border:1px solid #2d3f55;border-radius:8px;padding:10px 12px;color:#e8edf5;font-size:13px;box-sizing:border-box;outline:none" onfocus="this.style.borderColor=\'#0070c0\'" onblur="this.style.borderColor=\'#2d3f55\'">'
    + '</div>'
    // Stripe card element mount point
    + '<div style="margin-bottom:16px">'
    + '<label style="font-size:11px;color:#7d8ba3;display:block;margin-bottom:5px">Card Details</label>'
    + '<div id="stripe-card-element" style="background:#131e2e;border:1px solid #2d3f55;border-radius:8px;padding:12px;min-height:40px"></div>'
    + '<div id="stripe-card-errors" style="color:#f87171;font-size:11px;margin-top:6px;min-height:16px"></div>'
    + '</div>'
    // Security badges
    + '<div style="display:flex;gap:8px;margin-bottom:16px;flex-wrap:wrap">'
    + ['🔒 SSL Encrypted','🛡️ Stripe Secured','✓ PCI Compliant'].map(function(b){ return '<span style="font-size:10px;color:#4b5563;background:#0a1525;border:1px solid #1a2535;padding:3px 8px;border-radius:12px">'+b+'</span>'; }).join('')
    + '</div>'
    + '<button id="pm-save-btn" onclick="savePaymentMethod()" style="width:100%;padding:12px;background:linear-gradient(135deg,#0070c0,#0050a0);border:none;border-radius:8px;color:#fff;font-size:13px;font-weight:600;cursor:pointer">Save Card</button>'
    + '</div></div>';

  body.innerHTML = html;
  await _initStripeCardElement();
}

// ── Init Stripe Elements ──────────────────────────────────────────────────
async function _initStripeCardElement() {
  try {
    // Load Stripe.js if not already loaded
    if (!window.Stripe) {
      await new Promise(function(resolve, reject) {
        if (document.getElementById('stripe-js')) { resolve(); return; }
        var s = document.createElement('script');
        s.id  = 'stripe-js';
        s.src = 'https://js.stripe.com/v3/';
        s.onload = resolve; s.onerror = reject;
        document.head.appendChild(s);
      });
    }
    // Fetch publishable key
    if (!window._stripePubKey) {
      var r = await window.fetch(API + '/profile/stripe-config');
      if (!r.ok) {
        var errDiv = document.getElementById('stripe-card-errors');
        if (errDiv) errDiv.innerHTML = '<div style="background:#f8717122;border:1px solid #f8717144;border-radius:8px;padding:12px;color:#f87171;font-size:12px">'
          + '⚠️ Stripe is not configured. Please contact support or try refreshing the page.</div>';
        var btn = document.getElementById('pm-save-btn');
        if (btn) { btn.disabled = true; btn.style.opacity = '0.5'; }
        return;
      }
      var d = await r.json();
      window._stripePubKey = d.publishable_key;
    }
    if (!window._stripePubKey) {
      var errDiv = document.getElementById('stripe-card-errors');
      if (errDiv) errDiv.innerHTML = '<div style="background:#f8717122;border:1px solid #f8717144;border-radius:8px;padding:12px;color:#f87171;font-size:12px">'
        + '⚠️ Stripe is not configured. Please contact support or try refreshing the page.</div>';
      var btn = document.getElementById('pm-save-btn');
      if (btn) { btn.disabled = true; btn.style.opacity = '0.5'; }
      return;
    }

    _stripeInstance = window.Stripe(window._stripePubKey);
    _stripeElements = _stripeInstance.elements();
    _stripeCardEl = _stripeElements.create('card', {
      style: {
        base: {
          color: '#e8edf5', fontSize: '14px', fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
          '::placeholder': { color: '#4b5563' },
          iconColor: '#7d8ba3'
        },
        invalid: { color: '#f87171', iconColor: '#f87171' }
      }
    });
    _stripeCardEl.mount('#stripe-card-element');
    _stripeCardEl.on('change', function(e) {
      var errEl = document.getElementById('stripe-card-errors');
      if (errEl) errEl.textContent = e.error ? e.error.message : '';
    });
  } catch (e) {
    var errEl = document.getElementById('stripe-card-errors');
    if (errEl) errEl.textContent = 'Could not load card form: ' + e.message;
    console.error('[Stripe init]', e);
  }
}

// ── Save card ─────────────────────────────────────────────────────────────
async function savePaymentMethod() {
  var btn = document.getElementById('pm-save-btn');
  var errEl = document.getElementById('stripe-card-errors');
  if (!_stripeInstance || !_stripeCardEl) {
    if (errEl) errEl.textContent = 'Card form not ready. Please wait a moment.';
    return;
  }
  if (btn) { btn.textContent = 'Processing...'; btn.disabled = true; }
  if (errEl) errEl.textContent = '';

  try {
    // Get SetupIntent client_secret from backend
    var siRes = await window.fetch(API + '/profile/setup-intent', {
      method: 'POST',
      headers: {'Content-Type':'application/json', 'Authorization': 'Bearer ' + S.token}
    });
    var siData = await siRes.json();
    if (!siRes.ok || !siData.client_secret) {
      if (errEl) errEl.textContent = siData.error || 'Could not initialize card form';
      if (btn) { btn.textContent = 'Save Card'; btn.disabled = false; }
      return;
    }

    var nameVal = (document.getElementById('pm-name') || {}).value || '';

    // Confirm SetupIntent with card element
    var result = await _stripeInstance.confirmCardSetup(siData.client_secret, {
      payment_method: {
        card: _stripeCardEl,
        billing_details: { name: nameVal || (S.user && (S.user.fullName || S.user.name)) || '' }
      }
    });

    if (result.error) {
      if (errEl) errEl.textContent = result.error.message;
      if (btn) { btn.textContent = 'Save Card'; btn.disabled = false; }
      return;
    }

    // Send payment_method.id to backend to attach + update DB
    var pmRes = await window.fetch(API + '/profile/update-payment-method', {
      method: 'POST',
      headers: {'Content-Type':'application/json', 'Authorization': 'Bearer ' + S.token},
      body: JSON.stringify({ payment_method_id: result.setupIntent.payment_method })
    });
    var pmData = await pmRes.json();
    if (!pmRes.ok) {
      if (errEl) errEl.textContent = pmData.error || 'Failed to save card';
      if (btn) { btn.textContent = 'Save Card'; btn.disabled = false; }
      return;
    }

    // Success — update cache and refresh the tab
    if (pmData.payment_method) {
      _subCache.sub = _subCache.sub || {};
      _subCache.sub.payment_method = pmData.payment_method;
    }
    if (btn) { btn.textContent = '\u2713 Card Saved!'; btn.style.background = '#0fb574'; }
    setTimeout(function() {
      _switchBillingTab('plan'); // go back to plan tab
    }, 1200);

  } catch (e) {
    if (errEl) errEl.textContent = 'Network error: ' + e.message;
    if (btn) { btn.textContent = 'Save Card'; btn.disabled = false; }
    console.error('[savePaymentMethod]', e);
  }
}

// ── TAB 3: Billing Address ────────────────────────────────────────────────
async function _renderBillingAddressTab(body) {
  body.innerHTML = '<div style="text-align:center;padding:24px;color:#7d8ba3">Loading billing info\u2026</div>';
  var addr = {};
  try {
    var r = await window.fetch(API + '/profile/billing-address', {
      headers: {'Authorization': 'Bearer ' + S.token}
    });
    if (r.ok) { var d = await r.json(); addr = d.address || {}; }
  } catch(e) {}

  var countries = ['US','GB','CA','AU','DE','FR','AE','SA','QA','KW','OM','BH','EG','JO','LB','IQ','YE','IN','PK','SG','MY','PH','ID','NG','ZA','BR','MX','AR','JP','KR'];
  var countryNames = {US:'United States',GB:'United Kingdom',CA:'Canada',AU:'Australia',DE:'Germany',FR:'France',AE:'UAE',SA:'Saudi Arabia',QA:'Qatar',KW:'Kuwait',OM:'Oman',BH:'Bahrain',EG:'Egypt',JO:'Jordan',LB:'Lebanon',IQ:'Iraq',YE:'Yemen',IN:'India',PK:'Pakistan',SG:'Singapore',MY:'Malaysia',PH:'Philippines',ID:'Indonesia',NG:'Nigeria',ZA:'South Africa',BR:'Brazil',MX:'Mexico',AR:'Argentina',JP:'Japan',KR:'South Korea'};

  var inputStyle = 'width:100%;background:#131e2e;border:1px solid #2d3f55;border-radius:8px;padding:10px 12px;color:#e8edf5;font-size:13px;box-sizing:border-box;outline:none';
  var labelStyle = 'font-size:11px;color:#7d8ba3;display:block;margin-bottom:5px';
  var focus      = "onfocus=\"this.style.borderColor='#0070c0'\" onblur=\"this.style.borderColor='#2d3f55'\"";

  var html = '<div style="max-width:480px;margin:0 auto">'
    + '<div style="background:#0f1923;border:1px solid #2d3f55;border-radius:12px;padding:20px">'
    + '<div style="font-size:13px;font-weight:600;color:#e8edf5;margin-bottom:4px">Billing Address</div>'
    + '<div style="font-size:11px;color:#7d8ba3;margin-bottom:18px">Used for invoices and tax purposes.</div>'
    // Name
    + '<div style="margin-bottom:12px"><label style="'+labelStyle+'">Full Name / Company</label>'
    + '<input id="ba-name" value="'+_esc(addr.name||'')+'" '+focus+' style="'+inputStyle+'" placeholder="John Smith"></div>'
    // Address line 1
    + '<div style="margin-bottom:12px"><label style="'+labelStyle+'">Address Line 1</label>'
    + '<input id="ba-line1" value="'+_esc(addr.address_line1||'')+'" '+focus+' style="'+inputStyle+'" placeholder="123 Main Street"></div>'
    // Address line 2
    + '<div style="margin-bottom:12px"><label style="'+labelStyle+'">Address Line 2 (optional)</label>'
    + '<input id="ba-line2" value="'+_esc(addr.address_line2||'')+'" '+focus+' style="'+inputStyle+'" placeholder="Suite, Floor, etc."></div>'
    // City + State
    + '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:12px">'
    + '<div><label style="'+labelStyle+'">City</label><input id="ba-city" value="'+_esc(addr.city||'')+'" '+focus+' style="'+inputStyle+'" placeholder="Dubai"></div>'
    + '<div><label style="'+labelStyle+'">State / Province</label><input id="ba-state" value="'+_esc(addr.state||'')+'" '+focus+' style="'+inputStyle+'" placeholder="Dubai"></div>'
    + '</div>'
    // Postal + Country
    + '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:18px">'
    + '<div><label style="'+labelStyle+'">Postal Code</label><input id="ba-postal" value="'+_esc(addr.postal_code||'')+'" '+focus+' style="'+inputStyle+'" placeholder="00000"></div>'
    + '<div><label style="'+labelStyle+'">Country</label>'
    + '<select id="ba-country" '+focus+' style="'+inputStyle+';cursor:pointer">'
    + countries.map(function(cc){ return '<option value="'+cc+'"'+(addr.country===cc?' selected':'')+'>'+countryNames[cc]+'</option>'; }).join('')
    + '</select></div>'
    + '</div>'
    + '<button id="ba-save-btn" onclick="saveBillingAddress()" style="width:100%;padding:12px;background:linear-gradient(135deg,#0070c0,#0050a0);border:none;border-radius:8px;color:#fff;font-size:13px;font-weight:600;cursor:pointer">Save Billing Info</button>'
    + '<div id="ba-msg" style="font-size:11px;margin-top:8px;min-height:14px;text-align:center"></div>'
    + '</div></div>';
  body.innerHTML = html;
}

function _esc(s) { return String(s||'').replace(/"/g,'&quot;').replace(/</g,'&lt;'); }

async function saveBillingAddress() {
  var btn = document.getElementById('ba-save-btn');
  var msg = document.getElementById('ba-msg');
  if (btn) { btn.textContent = 'Saving...'; btn.disabled = true; }
  if (msg) msg.textContent = '';
  try {
    var payload = {
      name:          (document.getElementById('ba-name')   ||{}).value||'',
      address_line1: (document.getElementById('ba-line1')  ||{}).value||'',
      address_line2: (document.getElementById('ba-line2')  ||{}).value||'',
      city:          (document.getElementById('ba-city')   ||{}).value||'',
      state:         (document.getElementById('ba-state')  ||{}).value||'',
      postal_code:   (document.getElementById('ba-postal') ||{}).value||'',
      country:       (document.getElementById('ba-country')||{}).value||'US'
    };
    var res = await window.fetch(API + '/profile/billing-address', {
      method:'POST', headers:{'Content-Type':'application/json','Authorization':'Bearer '+S.token},
      body: JSON.stringify(payload)
    });
    var d = await res.json();
    if (res.ok) {
      if (btn) { btn.textContent = '\u2713 Saved!'; btn.style.background='#0fb574'; }
      setTimeout(function(){ if(btn){btn.textContent='Save Billing Info';btn.style.background='';btn.disabled=false;} },2000);
    } else {
      if (msg) { msg.textContent = d.error||'Save failed'; msg.style.color='#f87171'; }
      if (btn) { btn.textContent='Save Billing Info'; btn.disabled=false; }
    }
  } catch(e) {
    if (msg) { msg.textContent='Network error'; msg.style.color='#f87171'; }
    if (btn) { btn.textContent='Save Billing Info'; btn.disabled=false; }
  }
}

async function openBillingPortal() {
  try {
    var res = await window.fetch(API + '/profile/billing-portal', {
      method: 'POST', headers: {'Content-Type':'application/json','Authorization':'Bearer '+S.token}
    });
    var d = await res.json();
    if (d.url) window.open(d.url, '_blank');
    else alert('Billing portal not available');
  } catch(e) { alert('Could not open billing portal'); }
}

async function confirmCancel() {
  if (!confirm('Cancel subscription? You keep access until the end of this billing period.')) return;
  try {
    var res = await window.fetch(API + '/profile/cancel', {
      method: 'POST', headers: {'Content-Type':'application/json','Authorization':'Bearer '+S.token}
    });
    var d = await res.json().catch(function(){ return {}; });
    if (res.ok) {
      alert('Subscription will cancel at end of billing period. You will keep access until then.');
      showSubscriptionModal();
    } else {
      alert('Could not cancel: ' + (d.error || 'Please try again or contact support.'));
    }
  } catch(e) {
    alert('Network error while cancelling. Please try again.');
  }
}



function closeSubscriptionModal() {
  var el = document.getElementById('subscription-overlay');
  if (el) el.style.display = 'none';
}




// ==============================================================================
// USAGE LIMITS & COUNTERS — DB-driven, never hardcoded
// ==============================================================================

var S_USAGE = {};  // Loaded per-user after login — see syncUsageFromServer
var S_GIFT = { queries:0, docs:0, voice:0, screen:0 };  // per-user company gift credit, from /profile/usage

function _usageKey() {
  return 'eoh_usage_' + ((S.user && S.user.id) || 'anon');
}
function saveUsage() {
  // Include voice in the saved blob so it survives page refresh
  var blob = Object.assign({}, S_USAGE, { voice: S.voiceMinsUsed || 0 });
  try { localStorage.setItem(_usageKey(), JSON.stringify(blob)); } catch(e) {}
}
function loadUsageFromCache() {
  try {
    var blob = JSON.parse(localStorage.getItem(_usageKey()) || '{}');
    S_USAGE = blob;
    // Restore voice from cache immediately — DB sync will overwrite later
    if (blob.voice !== undefined) S.voiceMinsUsed = blob.voice;
  } catch(e) { S_USAGE = {}; }
}

// ── ABSOLUTE DB SYNC — writes all 4 counters as authoritative values ──────────
// Debounced: coalesces rapid changes (e.g. multiple TTS calls) into one DB write.
// Backend uses MAX(current, incoming) so this is always safe and idempotent.
var _syncAllTimer = null;
function syncAllUsageToServer() {
  if (!S.user || !S.token) return;
  clearTimeout(_syncAllTimer);
  _syncAllTimer = setTimeout(function() {
    // For screen: only commit what's actually been committed to S_USAGE
    // (live elapsed is tracked in getUsage() but not committed until stopLiveScreen)
    var payload = {
      queries_used:     S_USAGE.queries    || 0,
      docs_used:        S_USAGE.docs       || 0,
      voice_mins_used:  parseFloat((S.voiceMinsUsed || 0).toFixed(2)),
      screen_mins_used: parseFloat((S_USAGE.screen  || 0).toFixed(2)),
      client_reset_date: S._lastResetDate || null   // Option B: lets the server detect a reset this client hasn't seen
    };
    window.fetch(API + '/profile/sync-usage', {
      method:  'POST',
      headers: {'Content-Type':'application/json', 'Authorization':'Bearer ' + S.token},
      body:    JSON.stringify(payload)
    }).then(function(r){ return r.json(); }).then(function(d) {
      if (d && d.ok && d.usage) {
        // DB replied with authoritative values — reconcile local state
        var u = d.usage;
        if (u.messages_used    !== undefined) { S_USAGE.queries = u.messages_used;    if (S.user) S.user.messagesUsed   = u.messages_used; }
        if (u.docs_used        !== undefined) { S_USAGE.docs    = u.docs_used;        if (S.user) S.user.docsUsed       = u.docs_used; }
        if (u.voice_mins_used  !== undefined) { S.voiceMinsUsed = u.voice_mins_used;  if (S.user) S.user.voiceMinsUsed  = u.voice_mins_used; }
        if (u.screen_mins_used !== undefined) { S_USAGE.screen  = u.screen_mins_used; if (S.user) S.user.screenMinsUsed = u.screen_mins_used; }
        saveUsage();  // persist authoritative values to localStorage
      }
    }).catch(function(){});  // silent — localStorage cache is the fallback
  }, 200);   // 200ms debounce: fast enough that a refresh won't lose data
}

function getUsage() {
  // For screen: add live elapsed time so bar + watcher see real-time usage during session
  var _screenBase = S_USAGE.screen || (S.user && S.user.screenMinsUsed) || 0;
  var _screenLimit = getLimits().screen || 0;
  // Cap base to limit so corrupted DB values can't pass through to the display
  if (_screenLimit > 0 && _screenBase > _screenLimit * 5) _screenBase = _screenLimit;
  var _screenElapsed = (_liveScreen.active && _liveScreen.startTime)
    ? parseFloat(((Date.now() - _liveScreen.startTime) / 60000).toFixed(2))
    : 0;
  var _screenLive = _screenBase + _screenElapsed;
  return {
    queries: S_USAGE.queries || (S.user && S.user.messagesUsed) || 0,
    docs:    S_USAGE.docs    || (S.user && S.user.docsUsed)     || 0,
    voice:   S.voiceMinsUsed || (S.user && S.user.voiceMinsUsed) || 0,
    screen:  _screenLive
  };
}

function getLimits() {
  var plan = (S.user && S.user.plan) ? S.user.plan : 'free';
  var p = PLAN_LIMITS[plan] || PLAN_LIMITS.free || {};
  // Fallback to auth-response limits if PLAN_LIMITS still at zero
  return {
    queries: (p.queries || (S.user && S.user.queriesLimit) || 0) + (S_GIFT.queries || 0),
    docs:    (p.docs    || (S.user && S.user.docsLimit)    || 0) + (S_GIFT.docs    || 0),
    voice:   (p.voice   || (S.user && S.user.voiceLimit)   || 0) + (S_GIFT.voice   || 0),
    screen:  (p.screen  || (S.user && S.user.screenLimit)  || 0) + (S_GIFT.screen  || 0),
    docMB:   p.docMB   || (S.user && S.user.docMBLimit)   || 5,
    fileDownload: p.fileDownload || (S.user && S.user.fileDownload) || false
  };
}

function incrementQuery() {
  S_USAGE.queries = (S_USAGE.queries || 0) + 1;
  if (S.user) S.user.messagesUsed = S_USAGE.queries;
  saveUsage();
  updateLimits();
  syncAllUsageToServer();  // persist to DB immediately
}

function incrementDoc() {
  S_USAGE.docs = (S_USAGE.docs || 0) + 1;
  if (S.user) S.user.docsUsed = S_USAGE.docs;
  saveUsage();
  updateLimits();
  syncAllUsageToServer();  // persist to DB immediately
}

// -- PLAN EXPIRY GATE ---------------------------------------------------------
function isPlanExpired() {
  if (!S.user) return false;
  var plan = (S.user.plan || 'free').toLowerCase();
  if (plan === 'free') return false;
  // plan_expires_at is the authoritative source.
  // If it exists and is in the future → plan is active regardless of subscription_status.
  // subscription_status like 'past_due' does NOT mean the plan has ended.
  var exp = S.user.planExpiresAt || S.user.plan_expires_at || null;
  if (exp) {
    var d = new Date(exp);
    if (!isNaN(d)) return d < new Date();
  }
  // No expiry date — fall back to status only
  var status = (S.user.subscriptionStatus || S.user.subscription_status || '').toLowerCase();
  if (status === 'expired' || status === 'canceled' || status === 'unpaid') return true;
  return false;
}

function showExpiredPopup() {
  var plan   = S.user && S.user.plan ? S.user.plan.toUpperCase() : 'YOUR';
  var exp    = S.user && (S.user.planExpiresAt || S.user.plan_expires_at);
  var expStr = exp ? new Date(exp).toLocaleDateString([], {year:'numeric',month:'long',day:'numeric'}) : '';
  var msg    = '⏰ YOUR ' + plan + ' PLAN HAS EXPIRED'
    + (expStr ? ' on ' + expStr : '')
    + ' — All features are locked. Renew or upgrade to continue.';
  var reasonEl = document.getElementById('upgrade-reason');
  if (reasonEl) {
    reasonEl.textContent = msg;
    reasonEl.style.background  = 'rgba(239,68,68,.12)';
    reasonEl.style.borderColor = 'rgba(239,68,68,.35)';
    reasonEl.style.color       = '#f87171';
  }
  var el = document.getElementById('upgrade-overlay');
  if (el) { el.style.display = 'flex'; var box = document.getElementById('upgrade-box'); if (box) box.scrollTop = 0; }
  _loadAndRenderPlans();
  _loadUpgradeSubtitle();
}

// -- CHECK LIMITS BEFORE ACTION -----------------------------------------------
function checkQueryLimit() {
  if (!S.user) return true;
  if (isPlanExpired()) { showExpiredPopup(); return false; }
  if (!_planLimitsLoaded) {
    removeTyping();
    addMsg('assistant', '\u23f3 Loading your plan details, please try again in a moment.', null);
    return false;
  }
  var usage  = getUsage();
  var limits = getLimits();
  if (limits.queries > 0 && usage.queries >= limits.queries) {
    var plan = (S.user.plan || 'free').toLowerCase();
    showUpgrade('queries', '\u26a0\ufe0f QUERY LIMIT REACHED - ' + usage.queries + '/' + limits.queries + ' queries used on ' + plan.toUpperCase() + ' plan.');
    addMsg('assistant', '\u26a0\ufe0f You\u2019ve reached your **' + limits.queries + ' query limit** on the ' + plan.toUpperCase() + ' plan. Please upgrade to continue chatting.', null);
    return false;
  }
  return true;
}

function checkDocLimit() {
  if (!S.user) { showUpgrade('docs', '\uD83D\uDD10 SIGN IN REQUIRED'); return false; }
  if (isPlanExpired()) { showExpiredPopup(); return false; }
  if (!_planLimitsLoaded) {
    showUpgrade('docs', '\u23f3 Loading plan details, please try again in a moment.');
    return false;
  }
  var usage  = getUsage();
  var limits = getLimits();
  if (limits.docs > 0 && usage.docs >= limits.docs) {
    showUpgrade('docs', '\uD83D\uDCC4 EXPORT LIMIT REACHED - ' + usage.docs + '/' + limits.docs + ' exports used this month on ' + (S.user.plan||'FREE').toUpperCase() + ' plan');
    return false;
  }
  return true;
}

function checkVoiceLimit() {
  if (!S.user) return false;
  if (isPlanExpired()) { showExpiredPopup(); return false; }
  if (!_planLimitsLoaded) {
    showUpgrade('voice', '\u23f3 Loading plan details, please try again in a moment.');
    return false;
  }
  var usage  = getUsage();
  var limits = getLimits();
  if (limits.voice <= 0) {
    showUpgrade('voice', '\uD83C\uDFA4 VOICE NOT INCLUDED - Upgrade to Basic or higher for voice support');
    return false;
  }
  // Clamp used to limit — old over-counted data must never permanently block voice
  var usedClamped = Math.min(usage.voice || 0, limits.voice);
  if (usedClamped >= limits.voice) {
    showUpgrade('voice', '\uD83C\uDFA4 VOICE LIMIT REACHED - ' + Math.floor(usedClamped) + '/' + limits.voice + ' mins used this month');
    return false;
  }
  return true;
}


// ===============================================================================
// TAB 4: USAGE HISTORY
// ===============================================================================

var _uhState = { page:1, feature:'', loading:false, rows:[], total:0, totalPages:0 };

// ── TAB 5: Active Sessions ───────────────────────────────────────────────
function _renderSessionsTab(body) {
  if (!body) return;
  body.innerHTML = '<div style="text-align:center;padding:30px;color:#7d8ba3">Loading sessions…</div>';
  window.fetch(API + '/auth/sessions', {
    headers: { 'Authorization': 'Bearer ' + (S.token || '') }
  })
  .then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
  .then(function(data) {
    var sessions  = data.sessions || [];
    var now       = new Date();

    // Helpers
    function parseUA(ua) {
      if (!ua) return { browser: 'Unknown', os: 'Unknown', icon: '🖥️' };
      var browser = ua.includes('Edg')     ? 'Edge'
                  : ua.includes('Chrome')  ? 'Chrome'
                  : ua.includes('Firefox') ? 'Firefox'
                  : ua.includes('Safari')  ? 'Safari'
                  : ua.includes('curl')    ? 'API'    : 'Browser';
      var os      = ua.includes('Windows') ? 'Windows'
                  : ua.includes('Mac')     ? 'macOS'
                  : ua.includes('iPhone') || ua.includes('iPad') ? 'iOS'
                  : ua.includes('Android') ? 'Android'
                  : ua.includes('Linux')   ? 'Linux'  : 'Unknown';
      var icon    = ua.includes('iPhone') || ua.includes('iPad') || ua.includes('Android') ? '📱' : '🖥️';
      return { browser: browser, os: os, icon: icon };
    }

    function timeAgo(dateStr) {
      if (!dateStr) return '—';
      var diff = Math.floor((now - new Date(dateStr)) / 1000);
      if (diff < 60)   return 'Just now';
      if (diff < 3600) return Math.floor(diff/60) + ' min ago';
      if (diff < 86400) return Math.floor(diff/3600) + ' hr ago';
      return Math.floor(diff/86400) + ' days ago';
    }

    // Sort: most recent first
    sessions.sort(function(a,b) {
      return new Date(b.updated_at || b.created_at) - new Date(a.updated_at || a.created_at);
    });

    var html = '<div style="margin-bottom:16px;display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:8px">'
      + '<div>'
      + '<div style="font-size:14px;font-weight:600;color:#e8edf5">🔐 Active Sessions</div>'
      + '<div style="font-size:11px;color:#7d8ba3;margin-top:2px">' + sessions.length + ' active session' + (sessions.length !== 1 ? 's' : '') + '</div>'
      + '</div>';

    if (sessions.length > 1) {
      html += '<button onclick="_revokeAllSessions()" style="padding:7px 14px;background:rgba(239,68,68,.15);color:#ef4444;border:1px solid rgba(239,68,68,.3);border-radius:6px;font-size:11px;font-weight:600;cursor:pointer">🚪 Sign Out All Other Devices</button>';
    }
    html += '</div>';

    if (!sessions.length) {
      html += '<div style="text-align:center;padding:30px;color:#7d8ba3;font-size:13px">No active sessions found.</div>';
    } else {
      html += '<div style="display:flex;flex-direction:column;gap:10px">';
      sessions.forEach(function(s, idx) {
        // Use pre-parsed browser/os from server if available, else parse user_agent
        var ua = (s.browser && s.os)
          ? { browser: s.browser, os: s.os, icon: (s.user_agent||'').match(/iPhone|iPad|Android/) ? '📱' : '🖥️' }
          : parseUA(s.user_agent || '');
        var when    = timeAgo(s.updated_at || s.created_at);
        var created = s.created_at ? new Date(s.created_at).toLocaleDateString([], {month:'short',day:'numeric',year:'numeric'}) : '—';
        var isCurrent = idx === 0; // most recent = current
        var expires = s.not_after ? new Date(s.not_after).toLocaleDateString([], {month:'short',day:'numeric'}) : '30 days';

        html += '<div style="background:#0d1f35;border:1px solid '+(isCurrent?'#0fb574':'#1e3a56')+';border-radius:10px;padding:14px 16px;display:flex;align-items:center;gap:14px">'
          + '<div style="font-size:28px;flex-shrink:0">' + ua.icon + '</div>'
          + '<div style="flex:1;min-width:0">'
          + '<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap">'
          + '<span style="font-size:13px;font-weight:600;color:#e8edf5">' + ua.browser + ' · ' + ua.os + '</span>'
          + (isCurrent ? '<span style="font-size:10px;background:rgba(15,181,116,.2);color:#0fb574;padding:2px 8px;border-radius:10px;font-weight:600">This device</span>' : '')
          + '</div>'
          + '<div style="font-size:11px;color:#7d8ba3;margin-top:4px;line-height:1.6">'
          + (s.ip ? 'IP: <span style="font-family:monospace">' + s.ip + '</span> · ' : '')
          + 'Last active: ' + when
          + ' · Signed in: ' + created
          + ' · Expires: ' + expires
          + '</div>'
          + '</div>';

        // Show revoke only for non-current sessions; skip if id='current' (API fallback)
        if (!isCurrent && s.id !== 'current') {
          html += '<button data-revoke-id="'+s.id+'" style="padding:6px 14px;background:rgba(239,68,68,.1);color:#ef4444;border:1px solid rgba(239,68,68,.25);border-radius:6px;font-size:11px;font-weight:600;cursor:pointer;flex-shrink:0;white-space:nowrap">Sign Out</button>';
        }
        html += '</div>';
      });
      html += '</div>';
    }

    // Security tip
    html += '<div style="margin-top:16px;background:rgba(59,130,246,.06);border:1px solid rgba(59,130,246,.15);border-radius:8px;padding:12px 14px;font-size:11px;color:#94a3b8;line-height:1.6">'
      + '💡 <strong style="color:#e8edf5">Don&#39;t recognize a session?</strong> Revoke it immediately and change your password. Each session is tied to a specific device and browser.'
      + '</div>';

    body.innerHTML = html;
  })
  .catch(function(e) {
    body.innerHTML = '<div style="color:#f87171;text-align:center;padding:20px">Failed to load sessions: ' + e.message + '</div>';
  });
}

// Event delegation for revoke buttons (avoids quote nesting issues)
document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-revoke-id]');
  if (btn) { var id = btn.getAttribute('data-revoke-id'); if (id) _revokeSession(id); }
});

async function _revokeSession(sessionId) {
  if (!confirm('Revoke this session? That device will be signed out immediately.')) return;
  try {
    var r = await window.fetch(API + '/auth/sessions/' + sessionId, {
      method: 'DELETE',
      headers: { 'Authorization': 'Bearer ' + (S.token || '') }
    });
    var d = await r.json();
    if (!r.ok) { alert(d.error || 'Failed to revoke session'); return; }
    // Refresh the tab
    var body = document.getElementById('billing-tab-body');
    _renderSessionsTab(body);
  } catch(e) { alert('Error: ' + e.message); }
}

async function _revokeAllSessions() {
  if (!confirm('Sign out all other devices? Your current session will remain active.')) return;
  try {
    var r = await window.fetch(API + '/auth/sessions', {
      method: 'DELETE',
      headers: { 'Authorization': 'Bearer ' + (S.token || '') }
    });
    var d = await r.json();
    if (!r.ok) { alert(d.error || 'Failed to sign out'); return; }
    var body = document.getElementById('billing-tab-body');
    _renderSessionsTab(body);
  } catch(e) { alert('Error: ' + e.message); }
}


function _renderUsageHistoryTab(body) {
  if (!body) return;
  // Sub-tab: Activity vs Plan History
  body.innerHTML =
    '<div style="display:flex;gap:0;margin-bottom:16px;border-bottom:1px solid #2d3f55">'
    + '<button id="uhtab-activity" onclick="_uhSubTab(\'activity\')" style="padding:8px 16px;background:none;border:none;border-bottom:2px solid #0ea5e9;color:#e8edf5;font-size:12px;font-weight:600;cursor:pointer">📊 Usage Activity</button>'
    + '<button id="uhtab-plans" onclick="_uhSubTab(\'plans\')" style="padding:8px 16px;background:none;border:none;border-bottom:2px solid transparent;color:#7d8ba3;font-size:12px;font-weight:400;cursor:pointer">📋 Plan History</button>'
    + '</div>'
    + '<div id="uh-root"><div style="text-align:center;padding:40px;color:#7d8ba3">Loading…</div></div>';
  _uhState.page = 1; _uhState.feature = ''; _uhState.rows = [];
  _uhLoadPage();
}

function _uhSubTab(tab) {
  ['activity','plans'].forEach(function(t) {
    var btn = document.getElementById('uhtab-' + t);
    if (!btn) return;
    var active = t === tab;
    btn.style.borderBottomColor = active ? '#0ea5e9' : 'transparent';
    btn.style.color    = active ? '#e8edf5' : '#7d8ba3';
    btn.style.fontWeight = active ? '600' : '400';
  });
  var root = document.getElementById('uh-root');
  if (!root) return;
  if (tab === 'activity') {
    root.innerHTML = '<div style="text-align:center;padding:40px;color:#7d8ba3">Loading…</div>';
    _uhState.page = 1; _uhState.feature = ''; _uhState.rows = [];
    _uhLoadPage();
  } else {
    _loadPlanHistory(root);
  }
}

async function _loadPlanHistory(root) {
  if (!root) return;
  root.innerHTML = '<div style="text-align:center;padding:30px;color:#7d8ba3">Loading plan history…</div>';
  try {
    var res = await window.fetch(API + '/profile/plan-history', {
      headers: { 'Authorization': 'Bearer ' + (S.token || '') }
    });
    if (!res.ok) throw new Error('HTTP ' + res.status);
    var data = await res.json();
    var rows     = data.history  || [];
    var invoices = data.invoices || [];

    if (!rows.length && !invoices.length) {
      root.innerHTML = '<div style="text-align:center;padding:40px;color:#7d8ba3">No plan history yet.</div>';
      return;
    }

    var planCols = {free:'#7d8ba3',basic:'#0070c0',professional:'#0fb574',business:'#8B5CF6',manager:'#f59e0b',enterprise:'#ef4444'};
    var srcLabels = { stripe:'Stripe', manual:'Manual Payment', admin:'Admin', system:'System', migration:'Migration' };
    var fmtDate = function(d) { return d ? new Date(d).toLocaleDateString([],{year:'numeric',month:'short',day:'numeric'}) : '—'; };
    var fmtAmt  = function(a) { return a ? '$' + (a/100).toFixed(2) : '—'; };

    var html = '';

    // Plan periods table
    if (rows.length) {
      html += '<div style="margin-bottom:20px">'
        + '<div style="font-size:12px;font-weight:700;color:#7d8ba3;text-transform:uppercase;letter-spacing:.5px;margin-bottom:10px">Plan Periods</div>'
        + '<div style="overflow-x:auto"><table style="width:100%;border-collapse:collapse;font-size:12px">'
        + '<thead><tr style="border-bottom:1px solid #2d3f55">'
        + '<th style="text-align:left;padding:6px 8px;color:#7d8ba3;font-weight:600">Plan</th>'
        + '<th style="text-align:left;padding:6px 8px;color:#7d8ba3;font-weight:600">Started</th>'
        + '<th style="text-align:left;padding:6px 8px;color:#7d8ba3;font-weight:600">Ended</th>'
        + '<th style="text-align:right;padding:6px 8px;color:#7d8ba3;font-weight:600">Queries</th>'
        + '<th style="text-align:right;padding:6px 8px;color:#7d8ba3;font-weight:600">Exports</th>'
        + '<th style="text-align:right;padding:6px 8px;color:#7d8ba3;font-weight:600">Voice</th>'
        + '<th style="text-align:left;padding:6px 8px;color:#7d8ba3;font-weight:600">Source</th>'
        + '</tr></thead><tbody>';
      rows.forEach(function(r) {
        var col = planCols[r.plan] || '#7d8ba3';
        html += '<tr style="border-bottom:1px solid #1a2d44">'
          + '<td style="padding:8px 8px"><span style="background:' + col + '20;color:' + col + ';padding:2px 8px;border-radius:10px;font-weight:700;font-size:11px;text-transform:uppercase">' + (r.plan||'free') + '</span></td>'
          + '<td style="padding:8px 8px;color:#94a3b8">' + fmtDate(r.started_at) + '</td>'
          + '<td style="padding:8px 8px;color:#94a3b8">' + fmtDate(r.ended_at) + '</td>'
          + '<td style="padding:8px 8px;text-align:right;color:#e8edf5">' + (r.messages_used||0) + '<span style="color:#7d8ba3">/' + (r.messages_limit||'—') + '</span></td>'
          + '<td style="padding:8px 8px;text-align:right;color:#e8edf5">' + (r.docs_used||0) + '<span style="color:#7d8ba3">/' + (r.docs_limit||'—') + '</span></td>'
          + '<td style="padding:8px 8px;text-align:right;color:#e8edf5">' + (parseFloat(r.voice_mins_used)||0).toFixed(0) + 'm<span style="color:#7d8ba3">/' + (r.voice_mins_limit||'—') + '</span></td>'
          + '<td style="padding:8px 8px;color:#7d8ba3">' + (srcLabels[r.source] || r.source || '—') + (r.note ? '<br><span style="font-size:10px">' + r.note + '</span>' : '') + '</td>'
          + '</tr>';
      });
      html += '</tbody></table></div></div>';
    }

    // Payment records
    if (invoices.length) {
      html += '<div>'
        + '<div style="font-size:12px;font-weight:700;color:#7d8ba3;text-transform:uppercase;letter-spacing:.5px;margin-bottom:10px">Payment Records</div>'
        + '<div style="overflow-x:auto"><table style="width:100%;border-collapse:collapse;font-size:12px">'
        + '<thead><tr style="border-bottom:1px solid #2d3f55">'
        + '<th style="text-align:left;padding:6px 8px;color:#7d8ba3">Date</th>'
        + '<th style="text-align:left;padding:6px 8px;color:#7d8ba3">Plan</th>'
        + '<th style="text-align:right;padding:6px 8px;color:#7d8ba3">Amount</th>'
        + '<th style="text-align:left;padding:6px 8px;color:#7d8ba3">Method</th>'
        + '<th style="text-align:left;padding:6px 8px;color:#7d8ba3">Status</th>'
        + '<th style="text-align:left;padding:6px 8px;color:#7d8ba3">Reference</th>'
        + '</tr></thead><tbody>';
      invoices.forEach(function(inv) {
        var stColor = inv.status === 'paid' ? '#22c55e' : inv.status === 'pending' ? '#f59e0b' : '#ef4444';
        html += '<tr style="border-bottom:1px solid #1a2d44">'
          + '<td style="padding:8px 8px;color:#94a3b8">' + fmtDate(inv.created_at) + '</td>'
          + '<td style="padding:8px 8px"><span style="color:' + (planCols[inv.plan]||'#7d8ba3') + ';font-weight:600;text-transform:uppercase;font-size:11px">' + (inv.plan||'—') + '</span></td>'
          + '<td style="padding:8px 8px;text-align:right;font-weight:600;color:#e8edf5">' + fmtAmt(inv.amount) + '</td>'
          + '<td style="padding:8px 8px;color:#94a3b8">' + (inv.method||'—') + '</td>'
          + '<td style="padding:8px 8px"><span style="color:' + stColor + ';font-weight:600;text-transform:uppercase;font-size:11px">' + (inv.status||'—') + '</span></td>'
          + '<td style="padding:8px 8px;color:#7d8ba3;font-size:11px">' + (inv.reference||'—') + '</td>'
          + '</tr>';
      });
      html += '</tbody></table></div></div>';
    }

    root.innerHTML = html;
  } catch(e) {
    root.innerHTML = '<div style="color:#f87171;padding:20px;text-align:center">Failed to load plan history.</div>';
  }
}

function _uhLoadPage() {
  if (_uhState.loading) return;
  _uhState.loading = true;
  var url = API + '/profile/usage-history?page=' + _uhState.page + '&limit=15'
    + (_uhState.feature ? '&feature=' + _uhState.feature : '');
  window.fetch(url, { headers: { 'Authorization': 'Bearer ' + (S.token || '') } })
    .then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
    .then(function(data) {
    _uhState.loading    = false;
    _uhState.rows       = data.history     || [];
    _uhState.total      = data.total       || 0;
    _uhState.totalPages = data.total_pages || 1;
    _uhRender();
  }).catch(function() {
    _uhState.loading = false;
    _uhState.loading = false;
    var root = document.getElementById('uh-root');
    if (root) root.innerHTML = '<div style="color:#f87171;padding:20px;text-align:center">Failed to load usage history.<br><span style="font-size:11px;color:#7d8ba3">Check that you are signed in and try again.</span></div>';
  });
}

function _uhRender() {
  var root = document.getElementById('uh-root');
  if (!root) return;
  var fIcons  = { query:'&#128172;', export:'&#128196;', voice:'&#127908;', screen:'&#128421;' };
  var fLabels = { query:'AI Query', export:'Export', voice:'Voice', screen:'Live Screen' };
  var fColors = { query:'#3B82F6', export:'#10B981', voice:'#8B5CF6', screen:'#F59E0B' };
  var html = '';

  // Mini summary cards
  html += '<div style="display:grid;grid-template-columns:repeat(4,1fr);gap:8px;margin-bottom:16px">';
  [['query','Q','Queries'],['export','E','Exports'],['voice','V','Voice Min'],['screen','S','Screen']].forEach(function(f) {
    var tot = 0;
    _uhState.rows.forEach(function(r) { if (r.feature === f[0]) tot += parseFloat(r.units_used || 0); });
    html += '<div style="background:#0d1f35;border:1px solid #1e3a56;border-radius:8px;padding:8px;text-align:center">'
      + '<div style="font-size:11px;font-weight:600;color:' + fColors[f[0]] + '">' + f[1] + '</div>'
      + '<div style="font-size:14px;font-weight:700;color:' + fColors[f[0]] + ';margin:3px 0">'
      + (f[0]==='voice'||f[0]==='screen' ? tot.toFixed(1) : Math.round(tot)) + '</div>'
      + '<div style="font-size:9px;color:#7d8ba3">' + f[2] + '</div></div>';
  });
  html += '</div>';

  // Filter bar
  html += '<div style="display:flex;gap:6px;flex-wrap:wrap;align-items:center;margin-bottom:12px">';
  [['','All'],['query','Queries'],['export','Exports'],['voice','Voice'],['screen','Screen']].forEach(function(f) {
    var active = _uhState.feature === f[0];
    html += '<button onclick="_uhFilter(\'' + f[0] + '\')" style="padding:3px 10px;font-size:11px;border-radius:20px;border:1px solid '
      + (active?'#3B82F6':'#2d3f55') + ';background:' + (active?'#3B82F6':'transparent') + ';color:' + (active?'#fff':'#9ab') + ';cursor:pointer">'
      + f[1] + '</button>';
  });
  html += '<span style="margin-left:auto;font-size:10px;color:#7d8ba3">' + _uhState.total + ' total</span></div>';

  // ── Group query rows by session_id — exports stay per-row ───────────────
  var displayRows = [];
  var sessionMap  = {};
  _uhState.rows.forEach(function(row) {
    if (row.feature === 'query') {
      var sid = row.session_id || ('nosess_' + row.id);
      if (!sessionMap[sid]) {
        sessionMap[sid] = {
          _type: 'session', session_id: sid, feature: 'query',
          plan: row.plan, created_at: row.created_at,
          vendor: row.vendor, product: row.product,
          queries: [], totalTokens: 0
        };
        displayRows.push(sessionMap[sid]);
      }
      sessionMap[sid].queries.push(row);
      sessionMap[sid].totalTokens += (row.tokens_input||0) + (row.tokens_output||0);
    } else {
      displayRows.push(row);
    }
  });

  // Rows
  if (!displayRows.length) {
    html += '<div style="text-align:center;padding:40px;color:#7d8ba3">No records yet. Usage appears here after your first action.</div>';
  } else {
    html += '<div style="display:flex;flex-direction:column;gap:7px">';
    displayRows.forEach(function(row) {
      var col = fColors[row.feature] || '#7d8ba3';
      var dt  = new Date(row.created_at).toLocaleString([],{month:'short',day:'numeric',hour:'2-digit',minute:'2-digit'});
      var planBadge = '<span style="font-size:9px;padding:1px 5px;background:#1e3a56;border-radius:4px;color:#9ab">' + (row.plan||'free').toUpperCase() + '</span>';
      var timeBadge = '<span style="margin-left:auto;font-size:10px;color:#7d8ba3">' + dt + '</span>';
      html += '<div style="background:#0d1f35;border:1px solid #1e3a56;border-radius:8px;padding:11px">';

      if (row._type === 'session') {
        // ── Per-chat session card ─────────────────────────────────────────
        var qs    = row.queries;
        var first = qs[qs.length - 1]; // oldest (list is DESC)
        var ctx   = (row.vendor||'') + (row.product ? ' · ' + row.product : '');
        html += '<div style="display:flex;align-items:center;gap:7px;margin-bottom:6px">'
          + '<span style="font-size:12px;font-weight:600;color:' + col + '">AI Query</span>'
          + planBadge
          + '<span style="font-size:10px;color:#4d6a85;padding:1px 6px;background:#0f172a;border-radius:4px">' + qs.length + ' message' + (qs.length>1?'s':'') + '</span>'
          + timeBadge + '</div>';
        if (first && first.query_text) {
          html += '<div style="font-size:11px;color:#c8d8e8;margin-bottom:4px;line-height:1.4">'
            + _uhEsc(first.query_text.substring(0,160)) + (first.query_text.length>160?'…':'') + '</div>';
        }
        var meta = [];
        if (ctx) meta.push('EOH · ' + ctx);
        if (row.totalTokens) meta.push(row.totalTokens.toLocaleString() + ' tokens total');
        if (meta.length) html += '<div style="font-size:10px;color:#4d6a85">' + meta.join(' | ') + '</div>';
        // Attachments from any query in this session
        qs.forEach(function(q) {
          if (q.attachment_name) {
            html += '<div style="margin-top:5px;display:flex;align-items:center;gap:6px">'
              + '<span style="font-size:10px;color:#9ab">📎 ' + _uhEsc(q.attachment_name) + ' (' + _uhSz(q.attachment_size) + ')</span>';
            if (q.attachment_url) html += '<button onclick="_uhDl(\'' + q.id + '\')" style="font-size:10px;padding:2px 7px;border-radius:4px;border:1px solid #3B82F6;background:transparent;color:#3B82F6;cursor:pointer">Download</button>';
            html += '</div>';
          }
        });

      } else if (row.feature === 'export') {
        // ── Export card — per-file (unchanged) ───────────────────────────
        html += '<div style="display:flex;align-items:center;gap:7px;margin-bottom:5px">'
          + '<span style="font-size:12px;font-weight:600;color:' + col + '">Export</span>'
          + planBadge + timeBadge + '</div>';
        html += '<div style="font-size:11px;color:#c8d8e8;margin-bottom:4px">📄 ' + _uhEsc(row.export_filename || 'Exported file');
        if (row.export_format) html += ' .' + row.export_format.toUpperCase();
        if (row.export_size)   html += '  ·  ' + _uhSz(row.export_size);
        html += '</div>';
        if (row.export_url) html += '<button onclick="_uhDl(\'' + row.id + '\')" style="font-size:10px;padding:3px 10px;border-radius:4px;border:1px solid #10B981;background:transparent;color:#10B981;cursor:pointer;margin-top:2px">⬇ Download File</button>';

      } else if (row.feature === 'voice') {
        // ── Voice card ───────────────────────────────────────────────────
        html += '<div style="display:flex;align-items:center;gap:7px;margin-bottom:5px">'
          + '<span style="font-size:12px;font-weight:600;color:' + col + '">Voice</span>'
          + planBadge + timeBadge + '</div>';
        var vm = [];
        if (row.voice_duration_secs) vm.push(_uhDur(row.voice_duration_secs));
        if (row.voice_language) vm.push(row.voice_language);
        vm.push('EOH');
        html += '<div style="font-size:11px;color:#c8d8e8;margin-bottom:3px">' + vm.join(' | ') + '</div>';
        if (row.voice_transcript) html += '<div style="font-size:10px;color:#7d8ba3;font-style:italic">"' + _uhEsc(row.voice_transcript.substring(0,100)) + (row.voice_transcript.length>100?'...':'') + '"</div>';

      } else if (row.feature === 'screen') {
        // ── Live Screen card ─────────────────────────────────────────────
        html += '<div style="display:flex;align-items:center;gap:7px;margin-bottom:5px">'
          + '<span style="font-size:12px;font-weight:600;color:' + col + '">Live Screen</span>'
          + planBadge + timeBadge + '</div>';
        if (row.screen_duration_secs) html += '<div style="font-size:11px;color:#c8d8e8;margin-bottom:3px">Duration: ' + _uhDur(row.screen_duration_secs) + '</div>';
        if (row.screen_analysis) html += '<div style="font-size:10px;color:#7d8ba3">' + _uhEsc(row.screen_analysis.substring(0,120)) + '...</div>';
      }

      html += '</div>';
    });
    html += '</div>';
  }
  // Pagination
  if (_uhState.totalPages > 1) {
    html += '<div style="display:flex;justify-content:center;align-items:center;gap:12px;margin-top:14px">'
      + '<button onclick="_uhPrev()" ' + (_uhState.page<=1?'disabled':'') + ' style="padding:4px 12px;border-radius:6px;border:1px solid #2d3f55;background:transparent;color:#9ab;cursor:pointer;font-size:11px">Prev</button>'
      + '<span style="font-size:11px;color:#7d8ba3">Page ' + _uhState.page + ' / ' + _uhState.totalPages + '</span>'
      + '<button onclick="_uhNext()" ' + (_uhState.page>=_uhState.totalPages?'disabled':'') + ' style="padding:4px 12px;border-radius:6px;border:1px solid #2d3f55;background:transparent;color:#9ab;cursor:pointer;font-size:11px">Next</button>'
      + '</div>';
  }

  root.innerHTML = html;
}

function _uhFilter(f) {
  _uhState.feature = f; _uhState.page = 1; _uhState.rows = [];
  var r = document.getElementById('uh-root');
  if (r) r.innerHTML = '<div style="text-align:center;padding:30px;color:#7d8ba3">Loading...</div>';
  _uhLoadPage();
}
function _uhPrev() { if (_uhState.page > 1) { _uhState.page--; _uhLoadPage(); } }
function _uhNext() { if (_uhState.page < _uhState.totalPages) { _uhState.page++; _uhLoadPage(); } }

function _uhDl(id) {
  var btn = event && event.target;
  var origText = btn ? btn.textContent : 'Download';
  if (btn) { btn.textContent = 'Getting link...'; btn.disabled = true; }
  window.fetch(API + '/profile/usage-history/download/' + id, { headers: { 'Authorization': 'Bearer ' + (S.token || '') } })
    .then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
    .then(function(data) {
      if (data.url) {
        // Storage signed URL — open directly
        var a = document.createElement('a');
        a.href = data.url; a.download = data.filename || 'download';
        document.body.appendChild(a); a.click(); document.body.removeChild(a);
        if (btn) { btn.textContent = '✓ Done'; setTimeout(function() { btn.textContent = origText; btn.disabled = false; }, 1500); }
      } else if (data.file) {
        // Base64 file from DB fallback
        try {
          var byteChars = atob(data.file);
          var byteArr = new Uint8Array(byteChars.length);
          for (var i = 0; i < byteChars.length; i++) byteArr[i] = byteChars.charCodeAt(i);
          var blob = new Blob([byteArr], { type: data.mimeType || 'application/octet-stream' });
          var url = URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = url; a.download = data.filename || 'export';
          document.body.appendChild(a); a.click(); document.body.removeChild(a);
          URL.revokeObjectURL(url);
          if (btn) { btn.textContent = '✓ Done'; setTimeout(function() { btn.textContent = origText; btn.disabled = false; }, 1500); }
        } catch(ex) { throw new Error('Decode failed'); }
      } else {
        if (btn) { btn.textContent = origText; btn.disabled = false; }
      }
    }).catch(function(e) {
      console.error('[Download]', e.message);
      if (btn) { btn.textContent = 'Retry'; btn.style.borderColor = '#ef4444'; btn.style.color = '#ef4444'; btn.disabled = false; }
      // Reset after 3s
      setTimeout(function() {
        if (btn) { btn.textContent = origText; btn.style.borderColor = ''; btn.style.color = ''; }
      }, 3000);
    });
}

function _uhEsc(s) { return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
function _uhSz(b)  { if (!b) return ''; if (b<1024) return b+'B'; if (b<1048576) return (b/1024).toFixed(1)+'KB'; return (b/1048576).toFixed(1)+'MB'; }
function _uhDur(s) { if (!s) return ''; var v=Math.round(s); return v<60 ? v+'s' : Math.floor(v/60)+'m '+(v%60)+'s'; }

// -- UPGRADE OVERLAY ----------------------------------------------------------

// ═══════════════════════════════════════════════════════════════════════════
// UPGRADE MODAL — fully dynamic from /admin/plans
// ═══════════════════════════════════════════════════════════════════════════
var _plansCache     = null;   // cached array of plan objects from DB
var _plansLoading   = false;
var _savedCard = null;  // prevent duplicate fetches

var PLAN_COLORS = {
  free:         '#7d8ba3',
  basic:        '#0070c0',
  professional: '#0fb574',
  business:     '#8B5CF6',
  manager:      '#f59e0b',
  enterprise:   '#ef4444'
};

// ── Public: open upgrade modal ─────────────────────────────────────────────
function closeUpgrade() {
  clearPromoCode();
  var el = document.getElementById('upgrade-overlay');
  if (el) el.style.display = 'none';

  // If plan is still expired after closing → lock interactive features
  // User can read history but cannot send/voice/export/screen
  if (isPlanExpired()) {
    _lockExpiredFeatures();
  }
}

function _lockExpiredFeatures() {
  // Disable send button
  var sendBtn = document.getElementById('send-btn');
  if (sendBtn) { sendBtn.disabled = true; sendBtn.style.opacity = '0.35'; sendBtn.title = 'Upgrade to send messages'; }

  // Disable & grey-out textarea
  var ta = document.getElementById('chat-ta');
  if (ta) {
    ta.disabled = true;
    ta.placeholder = 'Your plan has expired — upgrade to continue chatting';
    ta.style.opacity = '0.5';
    ta.style.cursor  = 'not-allowed';
  }

  // Disable voice button
  var vBtn = document.getElementById('voice-btn');
  if (vBtn) { vBtn.disabled = true; vBtn.style.opacity = '0.35'; vBtn.title = 'Upgrade to use voice'; }

  // Disable attach / new chat buttons that trigger features
  var attBtn = document.getElementById('attach-btn');
  if (attBtn) { attBtn.disabled = true; attBtn.style.opacity = '0.35'; }

  // Show persistent expired banner above input area
  var existing = document.getElementById('eoh-expired-banner');
  if (!existing) {
    var inputArea = document.getElementById('text-input-area') || document.querySelector('.input-area');
    if (inputArea) {
      var banner = document.createElement('div');
      banner.id = 'eoh-expired-banner';
      banner.style.cssText = 'background:rgba(239,68,68,.12);border-top:1px solid rgba(239,68,68,.3);padding:8px 16px;display:flex;align-items:center;justify-content:space-between;gap:12px;font-size:13px;color:#f87171;flex-shrink:0;';
      banner.innerHTML = '<span>⏰ Your plan has expired. You can read old chats but cannot send new messages.</span>'
        + '<button onclick="showExpiredPopup()" style="background:#ef4444;border:none;border-radius:6px;color:#fff;padding:5px 14px;font-size:12px;font-weight:600;cursor:pointer;white-space:nowrap">Upgrade Now</button>';
      inputArea.parentNode.insertBefore(banner, inputArea);
    }
  }
}

function _unlockExpiredFeatures() {
  // Re-enable send
  var sendBtn = document.getElementById('send-btn');
  if (sendBtn) { sendBtn.disabled = false; sendBtn.style.opacity = ''; sendBtn.title = ''; }

  // Re-enable textarea
  var ta = document.getElementById('chat-ta');
  if (ta) { ta.disabled = false; ta.placeholder = ''; ta.style.opacity = ''; ta.style.cursor = ''; }

  // Re-enable voice
  var vBtn = document.getElementById('voice-btn');
  if (vBtn) { vBtn.disabled = false; vBtn.style.opacity = ''; vBtn.title = ''; }

  // Re-enable attach
  var attBtn = document.getElementById('attach-btn');
  if (attBtn) { attBtn.disabled = false; attBtn.style.opacity = ''; }

  // Remove banner
  var banner = document.getElementById('eoh-expired-banner');
  if (banner) banner.remove();
}


// Promo Code System
var _activePromo = null;

async function applyPromoCode() {
  var input = document.getElementById('promo-code-input');
  var resultEl = document.getElementById('promo-result');
  var applyBtn = document.getElementById('promo-apply-btn');
  var code = (input ? input.value.trim().toUpperCase() : '');
  if (!code) { if (resultEl) resultEl.textContent = ''; return; }
  if (applyBtn) { applyBtn.disabled = true; applyBtn.textContent = 'Checking...'; }
  if (resultEl) { resultEl.style.color = '#7d8ba3'; resultEl.textContent = 'Validating...'; }
  try {
    var r = await window.fetch(API + '/admin/promo-codes/validate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + (S.token || '') },
      body: JSON.stringify({ code: code, user_id: S.user ? S.user.id : null })
    });
    var d = await r.json();
    if (!r.ok || !d.valid) {
      _activePromo = null;
      if (resultEl) { resultEl.style.color = '#f87171'; resultEl.textContent = 'x ' + (d.error || 'Invalid code'); }
      if (applyBtn) { applyBtn.disabled = false; applyBtn.textContent = 'Apply'; }
      if (_plansCache) _renderUpgradePlans(_plansCache);
      return;
    }
    _activePromo = Object.assign({}, d.promo, { code: code });
    var desc = '';
    if (_activePromo.type === 'percent') desc = _activePromo.value + '% discount applied!';
    else if (_activePromo.type === 'fixed') desc = '$' + (_activePromo.value / 100).toFixed(2) + ' off applied!';
    else if (_activePromo.type === 'trial') desc = _activePromo.value + ' extra trial days applied!';
    else if (_activePromo.type === 'plan') desc = 'Free access to ' + (_activePromo.plan || '') + ' plan!';
    if (resultEl) { resultEl.style.color = '#34d399'; resultEl.textContent = 'OK ' + desc; }
    if (applyBtn) { applyBtn.disabled = false; applyBtn.textContent = 'Applied'; applyBtn.style.background = '#065f46'; }
    if (_plansCache) _renderUpgradePlans(_plansCache);
  } catch (e) {
    _activePromo = null;
    if (resultEl) { resultEl.style.color = '#f87171'; resultEl.textContent = 'Connection error'; }
    if (applyBtn) { applyBtn.disabled = false; applyBtn.textContent = 'Apply'; }
  }
}

function clearPromoCode() {
  _activePromo = null;
  var input = document.getElementById('promo-code-input');
  var result = document.getElementById('promo-result');
  var btn = document.getElementById('promo-apply-btn');
  if (input) input.value = '';
  if (result) result.textContent = '';
  if (btn) { btn.textContent = 'Apply'; btn.style.background = '#0070c0'; btn.disabled = false; }
}

function _getDiscountedPrice(plan) {
  if (!_activePromo) return null;
  if (_activePromo.plan && _activePromo.plan !== 'any' && _activePromo.plan !== plan.key) return null;
  var price = plan.price || 0;
  if (price === 0) return null;
  if (_activePromo.type === 'percent') return parseFloat(Math.max(0, price - Math.round(price * _activePromo.value / 100) * 1).toFixed(2));
  if (_activePromo.type === 'fixed') return parseFloat(Math.max(0, price - Math.round(_activePromo.value / 100) * 1).toFixed(2));
  return null;
}


function _showPaymentThankYou(planLabel) {
  var ex = document.getElementById('pay-ty-modal'); if (ex) ex.remove();
  var m = document.createElement('div');
  m.id = 'pay-ty-modal';
  m.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.85);z-index:99999;display:flex;align-items:center;justify-content:center;padding:20px';
  m.innerHTML = '<div style="background:#131e2e;border:1px solid #2d3f55;border-radius:16px;max-width:480px;width:100%;padding:36px;text-align:center;position:relative">'
    + '<button onclick="document.getElementById(\'pay-ty-modal\').remove()" style="position:absolute;top:14px;right:16px;background:none;border:none;color:#7d8ba3;font-size:22px;cursor:pointer">&#10005;</button>'
    + '<div style="font-size:56px;margin-bottom:16px">&#127881;</div>'
    + '<h2 style="color:#ffffff;font-size:22px;font-weight:800;margin:0 0 8px">Welcome to ' + planLabel + '!</h2>'
    + '<p style="color:#8b949e;font-size:14px;margin:0 0 20px">Payment confirmed! Your account is upgraded and a confirmation email is on its way.</p>'
    + '<div style="background:#0a1525;border:1px solid #1e3a5f;border-radius:8px;padding:14px;margin-bottom:24px">'
    + '<div style="color:#7d8ba3;font-size:11px;text-transform:uppercase;letter-spacing:.5px;margin-bottom:6px">Active Plan</div>'
    + '<div style="color:#0fb574;font-size:20px;font-weight:800">' + planLabel.toUpperCase() + '</div>'
    + '</div>'
    + '<button onclick="document.getElementById(\'pay-ty-modal\').remove()" style="width:100%;padding:13px;background:linear-gradient(135deg,#0A8A5F,#0ea5e9);border:none;border-radius:8px;color:#fff;font-size:14px;font-weight:700;cursor:pointer">Start Using ERP Online Hub &#8594;</button>'
    + '</div>';
  document.body.appendChild(m);
  setTimeout(function(){ var x=document.getElementById('pay-ty-modal'); if(x) x.remove(); }, 30000);
}

function showUpgrade(reason, message) {
  var el = document.getElementById('upgrade-overlay');
  if (!el) return;
  var reasonEl = document.getElementById('upgrade-reason');
  if (reasonEl) reasonEl.textContent = message || '';
  el.style.display = 'flex';
  var box = document.getElementById('upgrade-box');
  if (box) box.scrollTop = 0;
  _loadAndRenderPlans();
  _loadUpgradeSubtitle();
}

// Load upgrade modal subtitle from app_settings (editable in admin)
var _subtitleLoaded = false;
function _loadUpgradeSubtitle() {
  if (_subtitleLoaded) return;
  window.fetch(API + '/admin/app-settings')
    .then(function(r){ return r.json(); })
    .then(function(d){
      var s = d.settings || {};
      var el = document.getElementById('upgrade-subtitle');
      if (el && s.upgrade_subtitle) {
        el.textContent = s.upgrade_subtitle;
      }
      // Also update the modal title if set
      var titleEl = document.querySelector('#upgrade-box h2');
      if (titleEl && s.upgrade_modal_title) titleEl.textContent = s.upgrade_modal_title;
      _subtitleLoaded = true;
    })
    .catch(function(){});
}

// ── Load plans from /admin/plans (cached) ─────────────────────────────────
function _loadAndRenderPlans() {
  // Always re-fetch — never serve stale cache (disabled plans must disappear immediately)
  if (_plansLoading) return;
  _plansLoading = true;

  // Show loading state while fetching
  var gridEl  = document.getElementById('upgrade-plans-grid');
  var loadEl  = document.getElementById('upgrade-plans-loading');
  if (gridEl)  gridEl.style.display  = 'none';
  if (loadEl)  loadEl.style.display  = 'block';
  if (loadEl)  loadEl.innerHTML = '<div style="text-align:center;padding:40px;color:#7d8ba3"><div style="font-size:24px;margin-bottom:8px">⏳</div>Loading plans...</div>';

  window.fetch(API + '/admin/plans')
    .then(function(r) { return r.json(); })
    .then(function(d) {
      _plansLoading = false;
      // Filter: backend already only returns is_active=true for unauthenticated calls,
      // but double-filter on disabled just in case
      _plansCache = (d.plans || []).filter(function(p) {
        return p.is_active !== false && !p.disabled;
      });
      _renderUpgradePlans(_plansCache);
    })
    .catch(function(e) {
      _plansLoading = false;
      var loadEl2 = document.getElementById('upgrade-plans-loading');
      if (loadEl2) loadEl2.innerHTML = '<div style="color:#f87171;padding:20px;text-align:center">Could not load plans. Please refresh.</div>';
      console.error('[EOH] Plans load error:', e.message);
    });
}

// ── Render plan cards from DB data ─────────────────────────────────────────
function _renderUpgradePlans(plans) {
  var gridEl   = document.getElementById('upgrade-plans-grid');
  var loadEl   = document.getElementById('upgrade-plans-loading');
  if (!gridEl) return;

  var currentPlan = (S.user && S.user.plan) ? S.user.plan.toLowerCase() : 'free';

  // Decide column count: ≤3 plans = minmax(200px), more = minmax(160px)
  var minW = plans.length <= 3 ? '200px' : plans.length <= 4 ? '180px' : '155px';
  gridEl.style.cssText = 'display:grid;grid-template-columns:repeat(auto-fit,minmax('+minW+',1fr));gap:14px;margin-bottom:24px';

  gridEl.innerHTML = plans.map(function(p) {
    return _buildPlanCard(p, currentPlan);
  }).join('');

  if (loadEl) loadEl.style.display = 'none';
  gridEl.style.display = 'grid';
}

// ── Build a single plan card ───────────────────────────────────────────────
function _buildPlanCard(p, currentPlan) {
  var key      = (p.key || '').toLowerCase();
  var color    = PLAN_COLORS[key] || '#0070c0';
  var isCurrent = key === currentPlan;
  var isFree   = key === 'free';
  var isEnterprise = key === 'enterprise';

  // Price display
  var priceHtml;
  if (p.price === 0 || !p.price) {
    priceHtml = '<div style="font-size:28px;font-weight:900;color:#e8edf5;line-height:1">$0</div>'
              + '<div style="font-size:11px;color:#7d8ba3;margin-bottom:16px">forever</div>';
  } else if (p.period === 'custom') {
    priceHtml = '<div style="font-size:28px;font-weight:900;color:#e8edf5;line-height:1">Custom</div>'
              + '<div style="font-size:11px;color:#7d8ba3;margin-bottom:16px">contact us</div>';
  } else {
    var _disc = _getDiscountedPrice(p);
    priceHtml = _disc !== null
      ? '<div style="font-size:14px;color:#7d8ba3;text-decoration:line-through">$' + p.price + '</div>'
        + '<div style="font-size:28px;font-weight:900;color:#34d399;line-height:1">$' + parseFloat(_disc).toFixed(2) + '</div>'
        + '<div style="font-size:10px;color:#34d399;font-weight:700">PROMO APPLIED</div>'
      : '<div style="font-size:28px;font-weight:900;color:#e8edf5;line-height:1">$' + p.price + '</div>'
              + '<div style="font-size:11px;color:#7d8ba3;margin-bottom:16px">/ ' + (p.period || 'month') + '</div>';
  }

  // Badge (Most Popular / custom badge)
  var badgeHtml = '';
  if (p.is_featured && p.badge_text) {
    badgeHtml = '<div style="position:absolute;top:-11px;left:50%;transform:translateX(-50%);'
      + 'background:' + color + ';color:#fff;font-size:10px;font-weight:700;padding:3px 12px;'
      + 'border-radius:20px;white-space:nowrap;letter-spacing:0.5px">' + p.badge_text + '</div>';
  }

  // Border style: featured gets colored border, current gets cyan
  var borderStyle = isCurrent ? '2px solid #0ea5e9'
                  : p.is_featured ? '2px solid ' + color
                  : '1px solid #2d3f55';

  // Features list — from DB features field (one per line)
  // Lines starting with '-' are "not included" (gray X), everything else is included (checkmark)
  var featuresHtml = '<ul style="list-style:none;padding:0;margin:0 0 16px;font-size:12px;color:#9ca3af;line-height:2;flex:1">';
  var featLines = [];

  // Always prepend auto-generated limits as first features
  if (p.queries && !isEnterprise) featLines.push('+' + _fmt(p.queries) + ' queries / mo');
  else if (isEnterprise)          featLines.push('+Unlimited queries');
  if (p.docs && !isEnterprise)    featLines.push('+' + _fmt(p.docs) + ' exports / mo');
  else if (isEnterprise)          featLines.push('+Unlimited exports');
  if (p.voice_mins && !isEnterprise) featLines.push('+' + _fmt(p.voice_mins) + ' voice mins');
  else if (isEnterprise)          featLines.push('+Unlimited voice');
  if (p.doc_mb)                   featLines.push('+File upload (' + p.doc_mb + 'MB)');

  // Then append admin-configured features
  if (p.features && p.features.trim()) {
    p.features.trim().split('\n').forEach(function(line) {
      line = line.trim();
      if (line) featLines.push(line);
    });
  }

  featLines.forEach(function(line) {
    var included = !line.startsWith('-');
    var text = line.replace(/^[+\-]/, '').trim();
    if (!text) return;
    // Plan-colored checkmarks for special plans
    var checkColor = included ? (key==='manager'||key==='enterprise' ? color : '#9ca3af') : '#4b5563';
    featuresHtml += '<li style="color:' + (included?checkColor:'#4b5563') + '">'
      + (included ? '&#10003;' : '&#10007;') + ' ' + text + '</li>';
  });
  featuresHtml += '</ul>';

  // Button
  var btnStyle, btnText;
  if (isCurrent) {
    btnStyle = 'background:#1e3a5c;cursor:default;color:#0ea5e9;border:1px solid #0ea5e9';
    btnText  = '&#10003; Current Plan';
  } else if (isEnterprise || p.period === 'custom') {
    btnStyle = 'background:' + color + '22;border:1px solid '+color+'44;color:'+color;
    btnText  = 'Contact Sales';
  } else if (isFree) {
    btnStyle = 'background:#2d3f55;color:#7d8ba3;cursor:default;border:none';
    btnText  = 'Free Plan';
  } else {
    // Gradient button using plan color
    var btnBg = key==='manager' ? 'linear-gradient(135deg,#f59e0b,#d97706)' 
              : key==='business' ? 'linear-gradient(135deg,#8B5CF6,#6D28D9)'
              : 'linear-gradient(135deg,' + color + ',' + _darken(color) + ')';
    var btnTxt = key==='manager' ? '#000' : '#fff';
    btnStyle = 'background:' + btnBg + ';border:none;color:' + btnTxt;
    btnText  = 'Upgrade &#8594;';
  }

  var cardBg = key === 'manager' ? '#130f05' : '#0f1923';

  return '<div class="plan-card" data-plan="' + key + '" style="background:' + cardBg + ';border:' + borderStyle
    + ';border-radius:14px;padding:20px 16px;display:flex;flex-direction:column;position:relative'
    + (p.is_featured ? ';margin-top:12px' : '') + '">'
    + badgeHtml
    + '<div style="font-size:10px;color:' + color + ';font-weight:700;letter-spacing:1.5px;margin-bottom:8px">' + (p.name||key).toUpperCase() + '</div>'
    + priceHtml
    + featuresHtml
    + '<button class="plan-btn" data-plan-select="' + key + '" data-plan="' + key + '"'
    + ' style="width:100%;padding:9px;border-radius:8px;font-size:12px;font-weight:' + (key==='manager'?'700':'600') + ';cursor:pointer;' + btnStyle + '">'

    + ((!isCurrent && !isFree && _savedCard) ? '<div style="margin-bottom:5px;font-size:10px;color:#34d399;text-align:center">saved card ready</div>' : '')
    + ((!isCurrent && !isFree && _savedCard) ? 'Pay with saved card' : btnText) + '</button>'
    + '</div>';
}

function _fmt(n) { return n >= 1000 ? (n/1000).toFixed(n%1000===0?0:1)+'k' : n; }
function _darken(hex) {
  // simple darkening: replace last 2 digits of each channel
  var m = hex.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i);
  if (!m) return hex;
  return '#' + [m[1],m[2],m[3]].map(function(x){ return Math.max(0,parseInt(x,16)-32).toString(16).padStart(2,'0'); }).join('');
}

// ── selectPlan: trigger Stripe checkout or contact ─────────────────────────
function selectPlan(planKey) {
  var currentPlan = (S.user && S.user.plan) ? S.user.plan.toLowerCase() : 'free';
  if (planKey === currentPlan || planKey === 'free') { closeUpgrade(); return; }

  // Find plan config from cache
  var planCfg = (_plansCache || []).find(function(p){ return p.key === planKey; });
  var priceId  = planCfg && planCfg.stripe_price_id ? planCfg.stripe_price_id.trim() : '';

  // Enterprise / custom → contact email
  if (planKey === 'enterprise' || (planCfg && planCfg.period === 'custom')) {
    window.open('mailto:support@erponlinehub.com?subject=Enterprise+Plan+Inquiry&body=Hi%2C+I%27m+interested+in+the+Enterprise+plan.+Please+contact+me.', '_blank');
    return;
  }

  // No Stripe key configured → show friendly message
  if (!priceId) {
    _showUpgradeError('Payment not yet configured for this plan. Please contact support or try again later.');
    return;
  }

  // If it's a direct Stripe payment link (buy.stripe.com or checkout.stripe.com)
  if (priceId.startsWith('http')) {
    var url = priceId;
    // Append prefill if possible
    if (S.user && S.user.email && !url.includes('prefilled_email')) {
      url += (url.includes('?') ? '&' : '?') + 'prefilled_email=' + encodeURIComponent(S.user.email);
    }
    window.open(url, '_blank');
    return;
  }

  // Use saved card (direct) or fall back to Stripe Checkout
  _showUpgradeLoading(planKey);
  if (_savedCard) {
    window.fetch(API + '/profile/subscribe-direct', {
      method: 'POST',
      headers: {'Content-Type':'application/json', 'Authorization': 'Bearer ' + (S.token||'')},
      body: JSON.stringify({ plan: planKey, promo_code: _activePromo ? _activePromo.code : null })
    }).then(function(r){ return r.json(); }).then(function(d){
      _hideUpgradeLoading();
      if (d.ok || d.already_on_plan) {
        _hideUpgradeLoading();
        closeUpgrade();
        var _lbl = (d.plan || planKey);
        _showPaymentThankYou(_lbl.charAt(0).toUpperCase() + _lbl.slice(1));
        // Sync usage from server (resets to 0) + update limits bar
        if (typeof syncUsageFromServer === 'function') {
          syncUsageFromServer().then(function() {
            if (S && S.token) {
              window.fetch(API + '/profile/subscription', { headers:{'Authorization':'Bearer '+S.token} })
                .then(function(r){ return r.json(); })
                .then(function(sd) {
                  if (sd.subscription && sd.subscription.plan) {
                    if (S.user) S.user.plan = sd.subscription.plan;
                    if (typeof updateLimits==='function') updateLimits();
                  }
                }).catch(function(){});
            }
          });
        }
        return;
      }
      // Needs 3DS or new card - fall to checkout
      if (d.requires_action || d.needs_checkout) { _fallbackToCheckout(planKey); return; }
      if (d.payment_declined) {
        _hideUpgradeLoading();
        _showUpgradeError('\u26a0\ufe0f ' + (d.error || 'Payment declined. Please update your card and try again.'));
        return;
      }
      _hideUpgradeLoading();
      _showUpgradeError(d.error || 'Payment failed. Try again.');
    }).catch(function(){ _fallbackToCheckout(planKey); });
    return;
  }
  _fallbackToCheckout(planKey);
}

function _fallbackToCheckout(planKey) {
  _showUpgradeLoading(planKey);
  var _t = setTimeout(function() { _hideUpgradeLoading(); _showUpgradeError('Request timed out. Please try again.'); }, 15000);
  window.fetch(API + '/profile/subscribe', {
    method: 'POST',
    headers: {'Content-Type':'application/json', 'Authorization': 'Bearer ' + (S.token||'')},
    body: JSON.stringify({ plan: planKey, promo_code: _activePromo ? _activePromo.code : null })
  }).then(function(r){ return r.json(); }).then(function(d){
    clearTimeout(_t);
    if (d.upgraded && d.plan) {
      // Plan changed directly via subscription update - no Stripe checkout needed
      _hideUpgradeLoading();
      closeUpgrade();
      _showPaymentThankYou(d.plan.charAt(0).toUpperCase() + d.plan.slice(1));
      if (typeof syncUsageFromServer === 'function')
        syncUsageFromServer().then(function(){ if(typeof updateLimits==='function') updateLimits(); });
    } else if (d.url) {
      // Open Stripe checkout in new tab
      var _a = document.createElement('a');
      _a.href = d.url; _a.target = '_blank'; _a.rel = 'noopener';
      document.body.appendChild(_a); _a.click(); document.body.removeChild(_a);
      _hideUpgradeLoading(); // restore button since we stay on this page
    } else {
      _hideUpgradeLoading();
      _showUpgradeError(d.error || 'Stripe not configured. Please contact support.');
    }
  }).catch(function(e) {
    clearTimeout(_t);
    _hideUpgradeLoading();
    _showUpgradeError('Network error. Please try again.');
  });
}

function _showUpgradeLoading(planKey) {
  document.querySelectorAll('.plan-btn').forEach(function(btn) {
    if (btn.dataset.plan === planKey) {
      btn.dataset.origText = btn.textContent; // save for restore
      btn.textContent = _savedCard ? 'Processing...' : 'Redirecting to Stripe...';
      btn.disabled = true;
      btn.style.opacity = '0.7';
    }
  });
}
function _hideUpgradeLoading() {
  document.querySelectorAll('.plan-btn').forEach(function(btn) {
    btn.disabled = false;
    btn.style.opacity = '1';
  });
  // Re-render plans to restore original button text
  if (_plansCache && _plansCache.length) _renderUpgradePlans(_plansCache);
}
function _showUpgradeError(msg) {
  var reasonEl = document.getElementById('upgrade-reason');
  if (reasonEl) {
    reasonEl.style.color = '#f87171';
    reasonEl.textContent = '⚠️ ' + msg;
    setTimeout(function(){ if(reasonEl){ reasonEl.style.color='#f59e0b'; reasonEl.textContent=''; } }, 5000);
  }
}

// ── updatePlanButtons: called after plan change ────────────────────────────
function updatePlanButtons(currentPlan) {
  // Re-render if plans already loaded
  if (_plansCache) {
    _renderUpgradePlans(_plansCache);
  }
}

// ── Invalidate cache when admin changes plans ──────────────────────────────
function invalidatePlansCache() { _plansCache = null; }


// ── Upgrade overlay — unified event delegation (CSP-safe, no inline onclick) ──
document.addEventListener('click', function(e) {
  var overlay = document.getElementById('upgrade-overlay');
  if (!overlay || overlay.style.display !== 'flex') return;

  // Click outside the box → close
  if (e.target === overlay) { closeUpgrade(); return; }

  // Close button (data-close-upgrade attribute)
  if (e.target.closest('[data-close-upgrade]')) { closeUpgrade(); return; }

  // Plan select button (data-plan-select attribute)
  var planBtn = e.target.closest('[data-plan-select]');
  if (planBtn) {
    var planKey = planBtn.getAttribute('data-plan-select');
    if (planKey) selectPlan(planKey);
    return;
  }
});

// -- SESSION VARS -------------------------------------------------------------
var S_sessionId      = null;
// Stable per-conversation memory key, shared with live screen & voice so the
// chat→screen handoff stays one durable thread. Independent of the server
// session id (which is null on the first message, then changes) so it never splits.
function _genMemId() { return 'm-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10); }
var S_memSession     = _genMemId();
var S_autoSaveTimer  = null;
var _sessionsCache   = [];
var _searchQ         = '';
var _saving          = false;
var _pendingSave     = false;
var _pendingSkip     = false;

var _ctxMenu         = null;

function startAutoSave() {
  if (S_autoSaveTimer) clearInterval(S_autoSaveTimer);
  S_autoSaveTimer = setInterval(function() {
    if (S.history && S.history.length >= 2 && S.user) saveCurrentSession(true);
  }, 10000);
}

// -- SERVER SYNC --------------------------------------------------------------
var _syncInProgress = false;
// Merge server user object without losing client-side fields like learningBalance
function _mergeUser(newUser) {
  if (!newUser) return;
  var _keep = {
    learningBalance:   S.user && S.user.learningBalance,
    learningUnlimited: S.user && S.user.learningUnlimited,
    learningQuota:     S.user && S.user.learningQuota
  };
  S.user = newUser;
  if (_keep.learningBalance   != null) S.user.learningBalance   = _keep.learningBalance;
  if (_keep.learningUnlimited != null) S.user.learningUnlimited = _keep.learningUnlimited;
  if (_keep.learningQuota     != null) S.user.learningQuota     = _keep.learningQuota;
}

async function syncLearningBalance() {
  if (!S.token || !S.user) return;
  window.fetch(API + '/learning/balance', {
    method:'GET', headers:{'Authorization':'Bearer '+S.token}
  }).then(function(r){ return r.ok ? r.json() : null; }).then(function(d) {
    if (!d || !S.user) return;
    console.log('[EOH] syncLearningBalance response:', JSON.stringify(d));
    S.user.learningBalance   = d.balance   != null ? d.balance   : 0;
    S.user.learningUnlimited = !!d.unlimited;
    S.user.learningQuota     = d.plan_limit || 0;
    window._learningBalanceSynced = true;  // now safe to display
    console.log('[EOH] learningBalance set to:', S.user.learningBalance, '| planCfg learningEnabled:', !!(VOICE_CONFIG[S.user.plan||'free']||{}).learningEnabled);
    updateLimits();
  }).catch(function(e){ console.error('[EOH] syncLearningBalance failed:', e); });
}

async function syncUsageFromServer() {
  if (!S.user || !S.token) return;
  if (_syncInProgress) return;  // prevent parallel calls
  _syncInProgress = true;
  try {
    // Load user-specific cache first so bar shows something while waiting
    loadUsageFromCache();
    updateLimits();
    _syncInterviewQuota();   // interview quota rides along with every usage sync

    var res = await window.fetch(API + '/profile/usage', {
      headers: {'Authorization': 'Bearer ' + S.token},
      cache: 'no-store'
    });
    if (res.status === 403) {
      var _sb = await res.json().catch(function(){return {};});
      if (_sb.error === 'account_blocked') {
        _syncInProgress = false;
        showBlockedModal(S.user ? S.user.blockReason : null);
        return;
      }
    }
    if (!res.ok) { _syncInProgress = false; return; }
    var d = await res.json();
    // Server is authoritative — sync block status + expiry on every tick
    if (S.user) {
      S.user.isBlocked   = d.is_blocked    || false;
      S.user.blockReason = d.block_reason  || null;
      if (d.plan_expires_at) {
        S.user.planExpiresAt   = d.plan_expires_at;
        S.user.plan_expires_at = d.plan_expires_at;
        S.user.isExpired = (d.plan && d.plan !== 'free') ? new Date(d.plan_expires_at) < new Date() : false;
      }
      try { localStorage.setItem('eoh_u', JSON.stringify(S.user)); } catch(_) {}
    }
    if (d.is_blocked) {
      // Still blocked — show/keep modal
      showBlockedModal(d.block_reason || null);
      _syncInProgress = false;
      return;
    } else {
      // Was unblocked since last sync — remove modal if showing
      var _bOverlay = document.getElementById('eoh-blocked-overlay');
      if (_bOverlay) { hideBlockedModal(); }
    // Server-confirmed plan status decides the expiry lock (no cache-based flash, no stale flags):
    // lock ONLY when THIS response shows a paid plan whose expiry is genuinely in the past.
    var _srvExpired = !!(d.plan && d.plan !== 'free' && d.plan_expires_at && new Date(d.plan_expires_at) < new Date());
    if (S.user && _srvExpired) {
      _lockExpiredFeatures();
    } else {
      var _expBanner = document.getElementById('eoh-expired-banner');
      if (_expBanner) { _unlockExpiredFeatures(); }
    }
    }
    var u = d.usage || {};
    var _srvQ = u.queries     ? (u.queries.used     || 0) : 0;
    var _srvD = u.docs        ? (u.docs.used        || 0) : 0;
    var _srvV = u.voice_mins  ? (u.voice_mins.used  || 0) : 0;
    var _srvS = u.screen_mins ? (u.screen_mins.used || 0) : 0;

    // Per-user company gift credit — added on top of the plan limit so the usage
    // bar and the client-side gates match the gift-aware server (checkLimit).
    S_GIFT = {
      queries: (u.queries     && u.queries.gift)     || 0,
      docs:    (u.docs        && u.docs.gift)        || 0,
      voice:   (u.voice_mins  && u.voice_mins.gift)  || 0,
      screen:  (u.screen_mins && u.screen_mins.gift) || 0
    };

    // ── Reset adoption via reset-date (Option B) ────────────────────────────
    // The server tells us when usage was last reset (admin "Reset Usage", plan
    // change, invoice, cron). If that date is NEWER than the one we last saw, a
    // reset happened that this browser doesn't know about — so our local counts
    // are stale (pre-reset). Adopt the server values and clear the cache,
    // regardless of whether the counters are all zero (the user may have used a
    // little since the reset). This is what makes an admin reset STICK instead
    // of the browser pushing old values back after the grace window.
    var _srvResetDate = d.usage_reset_date || (u.usage_reset_date) || null;
    var _seenReset = S._lastResetDate || null;
    var _serverResetIsNewer = _srvResetDate && (!_seenReset || new Date(_srvResetDate).getTime() > new Date(_seenReset).getTime());
    if (_serverResetIsNewer) {
      console.log('[EOH] Newer server reset detected (' + _srvResetDate + ') — adopting server usage, clearing stale cache');
      S_USAGE.queries = _srvQ;
      S_USAGE.docs    = _srvD;
      S_USAGE.screen  = _srvS;
      S.voiceMinsUsed = _srvV;
      S._lastResetDate = _srvResetDate;
      if (S.user) {
        S.user.messagesUsed  = _srvQ; S.user.docsUsed = _srvD;
        S.user.voiceMinsUsed = _srvV; S.user.screenMinsUsed = _srvS;
      }
      saveUsage(); updateLimits();
      _syncInProgress = false;
      return;   // done — server reset is authoritative this tick
    }
    if (_srvResetDate) S._lastResetDate = _srvResetDate;   // remember latest seen

    // Reset detection: if ALL server counters are 0, the DB was reset (plan upgrade/manual invoice).
    // Trust the DB unconditionally — don't apply MAX which would preserve stale local values.
    var _allServerZero = (_srvQ === 0 && _srvD === 0 && _srvV === 0 && _srvS === 0);
    var _anyLocalUsage = ((S_USAGE.queries || 0) > 0 || (S_USAGE.docs || 0) > 0 ||
                          (S.voiceMinsUsed || 0) > 0 || (S_USAGE.screen || 0) > 0);

    if (_allServerZero && _anyLocalUsage) {
      // Server says 0 but we have local usage — server reset wins, clear local cache
      console.log('[EOH] Server reset detected — clearing local usage cache');
      S_USAGE.queries = 0;
      S_USAGE.docs    = 0;
      S_USAGE.screen  = 0;
      S.voiceMinsUsed = 0;
    } else {
      // Normal: use MAX so a message sent 1s ago doesn't get erased by a stale DB read
      S_USAGE.queries = Math.max(S_USAGE.queries || 0, _srvQ);
      S_USAGE.docs    = Math.max(S_USAGE.docs    || 0, _srvD);
      // Auto-correct corrupted screen_mins_used (e.g. 16834 from bad stopLiveScreen)
      var _screenLim  = u.screen_mins ? (u.screen_mins.limit || 0) : 0;
      var _isCorrupt  = _screenLim > 0 && _srvS > _screenLim * 5;
      if (_isCorrupt) {
        console.warn('[EOH] Corrupted screen_mins_used (' + _srvS + '/' + _screenLim + ') — resetting');
        _srvS = 0;
        window.fetch(API + '/profile/reset-screen-usage', {
          method: 'POST', headers: {'Content-Type':'application/json','Authorization':'Bearer '+S.token},
          body: JSON.stringify({reset_to: 0})
        }).catch(function(){});
      }
      S_USAGE.screen  = Math.max(S_USAGE.screen  || 0, _srvS);
      S.voiceMinsUsed = Math.max(S.voiceMinsUsed || 0, _srvV);
    }

    // Propagate to S.user so getUsage() is consistent
    if (S.user) {
      S.user.messagesUsed  = S_USAGE.queries;
      S.user.docsUsed      = S_USAGE.docs;
      S.user.voiceMinsUsed = S.voiceMinsUsed;
      S.user.screenMinsUsed= S_USAGE.screen;
    }

    // ── Sync avatar from server into S.user on every load ───────────────────
    var _srvAvatar = d.avatar_url || d.avatar || '';
    if (_srvAvatar && S.user) {
      var _hadAvatar = !!(S.user.avatar || S.user.avatar_url);
      S.user.avatar     = _srvAvatar;
      S.user.avatar_url = _srvAvatar;
      try { localStorage.setItem('eoh_u', JSON.stringify(S.user)); } catch(_) {}
      if (!_hadAvatar) updateUserUI(); // only re-render if we just got an avatar
    }

    // ── Correct S.user.plan immediately from server (fixes stale 'free' after login)
    if (d.plan && S.user && d.plan !== S.user.plan) {
      var _prevPlan = S.user.plan;
      console.log('[EOH] Plan corrected:', _prevPlan, '→', d.plan);
      S.user.plan = d.plan;
      if (d.subscription_status) S.user.subscriptionStatus  = d.subscription_status;
      if (d.subscription_status) S.user.subscription_status = d.subscription_status;
      if (d.plan_expires_at)     S.user.planExpiresAt        = d.plan_expires_at;
      // Clear expired state — new active plan just detected
      S.user.isExpired = false;
      try { localStorage.setItem('eoh_u', JSON.stringify(S.user)); } catch(_) {}
      updateLimits();
      // If user just upgraded from an expired/lower plan → close popup + celebrate
      if (d.plan !== 'free' && _prevPlan !== d.plan) {
        closeUpgrade();
        _unlockExpiredFeatures();
        var _newPlanName = d.plan.charAt(0).toUpperCase() + d.plan.slice(1);
        addMsg('assistant', '🎉 Your plan has been upgraded to **' + _newPlanName + '**! Your quota has been reset — you are all set to continue.', null);
        // Re-sync learning balance — webhook may have updated it after the previous sync
        if (typeof syncLearningBalance === 'function') {
          setTimeout(syncLearningBalance, 1500);
          setTimeout(syncLearningBalance, 4000); // second attempt in case webhook is slow
        }
      }
    }

    // Push limits from DB into PLAN_LIMITS — single source of truth
    var plan = (S.user && S.user.plan) || 'free';
    if (!PLAN_LIMITS[plan]) PLAN_LIMITS[plan] = {};
    if (u.queries     && u.queries.limit     !== undefined) PLAN_LIMITS[plan].queries = u.queries.limit;
    if (u.docs        && u.docs.limit        !== undefined) PLAN_LIMITS[plan].docs    = u.docs.limit;
    if (u.voice_mins  && u.voice_mins.limit  !== undefined) PLAN_LIMITS[plan].voice   = u.voice_mins.limit;
    if (u.screen_mins && u.screen_mins.limit !== undefined) PLAN_LIMITS[plan].screen  = u.screen_mins.limit;

    _planLimitsLoaded = true;
    saveUsage();  // Saves all 4 counters including voice to localStorage
    updateLimits();
    console.log('[EOH] Usage synced from DB — queries:', S_USAGE.queries, '| docs:', S_USAGE.docs, '| voice:', S.voiceMinsUsed, '| screen:', S_USAGE.screen);
  } catch(e) {
    console.error('[EOH] syncUsageFromServer error:', e);
  } finally {
    _syncInProgress = false;
  }
}

async function syncIncrementToServer(type, extras) {
  if (!S.user || !S.token) return;
  try {
    var res = await window.fetch(API + '/profile/increment-usage', {
      method: 'POST',
      headers: {'Content-Type':'application/json','Authorization':'Bearer '+S.token},
      body: JSON.stringify(Object.assign({type: type, sessionId: S_sessionId}, extras || {}))
    });
    var d = await res.json();
    if (res.status === 429) {
      // Server says over limit — force full sync
      await syncUsageFromServer();
      return;
    }
    // Server returned authoritative totals — update local state immediately
    if (res.ok && d.usage) {
      var u = d.usage;
      if (u.messages_used    !== undefined) { S_USAGE.queries = u.messages_used;    if (S.user) S.user.messagesUsed   = u.messages_used; }
      if (u.docs_used        !== undefined) { S_USAGE.docs    = u.docs_used;        if (S.user) S.user.docsUsed       = u.docs_used; }
      if (u.voice_mins_used  !== undefined) { S.voiceMinsUsed = u.voice_mins_used;  if (S.user) S.user.voiceMinsUsed  = u.voice_mins_used; }
      if (u.screen_mins_used !== undefined) { S_USAGE.screen  = u.screen_mins_used; if (S.user) S.user.screenMinsUsed = u.screen_mins_used; }
      saveUsage();
      updateLimits();
    }
  } catch(e) {}
}

// -- PATCHES ------------------------------------------------------------------
// Patch incrementQuery — sync to server after local increment
// NOTE: do NOT call syncAllUsageToServer() here — it races with syncIncrementToServer
var _origIncrementQuery = incrementQuery;
incrementQuery = function() {
  _origIncrementQuery.call(this);
  syncIncrementToServer('query', {vendor: S.vendor, product: S.product});
  // No syncAllUsageToServer() — causes race with increment-usage → double deduction
  if (S.user && S.token && S.history && S.history.length >= 2) saveCurrentSession(true);
};

// Patch incrementDoc — sync to server after local increment
// NOTE: do NOT call syncAllUsageToServer() here — it races with syncIncrementToServer
// and causes double-deduction. syncIncrementToServer returns authoritative DB values
// which are immediately applied to S_USAGE, so syncAllUsageToServer is redundant.
var _origIncrementDoc = incrementDoc;
incrementDoc = function() {
  _origIncrementDoc.call(this);
  syncIncrementToServer('doc', {vendor: S.vendor, product: S.product, format: S.lastExportFmt});
  // No syncAllUsageToServer() here — causes race condition → double deduction
  saveCurrentSession(true);
};

// Patch resetChat — save session before reset
var _origResetChat = resetChat;
resetChat = function() {
  if (S.user && S.token && S.history && S.history.length >= 2 && S_sessionId) saveCurrentSession(true);
  S_sessionId = null;
  _origResetChat();
};

// Save on tab switch
// Cross-tab logout: when any tab calls doLogout(), all other tabs detect
// the 'eoh_logout' key being written and immediately clear state + reload.
window.addEventListener('storage', function(e) {
  // Admin toggled ratings — update immediately without page refresh
  if (e.key === 'eoh_ratings_off') {
    window._ratingsEnabled = e.newValue !== '1';
    var bar = document.getElementById('eoh-rating-bar');
    if (bar) bar.style.display = window._ratingsEnabled ? '' : 'none';
  }
  if (e.key === 'eoh_logout' && e.newValue) {
    // Another tab logged out — clean up this tab silently
    S.user = null; S.token = null;
    try { if (window._supabaseClient) window._supabaseClient.auth.signOut(); } catch(_) {}
    // Small delay so the writing tab finishes its own reload first
    setTimeout(function() { window.location.reload(); }, 200);
  }
  // Also react if token is removed directly (extra safety net)
  if (e.key === 'eoh_t' && !e.newValue && S.user) {
    S.user = null; S.token = null;
    setTimeout(function() { window.location.reload(); }, 200);
  }
});

window.addEventListener('visibilitychange', function() {
  if (document.visibilityState === 'hidden' && S.user && S.token) {
    // Flush usage to DB whenever tab goes to background
    syncAllUsageToServer();
    if (S.history && S.history.length >= 2) saveCurrentSession(true);
  }
});

// Save on page close (sendBeacon for reliability)
window.addEventListener('beforeunload', function() {
  // ── Flush usage counters to DB on every page close / refresh ──
  if (S.user && S.token) {
    clearTimeout(_syncAllTimer);  // cancel pending debounce — flush NOW
    var usagePayload = {
      token: S.token,
      queries_used:     S_USAGE.queries || 0,
      docs_used:        S_USAGE.docs    || 0,
      voice_mins_used:  parseFloat((S.voiceMinsUsed || 0).toFixed(2)),
      screen_mins_used: parseFloat((S_USAGE.screen  || 0).toFixed(2)),
      client_reset_date: S._lastResetDate || null   // Option B: reset guard on unload flush too
    };
    navigator.sendBeacon(API + '/profile/sync-usage?beacon=1',
      new Blob([JSON.stringify(usagePayload)], {type: 'application/json'}));
  }
  // ── Flush session chat history ──
  if (S.user && S.token && S.history && S.history.length >= 2 && S_sessionId) {
    // Attach the latest cited sources to the newest assistant message first.
    try {
      if (window._eohLastSources && window._eohLastSources.length && S.history) {
        for (var _bi = S.history.length - 1; _bi >= 0; _bi--) {
          if (S.history[_bi].role === 'assistant') { if (!S.history[_bi].sources) S.history[_bi].sources = window._eohLastSources; break; }
        }
      }
    } catch (_) {}
    var msgs = S.history.map(function(m) {
      var o = { role: m.role, content: m.content || '', timestamp: m.timestamp || new Date().toISOString() };
      if (m.file) o.file = { name: m.file.name, size: m.file.size || 0, type: m.file.type || '' };
      if (m.exportFile) o.exportFile = m.exportFile;
      if (m.attachments && m.attachments.length) o.attachments = m.attachments.map(function(a){ return { kind:a.kind, key:a.key, name:a.name, mime:a.mime, size:a.size }; });
      if (m.sources && m.sources.length) o.sources = m.sources.map(function(s){ return { title:s.title||'', url:s.url||'', source:s.source||'' }; }).filter(function(s){ return s.url; }).slice(0,15);
      return o;
    });
    navigator.sendBeacon(API + '/sessions?beacon=1', new Blob([JSON.stringify({
      token: S.token,
      sessionId: S_sessionId, messages: msgs, vendor: S.vendor || 'SAP', product: S.product || 'S/4HANA'
    })], {type: 'application/json'}));
  }
});

// Patch updateUserUI — after login: refresh token, sync usage, load sessions, start autosave
var _origUpdateUserUI = updateUserUI;
updateUserUI = function() {
  // Force limits update immediately when user state changes
  setTimeout(function(){ if(S.user) updateLimits(); }, 100);
  _origUpdateUserUI();
  if (S.user && S.token) {
    var rt = localStorage.getItem('eoh_rt');
    if (rt) {
      if (_refreshInFlight) return;  // another refresh is already in progress
      // Skip refresh on fresh OAuth login — token is already new.
      // Calling refresh immediately causes a race: the stale httpOnly cookie
      // (not yet cleared by /auth/clear-cookie) gets used → 401 → session cleared.
      // Do NOT clear __oauthCallback here — _initOnReady owns this flag.
      // Race condition: on fast connections PKCE exchange (SIGNED_IN) fires BEFORE
      // _initOnReady runs, setting __oauthCallback=false and skipping OAuth handler.
      if (window.__oauthCallback) { return; }
      // Also skip if this is a fresh reload after OAuth login (within 90 seconds)
      try {
        var _oaFresh = parseInt(localStorage.getItem('eoh_oauth_fresh') || '0', 10);
        if (_oaFresh && (Date.now() - _oaFresh) < 90000) {
          localStorage.removeItem('eoh_oauth_fresh');
          syncUsageFromServer(); loadSessions(); startAutoSave();
          return;
        }
      } catch(_) {}
      // FIX2: Second guard — if the EOH token itself was saved less than 5 min ago
      // it is still fresh (e.g. eoh_oauth_fresh failed to persist due to tracking prevention).
      // Calling /auth/refresh this early consumes the single-use Supabase refresh token → auto-logout.
      try {
        var _tTsGuard = parseInt(localStorage.getItem('eoh_t_ts') || '0', 10);
        if (_tTsGuard && (Date.now() - _tTsGuard) < 5 * 60 * 1000) {
          syncUsageFromServer(); loadSessions(); startAutoSave();
          return;
        }
      } catch(_) {}
      _refreshInFlight = true;
      window.fetch(API + '/auth/refresh', {
        method:'POST', headers:{'Content-Type':'application/json'},
        credentials: 'include',
        body: JSON.stringify({refresh_token: rt})
      }).then(function(r){return r.json();}).then(function(d) {
        _refreshInFlight = false;
        if (d.token) {
          S.token = d.token; localStorage.setItem('eoh_t', d.token); localStorage.setItem('eoh_t_ts', String(Date.now()));
          if (d.refresh_token) localStorage.setItem('eoh_rt', d.refresh_token);
          if (d.user) { _mergeUser(d.user); localStorage.setItem('eoh_u', JSON.stringify(S.user)); }
          syncUsageFromServer(); loadSessions(); startAutoSave();
        } else if (d.error && (d.error.includes('expired') || d.error.includes('invalid'))) {
          // Our backend refresh failed — try refreshing directly via Supabase client
          // getSession() returns cached (expired) token — we need refreshSession() for a NEW one
          _supabase.auth.refreshSession().then(function(_sbr) {
            var sess = _sbr.data && _sbr.data.session;
            if (sess && sess.access_token) {
              // Got a fresh token from Supabase directly
              localStorage.setItem('eoh_t', sess.access_token);
              localStorage.setItem('eoh_t_ts', String(Date.now()));
              if (sess.refresh_token) localStorage.setItem('eoh_rt', sess.refresh_token);
              S.token = sess.access_token;
              console.log('[EOH] Recovered via Supabase refreshSession — new token saved');
              syncUsageFromServer(); loadSessions(); startAutoSave();
            } else {
              // FIX3: Before logging out, verify the EOH token itself is not still fresh.
              // This handles the case where /auth/refresh was called too early after OAuth
              // and the single-use Supabase refresh token was already consumed.
              try {
                var _tTsChk = parseInt(localStorage.getItem('eoh_t_ts') || '0', 10);
                if (_tTsChk && (Date.now() - _tTsChk) < 5 * 60 * 1000) {
                  console.warn('[EOH] Supabase refresh failed but EOH token is fresh — keeping session');
                  syncUsageFromServer(); loadSessions(); startAutoSave();
                  return;
                }
              } catch(_) {}
              // Supabase refresh also failed — force re-login
              console.warn('[EOH] Both backend and Supabase refresh failed — clearing session');
              localStorage.removeItem('eoh_t'); localStorage.removeItem('eoh_rt');
              localStorage.removeItem('eoh_u');
              S.token = null; S.user = null;
              showModal('login');
            }
          }).catch(function() {
            // FIX3: Same token-age guard in the catch path
            try {
              var _tTsChk2 = parseInt(localStorage.getItem('eoh_t_ts') || '0', 10);
              if (_tTsChk2 && (Date.now() - _tTsChk2) < 5 * 60 * 1000) {
                console.warn('[EOH] Supabase refreshSession catch — EOH token is fresh, keeping session');
                syncUsageFromServer(); loadSessions(); startAutoSave();
                return;
              }
            } catch(_) {}
            localStorage.removeItem('eoh_t'); localStorage.removeItem('eoh_rt');
            localStorage.removeItem('eoh_u');
            S.token = null; S.user = null;
            showModal('login');
          });
        } else {
          // Backend returned unexpected response — keep existing token and continue
          console.warn('[EOH] Unexpected refresh response — keeping existing session:', d);
          syncUsageFromServer(); loadSessions(); startAutoSave();
        }
      }).catch(function() {
        // Network error during refresh — DO NOT log out, keep current session
        console.warn('[EOH] Refresh network error — keeping session, proceeding normally');
        syncUsageFromServer(); loadSessions(); startAutoSave();
      });
    } else {
      syncUsageFromServer(); loadSessions(); startAutoSave();
    }
  }
};

// Auto-refresh token every 45 minutes to keep session alive
var _refreshInFlight = false;  // prevent concurrent refresh attempts
setInterval(function() {
  var rt = localStorage.getItem('eoh_rt');
  if (!rt || !S.token || _refreshInFlight) return;
  _refreshInFlight = true;
  window.fetch(API + '/auth/refresh', {
    method:'POST', headers:{'Content-Type':'application/json'},
    credentials: 'include',
    body: JSON.stringify({refresh_token: rt})
  }).then(function(r){return r.json();}).then(function(d) {
    _refreshInFlight = false;
    if (d.token) {
      S.token = d.token;
      localStorage.setItem('eoh_t', d.token);
      localStorage.setItem('eoh_t_ts', String(Date.now()));
      if (d.refresh_token) localStorage.setItem('eoh_rt', d.refresh_token);
    } else if (d.error && (d.error.includes('expired') || d.error.includes('invalid'))) {
      // Periodic refresh token expired — try Supabase direct refresh
      _supabase.auth.refreshSession().then(function(sr) {
        var s = sr.data && sr.data.session;
        if (s && s.access_token) {
          S.token = s.access_token;
          localStorage.setItem('eoh_t', s.access_token);
          localStorage.setItem('eoh_t_ts', String(Date.now()));
          if (s.refresh_token) localStorage.setItem('eoh_rt', s.refresh_token);
        }
      }).catch(function(){});
    }
  }).catch(function(){ _refreshInFlight = false; });
}, 45 * 60 * 1000);


// -- LIMITS --------------------------------------------------------------------
function updateLimits() {
  if (!S.user) return;
  var limits = getLimits();
  var usage  = getUsage();
  var qPct  = limits.queries > 0 ? usage.queries / limits.queries : 0;
  var dPct  = limits.docs    > 0 ? usage.docs    / limits.docs    : 0;
  var vPct  = limits.voice   > 0 ? (usage.voice||0) / limits.voice : 0;
  var sPct  = (limits.screen||0) > 0 ? (usage.screen||0) / limits.screen : 0;
  var vLeft = Math.max(0, limits.voice - (usage.voice||0));

  var qEl   = document.getElementById('lim-q');
  var dEl   = document.getElementById('lim-d');
  var vEl   = document.getElementById('lim-v');
  var sEl   = document.getElementById('lim-s');
  var sWrap = document.getElementById('lim-s-wrap');
  var vm    = document.getElementById('vmins');

  // Query counter + gate send/attach buttons
  var qHit = qPct >= 1 && limits.queries > 0;
  if (qEl) {
    qEl.textContent      = usage.queries + '/' + limits.queries + ' queries';
    qEl.style.color      = qHit ? '#f87171' : qPct >= 0.8 ? '#fb923c' : '#9ca3af';
    qEl.style.fontWeight = qHit ? '700' : '';
  }
  var sendBtn = document.getElementById('send-btn');
  var attachBtn = document.getElementById('attach-btn');
  if (_planLimitsLoaded && sendBtn && S.chatActive) {
    sendBtn.disabled      = qHit;
    sendBtn.title         = qHit ? 'Query limit reached — upgrade to continue' : '';
    sendBtn.style.opacity = qHit ? '0.4' : '';
  }
  if (_planLimitsLoaded && attachBtn) {
    attachBtn.disabled      = qHit;
    attachBtn.style.opacity = qHit ? '0.4' : '';
  }

  // Export counter
  var dHit = dPct >= 1 && limits.docs > 0;
  if (dEl) {
    dEl.textContent      = usage.docs + '/' + limits.docs + ' exports';
    dEl.style.color      = dHit ? '#f87171' : dPct >= 0.8 ? '#fb923c' : '#9ca3af';
    dEl.style.fontWeight = dHit ? '700' : '';
  }

  // Voice counter + gate voice button
  var vHit = vPct >= 1 && limits.voice > 0;
  if (vEl) {
    // Voice is charged in FRACTIONS of a minute per turn (e.g. ~0.3 min). Flooring to a
    // whole number made the live counter appear stuck at 0 until a full minute accrued —
    // which is why voice "didn't count live" and only looked right after refresh (once it
    // had crossed a whole number). Show ONE DECIMAL so each turn is visible immediately.
    var _vRaw = usage.voice || 0;
    var _vUsedDisplay = limits.voice > 0 ? Math.min(_vRaw, limits.voice) : _vRaw;
    _vUsedDisplay = (Math.round(_vUsedDisplay * 10) / 10).toFixed(1);
    vEl.textContent      = _vUsedDisplay + '/' + limits.voice + ' voice mins';
    vEl.style.color      = vHit ? '#f87171' : vPct >= 0.8 ? '#fb923c' : '#9ca3af';
    vEl.style.fontWeight = vHit ? '700' : '';
  }
  if (vm) vm.textContent = vLeft.toFixed(0) + ' min left';
  var voiceBtn = document.getElementById('voice-btn');
  if (_planLimitsLoaded && voiceBtn) {
    voiceBtn.disabled      = vHit;
    voiceBtn.title         = vHit ? 'Voice limit reached — upgrade for more' : '';
    voiceBtn.style.opacity = vHit ? '0.4' : '';
    if (vHit && S.voiceOn) endInlineVoice();
  }

  // Screen / Live counter + gate live buttons
  // Only act on live buttons AFTER plan config is loaded — never hide based on zero defaults
  var planKey = (S.user && S.user.plan) || 'free';
  // hasLive: BOTH feature flag (live_screen=On) AND screen_mins > 0 must be true.
  // Feature flag is the master switch — screen_mins alone does NOT enable Live.
  var _vcPlan  = VOICE_CONFIG[planKey] || {};
  var hasLive  = _planLimitsLoaded && !!_vcPlan.live && (limits.screen > 0);
  var sHit    = sPct >= 1 && (limits.screen||0) > 0;
  if (sWrap) sWrap.style.display = (hasLive && _planLimitsLoaded) ? '' : 'none';
  if (sEl && hasLive && _planLimitsLoaded) {
    var _sDisp = (usage.screen||0) < 1 ? parseFloat((usage.screen||0).toFixed(1)) : Math.floor(usage.screen||0);
    sEl.textContent      = _sDisp + '/' + (limits.screen||0) + ' live mins';
    sEl.style.color      = sHit ? '#f87171' : sPct >= 0.8 ? '#fb923c' : '#9ca3af';
    sEl.style.fontWeight = sHit ? '700' : '';
  }
  if (_planLimitsLoaded) {
    ['live-btn','live-header-btn'].forEach(function(id) {
      var btn = document.getElementById(id);
      if (!btn) return;
      if (!hasLive) { btn.style.display = 'none'; return; }
      btn.style.display   = (id === 'live-btn') ? 'flex' : 'inline-flex';
      btn.disabled        = sHit;
      btn.title           = sHit ? 'Live Screen limit reached — upgrade for more' : '';
      btn.style.opacity   = sHit ? '0.4' : '';
      if (sHit && _liveScreen.active) stopLiveScreen();
    });
  }

  // Push live timer to popup every tick
  if (_liveScreen.active && _liveScreen.popup) {
    try {
      var _elapsed  = _liveScreen.startTime ? Math.floor((Date.now() - _liveScreen.startTime) / 1000) : 0;
      var _remSecs  = (limits.screen||0) > 0 ? Math.max(0, Math.floor((limits.screen - (usage.screen||0)) * 60)) : null;
      var _timerEl  = _liveScreen.popup.document.getElementById('live-timer');
      if (_timerEl) {
        var _mm = String(Math.floor(_elapsed/60)).padStart(2,'0');
        var _ss = String(_elapsed%60).padStart(2,'0');
        var _remStr = _remSecs !== null
          ? (' • ' + String(Math.floor(_remSecs/60)).padStart(2,'0') + ':' + String(_remSecs%60).padStart(2,'0') + ' left')
          : '';
        _timerEl.textContent = _mm + ':' + _ss + _remStr;
        _timerEl.style.color = (_remSecs !== null && _remSecs < 60) ? '#f87171' : 'rgba(255,255,255,0.5)';
      }
    } catch(e) {}
  }

  // Learning hub quota — displayed on learning page only, not here
  var lWrap = document.getElementById('lim-l-wrap');
  if (lWrap) lWrap.style.display = 'none';

  // Interview Simulator quota (only when the plan includes interviews)
  var iWrap = document.getElementById('lim-i-wrap'), iEl = document.getElementById('lim-i');
  if (iWrap && iEl) {
    var iq = window._ivQuota;
    if (iq && iq.enabled) {
      iWrap.style.display = '';
      var iTxt = iq.unlimited ? ('Interviews: ' + iq.used + ' used') : ('Interviews: ' + iq.used + ' / ' + iq.limit);
      iEl.textContent = iTxt;
      iEl.style.color = (!iq.unlimited && iq.remaining <= 0) ? '#f87171' : '';
    } else iWrap.style.display = 'none';
  }

  // Apply feature flag visibility (show/hide UI based on plan capabilities)
  applyFeatureFlags();

  // Sidebar upgrade nudge
  var nudge    = document.getElementById('sb-upgrade-nudge');
  var atLimit  = qHit || dHit || vHit || sHit;
  var nearLimit = !atLimit && (qPct >= 0.8 || dPct >= 0.8 || vPct >= 0.8 || sPct >= 0.8);
  if (atLimit || nearLimit) {
    if (!nudge) {
      nudge = document.createElement('div'); nudge.id = 'sb-upgrade-nudge';
      var limBar = document.getElementById('limits-bar');
      if (limBar) limBar.parentNode.insertBefore(nudge, limBar.nextSibling);
    }
    nudge.style.cssText = 'margin:6px 10px 2px;padding:8px 12px;background:' + (atLimit?'#f8717122':'#fb923c18') + ';border:1px solid ' + (atLimit?'#f8717144':'#fb923c33') + ';border-radius:8px;cursor:pointer;text-align:center';
    nudge.innerHTML = '<div style="font-size:11px;font-weight:700;color:' + (atLimit?'#f87171':'#fb923c') + '">' + (atLimit?'⛔ Limit Reached!':'⚠️ Approaching Limit') + '</div>'
      + '<div style="font-size:10px;color:#7d8ba3;margin:2px 0 6px">Upgrade for more access</div>'
      + '<button onclick="showUpgrade()" style="padding:5px 14px;background:linear-gradient(135deg,#0070c0,#0050a0);border:none;border-radius:6px;color:#fff;font-size:11px;font-weight:600;cursor:pointer;width:100%">⬆️ Upgrade Plan</button>';
  } else {
    if (nudge) nudge.remove();
  }
}

// ── Feature flags — show/hide UI elements based on plan capabilities ──────────
// Called from updateLimits() and loadPlanConfig() so it runs on every plan change.
// Admin sets these per-plan in Admin → Plans → Features section.
function applyFeatureFlags() {
  if (!S.user) return;
  // VOICE_CONFIG is the authoritative source — set by loadPlanConfig() from DB.
  // Never use S.user.* fields as they are cached from login and may be stale.
  // If VOICE_CONFIG is not yet loaded (empty object), safe-default is to hide.
  var plan = (S.user.plan || 'free').toLowerCase();
  var vc   = VOICE_CONFIG[plan] || {};
  var vcLoaded = _planLimitsLoaded && !!VOICE_CONFIG[plan];

  // ── S2S VOICE ─────────────────────────────────────────────────────────────
  // Master switch: s2s_enabled on the plan in Admin → Plans → Features.
  // When Off → voice-btn and voice-toggle-btn are hidden and active session stopped.
  var hasS2S = vcLoaded ? !!vc.s2s : false;
  var voiceBtn    = document.getElementById('voice-btn');
  var voiceToggle = document.getElementById('voice-toggle-btn');
  if (voiceBtn) {
    voiceBtn.style.display = hasS2S ? 'inline-flex' : 'none';
    if (!hasS2S && S.voiceOn) endInlineVoice();
  }
  if (voiceToggle) {
    voiceToggle.style.display = hasS2S ? 'flex' : 'none';
  }

  // ── VOICE SELECT ──────────────────────────────────────────────────────────
  // Controls vb-voice-pill visibility. vb-lang select always stays hidden (we use custom UI).
  var hasVoiceSel = vcLoaded ? !!vc.voiceSelect : false;
  var vbLang = document.getElementById('vb-lang');
  if (vbLang) vbLang.style.display = 'none'; // always hidden — pill UI used instead
  var vbVoicePill = document.getElementById('vb-voice-pill');
  if (vbVoicePill) vbVoicePill.style.display = hasVoiceSel ? '' : 'none';

  // ── SPEED CONTROL ─────────────────────────────────────────────────────────
  // Controls vb-speed-pill visibility. vb-speed select always stays hidden.
  var vbSpeed = document.getElementById('vb-speed');
  if (vbSpeed) vbSpeed.style.display = 'none'; // always hidden — pill UI used instead
  var vbSpeedPill = document.getElementById('vb-speed-pill');
  if (vbSpeedPill) vbSpeedPill.style.display = ''; // always show speed pill

  // ── LIVE SCREEN ───────────────────────────────────────────────────────────
  // Master switch: live_screen on the plan.
  // IMPORTANT: screen_mins > 0 does NOT make Live visible — the feature flag is the gate.
  // Feature OFF → always hidden, even if screen_mins > 0.
  // Feature ON + screen_mins > 0 → updateLimits() handles show/disable.
  var hasLive = vcLoaded ? (!!vc.live && getLimits().screen > 0) : false;
  ['live-btn', 'live-header-btn'].forEach(function(id) {
    var btn = document.getElementById(id);
    if (!btn) return;
    if (!hasLive) {
      btn.style.display = 'none';
      if (_liveScreen.active) stopLiveScreen();
    }
    // hasLive = true → updateLimits() controls visibility based on usage
  });

  // ── FILE DOWNLOAD ─────────────────────────────────────────────────────────
  // Master switch: file_download on the plan controls creating NEW exports.
  // Buttons on ALREADY GENERATED files (dl-* ids) always stay visible —
  // the file was already created and paid for, hiding the button just frustrates users.
  var hasDownload = vcLoaded ? !!vc.fileDownload : false;
  // Note: we intentionally do NOT hide dl-* buttons here.
  // The plan gate is enforced inside the button click handler via showUpgrade().
  // This prevents the race where updateLimits() fires after loadSession() and
  // hides all download buttons on existing exported files.

  // ── PM FEATURES ───────────────────────────────────────────────────────────
  // Master switch: pm_features on the plan.
  // When Off → all [data-pm-feature] elements are hidden (⭐ PM badge etc).
  var hasPM = vcLoaded ? !!vc.pmFeatures : false;
  document.querySelectorAll('[data-pm-feature]').forEach(function(el) {
    el.style.display = hasPM ? '' : 'none';
  });

  // Learning Hub feature gate
  var hasLearning = vcLoaded ? !!vc.learningEnabled : false;
  document.querySelectorAll('[data-learning-feature]').forEach(function(el) {
    el.style.display = hasLearning ? '' : 'none';
  });

  // Screen Capture feature gate (admin plan setting: screen_capture_enabled)
  var hasScreenCapture = vcLoaded ? !!vc.screenCapture : false;
  document.querySelectorAll('[data-screencapture-feature]').forEach(function(el) {
    el.style.display = hasScreenCapture ? '' : 'none';
  });

  // Interview Simulator feature gate (admin plan setting: interview_enabled)
  var hasInterview = vcLoaded ? !!vc.interview : false;
  document.querySelectorAll('[data-interview-feature]').forEach(function(el) {
    el.style.display = hasInterview ? '' : 'none';
  });
}

// ── Interview Simulator quota (users.interviews_used vs plan interviews_per_cycle) ──
// Fetched with the usage sync (not on the 1s ticker); rendered by updateLimits().
window._ivQuota = null;
function _syncInterviewQuota() {
  if (!S.user || !S.token) return;
  window.fetch(API + '/interview/quota', { headers: { 'Authorization': 'Bearer ' + S.token }, cache: 'no-store' })
    .then(function(r){ return r.ok ? r.json() : null; })
    .then(function(d){ if (d && !d.error) { window._ivQuota = d; updateLimits(); } })
    .catch(function(){});
}

// Live counter ticker — 1s interval, only runs when features are active
var _limTickInterval = null;
function startLimTicker() {
  if (_limTickInterval) return;
  _limTickInterval = setInterval(function() {
    if (S.user && (S.voiceOn || _liveScreen.active || S.loading)) updateLimits();
  }, 1000);
}
// Boot ticker once user is confirmed logged in
(function _waitForUser() {
  var _tw = setInterval(function() {
    if (S.user) { startLimTicker(); clearInterval(_tw); }
  }, 500);
})();

// -- AUTH ----------------------------------------------------------------------
function showModal(screen) {
  document.getElementById('mov').classList.add('on');
  if (screen === 'signup') renderSignup();
  else if (screen === 'forgot') renderForgot();
  else if (screen === 'reset-password') renderResetPassword();
  else renderLogin();
}
function closeModal() { document.getElementById('mov').classList.remove('on'); }
function ovClick(e) { if (e.target === document.getElementById('mov')) closeModal(); }

// ── Remember Me: save/load email from localStorage ──────────────────────
function _getSavedEmail() {
  try { return localStorage.getItem('eoh_saved_email') || ''; } catch(_) { return ''; }
}
function _saveLoginInfo(email) {
  try { localStorage.setItem('eoh_saved_email', email); } catch(_) {}
}
function _clearSavedEmail() {
  try { localStorage.removeItem('eoh_saved_email'); } catch(_) {}
}

function renderLogin() {
  var ls = document.getElementById('main-logo') ? document.getElementById('main-logo').src : '';
  document.getElementById('mbd').innerHTML = ''
    + '<div class="mlogo"><img src="' + ls + '" alt="" style="width:36px;height:36px;border-radius:8px"><span class="mlogo-txt">ERP Online Hub</span></div>'
    + '<div class="mtitle">Sign In</div>'
    + '<div class="msub">Access your ERP AI Support account</div>'
    + '<button class="mbtn" onclick="doOAuthGoogle()" style="background:#fff;color:#1f2937;border:1px solid #d1d5db;display:flex;align-items:center;justify-content:center;gap:10px;margin-bottom:8px">'
    + '<svg width="18" height="18" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>'
    + 'Continue with Google</button>'
    + '<button class="mbtn" onclick="doOAuthLinkedIn()" style="background:#0A66C2;color:#fff;display:flex;align-items:center;justify-content:center;gap:10px;margin-bottom:12px">'
    + '<svg width="18" height="18" viewBox="0 0 24 24" fill="#fff"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>'
    + 'Continue with LinkedIn</button>'
    + '<div style="display:flex;align-items:center;gap:8px;margin-bottom:12px"><div style="flex:1;height:1px;background:#2d3f55"></div><span style="font-size:11px;color:#7d8ba3">OR SIGN IN WITH EMAIL</span><div style="flex:1;height:1px;background:#2d3f55"></div></div>'
    + '<input class="minp" id="m-em" type="email" placeholder="Email address" value="' + (_getSavedEmail()||'') + '">'
    + '<input class="minp" id="m-pw" type="password" placeholder="Password">'
    + '<div style="display:flex;justify-content:space-between;align-items:center;margin:-4px 0 12px">'
    + '<label style="display:flex;align-items:center;gap:7px;cursor:pointer;user-select:none">'
    + '<input type="checkbox" id="m-remember" style="width:14px;height:14px;accent-color:#0fb574;cursor:pointer;border-radius:3px"' + (_getSavedEmail() ? ' checked' : '') + '>'
    + '<span style="font-size:12px;color:#7d8ba3">Remember me</span>'
    + '</label>'
    + '<span class="mlnk" style="font-size:12px" onclick="renderForgot()">Forgot password?</span>'
    + '</div>'
    + '<div id="m-err" class="merr"></div>'
    + '<button class="mbtn" onclick="doLogin()">Sign In</button>'
    + '<button class="mbtn" style="background:transparent;border:1px solid rgba(10,138,95,.4);color:var(--gl);margin-top:8px" onclick="renderSignup()">Create Free Account</button>'
    + '<div class="mfoot">7-day free trial - no credit card required</div>';
}

function togglePw(inputId, btnId) {
  var inp = document.getElementById(inputId);
  var btn = document.getElementById(btnId);
  if (!inp) return;
  if (inp.type === 'password') { inp.type = 'text'; if (btn) btn.textContent = '🙈'; }
  else { inp.type = 'password'; if (btn) btn.textContent = '👁'; }
}

function renderSignup() {
  var ls = document.getElementById('main-logo') ? document.getElementById('main-logo').src : '';
  document.getElementById('mbd').innerHTML = ''
    + '<div class="mlogo"><img src="' + ls + '" alt="" style="width:36px;height:36px;border-radius:8px"><span class="mlogo-txt">ERP Online Hub</span></div>'
    + '<div class="mtitle">Create Account</div>'
    + '<div class="msub">7-day free trial \u00b7 No credit card required</div>'
    + '<button class="mbtn" onclick="doOAuthGoogle()" style="background:#fff;color:#1f2937;border:1px solid #d1d5db;display:flex;align-items:center;justify-content:center;gap:10px;margin-bottom:8px">'
    + '<svg width="18" height="18" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>'
    + 'Continue with Google</button>'
    + '<button class="mbtn" onclick="doOAuthLinkedIn()" style="background:#0A66C2;color:#fff;display:flex;align-items:center;justify-content:center;gap:10px;margin-bottom:12px">'
    + '<svg width="18" height="18" viewBox="0 0 24 24" fill="#fff"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>'
    + 'Continue with LinkedIn</button>'
    + '<div style="display:flex;align-items:center;gap:8px;margin-bottom:12px"><div style="flex:1;height:1px;background:#2d3f55"></div><span style="font-size:11px;color:#7d8ba3">OR SIGN UP WITH EMAIL</span><div style="flex:1;height:1px;background:#2d3f55"></div></div>'
    + '<input class="minp" id="m-nm" type="text" placeholder="Full name">'
    + '<input class="minp" id="m-em" type="email" placeholder="Email address">'
    + '<div style="display:flex;gap:8px">'
    + '<select id="m-cc" class="minp" style="width:130px;flex-shrink:0;padding:10px 8px">'
    + '<option value="+966">🇸🇦 +966 SA</option>'
    + '<option value="+971">🇦🇪 +971 UAE</option>'
    + '<option value="+965">🇰🇼 +965 KW</option>'
    + '<option value="+973">🇧🇭 +973 BH</option>'
    + '<option value="+968">🇴🇲 +968 OM</option>'
    + '<option value="+974">🇶🇦 +974 QA</option>'
    + '<option value="+20">🇪🇬 +20 EG</option>'
    + '<option value="+962">🇯🇴 +962 JO</option>'
    + '<option value="+961">🇱🇧 +961 LB</option>'
    + '<option value="+963">🇸🇾 +963 SY</option>'
    + '<option value="+964">🇮🇶 +964 IQ</option>'
    + '<option value="+967">🇾🇪 +967 YE</option>'
    + '<option value="+212">🇲🇦 +212 MA</option>'
    + '<option value="+213">🇩🇿 +213 DZ</option>'
    + '<option value="+216">🇹🇳 +216 TN</option>'
    + '<option value="+218">🇱🇾 +218 LY</option>'
    + '<option value="+249">🇸🇩 +249 SD</option>'
    + '<option value="+1">🇺🇸 +1 US</option>'
    + '<option value="+1">🇨🇦 +1 CA</option>'
    + '<option value="+44">🇬🇧 +44 UK</option>'
    + '<option value="+61">🇦🇺 +61 AU</option>'
    + '<option value="+64">🇳🇿 +64 NZ</option>'
    + '<option value="+49">🇩🇪 +49 DE</option>'
    + '<option value="+33">🇫🇷 +33 FR</option>'
    + '<option value="+39">🇮🇹 +39 IT</option>'
    + '<option value="+34">🇪🇸 +34 ES</option>'
    + '<option value="+31">🇳🇱 +31 NL</option>'
    + '<option value="+32">🇧🇪 +32 BE</option>'
    + '<option value="+41">🇨🇭 +41 CH</option>'
    + '<option value="+43">🇦🇹 +43 AT</option>'
    + '<option value="+46">🇸🇪 +46 SE</option>'
    + '<option value="+47">🇳🇴 +47 NO</option>'
    + '<option value="+45">🇩🇰 +45 DK</option>'
    + '<option value="+358">🇫🇮 +358 FI</option>'
    + '<option value="+48">🇵🇱 +48 PL</option>'
    + '<option value="+351">🇵🇹 +351 PT</option>'
    + '<option value="+30">🇬🇷 +30 GR</option>'
    + '<option value="+420">🇨🇿 +420 CZ</option>'
    + '<option value="+36">🇭🇺 +36 HU</option>'
    + '<option value="+40">🇷🇴 +40 RO</option>'
    + '<option value="+7">🇷🇺 +7 RU</option>'
    + '<option value="+380">🇺🇦 +380 UA</option>'
    + '<option value="+90">🇹🇷 +90 TR</option>'
    + '<option value="+91">🇮🇳 +91 IN</option>'
    + '<option value="+92">🇵🇰 +92 PK</option>'
    + '<option value="+880">🇧🇩 +880 BD</option>'
    + '<option value="+94">🇱🇰 +94 LK</option>'
    + '<option value="+977">🇳🇵 +977 NP</option>'
    + '<option value="+86">🇨🇳 +86 CN</option>'
    + '<option value="+81">🇯🇵 +81 JP</option>'
    + '<option value="+82">🇰🇷 +82 KR</option>'
    + '<option value="+852">🇭🇰 +852 HK</option>'
    + '<option value="+886">🇹🇼 +886 TW</option>'
    + '<option value="+65">🇸🇬 +65 SG</option>'
    + '<option value="+60">🇲🇾 +60 MY</option>'
    + '<option value="+62">🇮🇩 +62 ID</option>'
    + '<option value="+63">🇵🇭 +63 PH</option>'
    + '<option value="+66">🇹🇭 +66 TH</option>'
    + '<option value="+84">🇻🇳 +84 VN</option>'
    + '<option value="+55">🇧🇷 +55 BR</option>'
    + '<option value="+54">🇦🇷 +54 AR</option>'
    + '<option value="+56">🇨🇱 +56 CL</option>'
    + '<option value="+57">🇨🇴 +57 CO</option>'
    + '<option value="+51">🇵🇪 +51 PE</option>'
    + '<option value="+52">🇲🇽 +52 MX</option>'
    + '<option value="+27">🇿🇦 +27 ZA</option>'
    + '<option value="+234">🇳🇬 +234 NG</option>'
    + '<option value="+254">🇰🇪 +254 KE</option>'
    + '<option value="+233">🇬🇭 +233 GH</option>'
    + '<option value="+251">🇪🇹 +251 ET</option>'
    + '<option value="+255">🇹🇿 +255 TZ</option>'
    + '<option value="+256">🇺🇬 +256 UG</option>'
    + '<option value="+98">🇮🇷 +98 IR</option>'
    + '<option value="+93">🇦🇫 +93 AF</option>'
    + '<option value="+994">🇦🇿 +994 AZ</option>'
    + '<option value="+995">🇬🇪 +995 GE</option>'
    + '<option value="+375">🇧🇾 +375 BY</option>'
    + '<option value="+372">🇪🇪 +372 EE</option>'
    + '<option value="+371">🇱🇻 +371 LV</option>'
    + '<option value="+370">🇱🇹 +370 LT</option>'
    + '</select>'
    + '<input class="minp" id="m-ph" type="tel" placeholder="Mobile number (required)" style="flex:1">'
    + '</div>'
    + '<div style="position:relative">'
    + '<input class="minp" id="m-pw" type="password" placeholder="Password (min 8 characters)" style="padding-right:42px">'
    + '<button type="button" onclick="togglePw(\'m-pw\',\'m-eye1\')" id="m-eye1" style="position:absolute;right:10px;top:50%;transform:translateY(-50%);background:none;border:none;cursor:pointer;color:#7d8ba3;padding:4px;font-size:16px">👁</button>'
    + '</div>'
    + '<div style="position:relative">'
    + '<input class="minp" id="m-pw2" type="password" placeholder="Confirm password" style="padding-right:42px">'
    + '<button type="button" onclick="togglePw(\'m-pw2\',\'m-eye2\')" id="m-eye2" style="position:absolute;right:10px;top:50%;transform:translateY(-50%);background:none;border:none;cursor:pointer;color:#7d8ba3;padding:4px;font-size:16px">👁</button>'
    + '</div>'
    + '<div id="m-err" class="merr"></div>'
    + '<div id="m-ok" class="mok"></div>'
    + '<button class="mbtn" onclick="doSignup()">Create Account</button>'
    + '<div class="mfoot">Already have an account? <span class="mlnk" onclick="renderLogin()">Sign in</span></div>'
    + '<div style="text-align:center;font-size:10px;color:#4b5563;margin-top:6px">By signing up you agree to our <span class="mlnk">Terms</span> &amp; <span class="mlnk">Privacy Policy</span></div>';
}

function renderForgot() {
  var ls = document.getElementById('main-logo') ? document.getElementById('main-logo').src : '';
  document.getElementById('mbd').innerHTML = ''
    + '<div class="mlogo"><img src="' + ls + '" alt="" style="width:36px;height:36px;border-radius:8px"><span class="mlogo-txt">ERP Online Hub</span></div>'
    + '<div class="mtitle">Reset Password</div>'
    + '<div class="msub">Enter your email and we will send a reset link</div>'
    + '<input class="minp" id="m-em" type="email" placeholder="Email address">'
    + '<div id="m-err" class="merr"></div>'
    + '<div id="m-ok" class="mok"></div>'
    + '<button class="mbtn" onclick="doForgot()">Send Reset Link</button>'
    + '<div class="mfoot"><span class="mlnk" onclick="renderLogin()">&#8592; Back to Sign In</span></div>';
}

function renderResetPassword() {
  var ls = document.getElementById('main-logo') ? document.getElementById('main-logo').src : '';
  document.getElementById('mbd').innerHTML = ''
    + '<div class="mlogo"><img src="' + ls + '" alt="" style="width:36px;height:36px;border-radius:8px"><span class="mlogo-txt">ERP Online Hub</span></div>'
    + '<div class="mtitle">Set New Password</div>'
    + '<div class="msub">Enter your new password below</div>'
    + '<input class="minp" id="m-newpw" type="password" placeholder="New password (min 8 characters)">'
    + '<input class="minp" id="m-newpw2" type="password" placeholder="Confirm new password">'
    + '<div id="m-err" class="merr"></div>'
    + '<div id="m-ok" class="mok"></div>'
    + '<button class="mbtn" onclick="doResetPassword()">Update Password</button>'
    + '<div class="mfoot"><span class="mlnk" onclick="renderLogin()">&#8592; Back to Sign In</span></div>';
  setTimeout(function(){ var el = document.getElementById('m-newpw'); if(el) el.focus(); }, 100);
}

async function doResetPassword() {
  var pw = document.getElementById('m-newpw').value;
  var pw2 = document.getElementById('m-newpw2').value;
  var err = document.getElementById('m-err');
  var ok = document.getElementById('m-ok');
  err.textContent = ''; ok.textContent = '';

  if (!pw || pw.length < 8) { err.textContent = 'Password must be at least 8 characters.'; return; }
  if (pw !== pw2) { err.textContent = 'Passwords do not match.'; return; }
  if (!S._recoveryToken) { err.textContent = 'Recovery session expired. Please request a new reset link.'; return; }

  var btn = document.querySelector('.mbtn[onclick="doResetPassword()"]');
  if (btn) { btn.textContent = 'Updating...'; btn.disabled = true; }

  try {
    var res = await window.fetch(API + '/auth/update-password', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({ access_token: S._recoveryToken, password: pw })
    });
    var d = await res.json();
    if (!res.ok) {
      err.textContent = d.error || 'Failed to update password.';
      if (btn) { btn.textContent = 'Update Password'; btn.disabled = false; }
      return;
    }
    ok.textContent = 'Password updated successfully! You can now sign in.';
    S._recoveryToken = null;
    if (btn) { btn.textContent = 'Done!'; btn.disabled = true; }
    setTimeout(function() { renderLogin(); }, 2000);
  } catch(e) {
    err.textContent = 'Error: ' + e.message;
    if (btn) { btn.textContent = 'Update Password'; btn.disabled = false; }
  }
}

async function doLogin() {
  var em = document.getElementById('m-em').value.trim();
  var pw = document.getElementById('m-pw').value;
  var err = document.getElementById('m-err');
  var rememberMe = document.getElementById('m-remember') ? document.getElementById('m-remember').checked : false;
  if (!em || !pw) { err.textContent = 'Please fill in all fields.'; return; }
  err.textContent = '';
  if (rememberMe) { _saveLoginInfo(em); } else { _clearSavedEmail(); }
  var btn = document.querySelector('.mbtn[onclick="doLogin()"]');
  if (btn) { btn.textContent = 'Signing in…'; btn.disabled = true; }
  try {
    var res = await window.fetch(API + '/auth/signin', {
      method:'POST', headers:{'Content-Type':'application/json'},
      credentials: 'include',
      body: JSON.stringify({email:em, password:pw, captcha_token: window._captchaToken || ''})
    });
    var d = await res.json();
    if (!res.ok) {
      var msg = d.error || 'Login failed.';
      if (btn) { btn.textContent = 'Sign In'; btn.disabled = false; }
      if (d.requiresConfirmation || d.requiresVerification) {
        // Email not verified — server already sent a fresh code — show verify popup immediately
        renderEmailVerify(d.email || em, pw);
        return;
      }
      err.textContent = msg;
      return;
    }
    // 200 OK — but check if server is asking for email verification before granting access
    if (d.requiresVerification) {
      if (btn) { btn.textContent = 'Sign In'; btn.disabled = false; }
      // Store password so we can auto-signin after verification
      _pendingVerifyPw = pw;
      renderEmailVerify(d.email || em, pw);
      return;
    }
    S.user = d.user; S.token = d.token;
    localStorage.setItem('eoh_t', d.token); if (d.refresh_token) localStorage.setItem('eoh_rt', d.refresh_token);
    localStorage.setItem('eoh_u', JSON.stringify(d.user));
    if (checkAndShowBlock(d.user)) { closeModal(); return; }
    updateUserUI(); closeModal();
    if (S._pendingStartChat && S.vendor && S.product) {
      S._pendingStartChat = false;
      startChat();
    } else if (S.vendor && S.product) {
      startChat();
    }
  } catch(e) {
    err.textContent = 'Cannot connect to server. Please try again.';
    if (btn) { btn.textContent = 'Sign In'; btn.disabled = false; }
    console.error('Login error:', e);
  }
}

async function doSignup() {
  var nm  = (document.getElementById('m-nm') || {}).value || '';
  var em  = (document.getElementById('m-em') || {}).value || '';
  var pw  = (document.getElementById('m-pw') || {}).value || '';
  var pw2 = (document.getElementById('m-pw2') || {}).value || '';
  var cc  = (document.getElementById('m-cc') || {}).value || '+1';
  var ph  = (document.getElementById('m-ph') || {}).value || '';
  var err = document.getElementById('m-err');
  var ok  = document.getElementById('m-ok');
  nm = nm.trim(); em = em.trim(); ph = ph.trim().replace(/\D/g,'');

  if (!nm)  { err.textContent = 'Please enter your full name.'; return; }
  if (!em || !em.includes('@')) { err.textContent = 'Please enter a valid email address.'; return; }
  if (!ph || ph.length < 7)   { err.textContent = 'Please enter a valid mobile number.'; return; }
  if (!pw || pw.length < 8)   { err.textContent = 'Password must be at least 8 characters.'; return; }
  if (pw2 && pw !== pw2)       { err.textContent = 'Passwords do not match.'; document.getElementById('m-pw2').focus(); return; }
  if (document.getElementById('m-pw2') && !pw2) { err.textContent = 'Please confirm your password.'; document.getElementById('m-pw2').focus(); return; }

  err.textContent = ''; ok.textContent = '';
  var btn = document.querySelector('.mbtn[onclick="doSignup()"]');
  if (btn) { btn.textContent = 'Creating account\u2026'; btn.disabled = true; }

  var fullPhone = cc + ph;

  try {
    var res = await window.fetch(API + '/auth/signup', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({email:em, password:pw, fullName:nm, phone:fullPhone})
    });
    var d = await res.json();
    if (!res.ok) {
      var errMsg = d.error || 'Registration failed. Please try again.';
      // If email already registered, suggest signing in
      if (errMsg.toLowerCase().includes('already')) {
        err.innerHTML = errMsg + ' <span class="mlnk" onclick="renderLogin()" style="font-size:12px">Sign in instead →</span>';
      } else {
        err.textContent = errMsg;
      }
      if (btn) { btn.textContent = 'Create Account'; btn.disabled = false; }
      return;
    }

    if (d.token && d.user) {
      // Auto-confirmed — log straight in
      S.user = d.user; S.token = d.token;
      localStorage.setItem('eoh_t', d.token); if (d.refresh_token) localStorage.setItem('eoh_rt', d.refresh_token);
      localStorage.setItem('eoh_u', JSON.stringify(d.user));
      if (checkAndShowBlock(d.user)) { closeModal(); return; }
      updateUserUI(); closeModal();
      if (S.vendor && S.product) startChat();
    } else {
      // Always show verify popup — server sent the code
      // Store pending session tokens in case Supabase already issued them
      if (d._pt)  window._signupPendingToken  = d._pt;
      if (d._prt) window._signupPendingRt     = d._prt;
      renderEmailVerify(d.email || em, pw);
    }
  } catch(e) {
    err.textContent = 'Connection error. Please try again.';
    if (btn) { btn.textContent = 'Create Account'; btn.disabled = false; }
  }
}


// =============================================================================
// EMAIL VERIFICATION — 6-digit code screen (after signup or blocked login)
// =============================================================================
var _pendingVerifyEmail = '';
var _pendingVerifyPw    = '';

async function _sendVerifyAndShow(email, password) {
  _pendingVerifyEmail = email || '';
  _pendingVerifyPw    = password || '';
  try {
    await window.fetch(API + '/auth/resend-verification', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ email: email })
    });
  } catch(_) { /* best-effort — show screen anyway */ }
  renderEmailVerify(email, password);
}

// Resend cooldown state
var _evResendCount   = 0;      // how many times resent (0 = first time)
var _evResendTimer   = null;   // setInterval handle
var _evResendExpires = 0;      // timestamp when cooldown expires

function _evStartCooldown() {
  // First resend: 2 min cooldown. Every subsequent: 5 min.
  var secs = _evResendCount === 0 ? 120 : 300;
  _evResendExpires = Date.now() + secs * 1000;
  _evResendCount++;
  _evTickCooldown();
  if (_evResendTimer) clearInterval(_evResendTimer);
  _evResendTimer = setInterval(_evTickCooldown, 1000);
}

function _evTickCooldown() {
  var btn = document.getElementById('ev-resend-btn');
  if (!btn) { clearInterval(_evResendTimer); return; }
  var remaining = Math.ceil((_evResendExpires - Date.now()) / 1000);
  if (remaining <= 0) {
    clearInterval(_evResendTimer);
    btn.disabled = false;
    btn.textContent = 'Resend code';
    btn.style.opacity = '1';
    btn.style.cursor  = 'pointer';
  } else {
    btn.disabled = true;
    var m = Math.floor(remaining / 60);
    var s = remaining % 60;
    btn.textContent = 'Resend in ' + (m > 0 ? m + ':' + (s < 10 ? '0' : '') + s : s + 's');
    btn.style.opacity = '0.5';
    btn.style.cursor  = 'default';
  }
}

function renderEmailVerify(email, password) {
  _pendingVerifyEmail = email || _pendingVerifyEmail;
  _pendingVerifyPw    = password || _pendingVerifyPw;
  var safeEmail = (_pendingVerifyEmail || '').replace(/'/g, '');
  // Reset cooldown when screen is freshly shown
  // (code was just sent by server — start the 2-min initial cooldown)
  if (_evResendTimer) clearInterval(_evResendTimer);
  _evResendExpires = Date.now() + 120 * 1000;  // 2 min from now (code just sent)
  _evResendCount   = 1;                          // next resend will be 5 min

  document.getElementById('mbd').innerHTML =
    '<div class="mtitle" style="margin-bottom:4px">✉️ Verify Your Email</div>'
    + '<div class="msub" style="margin-bottom:16px">We sent a <strong>6-digit code</strong> to<br><strong style="color:var(--text)">' + safeEmail + '</strong></div>'
    + '<div style="margin:14px 0;display:flex;gap:8px;justify-content:center">'
    + '<input id="ev-0" class="minp" type="tel" maxlength="1" style="width:44px;text-align:center;font-size:22px;font-weight:700;padding:8px;letter-spacing:0" oninput="evFocus(this,1)" onkeydown="evBack(event,this,null)">'
    + '<input id="ev-1" class="minp" type="tel" maxlength="1" style="width:44px;text-align:center;font-size:22px;font-weight:700;padding:8px" oninput="evFocus(this,2)" onkeydown="evBack(event,this,0)">'
    + '<input id="ev-2" class="minp" type="tel" maxlength="1" style="width:44px;text-align:center;font-size:22px;font-weight:700;padding:8px" oninput="evFocus(this,3)" onkeydown="evBack(event,this,1)">'
    + '<input id="ev-3" class="minp" type="tel" maxlength="1" style="width:44px;text-align:center;font-size:22px;font-weight:700;padding:8px" oninput="evFocus(this,4)" onkeydown="evBack(event,this,2)">'
    + '<input id="ev-4" class="minp" type="tel" maxlength="1" style="width:44px;text-align:center;font-size:22px;font-weight:700;padding:8px" oninput="evFocus(this,5)" onkeydown="evBack(event,this,3)">'
    + '<input id="ev-5" class="minp" type="tel" maxlength="1" style="width:44px;text-align:center;font-size:22px;font-weight:700;padding:8px" oninput="evAutoSubmit()" onkeydown="evBack(event,this,4)">'
    + '</div>'
    + '<div id="m-err" class="merr"></div>'
    + '<div id="m-ok"  class="mok"></div>'
    + '<button class="mbtn" onclick="doEmailVerify()">Verify Email</button>'
    + '<div class="mfoot">'
    + '<button id="ev-resend-btn" onclick="resendEmailVerify()" style="background:none;border:none;color:var(--gl);font-size:13px;cursor:default;opacity:.5;padding:0;text-decoration:underline;text-underline-offset:2px" disabled>Resend in 2:00</button>'
    + ' &nbsp;&bull;&nbsp; '
    + '<span class="mlnk" onclick="renderLogin()">Back to Sign In</span>'
    + '</div>';
  setTimeout(function() {
    var f = document.getElementById('ev-0'); if(f) f.focus();
    _evResendTimer = setInterval(_evTickCooldown, 1000);
  }, 100);
}

function evFocus(el, next) {
  if (el.value && next <= 5) { var n = document.getElementById('ev-' + next); if(n) n.focus(); }
}
function evBack(e, el, prev) {
  if (e.key === 'Backspace' && !el.value && prev !== null) {
    var p = document.getElementById('ev-' + prev); if(p) { p.value = ''; p.focus(); }
  }
}
function evAutoSubmit() {
  var code = [0,1,2,3,4,5].map(function(i) { var el = document.getElementById('ev-'+i); return el ? el.value : ''; }).join('');
  if (code.length === 6) doEmailVerify();
}

async function doEmailVerify() {
  var code = [0,1,2,3,4,5].map(function(i) { var el = document.getElementById('ev-'+i); return el ? el.value.trim() : ''; }).join('');
  var err  = document.getElementById('m-err');
  var ok   = document.getElementById('m-ok');
  if (code.length < 6) { if(err) err.textContent = 'Please enter all 6 digits.'; return; }
  if(err) err.textContent = '';
  var btn = document.querySelector('.mbtn[onclick="doEmailVerify()"]');
  if (btn) { btn.disabled = true; btn.textContent = 'Verifying…'; }

  try {
    var res = await window.fetch(API + '/auth/verify-email', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ email: _pendingVerifyEmail, code: code })
    });
    var d = await res.json();
    if (!res.ok) {
      if(err) err.textContent = d.error || 'Invalid code. Please try again.';
      if (btn) { btn.disabled = false; btn.textContent = 'Verify Email'; }
      [0,1,2,3,4,5].forEach(function(i){var el=document.getElementById('ev-'+i);if(el)el.value='';});
      var f = document.getElementById('ev-0'); if(f) f.focus();
      return;
    }
    if(ok) ok.textContent = '✅ Email verified! Signing you in…';

    // If backend returned a token directly (auto-signin succeeded server-side)
    if (d.token && d.user) {
      S.user = d.user; S.token = d.token;
      localStorage.setItem('eoh_t', d.token);
      if (d.refresh_token) localStorage.setItem('eoh_rt', d.refresh_token);
      localStorage.setItem('eoh_u', JSON.stringify(d.user));
      _pendingVerifyPw = ''; updateUserUI(); closeModal();
      if (S._pendingStartChat && S.vendor && S.product) { S._pendingStartChat = false; setTimeout(startChat, 300); }
      else if (S.vendor && S.product) startChat();
      return;
    }

    // verified=true but no token — try signing in with stored password
    var _verifyEmail = d.email || _pendingVerifyEmail;
    if (_pendingVerifyPw && _verifyEmail) {
      try {
        var loginRes = await window.fetch(API + '/auth/signin', {
          method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ email: _verifyEmail, password: _pendingVerifyPw })
        });
        var ld = await loginRes.json();
        if (ld.token && ld.user) {
          S.user = ld.user; S.token = ld.token;
          localStorage.setItem('eoh_t', ld.token);
          if (ld.refresh_token) localStorage.setItem('eoh_rt', ld.refresh_token);
          localStorage.setItem('eoh_u', JSON.stringify(ld.user));
          _pendingVerifyPw = ''; window._signupPendingToken = null; window._signupPendingRt = null;
          updateUserUI(); closeModal();
          if (S._pendingStartChat && S.vendor && S.product) { S._pendingStartChat = false; setTimeout(startChat, 300); }
          else if (S.vendor && S.product) startChat();
          return;
        }
        // Signin still blocked — use pending token from signup as last resort
        if (window._signupPendingToken) {
          S.token = window._signupPendingToken;
          localStorage.setItem('eoh_t', window._signupPendingToken);
          if (window._signupPendingRt) localStorage.setItem('eoh_rt', window._signupPendingRt);
          window._signupPendingToken = null; window._signupPendingRt = null;
          _pendingVerifyPw = '';
          // Reload user from server with new token
          try {
            var meRes = await window.fetch(API + '/auth/me', { headers:{'Authorization':'Bearer '+S.token} });
            var meD = await meRes.json();
            if (meD.user) { _mergeUser(meD.user); localStorage.setItem('eoh_u', JSON.stringify(S.user)); }
          } catch(_) {}
          updateUserUI(); closeModal();
          if (S.vendor && S.product) startChat();
          return;
        }
        if(ok) ok.textContent = '✅ Email verified!';
        if(err) { err.style.color = '#f59e0b'; err.textContent = ld.error || 'Verified! Please sign in again.'; }
      } catch(_) {}
    }

    // No password stored — go to login showing verified message
    _pendingVerifyPw = '';
    setTimeout(function() {
      renderLogin();
      var ok2 = document.getElementById('m-ok');
      if(ok2) { ok2.style.color='#34d399'; ok2.textContent = '✅ Email verified! Please sign in.'; }
    }, 1200);
  } catch(e) {
    if(err) err.textContent = 'Verification failed. Please try again.';
    if (btn) { btn.disabled = false; btn.textContent = 'Verify Email'; }
  }
}

async function resendEmailVerify() {
  var btn = document.getElementById('ev-resend-btn');
  if (btn && btn.disabled) return;  // already in cooldown — ignore
  var ok  = document.getElementById('m-ok');
  var err = document.getElementById('m-err');
  if(ok)  ok.textContent  = '';
  if(err) err.textContent = '';
  // Start cooldown immediately so user cannot spam
  _evStartCooldown();
  try {
    var res = await window.fetch(API + '/auth/resend-verification', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ email: _pendingVerifyEmail })
    });
    var d = await res.json();
    if (!res.ok) {
      if(err) err.textContent = d.error || 'Could not resend. Please try again.';
      return;
    }
    if(ok) ok.textContent = '✅ New code sent to ' + _pendingVerifyEmail;
    [0,1,2,3,4,5].forEach(function(i){var el=document.getElementById('ev-'+i);if(el)el.value='';});
    var f = document.getElementById('ev-0'); if(f) f.focus();
  } catch(e) {
    if(err) err.textContent = 'Could not resend. Please try again.';
  }
}

function renderOTPVerify(email, phone) {
  var isEmail = !phone;
  var dest = isEmail ? email : phone;
  var icon = isEmail ? '\u2709\ufe0f' : '\ud83d\udcf1';
  var label = isEmail ? 'Verify Your Email' : 'Verify Your Mobile';
  var subMsg = isEmail
    ? 'We sent a 6-digit code to <strong>' + dest + '</strong><br><span style="font-size:11px;color:#7d8ba3">Check your inbox and spam folder</span>'
    : 'We sent a 6-digit code to <strong>' + dest + '</strong>';
  document.getElementById('mbd').innerHTML = ''
    + '<div class="mtitle" style="margin-bottom:6px">' + icon + ' ' + label + '</div>'
    + '<div class="msub">' + subMsg + '</div>'
    + '<div style="margin:16px 0;display:flex;gap:8px;justify-content:center">'
    + '<input id="otp-0" class="minp" type="tel" maxlength="1" style="width:44px;text-align:center;font-size:22px;font-weight:700;padding:8px;letter-spacing:0" oninput="otpFocus(this,1)" onkeydown="otpBack(event,this,null)">'
    + '<input id="otp-1" class="minp" type="tel" maxlength="1" style="width:44px;text-align:center;font-size:22px;font-weight:700;padding:8px" oninput="otpFocus(this,2)" onkeydown="otpBack(event,this,0)">'
    + '<input id="otp-2" class="minp" type="tel" maxlength="1" style="width:44px;text-align:center;font-size:22px;font-weight:700;padding:8px" oninput="otpFocus(this,3)" onkeydown="otpBack(event,this,1)">'
    + '<input id="otp-3" class="minp" type="tel" maxlength="1" style="width:44px;text-align:center;font-size:22px;font-weight:700;padding:8px" oninput="otpFocus(this,4)" onkeydown="otpBack(event,this,2)">'
    + '<input id="otp-4" class="minp" type="tel" maxlength="1" style="width:44px;text-align:center;font-size:22px;font-weight:700;padding:8px" oninput="otpFocus(this,5)" onkeydown="otpBack(event,this,3)">'
    + '<input id="otp-5" class="minp" type="tel" maxlength="1" style="width:44px;text-align:center;font-size:22px;font-weight:700;padding:8px" oninput="otpSubmitAuto()" onkeydown="otpBack(event,this,4)">'
    + '</div>'
    + '<div id="m-err" class="merr"></div>'
    + '<div id="m-ok" class="mok"></div>'
    + '<button class="mbtn" onclick="doVerifyOTP(\'' + email + '\')">Verify Code</button>'
    + '<div class="mfoot"><span class="mlnk" onclick="resendOTP(\'' + email + '\', ' + (isEmail?'true':'false') + ')">Resend code</span> &nbsp;&bull;&nbsp; <span class="mlnk" onclick="renderLogin()">Back to login</span></div>';
  setTimeout(function() { var f = document.getElementById('otp-0'); if(f) f.focus(); }, 100);
}

function otpFocus(el, next) {
  if (el.value && next <= 5) { var n = document.getElementById('otp-'+next); if(n) n.focus(); }
}
function otpBack(e, el, prev) {
  if (e.key === 'Backspace' && !el.value && prev !== null) { var p = document.getElementById('otp-'+prev); if(p) { p.value=''; p.focus(); } }
}
function otpSubmitAuto() {
  var code = [0,1,2,3,4,5].map(function(i){ var el=document.getElementById('otp-'+i); return el?el.value:''; }).join('');
  if (code.length === 6) { var emailEl = document.querySelector('[onclick*="doVerifyOTP"]'); if(emailEl) emailEl.click(); }
}

async function doVerifyOTP(email) {
  var code = [0,1,2,3,4,5].map(function(i){ var el=document.getElementById('otp-'+i); return el?el.value.trim():''; }).join('');
  var err  = document.getElementById('m-err');
  var ok   = document.getElementById('m-ok');
  if (code.length < 6) { err.textContent = 'Please enter all 6 digits.'; return; }
  err.textContent = '';
  try {
    var res = await window.fetch(API + '/auth/verify-otp', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({email:email, token:code, type:'email'})
    });
    var d = await res.json();
    if (!res.ok) { err.textContent = d.error || 'Invalid code. Please try again.'; return; }
    if (d.token && d.user) {
      S.user = d.user; S.token = d.token;
      localStorage.setItem('eoh_t', d.token); if (d.refresh_token) localStorage.setItem('eoh_rt', d.refresh_token);
      localStorage.setItem('eoh_u', JSON.stringify(d.user));
      updateUserUI(); closeModal();
      ok.textContent = '\u2705 Email verified! Welcome to ERP Online Hub.';
      if (S._pendingStartChat && S.vendor && S.product) {
        S._pendingStartChat = false;
        setTimeout(startChat, 500);
      } else if (S.vendor && S.product) {
        startChat();
      }
    } else {
      ok.textContent = '\u2705 Verified! Signing you in...';
      setTimeout(renderLogin, 1500);
    }
  } catch(e) { err.textContent = 'Verification failed. Please try again.'; }
}

async function resendOTP(dest, isEmail) {
  try {
    var body = isEmail
      ? JSON.stringify({email: dest})
      : JSON.stringify({phone: dest});
    await window.fetch(API + '/auth/resend-otp', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: body
    });
    var ok = document.getElementById('m-ok');
    if (ok) ok.textContent = '\u2705 New code sent to ' + dest;
  } catch(e) {
    var err = document.getElementById('m-err');
    if (err) err.textContent = 'Could not resend code. Try again.';
  }
}

var REDIRECT_URL = 'https://erponlinehub.com/pages/oauth-callback';

function _persistPkceToFirstPartyCookie() {
  try {
    for (var i = 0; i < localStorage.length; i++) {
      var k = localStorage.key(i);
      if (k && (k.indexOf('code-verifier') !== -1 || k.indexOf('code_verifier') !== -1 || k.indexOf('pkce') !== -1)) {
        var v = localStorage.getItem(k);
        if (v) {
          var safe = k.replace(/[^a-zA-Z0-9]/g, '_');
          document.cookie = 'eoh_pkce_' + safe + '=' + encodeURIComponent(v) + '; path=/; max-age=300; SameSite=Lax; Secure';
        }
      }
    }
    console.log('[OAuth] PKCE persisted to cookie');
  } catch(e) { console.warn('[OAuth] PKCE persist error:', e.message); }
}

async function doOAuthGoogle() {
  var errEl = document.getElementById('m-err');
  if (errEl) errEl.textContent = '';
  try {
    var { error } = await _supabase.auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: REDIRECT_URL, queryParams: { prompt: 'select_account', access_type: 'offline' } }
    });
    if (error) throw error;
  } catch(e) {
    if (errEl) errEl.textContent = 'Google sign-in error: ' + e.message;
    console.error('[OAuth Google]', e);
  }
}

async function doOAuthFacebook() {
  try {
    await _supabase.auth.signInWithOAuth({ provider: 'facebook', options: { redirectTo: REDIRECT_URL } });
  } catch(e) {}
}

async function doOAuthLinkedIn() {
  var errEl = document.getElementById('m-err');
  if (errEl) errEl.textContent = '';
  try {
    var { error } = await _supabase.auth.signInWithOAuth({
      provider: 'linkedin_oidc',
      options: { redirectTo: REDIRECT_URL, scopes: 'openid profile email' }
    });
    if (error) throw error;
  } catch(e) {
    console.error('[LinkedIn OAuth]', e.message);
    if (errEl) errEl.textContent = 'LinkedIn sign-in failed. Please try again.';
  }
}

async function doForgot() {
  var em = document.getElementById('m-em').value.trim();
  var err = document.getElementById('m-err');
  var ok = document.getElementById('m-ok');
  if (!em) { err.textContent = 'Please enter your email address.'; return; }
  err.textContent = '';
  try {
    var res = await window.fetch(API + '/auth/forgot-password', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({email:em})
    });
    var d = await res.json();
    if (!res.ok) { err.textContent = d.error || 'Failed to send reset email.'; return; }
    ok.textContent = 'Reset link sent! Check your inbox.';
    setTimeout(renderLogin, 4000);
  } catch(e) { err.textContent = 'Connection error: ' + e.message; console.error('Login error:', e); }
}

async function resendConfirmation(email) {
  try {
    await window.fetch(API + '/auth/resend-confirmation', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ email: email })
    });
    var ok = document.getElementById('m-ok');
    if (ok) ok.innerHTML = '<span style="font-size:12px;color:var(--gl)">✅ Confirmation email resent! Check your inbox.</span>';
  } catch(e) {
    var ok = document.getElementById('m-ok');
    if (ok) ok.innerHTML = '<span style="font-size:12px;color:var(--red)">Failed to resend. Please try again.</span>';
  }
}

function showErpSel() {
  var erp = document.querySelector('.erp-sel');
  if (erp) erp.style.display = '';
  var cb = document.getElementById('change-sys-btn');
  if (cb) cb.style.display = 'none';
  if (window.innerWidth < 768) openSidebar();
}
window.showErpSel = showErpSel;
function updateUserUI() {
  if (!S.user) return;
  var init = (S.user.fullName ? S.user.fullName[0] : S.user.email ? S.user.email[0] : 'U').toUpperCase();
  var uavEl = document.getElementById('uav');
  if (uavEl) {
    var avatarUrl = S.user.avatar || S.user.avatar_url || '';
    if (avatarUrl) {
      // Show initial while image loads
      uavEl.textContent = init;
      uavEl.style.background = '';
      var tmpImg = new Image();
      tmpImg.crossOrigin = 'anonymous';
      tmpImg.onload = function() {
        var el = document.getElementById('uav');
        if (!el) return;
        el.style.background = 'none';
        el.innerHTML = '';
        var img = document.createElement('img');
        img.src = avatarUrl;
        img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;border-radius:50%';
        el.appendChild(img);
      };
      tmpImg.onerror = function() {
        console.warn('[EOH] Avatar failed to load:', avatarUrl);
        // Try without cache-bust param if URL has one
        if (avatarUrl.indexOf('?') !== -1) {
          var cleanUrl = avatarUrl.split('?')[0];
          var retryImg = new Image();
          retryImg.onload = function() {
            var el = document.getElementById('uav');
            if (!el) return;
            el.style.background = 'none'; el.innerHTML = '';
            var img = document.createElement('img');
            img.src = cleanUrl;
            img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;border-radius:50%';
            el.appendChild(img);
            // Update stored URL to clean version
            if (S.user) { S.user.avatar = cleanUrl; S.user.avatar_url = cleanUrl; }
            try { localStorage.setItem('eoh_u', JSON.stringify(S.user)); } catch(_) {}
          };
          retryImg.onerror = function() {
            var el = document.getElementById('uav');
            if (el) { el.textContent = init; el.style.background = ''; }
          };
          retryImg.src = cleanUrl;
        } else {
          var el = document.getElementById('uav');
          if (el) { el.textContent = init; el.style.background = ''; }
        }
      };
      tmpImg.src = avatarUrl;
    } else {
      uavEl.textContent = init;
      uavEl.style.background = '';
    }
  }
  var tbAv = document.getElementById('tb-uav');
  if (tbAv) {
    var _av2 = S.user.avatar || S.user.avatar_url || '';
    if (_av2) {
      var _ti = new Image();
      _ti.onload = function(){ var e=document.getElementById('tb-uav'); if(!e) return; e.style.background='none'; e.innerHTML=''; var img=document.createElement('img'); img.src=_av2; img.style.cssText='width:100%;height:100%;object-fit:cover;display:block;border-radius:50%'; e.appendChild(img); };
      _ti.onerror = function(){ var e=document.getElementById('tb-uav'); if(e) e.textContent=init; };
      _ti.src = _av2;
    } else { tbAv.textContent = init; }
    var tbPb = document.getElementById('tb-profile-btn');
    if (tbPb) tbPb.style.display = window.innerWidth < 768 ? 'flex' : 'none';
  }
  document.getElementById('unm').textContent = S.user.fullName || S.user.email;
  document.getElementById('upl').textContent = (S.user.plan || 'FREE').toUpperCase();
  var sb = document.getElementById('signup-btn'); if (sb) sb.style.display = 'none';
  // export-tb-btn removed — export is chat-only
  // Sync rail avatar if sidebar is collapsed
  if (_sbCollapsed) setTimeout(_syncRailAvatar, 200);
  // Dispatch login event so idle timer starts immediately
  try { document.dispatchEvent(new CustomEvent('eoh:login')); } catch(_) {}
  var ab = document.getElementById('auth-btn');
  ab.textContent = S.user.fullName ? S.user.fullName.split(' ')[0] : 'Account';
  ab.onclick = showAccountMenu;
}

function showAccountMenu() {
  var existing = document.getElementById('acct-menu');
  if (existing) { existing.remove(); return; }
  var ab = document.getElementById('auth-btn');
  var rect = ab.getBoundingClientRect();
  var menu = document.createElement('div');
  menu.id = 'acct-menu';
  menu.style.cssText = 'position:fixed;top:' + (rect.bottom+6) + 'px;right:' + (window.innerWidth-rect.right) + 'px;'
    + 'background:#1c2135;border:1px solid rgba(255,255,255,.1);border-radius:8px;padding:6px;'
    + 'z-index:999;min-width:190px;box-shadow:0 8px 24px rgba(0,0,0,.5)';
  var plan = (S.user.plan || 'FREE').toUpperCase();
  var pc = plan === 'FREE' ? '#7d8ba3' : '#0fb574';
  menu.innerHTML = ''
    + '<div style="padding:8px 10px 10px;border-bottom:1px solid rgba(255,255,255,.06);margin-bottom:4px">'
    + '<div style="font-size:13px;font-weight:600;color:#e8edf5">' + (S.user.fullName||S.user.email) + '</div>'
    + '<div style="font-size:11px;color:' + pc + ';margin-top:2px">' + plan + ' PLAN</div></div>'
    + '<div class="amitem" onclick="showProfileModal()">My Profile</div>'
    + '<div class="amitem" onclick="showSubscriptionModal()">Subscription &amp; Billing</div>'
    + '<div class="amitem" onclick="showUpgrade(null,null)">' + (S.user.plan === 'free' ? 'Upgrade Plan' : 'Change Plan') + '</div>'
    + '<div class="amitem" onclick="showAcctSessions()">Active Sessions</div>'
    + '<div class="amitem" onclick="var m=document.getElementById(\'acct-menu\');if(m)m.remove();window.open(\'https://erponlinehub.com/pages/eoh-bundles\',\'_blank\')" style="display:flex;align-items:center;justify-content:space-between">Team Bundles <span style="font-size:10px;background:rgba(10,138,95,.15);color:var(--gl);padding:2px 7px;border-radius:20px;font-weight:600">For Teams</span></div>'
    + '<div class="amitem" onclick="var m=document.getElementById(\'acct-menu\');if(m)m.remove();showRedeemBundleModal()" style="display:flex;align-items:center;justify-content:space-between">Redeem Bundle Code <span style="font-size:10px;background:rgba(99,102,241,.15);color:#818cf8;padding:2px 7px;border-radius:20px;font-weight:600">&#127873; Code</span></div>'
    + '<div class="amitem" onclick="var m=document.getElementById(\'acct-menu\');if(m)m.remove();openHelpModal()">Help &amp; Shortcuts</div>'
    + '<div class="amitem" onclick="window.location.href=\'https://erponlinehub.com/pages/support-ticket\'">Support Tickets</div>'
    + '<div style="height:1px;background:rgba(255,255,255,.06);margin:6px 0"></div>'
    + '<div class="amitem amitem-red" onclick="doLogout()">Sign Out</div>';
  document.body.appendChild(menu);
  setTimeout(function() {
    document.addEventListener('click', function h(e) {
      if (!menu.contains(e.target) && e.target !== ab && !ab.contains(e.target)) {
        menu.remove(); document.removeEventListener('click', h);
      }
    });
  }, 100);
}

// ── Active Sessions Modal ─────────────────────────────────────────────────────
window.showAcctSessions = function() {
  var m = document.getElementById('acct-menu'); if (m) m.remove();
  var existing = document.getElementById('acct-sessions-overlay');
  if (existing) { existing.remove(); return; }
  var overlay = document.createElement('div');
  overlay.id = 'acct-sessions-overlay';
  overlay.style.cssText = 'position:fixed;inset:0;z-index:9999;background:rgba(0,0,0,.65);display:flex;align-items:center;justify-content:center;padding:20px';
  var box = document.createElement('div');
  box.style.cssText = 'background:#131722;border:1px solid rgba(255,255,255,.08);border-radius:14px;width:100%;max-width:520px;max-height:85vh;overflow-y:auto;box-shadow:0 24px 64px rgba(0,0,0,.6)';
  box.innerHTML = '<div style="display:flex;align-items:center;justify-content:space-between;padding:18px 22px;border-bottom:1px solid rgba(255,255,255,.07)">'
    + '<div style="font-size:15px;font-weight:700;color:#e8edf5">Active Sessions</div>'
    + '<button onclick="document.getElementById(&quot;acct-sessions-overlay&quot;).remove()" style="background:none;border:none;color:#7d8ba3;font-size:20px;cursor:pointer;line-height:1;padding:0">&#10005;</button>'
    + '</div><div id="acct-sessions-inner" style="padding:18px 22px"></div>';
  overlay.appendChild(box);
  document.body.appendChild(overlay);
  overlay.addEventListener('click', function(e){ if(e.target===overlay) overlay.remove(); });
  _renderSessionsTab(document.getElementById('acct-sessions-inner'));
};


function showRedeemBundleModal() {
  var ex=document.getElementById('bundle-redeem-overlay'); if(ex){ex.remove();return;}
  var ov=document.createElement('div'); ov.id='bundle-redeem-overlay';
  ov.style.cssText='position:fixed;inset:0;z-index:9999;background:rgba(0,0,0,.72);display:flex;align-items:center;justify-content:center;padding:20px';
  ov.innerHTML='<div style="background:#131722;border:1px solid rgba(255,255,255,.1);border-radius:16px;width:100%;max-width:420px;padding:28px;position:relative">'
    +'<button onclick="document.getElementById(\'bundle-redeem-overlay\').remove()" style="position:absolute;top:14px;right:16px;background:none;border:none;color:#7d8ba3;font-size:20px;cursor:pointer">✕</button>'
    +'<div style="font-size:18px;font-weight:700;color:#e8edf5;margin-bottom:6px">&#127873; Redeem Bundle Code</div>'
    +'<div style="font-size:13px;color:#7d8ba3;line-height:1.6;margin-bottom:20px">Enter the bundle code your company provided.</div>'
    +'<label style="display:block;font-size:11px;font-weight:600;color:#7d8ba3;text-transform:uppercase;letter-spacing:.06em;margin-bottom:7px">Bundle Code</label>'
    +'<input id="bundle-code-input" type="text" placeholder="EOH-XXXX-XXXX-XXXX" style="width:100%;padding:11px 14px;background:#1c2135;border:1px solid rgba(255,255,255,.12);border-radius:8px;color:#e8edf5;font-size:15px;font-family:monospace;letter-spacing:1px;outline:none;box-sizing:border-box;margin-bottom:14px" oninput="this.value=this.value.toUpperCase()" onkeydown="if(event.key===\'Enter\')redeemBundleCode()">'
    +'<div id="bundle-redeem-msg" style="min-height:18px;font-size:13px;margin-bottom:14px;text-align:center"></div>'
    +'<button onclick="redeemBundleCode()" id="bundle-redeem-btn" style="width:100%;padding:12px;background:linear-gradient(135deg,#0A8A5F,#0A4FCC);color:#fff;border:none;border-radius:8px;font-size:14px;font-weight:600;cursor:pointer">Activate Bundle</button>'
    +'</div>';
  document.body.appendChild(ov);
  ov.addEventListener('click',function(e){if(e.target===ov)ov.remove();});
  setTimeout(function(){var i=document.getElementById('bundle-code-input');if(i)i.focus();},100);
}
window.showRedeemBundleModal=showRedeemBundleModal;

async function redeemBundleCode(){
  var btn=document.getElementById('bundle-redeem-btn'),msg=document.getElementById('bundle-redeem-msg'),inp=document.getElementById('bundle-code-input');
  var code=(inp?inp.value:'').trim().toUpperCase();
  if(!code){msg.style.color='#f87171';msg.textContent='Please enter your bundle code.';return;}
  if(!S.user||!S.token){msg.style.color='#f87171';msg.textContent='Please log in first.';return;}
  btn.disabled=true;btn.textContent='⏳ Activating…';msg.style.color='#7d8ba3';msg.textContent='Validating…';
  try{
    var r=await window.fetch(API+'/profile/bundle/redeem',{method:'POST',headers:{'Content-Type':'application/json','Authorization':'Bearer '+S.token},body:JSON.stringify({code:code})});
    var d=await r.json();
    if(!d.valid){msg.style.color='#f87171';msg.textContent=d.error||'Invalid bundle code.';btn.disabled=false;btn.textContent='Activate Bundle';return;}
    msg.style.color='#0fb574';msg.textContent=d.message||'✅ Bundle activated!';btn.textContent='✅ Activated!';
    if(d.user){S.user.plan=d.user.plan;S.user.planExpiresAt=d.user.plan_expires_at;S.user.plan_expires_at=d.user.plan_expires_at;S.user.subscription_status='active';S.user.isExpired=false;S.user.messagesUsed=0;S.user.docsUsed=0;S.user.voiceMinsUsed=0;S.user.screenMinsUsed=0;if(d.user.learning_paths_balance!==undefined)S.user.learningBalance=d.user.learning_paths_balance;}
    if(d.limits)S.planConfig=d.limits;
    try{localStorage.removeItem('eoh_usage_cache');}catch(_){}
    updateUserUI();updateLimits();
    if(typeof syncUsageFromServer==='function')syncUsageFromServer();
    setTimeout(function(){var ov=document.getElementById('bundle-redeem-overlay');if(ov)ov.remove();if(typeof showSubscriptionModal==='function')showSubscriptionModal();},2500);
  }catch(e){msg.style.color='#f87171';msg.textContent='Connection error.';btn.disabled=false;btn.textContent='Activate Bundle';}
}
window.redeemBundleCode=redeemBundleCode;

function doLogout() {
  var m = document.getElementById('acct-menu'); if (m) m.remove();
  // Tell backend to null last_active_at so user disappears from Online Now
  var tok = S.token;
  if (tok) {
    try {
      window.fetch(API + '/auth/logout', {
        method: 'POST',
        headers: { 'Authorization': 'Bearer ' + tok, 'Content-Type': 'application/json' },
        keepalive: true
      });
    } catch(e) { /* best-effort */ }
  }
  S.user = null; S.token = null;
  // Signal all other open tabs to log out too (storage event fires in other tabs)
  try { localStorage.setItem('eoh_logout', String(Date.now())); } catch(_) {}
  localStorage.removeItem('eoh_t'); localStorage.removeItem('eoh_u'); localStorage.removeItem('eoh_rt');
  localStorage.removeItem('eoh_rt_exp');
  // Synchronously clear ALL Supabase session keys so they cannot bleed into next OAuth flow
  try {
    var _sbKeys = Object.keys(localStorage);
    for (var _i = 0; _i < _sbKeys.length; _i++) {
      if (_sbKeys[_i].indexOf('sb-') === 0 || _sbKeys[_i].indexOf('supabase') !== -1) {
        localStorage.removeItem(_sbKeys[_i]);
      }
    }
  } catch(_) {}
  // Await signOut completion before reloading — ensures Supabase invalidates the token
  var _doReload = function() { window.location.reload(); };
  try {
    if (window._supabaseClient) {
      window._supabaseClient.auth.signOut().then(_doReload).catch(_doReload);
      setTimeout(_doReload, 2000); // safety fallback if signOut hangs
    } else { _doReload(); }
  } catch(e) { _doReload(); }
}

// ═══════════════════════════════════════════════════════════════════════════
// ACCOUNT BLOCKED — full-screen overlay + appeal form
// ═══════════════════════════════════════════════════════════════════════════
// ── Guest limit modal — shown when unauthenticated user hits free message cap ──
function _showGuestLimitModal() {
  var ex = document.getElementById('eoh-guest-limit-overlay');
  if (ex) ex.remove();
  var overlay = document.createElement('div');
  overlay.id = 'eoh-guest-limit-overlay';
  overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.82);z-index:99999;display:flex;align-items:center;justify-content:center;padding:20px;backdrop-filter:blur(4px)';
  overlay.innerHTML = '<div style="background:#0d1828;border:1px solid rgba(10,138,95,.35);border-radius:16px;max-width:420px;width:100%;padding:36px 32px;text-align:center;box-shadow:0 24px 80px rgba(0,0,0,.6)">'
    + '<div style="width:56px;height:56px;background:linear-gradient(135deg,#0a8a5f,#0fb574);border-radius:14px;display:flex;align-items:center;justify-content:center;margin:0 auto 20px;font-size:26px">🚀</div>'
    + '<div style="font-size:20px;font-weight:700;color:#e8edf5;margin-bottom:10px">You\'ve used your free messages</div>'
    + '<div style="font-size:14px;color:#7d8ba3;line-height:1.6;margin-bottom:28px">Create a free account to keep chatting — no credit card required. Get instant access to all ERP expertise.</div>'
    + '<div style="display:flex;flex-direction:column;gap:10px">'
    + '<button onclick="document.getElementById(\'eoh-guest-limit-overlay\').remove();showModal(\'signup\')" style="padding:13px 24px;background:linear-gradient(135deg,#0a8a5f,#0fb574);border:none;border-radius:10px;color:#fff;font-size:14px;font-weight:700;cursor:pointer">Create Free Account</button>'
    + '<button onclick="document.getElementById(\'eoh-guest-limit-overlay\').remove();showModal(\'login\')" style="padding:12px 24px;background:transparent;border:1px solid rgba(255,255,255,.12);border-radius:10px;color:#94a3b8;font-size:14px;cursor:pointer">Sign In</button>'
    + '</div>'
    + '</div>';
  document.body.appendChild(overlay);
}

function showBlockedModal(reason) {
  // Remove old overlay if present
  var ex = document.getElementById('eoh-blocked-overlay');
  if (ex) ex.remove();

  // Update S.user with latest block state
  if (S.user) {
    S.user.isBlocked   = true;
    S.user.blockReason = reason || S.user.blockReason || null;
    try { localStorage.setItem('eoh_u', JSON.stringify(S.user)); } catch(_) {}
  }

  var supportEmail = 'support@erponlinehub.com';
  var reasonHtml = (reason || (S.user && S.user.blockReason))
    ? '<div style="background:#1e293b;border:1px solid #dc2626;border-radius:8px;padding:14px 16px;margin:16px 0 0">'
      + '<p style="margin:0 0 4px;font-size:11px;text-transform:uppercase;letter-spacing:.5px;color:#ef4444;font-weight:700">Reason from Administrator</p>'
      + '<p style="margin:0;color:#f1f5f9;font-size:14px">' + _escBlockHtml(reason || S.user.blockReason) + '</p></div>'
    : '<div style="background:#1e293b;border:1px solid #334155;border-radius:8px;padding:12px 16px;margin:16px 0 0">'
      + '<p style="margin:0;color:#94a3b8;font-size:13px">No specific reason was provided. Please contact support for details.</p></div>';

  var overlay = document.createElement('div');
  overlay.id = 'eoh-blocked-overlay';
  overlay.style.cssText = [
    'position:fixed', 'inset:0', 'background:rgba(2,6,23,0.98)',
    'z-index:2147483647', 'display:flex', 'align-items:center',
    'justify-content:center', 'font-family:inherit', 'overflow-y:auto',
    'pointer-events:all'
  ].join(';') + ';';

  overlay.innerHTML =
    '<div style="width:520px;max-width:95vw;text-align:center;padding:32px 20px">'
    + '<div style="font-size:60px;margin-bottom:16px">🚫</div>'
    + '<h2 style="margin:0 0 10px;color:#f1f5f9;font-size:22px;font-weight:700">Account Suspended</h2>'
    + '<p style="margin:0;color:#94a3b8;font-size:14px;line-height:1.6">An administrator has suspended your account. All features are locked.</p>'
    + reasonHtml
    + '<div style="margin:24px 0 0;background:#1e293b;border:1px solid #334155;border-radius:12px;padding:24px;text-align:left">'
    + '<p style="margin:0 0 6px;color:#f1f5f9;font-size:15px;font-weight:600">📨 Submit an Appeal</p>'
    + '<p style="margin:0 0 14px;color:#94a3b8;font-size:13px">Believe this is a mistake? Send an appeal and our team will review it.</p>'
    + '<textarea id="eoh-appeal-msg" rows="3" placeholder="Explain why you believe this suspension should be reviewed..." '
    +   'style="width:100%;padding:10px 12px;background:#0f172a;border:1px solid #334155;border-radius:8px;'
    +   'color:#f1f5f9;font-size:13px;resize:vertical;box-sizing:border-box;font-family:inherit;margin-bottom:12px"></textarea>'
    + '<div style="display:flex;gap:10px;flex-wrap:wrap">'
    + '<button onclick="_sendAppeal()" style="flex:1;padding:11px 16px;background:#0ea5e9;border:none;border-radius:8px;color:#fff;font-size:13px;font-weight:600;cursor:pointer;min-width:130px">Send Appeal</button>'
    + '<button onclick="_appealByEmail()" style="flex:1;padding:11px 16px;background:transparent;border:1px solid #475569;border-radius:8px;color:#94a3b8;font-size:13px;cursor:pointer;min-width:130px">📧 Email Support</button>'
    + '<button onclick="doLogout()" style="flex:1;padding:11px 16px;background:transparent;border:1px solid #475569;border-radius:8px;color:#64748b;font-size:13px;cursor:pointer;min-width:100px">Sign Out</button>'
    + '</div>'
    + '<p id="eoh-appeal-status" style="margin:12px 0 0;font-size:13px;display:none"></p>'
    + '</div>'
    + '<p style="margin:20px 0 0;color:#475569;font-size:12px">Need help? '
    +   '<a href="mailto:' + supportEmail + '" style="color:#0ea5e9;text-decoration:none">' + supportEmail + '</a></p>'
    + '</div>';

  document.body.appendChild(overlay);

  // Block Escape key and any keydown outside overlay
  document.addEventListener('keydown', _blockKeyTrap, true);
}

function hideBlockedModal() {
  var el = document.getElementById('eoh-blocked-overlay');
  if (el) el.remove();
  document.removeEventListener('keydown', _blockKeyTrap, true);
  // Clear block state from S.user
  if (S.user) {
    S.user.isBlocked   = false;
    S.user.blockReason = null;
    try { localStorage.setItem('eoh_u', JSON.stringify(S.user)); } catch(_) {}
  }
}

function _blockKeyTrap(e) {
  var overlay = document.getElementById('eoh-blocked-overlay');
  if (!overlay) { document.removeEventListener('keydown', _blockKeyTrap, true); return; }
  if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); return; }
  if (!overlay.contains(e.target)) { e.preventDefault(); e.stopPropagation(); }
}

function _escBlockHtml(s) {
  return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
}

async function _sendAppeal() {
  var msg = (document.getElementById('eoh-appeal-msg') || {}).value || '';
  var st  = document.getElementById('eoh-appeal-status');
  if (!msg.trim()) {
    if (st) { st.style.display='block'; st.style.color='#ef4444'; st.textContent='Please write your appeal message first.'; }
    return;
  }
  // Disable button immediately to prevent double submit
  var sendBtn = document.querySelector('#eoh-blocked-overlay button[onclick="_sendAppeal()"]');
  if (sendBtn) { sendBtn.disabled = true; sendBtn.textContent = 'Sending...'; }
  if (st) { st.style.display='block'; st.style.color='#94a3b8'; st.textContent='Sending your appeal...'; }

  try {
    var fetchFn = window._origFetch || window.fetch;
    var res = await fetchFn(API + '/auth/appeal', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + (S.token || '') },
      body: JSON.stringify({
        message: msg.trim(),
        email:   S.user ? S.user.email : '',
        reason:  S.user ? (S.user.blockReason || '') : ''
      })
    });
    if (res.ok) {
      // Success — show confirmation, disable send button
      if (st) { st.style.color='#22c55e'; st.textContent='✅ Appeal submitted! Our team will review and contact you by email.'; }
      if (sendBtn) { sendBtn.textContent = 'Appeal Sent ✓'; }
    } else {
      // Server returned error — show message, do NOT auto-open email
      var errData = await res.json().catch(function(){ return {}; });
      if (st) { st.style.color='#ef4444'; st.textContent='Failed to submit: ' + (errData.error || 'Server error. Please try again or use Email Support.'); }
      if (sendBtn) { sendBtn.disabled = false; sendBtn.textContent = 'Send Appeal'; }
    }
  } catch(e) {
    // Network error — show message only, do NOT auto-open email
    if (st) { st.style.color='#ef4444'; st.textContent='Network error. Please check your connection or use Email Support.'; }
    if (sendBtn) { sendBtn.disabled = false; sendBtn.textContent = 'Send Appeal'; }
  }
}

function _appealByEmail() {
  var msg    = (document.getElementById('eoh-appeal-msg') || {}).value || '';
  var reason = S.user ? (S.user.blockReason || '') : '';
  var email  = S.user ? (S.user.email || '') : '';
  var subject = encodeURIComponent('Account Suspension Appeal — ' + email);
  var body = encodeURIComponent(
    'Hello Support Team,\n\nI would like to appeal my account suspension.\n\n'
    + (reason ? 'Stated reason: ' + reason + '\n\n' : '')
    + (msg    ? 'My appeal:\n'   + msg    + '\n\n' : '')
    + 'Account email: ' + email + '\n\nThank you.'
  );
  window.open('mailto:support@erponlinehub.com?subject=' + subject + '&body=' + body, '_blank');
}

window._sendAppeal    = _sendAppeal;
window._appealByEmail  = _appealByEmail;
// Rating bar functions — must be on window since called from inline onclick
window.rbRate         = rbRate;
window.rbHover        = rbHover;
window.rbUnhover      = rbUnhover;
window.showRatingBar  = showRatingBar;
window.submitRating   = submitRating;
window.submitImgRating= submitImgRating;
window.hoverStars     = hoverStars;
window.unhoverStars   = unhoverStars;
window.voteImage      = voteImage;
window.applyStoredVotes = applyStoredVotes;

// ── checkAndShowBlock — call after login/sync to show modal if blocked ───────
function checkAndShowBlock(userObj) {
  if (userObj && userObj.isBlocked) {
    showBlockedModal(userObj.blockReason || null);
    return true;
  }
  return false;
}


// -- PLANS ---------------------------------------------------------------------
function showPlans() {
  var m = document.getElementById('acct-menu'); if (m) m.remove();
  closeModal();
  // Open the full upgrade overlay — uses real plan prices from DB
  _loadAndRenderPlans();
  _loadUpgradeSubtitle();
  var el = document.getElementById('upgrade-overlay');
  if (el) { el.style.display = 'flex'; var box = document.getElementById('upgrade-box'); if (box) box.scrollTop = 0; }
}

// selectPlan is defined above (line ~4516) — this alias ensures showPlans() modal also uses it
// No duplicate definition needed

function onUser() {
  if (!S.user) { showModal('login'); } else { showAccountMenu(); }
}

function toggleAttachMenu() {
  if (!S.user || !S.token) { showModal('login'); return; }
  var m = document.getElementById('attach-menu');
  var isOpen = m.classList.contains('open');
  if (isOpen) { m.classList.remove('open'); return; }
  m.classList.add('open');
  setTimeout(function() {
    document.addEventListener('click', function h(e) {
      var btn = document.getElementById('attach-btn');
      if (!m.contains(e.target) && e.target !== btn && !btn.contains(e.target)) {
        m.classList.remove('open');
      }
      document.removeEventListener('click', h);
    });
  }, 100);
}

// closeProfileModal — needed by profile modal buttons
function closeProfileModal() {
  var el = document.getElementById('profile-overlay');
  if (el) el.style.display = 'none';
}

// renderSessions — alias for _renderList (session list renderer)
function renderSessions(sessions) {
  if (typeof _renderList === 'function') _renderList(sessions);
}

// =============================================================================
// SITE BANNER OVERLAY
// =============================================================================
function showSiteBanner(opts) {
  var existing = document.getElementById('eoh-site-banner');
  if (existing) existing.remove();
  var TYPES = { maintenance:{icon:'🔧',title:'Under Maintenance'}, coming_soon:{icon:'🚀',title:'Coming Soon'}, under_construction:{icon:'🏗️',title:'Under Construction'}, announcement:{icon:'📣',title:'Announcement'}, custom:{icon:'📢',title:'Notice'} };
  var BG = {
    dark:  {bg:'#0f172a',text:'#f1f5f9',sub:'#94a3b8',accent:'#3b82f6',card:'rgba(255,255,255,0.05)',border:'rgba(255,255,255,0.08)'},
    light: {bg:'#f8fafc',text:'#1e293b',sub:'#64748b',accent:'#3b82f6',card:'rgba(0,0,0,0.04)',border:'rgba(0,0,0,0.1)'},
    blue:  {bg:'#0d3e6e',text:'#ffffff',sub:'#7bafd4',accent:'#f0ab00',card:'rgba(255,255,255,0.06)',border:'rgba(255,255,255,0.12)'},
    amber: {bg:'#78350f',text:'#fef3c7',sub:'#fcd34d',accent:'#f59e0b',card:'rgba(255,255,255,0.06)',border:'rgba(255,255,255,0.12)'},
    red:   {bg:'#450a0a',text:'#fef2f2',sub:'#fca5a5',accent:'#ef4444',card:'rgba(255,255,255,0.06)',border:'rgba(255,255,255,0.12)'},
  };
  var t = TYPES[opts.type] || TYPES.maintenance;
  var s = BG[opts.bg] || BG.dark;
  var title    = opts.title    || t.title;
  var subtitle = opts.subtitle || '';
  var back     = opts.back     || '';
  var email    = opts.email    || '';
  var logo     = opts.logo     || '';
  var logoHtml = logo
    ? '<img src="'+logo+'" onerror="this.style.display=\'none\'" style="height:60px;object-fit:contain;margin-bottom:20px">'
    : '<div style="font-size:56px;margin-bottom:16px;line-height:1">'+t.icon+'</div>';
  var backHtml  = back  ? '<div style="margin-top:16px;display:inline-flex;align-items:center;gap:8px;background:'+s.card+';border:1px solid '+s.border+';padding:8px 20px;border-radius:99px;font-size:13px;color:'+s.sub+'"><span>⏱</span>'+back+'</div>' : '';
  var emailHtml = email ? '<div style="margin-top:14px;font-size:12px;color:'+s.sub+'">Questions? <a href="mailto:'+email+'" style="color:'+s.accent+';text-decoration:none">'+email+'</a></div>' : '';
  var divider   = subtitle ? '<div style="width:48px;height:3px;background:'+s.accent+';border-radius:2px;margin:16px auto"></div>' : '';
  var overlay = document.createElement('div');
  overlay.id = 'eoh-site-banner';
  overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:'+s.bg+';z-index:999999;display:flex;align-items:center;justify-content:center;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;text-align:center;padding:24px;box-sizing:border-box';
  overlay.innerHTML = '<div style="max-width:480px;width:100%">'+logoHtml+'<h1 style="font-size:28px;font-weight:700;color:'+s.text+';margin:0 0 12px">'+title+'</h1>'+divider+(subtitle?'<p style="font-size:15px;color:'+s.sub+';line-height:1.7;margin:12px 0 0">'+subtitle+'</p>':'')+backHtml+emailHtml+'</div>';
  document.body.appendChild(overlay);
}

// ══════════════════════════════════════════════════════════════════════════════
// SESSION INACTIVITY TIMEOUT — Phase 6
// Reads session_timeout_mins + session_warning_mins from app_settings
// Resets on any user interaction. Shows a warning modal before auto-logout.
// ══════════════════════════════════════════════════════════════════════════════
(function _initIdleTimeout() {
  var _idleTimer = null, _warnTimer = null, _warnShown = false;

  function _getTimeouts() {
    var timeoutMins = window._sessionTimeoutMins !== undefined ? window._sessionTimeoutMins : 720;
    var warningMins = window._sessionWarningMins !== undefined ? window._sessionWarningMins : 3;
    return {
      timeout: Math.max(5, timeoutMins) * 60000,
      warning: Math.max(1, warningMins) * 60000,
    };
  }

  function _clearTimers() {
    clearTimeout(_idleTimer); clearTimeout(_warnTimer); _idleTimer = null; _warnTimer = null;
  }

  function _doLogout() {
    var w = document.getElementById('eoh-idle-warning'); if (w) w.remove();
    if (S.token) {
      // Clear session
      localStorage.removeItem('eoh_t'); localStorage.removeItem('eoh_rt');
      S.token = null; S.user = null;
      addMsg('assistant', '🔒 You were signed out due to inactivity. Please sign in again.', null);
      showModal('login');
    }
  }

  function _showWarning(secsLeft) {
    if (_warnShown) return;
    _warnShown = true;
    var ex = document.getElementById('eoh-idle-warning'); if (ex) ex.remove();
    var overlay = document.createElement('div');
    overlay.id = 'eoh-idle-warning';
    overlay.style.cssText = 'position:fixed;bottom:24px;right:24px;z-index:9999;background:var(--bg2);border:1px solid #f59e0b55;border-radius:12px;padding:16px 20px;max-width:320px;box-shadow:0 8px 32px rgba(0,0,0,.4)';
    overlay.innerHTML = '<div style="display:flex;align-items:flex-start;gap:12px">'
      + '<span style="font-size:22px">⏱</span>'
      + '<div style="flex:1">'
      + '<div style="font-size:13px;font-weight:700;color:var(--text);margin-bottom:4px">Session expiring soon</div>'
      + '<div style="font-size:12px;color:var(--dim);margin-bottom:12px">You\'ll be signed out in <strong id="idle-secs-left">' + secsLeft + '</strong> seconds due to inactivity.</div>'
      + '<div style="display:flex;gap:8px">'
      + '<button onclick="window._idleResetFn && window._idleResetFn()" style="flex:1;padding:7px 12px;background:linear-gradient(135deg,var(--g1),var(--g2));border:none;border-radius:7px;color:#fff;font-size:12px;font-weight:600;cursor:pointer">Stay signed in</button>'
      + '<button onclick="document.getElementById(\'eoh-idle-warning\').remove()" style="padding:7px 12px;background:var(--bg3);border:1px solid var(--border);border-radius:7px;color:var(--muted);font-size:12px;cursor:pointer">Dismiss</button>'
      + '</div></div></div>';
    document.body.appendChild(overlay);
    // Count down seconds
    var _cd = setInterval(function() {
      secsLeft--;
      var el = document.getElementById('idle-secs-left'); if (el) el.textContent = secsLeft;
      if (secsLeft <= 0) clearInterval(_cd);
    }, 1000);
  }

  function _resetIdleTimer() {
    if (!S.user || !S.token) return;
    var t = _getTimeouts();
    if (t.timeout <= 0) return; // 0 = disabled
    _clearTimers();
    _warnShown = false;
    var ex = document.getElementById('eoh-idle-warning'); if (ex) ex.remove();
    _warnTimer = setTimeout(function() {
      _showWarning(Math.round(t.warning / 1000));
      _idleTimer = setTimeout(_doLogout, t.warning);
    }, t.timeout - t.warning);
  }
  window._idleResetFn = _resetIdleTimer;

  // Listen for any user activity
  ['mousemove','keydown','click','touchstart','scroll'].forEach(function(ev) {
    document.addEventListener(ev, function() { if (S.user) _resetIdleTimer(); }, { passive: true });
  });

  // Start timer after login
  document.addEventListener('eoh:login', _resetIdleTimer);
  // Also start if already logged in when page loads
  setTimeout(function() { if (S.user && S.token) _resetIdleTimer(); }, 2000);
})();

// ══════════════════════════════════════════════════════════════════════════════
// KEYBOARD SHORTCUTS — Phase 8 (Fix 18)
// Ctrl/Cmd + Enter = send, N = new chat, E = export, / = slash menu, ? = help
// ══════════════════════════════════════════════════════════════════════════════
document.addEventListener('keydown', function(e) {
  var mod = e.ctrlKey || e.metaKey;
  if (!mod && e.key !== 'Escape') return;

  // Escape — close any open overlay
  if (e.key === 'Escape') {
    var overlays = ['eoh-help-modal','eoh-export-modal','eoh-idle-warning','slash-menu','eoh-toast'];
    overlays.forEach(function(id) { var el = document.getElementById(id); if (el) el.remove(); });
    return;
  }

  // Don't fire when typing in an input/textarea (except Ctrl+Enter)
  var inInput = document.activeElement && (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA' || document.activeElement.tagName === 'SELECT');
  if (inInput && e.key !== 'Enter') return;

  if (mod && e.key === 'Enter') {
    // Ctrl+Enter — send message
    e.preventDefault();
    sendMsg();
    return;
  }
  if (mod && e.key.toLowerCase() === 'n') {
    // Ctrl+N — new chat
    e.preventDefault();
    resetChat();
    return;
  }
  if (mod && e.key.toLowerCase() === 'e') {
    // Ctrl+E — export modal
    e.preventDefault();
    openExportModal();
    return;
  }
  if (mod && (e.key === '/' || e.key === '?')) {
    // Ctrl+/ or Ctrl+? — focus textarea and open slash menu
    e.preventDefault();
    var ta = document.getElementById('chat-ta');
    if (ta && !ta.disabled) {
      ta.focus();
      if (!ta.value) { ta.value = '/'; _handleSlashInput('/'); }
    }
    return;
  }
}, false);

/* ── EOH Popup Ads renderer (self-contained; shows admin-configured popups) ───── */
(function(){
  var API='https://erp-ai-backend.vercel.app';
  function key(id){ return 'eoh_popup_seen_'+id; }
  function isSeen(p){
    try{
      if(p.show_frequency==='once_ever') return !!localStorage.getItem(key(p.id));
      if(p.show_frequency==='once_per_session') return !!sessionStorage.getItem(key(p.id));
    }catch(e){}
    return false;
  }
  function markSeen(p){
    try{
      if(p.show_frequency==='once_ever') localStorage.setItem(key(p.id),'1');
      else if(p.show_frequency==='once_per_session') sessionStorage.setItem(key(p.id),'1');
    }catch(e){}
  }
  function targetOk(p){
    var loggedIn=!!(window.S && window.S.user);
    if(p.target==='logged_in' && !loggedIn) return false;
    if(p.target==='logged_out' && loggedIn) return false;
    if(Array.isArray(p.target_plans) && p.target_plans.length){
      var plan=(window.S && window.S.user && window.S.user.plan) || 'free';
      if(p.target_plans.indexOf(plan)===-1) return false;
    }
    return true;
  }
  function widthPx(w){ return {small:'360px',medium:'440px',large:'560px',fullscreen:'92vw'}[w]||'440px'; }

  function render(p){
    if(document.getElementById('eoh-popup-overlay')) return;
    var pos=p.position||'center', center=(pos==='center'), banner=(pos==='top-banner'||pos==='bottom-banner');
    var ov=document.createElement('div'); ov.id='eoh-popup-overlay';
    var css='position:fixed;inset:0;z-index:2147483000;display:flex;';
    if(center){ css+='align-items:center;justify-content:center;padding:20px;background:rgba(0,0,0,'+(p.backdrop_opacity!=null?p.backdrop_opacity:0.65)+');'; }
    else { css+='background:none;pointer-events:none;';
      if(pos==='top-banner') css+='align-items:flex-start;justify-content:center;';
      else if(pos==='bottom-banner') css+='align-items:flex-end;justify-content:center;';
      else css+='align-items:flex-end;justify-content:flex-end;padding:18px;'; }
    ov.style.cssText=css;

    var card=document.createElement('div');
    var cc='pointer-events:auto;position:relative;box-sizing:border-box;'
      +'background:'+(p.bg_color||'#0D1B2E')+';color:'+(p.text_color||'#fff')+';'
      +'border:'+(p.border_width!=null?p.border_width:2)+'px solid '+(p.border_color||'#0a8a5f')+';'
      +'border-radius:'+(banner?0:(p.border_radius!=null?p.border_radius:16))+'px;'
      +'text-align:'+(p.text_align||'center')+';font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;'
      +'box-shadow:0 12px 48px rgba(0,0,0,.4);animation:eohPopIn .25s ease;';
    cc+= banner ? 'width:100%;max-width:none;padding:14px 44px 14px 20px;display:flex;align-items:center;gap:16px;'
                : 'width:100%;max-width:'+widthPx(p.popup_width)+';padding:26px 24px;';
    card.style.cssText=cc;

    var html='';
    if(p.image_url && !banner) html+='<img src="'+p.image_url+'" alt="" style="max-width:100%;max-height:180px;object-fit:contain;border-radius:8px;margin-bottom:14px">';
    var t=(p.icon?p.icon+' ':'')+(p.title||'');
    if(t.trim()) html+='<div style="font-weight:700;font-size:'+(p.title_font_size||18)+'px;margin-bottom:'+(banner?2:8)+'px">'+t+'</div>';
    if(p.text_content) html+='<div style="font-size:'+(p.body_font_size||14)+'px;line-height:1.5;opacity:.92">'+p.text_content+'</div>';
    var body=document.createElement('div'); body.style.cssText=banner?'flex:1;min-width:0':''; body.innerHTML=html;

    var actions=document.createElement('div');
    actions.style.cssText='margin-top:'+(banner?0:16)+'px;display:flex;gap:10px;'+(banner?'':'justify-content:center;')+'align-items:center;flex:0 0 auto';
    if(p.button_text && p.button_url){
      var a=document.createElement('a'); a.href=p.button_url; a.textContent=p.button_text;
      a.style.cssText='display:inline-block;background:'+(p.button_bg_color||'#0a8a5f')+';color:#fff;text-decoration:none;padding:10px 20px;border-radius:8px;font-weight:600;font-size:14px;white-space:nowrap';
      a.addEventListener('click',function(){ markSeen(p); }); actions.appendChild(a);
    }

    function close(){ try{ov.remove();}catch(e){} }
    var dismiss=p.dismiss_type||'closeable';
    if(dismiss!=='persistent'){
      var x=document.createElement('button'); x.setAttribute('aria-label','Close'); x.innerHTML='&#10005;';
      x.style.cssText='position:absolute;top:10px;right:12px;background:none;border:none;color:'+(p.text_color||'#fff')+';opacity:.65;font-size:16px;cursor:pointer;line-height:1;padding:4px';
      x.addEventListener('click',close); card.appendChild(x);
    }
    if(dismiss==='countdown'){
      var secs=parseInt(p.countdown_secs)||5;
      var cd=document.createElement('div'); cd.style.cssText='font-size:11px;opacity:.6;margin-top:'+(banner?0:10)+'px';
      cd.textContent='Closing in '+secs+'s'; actions.appendChild(cd);
      var iv=setInterval(function(){ secs--; if(secs<=0){ clearInterval(iv); close(); } else cd.textContent='Closing in '+secs+'s'; },1000);
    }

    card.appendChild(body); if(actions.childNodes.length) card.appendChild(actions);
    ov.appendChild(card);
    if(center){ ov.addEventListener('click',function(e){ if(e.target===ov && dismiss!=='persistent') close(); }); }
    document.body.appendChild(ov);
    markSeen(p);
  }

  function run(){
    fetch(API+'/admin/popups/active').then(function(r){return r.json();}).then(function(d){
      var list=(d&&d.popups)||[];
      for(var i=0;i<list.length;i++){ var p=list[i]; if(targetOk(p) && !isSeen(p)){ render(p); break; } }
    }).catch(function(){});
  }
  try{ var st=document.createElement('style'); st.textContent='@keyframes eohPopIn{from{opacity:0;transform:translateY(8px) scale(.98)}to{opacity:1;transform:none}}'; document.head.appendChild(st); }catch(e){}
  if(document.readyState==='complete'||document.readyState==='interactive') setTimeout(run,3000);
  else document.addEventListener('DOMContentLoaded',function(){ setTimeout(run,3000); });


})();
